//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.5.0.0 (NJsonSchema v11.4.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

export const ApiBaseUrl = new InjectionToken<string>('ApiBaseUrl');

export interface IAccountClient {
    get(id?: number | undefined): Observable<GetAccountResponse>;
    updateAccountPlanInformation(request: UpdateAccountPlanInformationRequest): Observable<UpdateAccountPlanInformationResponse>;
    swapAccountApplicantTypes(request: SwapAccountApplicantTypesRequest): Observable<SwapAccountApplicantTypesResponse>;
    getAccountSemesters(accountsMainsId?: number | undefined): Observable<GetAccountSemestersResponse>;
    updateAccountSemesters(request: UpdateAccountSemestersRequest): Observable<UpdateAccountSemestersResponse>;
    deleteAccount(accountMainsId?: number | undefined): Observable<DeleteAccountResponse>;
    cancelAccount(request: CancelAccountRequest): Observable<CancelAccountResponse>;
    getAccountSemestersPreview(financialSummaryId?: number | null | undefined, accountMainsId?: number | null | undefined): Observable<GetApplicationAccountSemestersResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class AccountClient implements IAccountClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(id?: number | undefined): Observable<GetAccountResponse> {
        let url_ = this.baseUrl + "/Account?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetAccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccountResponse>(null as any);
    }

    updateAccountPlanInformation(request: UpdateAccountPlanInformationRequest): Observable<UpdateAccountPlanInformationResponse> {
        let url_ = this.baseUrl + "/Account/UpdateAccountPlanInformation";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountPlanInformation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountPlanInformation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAccountPlanInformationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAccountPlanInformationResponse>;
        }));
    }

    protected processUpdateAccountPlanInformation(response: HttpResponseBase): Observable<UpdateAccountPlanInformationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAccountPlanInformationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateAccountPlanInformationResponse>(null as any);
    }

    swapAccountApplicantTypes(request: SwapAccountApplicantTypesRequest): Observable<SwapAccountApplicantTypesResponse> {
        let url_ = this.baseUrl + "/Account/SwapAccountApplicantTypes";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSwapAccountApplicantTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSwapAccountApplicantTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SwapAccountApplicantTypesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SwapAccountApplicantTypesResponse>;
        }));
    }

    protected processSwapAccountApplicantTypes(response: HttpResponseBase): Observable<SwapAccountApplicantTypesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SwapAccountApplicantTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SwapAccountApplicantTypesResponse>(null as any);
    }

    getAccountSemesters(accountsMainsId?: number | undefined): Observable<GetAccountSemestersResponse> {
        let url_ = this.baseUrl + "/Account/GetAccountSemesters?";
        if (accountsMainsId === null)
            throw new globalThis.Error("The parameter 'accountsMainsId' cannot be null.");
        else if (accountsMainsId !== undefined)
            url_ += "accountsMainsId=" + encodeURIComponent("" + accountsMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountSemesters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountSemesters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountSemestersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountSemestersResponse>;
        }));
    }

    protected processGetAccountSemesters(response: HttpResponseBase): Observable<GetAccountSemestersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountSemestersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccountSemestersResponse>(null as any);
    }

    updateAccountSemesters(request: UpdateAccountSemestersRequest): Observable<UpdateAccountSemestersResponse> {
        let url_ = this.baseUrl + "/Account/UpdateAccountSemesters";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountSemesters(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountSemesters(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAccountSemestersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAccountSemestersResponse>;
        }));
    }

    protected processUpdateAccountSemesters(response: HttpResponseBase): Observable<UpdateAccountSemestersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAccountSemestersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateAccountSemestersResponse>(null as any);
    }

    deleteAccount(accountMainsId?: number | undefined): Observable<DeleteAccountResponse> {
        let url_ = this.baseUrl + "/Account/DeleteAccount?";
        if (accountMainsId === null)
            throw new globalThis.Error("The parameter 'accountMainsId' cannot be null.");
        else if (accountMainsId !== undefined)
            url_ += "accountMainsId=" + encodeURIComponent("" + accountMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteAccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteAccountResponse>;
        }));
    }

    protected processDeleteAccount(response: HttpResponseBase): Observable<DeleteAccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteAccountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteAccountResponse>(null as any);
    }

    cancelAccount(request: CancelAccountRequest): Observable<CancelAccountResponse> {
        let url_ = this.baseUrl + "/Account/CancelAccount";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCancelAccount(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCancelAccount(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CancelAccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CancelAccountResponse>;
        }));
    }

    protected processCancelAccount(response: HttpResponseBase): Observable<CancelAccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CancelAccountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CancelAccountResponse>(null as any);
    }

    getAccountSemestersPreview(financialSummaryId?: number | null | undefined, accountMainsId?: number | null | undefined): Observable<GetApplicationAccountSemestersResponse> {
        let url_ = this.baseUrl + "/Account/GetAccountSemestersPreview?";
        if (financialSummaryId !== undefined && financialSummaryId !== null)
            url_ += "financialSummaryId=" + encodeURIComponent("" + financialSummaryId) + "&";
        if (accountMainsId !== undefined && accountMainsId !== null)
            url_ += "accountMainsId=" + encodeURIComponent("" + accountMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountSemestersPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountSemestersPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationAccountSemestersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationAccountSemestersResponse>;
        }));
    }

    protected processGetAccountSemestersPreview(response: HttpResponseBase): Observable<GetApplicationAccountSemestersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicationAccountSemestersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApplicationAccountSemestersResponse>(null as any);
    }
}

export interface IApplicantClient {
    getApplicantDetail(applicationApplicantRootId?: number | undefined): Observable<GetApplicantDetailResponse>;
    updateApplicantDetail(request: UpdateApplicantDetailRequest): Observable<UpdateApplicantDetailResponse>;
    getFinancialSummaryPreviews(applicantId?: number | undefined): Observable<GetFinancialSummaryPreviewsResponse>;
    getApplicationPreviews(applicantId?: number | undefined): Observable<GetApplicationPreviewsResponse>;
    getAccountPreviews(applicantId?: number | undefined): Observable<GetAccountPreviewsResponse>;
    searchApplicantPreviews(request: SearchApplicantPreviewsRequest): Observable<SearchApplicantPreviewsResponse>;
    updateApplicantRootId(request: UpdateApplicantRootIdRequest): Observable<UpdateApplicantRootIdResponse>;
    getApplicantPreview(applicantId?: number | undefined): Observable<GetApplicantPreviewResponse>;
    updateSsn(request: UpdateSsnRequest): Observable<UpdateSsnResponse>;
    getAllMatchingRootApplicants(applicantRootId?: number | undefined): Observable<GetAllMatchingRootApplicantsResponse>;
    getAccountQuickNavigation(applicantRootId?: number | null | undefined, studentRootId?: number | null | undefined): Observable<AccountQuickNavigationResponse>;
    getApplicantDetailHistory(applicationApplicantRootId?: number | undefined): Observable<GetApplicantDetailHistoryResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicantClient implements IApplicantClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getApplicantDetail(applicationApplicantRootId?: number | undefined): Observable<GetApplicantDetailResponse> {
        let url_ = this.baseUrl + "/Applicant/GetApplicantDetail?";
        if (applicationApplicantRootId === null)
            throw new globalThis.Error("The parameter 'applicationApplicantRootId' cannot be null.");
        else if (applicationApplicantRootId !== undefined)
            url_ += "applicationApplicantRootId=" + encodeURIComponent("" + applicationApplicantRootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicantDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicantDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicantDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicantDetailResponse>;
        }));
    }

    protected processGetApplicantDetail(response: HttpResponseBase): Observable<GetApplicantDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicantDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApplicantDetailResponse>(null as any);
    }

    updateApplicantDetail(request: UpdateApplicantDetailRequest): Observable<UpdateApplicantDetailResponse> {
        let url_ = this.baseUrl + "/Applicant/UpdateApplicantDetail";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplicantDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplicantDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateApplicantDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateApplicantDetailResponse>;
        }));
    }

    protected processUpdateApplicantDetail(response: HttpResponseBase): Observable<UpdateApplicantDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateApplicantDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateApplicantDetailResponse>(null as any);
    }

    getFinancialSummaryPreviews(applicantId?: number | undefined): Observable<GetFinancialSummaryPreviewsResponse> {
        let url_ = this.baseUrl + "/Applicant/GetFinancialSummaryPreviews?";
        if (applicantId === null)
            throw new globalThis.Error("The parameter 'applicantId' cannot be null.");
        else if (applicantId !== undefined)
            url_ += "applicantId=" + encodeURIComponent("" + applicantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialSummaryPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialSummaryPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFinancialSummaryPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFinancialSummaryPreviewsResponse>;
        }));
    }

    protected processGetFinancialSummaryPreviews(response: HttpResponseBase): Observable<GetFinancialSummaryPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialSummaryPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialSummaryPreviewsResponse>(null as any);
    }

    getApplicationPreviews(applicantId?: number | undefined): Observable<GetApplicationPreviewsResponse> {
        let url_ = this.baseUrl + "/Applicant/GetApplicationPreviews?";
        if (applicantId === null)
            throw new globalThis.Error("The parameter 'applicantId' cannot be null.");
        else if (applicantId !== undefined)
            url_ += "applicantId=" + encodeURIComponent("" + applicantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationPreviewsResponse>;
        }));
    }

    protected processGetApplicationPreviews(response: HttpResponseBase): Observable<GetApplicationPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicationPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApplicationPreviewsResponse>(null as any);
    }

    getAccountPreviews(applicantId?: number | undefined): Observable<GetAccountPreviewsResponse> {
        let url_ = this.baseUrl + "/Applicant/GetAccountPreviews?";
        if (applicantId === null)
            throw new globalThis.Error("The parameter 'applicantId' cannot be null.");
        else if (applicantId !== undefined)
            url_ += "applicantId=" + encodeURIComponent("" + applicantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountPreviewsResponse>;
        }));
    }

    protected processGetAccountPreviews(response: HttpResponseBase): Observable<GetAccountPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccountPreviewsResponse>(null as any);
    }

    searchApplicantPreviews(request: SearchApplicantPreviewsRequest): Observable<SearchApplicantPreviewsResponse> {
        let url_ = this.baseUrl + "/Applicant/SearchApplicantPreviews";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchApplicantPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchApplicantPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchApplicantPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchApplicantPreviewsResponse>;
        }));
    }

    protected processSearchApplicantPreviews(response: HttpResponseBase): Observable<SearchApplicantPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchApplicantPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchApplicantPreviewsResponse>(null as any);
    }

    updateApplicantRootId(request: UpdateApplicantRootIdRequest): Observable<UpdateApplicantRootIdResponse> {
        let url_ = this.baseUrl + "/Applicant/UpdateApplicantRootId";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateApplicantRootId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateApplicantRootId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateApplicantRootIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateApplicantRootIdResponse>;
        }));
    }

    protected processUpdateApplicantRootId(response: HttpResponseBase): Observable<UpdateApplicantRootIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateApplicantRootIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateApplicantRootIdResponse>(null as any);
    }

    getApplicantPreview(applicantId?: number | undefined): Observable<GetApplicantPreviewResponse> {
        let url_ = this.baseUrl + "/Applicant/GetApplicantPreview?";
        if (applicantId === null)
            throw new globalThis.Error("The parameter 'applicantId' cannot be null.");
        else if (applicantId !== undefined)
            url_ += "applicantId=" + encodeURIComponent("" + applicantId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicantPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicantPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicantPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicantPreviewResponse>;
        }));
    }

    protected processGetApplicantPreview(response: HttpResponseBase): Observable<GetApplicantPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicantPreviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApplicantPreviewResponse>(null as any);
    }

    updateSsn(request: UpdateSsnRequest): Observable<UpdateSsnResponse> {
        let url_ = this.baseUrl + "/Applicant/UpdateSsn";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSsnResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSsnResponse>;
        }));
    }

    protected processUpdateSsn(response: HttpResponseBase): Observable<UpdateSsnResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSsnResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSsnResponse>(null as any);
    }

    getAllMatchingRootApplicants(applicantRootId?: number | undefined): Observable<GetAllMatchingRootApplicantsResponse> {
        let url_ = this.baseUrl + "/Applicant/GetAllMatchingRootApplicants?";
        if (applicantRootId === null)
            throw new globalThis.Error("The parameter 'applicantRootId' cannot be null.");
        else if (applicantRootId !== undefined)
            url_ += "applicantRootId=" + encodeURIComponent("" + applicantRootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllMatchingRootApplicants(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllMatchingRootApplicants(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllMatchingRootApplicantsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllMatchingRootApplicantsResponse>;
        }));
    }

    protected processGetAllMatchingRootApplicants(response: HttpResponseBase): Observable<GetAllMatchingRootApplicantsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllMatchingRootApplicantsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllMatchingRootApplicantsResponse>(null as any);
    }

    getAccountQuickNavigation(applicantRootId?: number | null | undefined, studentRootId?: number | null | undefined): Observable<AccountQuickNavigationResponse> {
        let url_ = this.baseUrl + "/Applicant/GetAccountQuickNavigation?";
        if (applicantRootId !== undefined && applicantRootId !== null)
            url_ += "applicantRootId=" + encodeURIComponent("" + applicantRootId) + "&";
        if (studentRootId !== undefined && studentRootId !== null)
            url_ += "studentRootId=" + encodeURIComponent("" + studentRootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountQuickNavigation(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountQuickNavigation(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AccountQuickNavigationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AccountQuickNavigationResponse>;
        }));
    }

    protected processGetAccountQuickNavigation(response: HttpResponseBase): Observable<AccountQuickNavigationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AccountQuickNavigationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AccountQuickNavigationResponse>(null as any);
    }

    getApplicantDetailHistory(applicationApplicantRootId?: number | undefined): Observable<GetApplicantDetailHistoryResponse> {
        let url_ = this.baseUrl + "/Applicant/GetApplicantDetailHistory?";
        if (applicationApplicantRootId === null)
            throw new globalThis.Error("The parameter 'applicationApplicantRootId' cannot be null.");
        else if (applicationApplicantRootId !== undefined)
            url_ += "applicationApplicantRootId=" + encodeURIComponent("" + applicationApplicantRootId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicantDetailHistory(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicantDetailHistory(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicantDetailHistoryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicantDetailHistoryResponse>;
        }));
    }

    protected processGetApplicantDetailHistory(response: HttpResponseBase): Observable<GetApplicantDetailHistoryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicantDetailHistoryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApplicantDetailHistoryResponse>(null as any);
    }
}

export interface IApplicationClient {
    searchApplicationPreviews(request: SearchApplicationPreviewsRequest): Observable<SearchApplicationPreviewsResponse>;
    get(id?: number | null | undefined): Observable<GetApplicationResponse>;
    getPdf(request: GetPepApplicationPdfRequest): Observable<FileResponse>;
    getTaxReturns(applicationId?: number | undefined): Observable<FileResponse>;
    updateStatus(request: UpdateStatusRequest): Observable<UpdateStatusResponse>;
    createRefinanceApplication(request: CreateRefinanceApplicationRequest): Observable<CreateRefinanceApplicationResponse>;
    getMatchingAccountIds(request: GetMatchingAccountIdsRequest): Observable<GetMatchingAccountIdsResponse>;
    addFinancialSummary(request: AddFinancialSummaryRequest): Observable<AddFinancialSummaryResponse>;
    getFinancialSummary(applicationId?: number | undefined, financialSummaryId?: number | null | undefined): Observable<GetFinancialSummaryResponse>;
    getFinancialSummaryPreviews(applicationId?: number | undefined): Observable<GetFinancialSummaryPreviewsResponse2>;
    updateFinancialSummary(request: UpdateFinancialSummaryRequest): Observable<UpdateFinancialSummaryResponse>;
    getMakePlanPreviews(applicationId?: number | undefined): Observable<MakePlanResponse>;
    deleteApplication(applicationId?: number | undefined): Observable<DeleteApplicationResponse>;
    getApplicationSemestersPreview(financialSummaryId?: number | null | undefined, accountMainsId?: number | null | undefined): Observable<GetApplicationAccountSemestersResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ApplicationClient implements IApplicationClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    searchApplicationPreviews(request: SearchApplicationPreviewsRequest): Observable<SearchApplicationPreviewsResponse> {
        let url_ = this.baseUrl + "/Application";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchApplicationPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchApplicationPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchApplicationPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchApplicationPreviewsResponse>;
        }));
    }

    protected processSearchApplicationPreviews(response: HttpResponseBase): Observable<SearchApplicationPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchApplicationPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchApplicationPreviewsResponse>(null as any);
    }

    get(id?: number | null | undefined): Observable<GetApplicationResponse> {
        let url_ = this.baseUrl + "/Application?";
        if (id !== undefined && id !== null)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApplicationResponse>(null as any);
    }

    getPdf(request: GetPepApplicationPdfRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Application/GetPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getTaxReturns(applicationId?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Application/GetTaxReturns?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTaxReturns(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTaxReturns(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetTaxReturns(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    updateStatus(request: UpdateStatusRequest): Observable<UpdateStatusResponse> {
        let url_ = this.baseUrl + "/Application/UpdateStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateStatusResponse>;
        }));
    }

    protected processUpdateStatus(response: HttpResponseBase): Observable<UpdateStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateStatusResponse>(null as any);
    }

    createRefinanceApplication(request: CreateRefinanceApplicationRequest): Observable<CreateRefinanceApplicationResponse> {
        let url_ = this.baseUrl + "/Application/CreateRefinanceApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateRefinanceApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateRefinanceApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateRefinanceApplicationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateRefinanceApplicationResponse>;
        }));
    }

    protected processCreateRefinanceApplication(response: HttpResponseBase): Observable<CreateRefinanceApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateRefinanceApplicationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateRefinanceApplicationResponse>(null as any);
    }

    getMatchingAccountIds(request: GetMatchingAccountIdsRequest): Observable<GetMatchingAccountIdsResponse> {
        let url_ = this.baseUrl + "/Application/GetMatchingAccountIds";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMatchingAccountIds(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMatchingAccountIds(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetMatchingAccountIdsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetMatchingAccountIdsResponse>;
        }));
    }

    protected processGetMatchingAccountIds(response: HttpResponseBase): Observable<GetMatchingAccountIdsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetMatchingAccountIdsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetMatchingAccountIdsResponse>(null as any);
    }

    addFinancialSummary(request: AddFinancialSummaryRequest): Observable<AddFinancialSummaryResponse> {
        let url_ = this.baseUrl + "/Application/AddFinancialSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddFinancialSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddFinancialSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFinancialSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFinancialSummaryResponse>;
        }));
    }

    protected processAddFinancialSummary(response: HttpResponseBase): Observable<AddFinancialSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddFinancialSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddFinancialSummaryResponse>(null as any);
    }

    getFinancialSummary(applicationId?: number | undefined, financialSummaryId?: number | null | undefined): Observable<GetFinancialSummaryResponse> {
        let url_ = this.baseUrl + "/Application/GetFinancialSummary?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        if (financialSummaryId !== undefined && financialSummaryId !== null)
            url_ += "financialSummaryId=" + encodeURIComponent("" + financialSummaryId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFinancialSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFinancialSummaryResponse>;
        }));
    }

    protected processGetFinancialSummary(response: HttpResponseBase): Observable<GetFinancialSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialSummaryResponse>(null as any);
    }

    getFinancialSummaryPreviews(applicationId?: number | undefined): Observable<GetFinancialSummaryPreviewsResponse2> {
        let url_ = this.baseUrl + "/Application/GetFinancialSummaryPreviews?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFinancialSummaryPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFinancialSummaryPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFinancialSummaryPreviewsResponse2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFinancialSummaryPreviewsResponse2>;
        }));
    }

    protected processGetFinancialSummaryPreviews(response: HttpResponseBase): Observable<GetFinancialSummaryPreviewsResponse2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFinancialSummaryPreviewsResponse2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFinancialSummaryPreviewsResponse2>(null as any);
    }

    updateFinancialSummary(request: UpdateFinancialSummaryRequest): Observable<UpdateFinancialSummaryResponse> {
        let url_ = this.baseUrl + "/Application/UpdateFinancialSummary";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateFinancialSummary(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateFinancialSummary(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFinancialSummaryResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFinancialSummaryResponse>;
        }));
    }

    protected processUpdateFinancialSummary(response: HttpResponseBase): Observable<UpdateFinancialSummaryResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFinancialSummaryResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFinancialSummaryResponse>(null as any);
    }

    getMakePlanPreviews(applicationId?: number | undefined): Observable<MakePlanResponse> {
        let url_ = this.baseUrl + "/Application/GetMakePlanPreviews?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMakePlanPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMakePlanPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MakePlanResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MakePlanResponse>;
        }));
    }

    protected processGetMakePlanPreviews(response: HttpResponseBase): Observable<MakePlanResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MakePlanResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MakePlanResponse>(null as any);
    }

    deleteApplication(applicationId?: number | undefined): Observable<DeleteApplicationResponse> {
        let url_ = this.baseUrl + "/Application/DeleteApplication?";
        if (applicationId === null)
            throw new globalThis.Error("The parameter 'applicationId' cannot be null.");
        else if (applicationId !== undefined)
            url_ += "applicationId=" + encodeURIComponent("" + applicationId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteApplicationResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteApplicationResponse>;
        }));
    }

    protected processDeleteApplication(response: HttpResponseBase): Observable<DeleteApplicationResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteApplicationResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteApplicationResponse>(null as any);
    }

    getApplicationSemestersPreview(financialSummaryId?: number | null | undefined, accountMainsId?: number | null | undefined): Observable<GetApplicationAccountSemestersResponse> {
        let url_ = this.baseUrl + "/Application/GetApplicationSemestersPreview?";
        if (financialSummaryId !== undefined && financialSummaryId !== null)
            url_ += "financialSummaryId=" + encodeURIComponent("" + financialSummaryId) + "&";
        if (accountMainsId !== undefined && accountMainsId !== null)
            url_ += "accountMainsId=" + encodeURIComponent("" + accountMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetApplicationSemestersPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetApplicationSemestersPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApplicationAccountSemestersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApplicationAccountSemestersResponse>;
        }));
    }

    protected processGetApplicationSemestersPreview(response: HttpResponseBase): Observable<GetApplicationAccountSemestersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApplicationAccountSemestersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApplicationAccountSemestersResponse>(null as any);
    }
}

export interface IBaseYearAccountJournalClient {
    downloadJournalEntryLineReplacementFile(semester?: string | null | undefined, planType?: string | null | undefined): Observable<FileResponse>;
    downloadImportAccountingJournalFile(semester?: string | null | undefined, planType?: string | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class BaseYearAccountJournalClient implements IBaseYearAccountJournalClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    downloadJournalEntryLineReplacementFile(semester?: string | null | undefined, planType?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseYearAccountJournal/DownloadJournalEntryLineReplacementFile?";
        if (semester !== undefined && semester !== null)
            url_ += "semester=" + encodeURIComponent("" + semester) + "&";
        if (planType !== undefined && planType !== null)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadJournalEntryLineReplacementFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadJournalEntryLineReplacementFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadJournalEntryLineReplacementFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    downloadImportAccountingJournalFile(semester?: string | null | undefined, planType?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/BaseYearAccountJournal/DownloadImportAccountingJournalFile?";
        if (semester !== undefined && semester !== null)
            url_ += "semester=" + encodeURIComponent("" + semester) + "&";
        if (planType !== undefined && planType !== null)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadImportAccountingJournalFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadImportAccountingJournalFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadImportAccountingJournalFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ICorrespondenceClient {
    getCorrespondenceTypes(): Observable<GetCorrespondenceTypesResponse>;
    getPepAgreements(planType?: string | null | undefined): Observable<GetPepAgreementResponse>;
    getAccountDocuments(accountId?: number | undefined): Observable<GetAccountDocumentsResponse>;
    exportPepAgreement(request: ExportPepAgreementRequest): Observable<ExportPepAgreementResponse>;
    downloadErrorsFile(request: DownloadPepAgreementErrorsFileRequest): Observable<FileResponse>;
    createAccountDocument(accountsMainId?: number | undefined, sentDate?: Date | undefined, documentType?: string | null | undefined, receivedDate?: Date | null | undefined, comments?: string | null | undefined, file?: FileParameter | null | undefined): Observable<CreateAccountDocumentResponse>;
    updateAccountDocument(id?: number | undefined, accountsMainId?: number | undefined, sentDate?: Date | undefined, documentType?: string | null | undefined, receivedDate?: Date | null | undefined, comments?: string | null | undefined, file?: FileParameter | null | undefined, removeFile?: boolean | undefined): Observable<UpdateAccountDocumentResponse>;
    deleteCorrespondence(id?: number | undefined): Observable<DeleteCorrespondenceResponse>;
    downloadAccountDocument(id?: number | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CorrespondenceClient implements ICorrespondenceClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getCorrespondenceTypes(): Observable<GetCorrespondenceTypesResponse> {
        let url_ = this.baseUrl + "/Correspondence/GetCorrespondenceTypes";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCorrespondenceTypes(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCorrespondenceTypes(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCorrespondenceTypesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCorrespondenceTypesResponse>;
        }));
    }

    protected processGetCorrespondenceTypes(response: HttpResponseBase): Observable<GetCorrespondenceTypesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCorrespondenceTypesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCorrespondenceTypesResponse>(null as any);
    }

    getPepAgreements(planType?: string | null | undefined): Observable<GetPepAgreementResponse> {
        let url_ = this.baseUrl + "/Correspondence/GetPepAgreements?";
        if (planType !== undefined && planType !== null)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPepAgreements(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPepAgreements(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPepAgreementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPepAgreementResponse>;
        }));
    }

    protected processGetPepAgreements(response: HttpResponseBase): Observable<GetPepAgreementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPepAgreementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPepAgreementResponse>(null as any);
    }

    getAccountDocuments(accountId?: number | undefined): Observable<GetAccountDocumentsResponse> {
        let url_ = this.baseUrl + "/Correspondence/GetAccountDocuments?";
        if (accountId === null)
            throw new globalThis.Error("The parameter 'accountId' cannot be null.");
        else if (accountId !== undefined)
            url_ += "accountId=" + encodeURIComponent("" + accountId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAccountDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAccountDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAccountDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAccountDocumentsResponse>;
        }));
    }

    protected processGetAccountDocuments(response: HttpResponseBase): Observable<GetAccountDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAccountDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAccountDocumentsResponse>(null as any);
    }

    exportPepAgreement(request: ExportPepAgreementRequest): Observable<ExportPepAgreementResponse> {
        let url_ = this.baseUrl + "/Correspondence/ExportPepAgreement";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExportPepAgreement(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExportPepAgreement(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ExportPepAgreementResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ExportPepAgreementResponse>;
        }));
    }

    protected processExportPepAgreement(response: HttpResponseBase): Observable<ExportPepAgreementResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ExportPepAgreementResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ExportPepAgreementResponse>(null as any);
    }

    downloadErrorsFile(request: DownloadPepAgreementErrorsFileRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Correspondence/DownloadErrorsFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadErrorsFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadErrorsFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadErrorsFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    createAccountDocument(accountsMainId?: number | undefined, sentDate?: Date | undefined, documentType?: string | null | undefined, receivedDate?: Date | null | undefined, comments?: string | null | undefined, file?: FileParameter | null | undefined): Observable<CreateAccountDocumentResponse> {
        let url_ = this.baseUrl + "/Correspondence/CreateAccountDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (accountsMainId === null || accountsMainId === undefined)
            throw new globalThis.Error("The parameter 'accountsMainId' cannot be null.");
        else
            content_.append("AccountsMainId", accountsMainId.toString());
        if (sentDate === null || sentDate === undefined)
            throw new globalThis.Error("The parameter 'sentDate' cannot be null.");
        else
            content_.append("SentDate", sentDate.toJSON());
        if (documentType !== null && documentType !== undefined)
            content_.append("DocumentType", documentType.toString());
        if (receivedDate !== null && receivedDate !== undefined)
            content_.append("ReceivedDate", receivedDate.toJSON());
        if (comments !== null && comments !== undefined)
            content_.append("Comments", comments.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateAccountDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateAccountDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateAccountDocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateAccountDocumentResponse>;
        }));
    }

    protected processCreateAccountDocument(response: HttpResponseBase): Observable<CreateAccountDocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateAccountDocumentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateAccountDocumentResponse>(null as any);
    }

    updateAccountDocument(id?: number | undefined, accountsMainId?: number | undefined, sentDate?: Date | undefined, documentType?: string | null | undefined, receivedDate?: Date | null | undefined, comments?: string | null | undefined, file?: FileParameter | null | undefined, removeFile?: boolean | undefined): Observable<UpdateAccountDocumentResponse> {
        let url_ = this.baseUrl + "/Correspondence/UpdateAccountDocument";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (id === null || id === undefined)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else
            content_.append("Id", id.toString());
        if (accountsMainId === null || accountsMainId === undefined)
            throw new globalThis.Error("The parameter 'accountsMainId' cannot be null.");
        else
            content_.append("AccountsMainId", accountsMainId.toString());
        if (sentDate === null || sentDate === undefined)
            throw new globalThis.Error("The parameter 'sentDate' cannot be null.");
        else
            content_.append("SentDate", sentDate.toJSON());
        if (documentType !== null && documentType !== undefined)
            content_.append("DocumentType", documentType.toString());
        if (receivedDate !== null && receivedDate !== undefined)
            content_.append("ReceivedDate", receivedDate.toJSON());
        if (comments !== null && comments !== undefined)
            content_.append("Comments", comments.toString());
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (removeFile === null || removeFile === undefined)
            throw new globalThis.Error("The parameter 'removeFile' cannot be null.");
        else
            content_.append("RemoveFile", removeFile.toString());

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateAccountDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateAccountDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateAccountDocumentResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateAccountDocumentResponse>;
        }));
    }

    protected processUpdateAccountDocument(response: HttpResponseBase): Observable<UpdateAccountDocumentResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateAccountDocumentResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateAccountDocumentResponse>(null as any);
    }

    deleteCorrespondence(id?: number | undefined): Observable<DeleteCorrespondenceResponse> {
        let url_ = this.baseUrl + "/Correspondence/DeleteCorrespondence?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteCorrespondence(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteCorrespondence(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteCorrespondenceResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteCorrespondenceResponse>;
        }));
    }

    protected processDeleteCorrespondence(response: HttpResponseBase): Observable<DeleteCorrespondenceResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteCorrespondenceResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteCorrespondenceResponse>(null as any);
    }

    downloadAccountDocument(id?: number | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Correspondence/DownloadAccountDocument?";
        if (id === null)
            throw new globalThis.Error("The parameter 'id' cannot be null.");
        else if (id !== undefined)
            url_ += "id=" + encodeURIComponent("" + id) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadAccountDocument(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadAccountDocument(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadAccountDocument(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface ICostClient {
    get(fiscalYearId?: number | null | undefined): Observable<GetCostsResponse>;
    add(request: AddCostsRequest): Observable<AddCostsResponse>;
    updateByFiscalYear(request: UpdateCostsByFiscalYearRequest): Observable<UpdateCostsByFiscalYearResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CostClient implements ICostClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(fiscalYearId?: number | null | undefined): Observable<GetCostsResponse> {
        let url_ = this.baseUrl + "/Cost?";
        if (fiscalYearId !== undefined && fiscalYearId !== null)
            url_ += "fiscalYearId=" + encodeURIComponent("" + fiscalYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCostsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCostsResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetCostsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCostsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCostsResponse>(null as any);
    }

    add(request: AddCostsRequest): Observable<AddCostsResponse> {
        let url_ = this.baseUrl + "/Cost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddCostsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddCostsResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddCostsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddCostsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddCostsResponse>(null as any);
    }

    updateByFiscalYear(request: UpdateCostsByFiscalYearRequest): Observable<UpdateCostsByFiscalYearResponse> {
        let url_ = this.baseUrl + "/Cost";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateByFiscalYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateByFiscalYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateCostsByFiscalYearResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateCostsByFiscalYearResponse>;
        }));
    }

    protected processUpdateByFiscalYear(response: HttpResponseBase): Observable<UpdateCostsByFiscalYearResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateCostsByFiscalYearResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateCostsByFiscalYearResponse>(null as any);
    }
}

export interface ICustomerInvoiceEIBClient {
    downloadInvoiceTab1File(semester?: string | null | undefined, planType?: string | null | undefined): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class CustomerInvoiceEIBClient implements ICustomerInvoiceEIBClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    downloadInvoiceTab1File(semester?: string | null | undefined, planType?: string | null | undefined): Observable<FileResponse> {
        let url_ = this.baseUrl + "/CustomerInvoiceEIB/DownloadInvoiceTab1File?";
        if (semester !== undefined && semester !== null)
            url_ += "semester=" + encodeURIComponent("" + semester) + "&";
        if (planType !== undefined && planType !== null)
            url_ += "planType=" + encodeURIComponent("" + planType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadInvoiceTab1File(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadInvoiceTab1File(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadInvoiceTab1File(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IEmployeeClient {
    get(firstName?: string | null | undefined, lastName?: string | null | undefined, employeeId?: string | null | undefined): Observable<GetEmployeesResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class EmployeeClient implements IEmployeeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(firstName?: string | null | undefined, lastName?: string | null | undefined, employeeId?: string | null | undefined): Observable<GetEmployeesResponse> {
        let url_ = this.baseUrl + "/Employee?";
        if (firstName !== undefined && firstName !== null)
            url_ += "firstName=" + encodeURIComponent("" + firstName) + "&";
        if (lastName !== undefined && lastName !== null)
            url_ += "lastName=" + encodeURIComponent("" + lastName) + "&";
        if (employeeId !== undefined && employeeId !== null)
            url_ += "employeeId=" + encodeURIComponent("" + employeeId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetEmployeesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetEmployeesResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetEmployeesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetEmployeesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetEmployeesResponse>(null as any);
    }
}

export interface IExportClient {
    export(request: ExportRequest): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ExportClient implements IExportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    export(request: ExportRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Export/Export";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processExport(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processExport(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processExport(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IFiscalYearClient {
    get(): Observable<GetFiscalYearsResponse>;
    update(request: UpdateFiscalYearsRequest): Observable<UpdateFiscalYearsResponse>;
    add(request: AddFiscalYearRequest): Observable<AddFiscalYearResponse>;
    delete(request: DeleteFiscalYearRequest): Observable<DeleteFiscalYearResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class FiscalYearClient implements IFiscalYearClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(): Observable<GetFiscalYearsResponse> {
        let url_ = this.baseUrl + "/FiscalYear";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFiscalYearsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFiscalYearsResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetFiscalYearsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFiscalYearsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFiscalYearsResponse>(null as any);
    }

    update(request: UpdateFiscalYearsRequest): Observable<UpdateFiscalYearsResponse> {
        let url_ = this.baseUrl + "/FiscalYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateFiscalYearsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateFiscalYearsResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateFiscalYearsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateFiscalYearsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateFiscalYearsResponse>(null as any);
    }

    add(request: AddFiscalYearRequest): Observable<AddFiscalYearResponse> {
        let url_ = this.baseUrl + "/FiscalYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddFiscalYearResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddFiscalYearResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddFiscalYearResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddFiscalYearResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddFiscalYearResponse>(null as any);
    }

    delete(request: DeleteFiscalYearRequest): Observable<DeleteFiscalYearResponse> {
        let url_ = this.baseUrl + "/FiscalYear";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteFiscalYearResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteFiscalYearResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteFiscalYearResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteFiscalYearResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteFiscalYearResponse>(null as any);
    }
}

export interface IPersonClient {
    getSsn(personRootId?: number | undefined, personType?: string | null | undefined): Observable<GetPersonSsnResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PersonClient implements IPersonClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getSsn(personRootId?: number | undefined, personType?: string | null | undefined): Observable<GetPersonSsnResponse> {
        let url_ = this.baseUrl + "/Person/GetSsn?";
        if (personRootId === null)
            throw new globalThis.Error("The parameter 'personRootId' cannot be null.");
        else if (personRootId !== undefined)
            url_ += "personRootId=" + encodeURIComponent("" + personRootId) + "&";
        if (personType !== undefined && personType !== null)
            url_ += "personType=" + encodeURIComponent("" + personType) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPersonSsnResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPersonSsnResponse>;
        }));
    }

    protected processGetSsn(response: HttpResponseBase): Observable<GetPersonSsnResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPersonSsnResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPersonSsnResponse>(null as any);
    }
}

export interface IPlanReductionClient {
    addPlanReduction(request: AddPlanReductionRequest): Observable<AddPlanReductionResponse>;
    getPlanReductions(accountsMainsId?: number | undefined): Observable<GetPlanReductionsResponse>;
    updatePlanReduction(request: UpdatePlanReductionRequest): Observable<UpdatePlanReductionResponse>;
    deletePlanReduction(reductionId?: number | undefined): Observable<DeletePlanReductionResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PlanReductionClient implements IPlanReductionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    addPlanReduction(request: AddPlanReductionRequest): Observable<AddPlanReductionResponse> {
        let url_ = this.baseUrl + "/PlanReduction/AddPlanReduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPlanReduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPlanReduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddPlanReductionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddPlanReductionResponse>;
        }));
    }

    protected processAddPlanReduction(response: HttpResponseBase): Observable<AddPlanReductionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPlanReductionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPlanReductionResponse>(null as any);
    }

    getPlanReductions(accountsMainsId?: number | undefined): Observable<GetPlanReductionsResponse> {
        let url_ = this.baseUrl + "/PlanReduction/GetPlanReductions?";
        if (accountsMainsId === null)
            throw new globalThis.Error("The parameter 'accountsMainsId' cannot be null.");
        else if (accountsMainsId !== undefined)
            url_ += "accountsMainsId=" + encodeURIComponent("" + accountsMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPlanReductions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPlanReductions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPlanReductionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPlanReductionsResponse>;
        }));
    }

    protected processGetPlanReductions(response: HttpResponseBase): Observable<GetPlanReductionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPlanReductionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPlanReductionsResponse>(null as any);
    }

    updatePlanReduction(request: UpdatePlanReductionRequest): Observable<UpdatePlanReductionResponse> {
        let url_ = this.baseUrl + "/PlanReduction/UpdatePlanReduction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePlanReduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePlanReduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePlanReductionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePlanReductionResponse>;
        }));
    }

    protected processUpdatePlanReduction(response: HttpResponseBase): Observable<UpdatePlanReductionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePlanReductionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePlanReductionResponse>(null as any);
    }

    deletePlanReduction(reductionId?: number | undefined): Observable<DeletePlanReductionResponse> {
        let url_ = this.baseUrl + "/PlanReduction/DeletePlanReduction?";
        if (reductionId === null)
            throw new globalThis.Error("The parameter 'reductionId' cannot be null.");
        else if (reductionId !== undefined)
            url_ += "reductionId=" + encodeURIComponent("" + reductionId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePlanReduction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePlanReduction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePlanReductionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePlanReductionResponse>;
        }));
    }

    protected processDeletePlanReduction(response: HttpResponseBase): Observable<DeletePlanReductionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePlanReductionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePlanReductionResponse>(null as any);
    }
}

export interface IPrepaymentTrackingClient {
    addPrepaymentRecord(request: AddPrepaymentRecordRequest): Observable<AddPrepaymentRecordResponse>;
    getPrepaymentRecords(accountsMainsId?: number | undefined): Observable<GetPrepaymentRecordsResponse>;
    updatePrepaymentRecord(request: UpdatePrepaymentRecordRequest): Observable<UpdatePrepaymentRecordResponse>;
    deletePrepaymentRecord(accountsMainsId?: number | undefined, prepaymentRecordId?: number | undefined): Observable<DeletePrepaymentRecordResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PrepaymentTrackingClient implements IPrepaymentTrackingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    addPrepaymentRecord(request: AddPrepaymentRecordRequest): Observable<AddPrepaymentRecordResponse> {
        let url_ = this.baseUrl + "/PrepaymentTracking/AddPrepaymentRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddPrepaymentRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddPrepaymentRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddPrepaymentRecordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddPrepaymentRecordResponse>;
        }));
    }

    protected processAddPrepaymentRecord(response: HttpResponseBase): Observable<AddPrepaymentRecordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddPrepaymentRecordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddPrepaymentRecordResponse>(null as any);
    }

    getPrepaymentRecords(accountsMainsId?: number | undefined): Observable<GetPrepaymentRecordsResponse> {
        let url_ = this.baseUrl + "/PrepaymentTracking/GetPrepaymentRecords?";
        if (accountsMainsId === null)
            throw new globalThis.Error("The parameter 'accountsMainsId' cannot be null.");
        else if (accountsMainsId !== undefined)
            url_ += "accountsMainsId=" + encodeURIComponent("" + accountsMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPrepaymentRecords(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPrepaymentRecords(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPrepaymentRecordsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPrepaymentRecordsResponse>;
        }));
    }

    protected processGetPrepaymentRecords(response: HttpResponseBase): Observable<GetPrepaymentRecordsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPrepaymentRecordsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPrepaymentRecordsResponse>(null as any);
    }

    updatePrepaymentRecord(request: UpdatePrepaymentRecordRequest): Observable<UpdatePrepaymentRecordResponse> {
        let url_ = this.baseUrl + "/PrepaymentTracking/UpdatePrepaymentRecord";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdatePrepaymentRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdatePrepaymentRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdatePrepaymentRecordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdatePrepaymentRecordResponse>;
        }));
    }

    protected processUpdatePrepaymentRecord(response: HttpResponseBase): Observable<UpdatePrepaymentRecordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdatePrepaymentRecordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdatePrepaymentRecordResponse>(null as any);
    }

    deletePrepaymentRecord(accountsMainsId?: number | undefined, prepaymentRecordId?: number | undefined): Observable<DeletePrepaymentRecordResponse> {
        let url_ = this.baseUrl + "/PrepaymentTracking/DeletePrepaymentRecord?";
        if (accountsMainsId === null)
            throw new globalThis.Error("The parameter 'accountsMainsId' cannot be null.");
        else if (accountsMainsId !== undefined)
            url_ += "accountsMainsId=" + encodeURIComponent("" + accountsMainsId) + "&";
        if (prepaymentRecordId === null)
            throw new globalThis.Error("The parameter 'prepaymentRecordId' cannot be null.");
        else if (prepaymentRecordId !== undefined)
            url_ += "prepaymentRecordId=" + encodeURIComponent("" + prepaymentRecordId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeletePrepaymentRecord(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeletePrepaymentRecord(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeletePrepaymentRecordResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeletePrepaymentRecordResponse>;
        }));
    }

    protected processDeletePrepaymentRecord(response: HttpResponseBase): Observable<DeletePrepaymentRecordResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeletePrepaymentRecordResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeletePrepaymentRecordResponse>(null as any);
    }
}

export interface IProgramTermsClient {
    get(fiscalYearId?: number | null | undefined): Observable<GetProgramTermsResponse>;
    update(request: UpdateProgramTermsRequest): Observable<UpdateProgramTermsResponse>;
    create(request: CreateProgramTermsRequest): Observable<CreateProgramTermsResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ProgramTermsClient implements IProgramTermsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(fiscalYearId?: number | null | undefined): Observable<GetProgramTermsResponse> {
        let url_ = this.baseUrl + "/ProgramTerms?";
        if (fiscalYearId !== undefined && fiscalYearId !== null)
            url_ += "fiscalYearId=" + encodeURIComponent("" + fiscalYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramTermsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramTermsResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetProgramTermsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProgramTermsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramTermsResponse>(null as any);
    }

    update(request: UpdateProgramTermsRequest): Observable<UpdateProgramTermsResponse> {
        let url_ = this.baseUrl + "/ProgramTerms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateProgramTermsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateProgramTermsResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateProgramTermsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateProgramTermsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateProgramTermsResponse>(null as any);
    }

    create(request: CreateProgramTermsRequest): Observable<CreateProgramTermsResponse> {
        let url_ = this.baseUrl + "/ProgramTerms";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateProgramTermsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateProgramTermsResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateProgramTermsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateProgramTermsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateProgramTermsResponse>(null as any);
    }
}

export interface IRiskGradingClient {
    get(planType?: string | null | undefined): Observable<GetRiskGradingsResponse>;
    update(request: UpdateRiskGradingsRequest): Observable<UpdateRiskGradingsResponse>;
    calculateRiskRanking(request: CalculateRiskRankingRequest): Observable<CalculateRiskRankingResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RiskGradingClient implements IRiskGradingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(planType?: string | null | undefined): Observable<GetRiskGradingsResponse> {
        let url_ = this.baseUrl + "/RiskGrading";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "planType": planType !== undefined && planType !== null ? "" + planType : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRiskGradingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRiskGradingsResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRiskGradingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRiskGradingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRiskGradingsResponse>(null as any);
    }

    update(request: UpdateRiskGradingsRequest): Observable<UpdateRiskGradingsResponse> {
        let url_ = this.baseUrl + "/RiskGrading";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateRiskGradingsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateRiskGradingsResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateRiskGradingsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRiskGradingsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateRiskGradingsResponse>(null as any);
    }

    calculateRiskRanking(request: CalculateRiskRankingRequest): Observable<CalculateRiskRankingResponse> {
        let url_ = this.baseUrl + "/RiskGrading/CalculateRiskRanking";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCalculateRiskRanking(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCalculateRiskRanking(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CalculateRiskRankingResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CalculateRiskRankingResponse>;
        }));
    }

    protected processCalculateRiskRanking(response: HttpResponseBase): Observable<CalculateRiskRankingResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CalculateRiskRankingResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CalculateRiskRankingResponse>(null as any);
    }
}

export interface IRoleClient {
    get(): Observable<GetRolesResponse>;
    getPermissions(): Observable<GetPermissionsResponse>;
    update(request: UpdateRoleRequest): Observable<UpdateRoleResponse>;
    add(request: AddRoleRequest): Observable<AddRoleResponse>;
    delete(id?: number | undefined): Observable<DeleteRoleResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class RoleClient implements IRoleClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(): Observable<GetRolesResponse> {
        let url_ = this.baseUrl + "/Role";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRolesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRolesResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetRolesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRolesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRolesResponse>(null as any);
    }

    getPermissions(): Observable<GetPermissionsResponse> {
        let url_ = this.baseUrl + "/Role/GetPermissions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetPermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetPermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetPermissionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetPermissionsResponse>;
        }));
    }

    protected processGetPermissions(response: HttpResponseBase): Observable<GetPermissionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetPermissionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetPermissionsResponse>(null as any);
    }

    update(request: UpdateRoleRequest): Observable<UpdateRoleResponse> {
        let url_ = this.baseUrl + "/Role/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateRoleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateRoleResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateRoleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateRoleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateRoleResponse>(null as any);
    }

    add(request: AddRoleRequest): Observable<AddRoleResponse> {
        let url_ = this.baseUrl + "/Role/Add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAdd(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAdd(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddRoleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddRoleResponse>;
        }));
    }

    protected processAdd(response: HttpResponseBase): Observable<AddRoleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddRoleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddRoleResponse>(null as any);
    }

    delete(id?: number | undefined): Observable<DeleteRoleResponse> {
        let url_ = this.baseUrl + "/Role/Delete";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "id": id !== undefined && id !== null ? "" + id : "",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DeleteRoleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DeleteRoleResponse>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DeleteRoleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DeleteRoleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<DeleteRoleResponse>(null as any);
    }
}

export interface ISearchClient {
    searchPeople(request: SearchApplicantRequest): Observable<SearchApplicantResponse>;
    searchApplicationsAccounts(request: SearchApplicationAccountRequest): Observable<SearchApplicationAccountResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SearchClient implements ISearchClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    searchPeople(request: SearchApplicantRequest): Observable<SearchApplicantResponse> {
        let url_ = this.baseUrl + "/Search/SearchPeople";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchPeople(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchPeople(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchApplicantResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchApplicantResponse>;
        }));
    }

    protected processSearchPeople(response: HttpResponseBase): Observable<SearchApplicantResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchApplicantResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchApplicantResponse>(null as any);
    }

    searchApplicationsAccounts(request: SearchApplicationAccountRequest): Observable<SearchApplicationAccountResponse> {
        let url_ = this.baseUrl + "/Search/SearchApplicationsAccounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSearchApplicationsAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSearchApplicationsAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SearchApplicationAccountResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SearchApplicationAccountResponse>;
        }));
    }

    protected processSearchApplicationsAccounts(response: HttpResponseBase): Observable<SearchApplicationAccountResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SearchApplicationAccountResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SearchApplicationAccountResponse>(null as any);
    }
}

export interface ISemesterClient {
    getByFiscalYear(fiscalYear?: number | undefined): Observable<GetSemestersByFiscalYearResponse>;
    getOptions(): Observable<GetSemesterOptionsResponse>;
    get(): Observable<GetSemestersResponse>;
    update(request: UpdateSemestersRequest): Observable<UpdateSemestersResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class SemesterClient implements ISemesterClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getByFiscalYear(fiscalYear?: number | undefined): Observable<GetSemestersByFiscalYearResponse> {
        let url_ = this.baseUrl + "/Semester/GetByFiscalYear?";
        if (fiscalYear === null)
            throw new globalThis.Error("The parameter 'fiscalYear' cannot be null.");
        else if (fiscalYear !== undefined)
            url_ += "fiscalYear=" + encodeURIComponent("" + fiscalYear) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetByFiscalYear(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetByFiscalYear(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSemestersByFiscalYearResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSemestersByFiscalYearResponse>;
        }));
    }

    protected processGetByFiscalYear(response: HttpResponseBase): Observable<GetSemestersByFiscalYearResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSemestersByFiscalYearResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSemestersByFiscalYearResponse>(null as any);
    }

    getOptions(): Observable<GetSemesterOptionsResponse> {
        let url_ = this.baseUrl + "/Semester/GetOptions";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOptions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOptions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSemesterOptionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSemesterOptionsResponse>;
        }));
    }

    protected processGetOptions(response: HttpResponseBase): Observable<GetSemesterOptionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSemesterOptionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSemesterOptionsResponse>(null as any);
    }

    get(): Observable<GetSemestersResponse> {
        let url_ = this.baseUrl + "/Semester/Get";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetSemestersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetSemestersResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetSemestersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetSemestersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetSemestersResponse>(null as any);
    }

    update(request: UpdateSemestersRequest): Observable<UpdateSemestersResponse> {
        let url_ = this.baseUrl + "/Semester/Update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateSemestersResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateSemestersResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateSemestersResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateSemestersResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 409) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result409: any = null;
            let resultData409 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result409 = ApiError.fromJS(resultData409);
            return throwException("A server side error occurred.", status, _responseText, _headers, result409);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateSemestersResponse>(null as any);
    }
}

export interface IStudentAccountingClient {
    prepareAccountTransactions(request: AddStudentAccountTransactionsRequest): Observable<AddStudentAccountTransactionsResponse>;
    downloadFile(request: DownloadResultsFileRequest): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class StudentAccountingClient implements IStudentAccountingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    prepareAccountTransactions(request: AddStudentAccountTransactionsRequest): Observable<AddStudentAccountTransactionsResponse> {
        let url_ = this.baseUrl + "/StudentAccounting/PrepareAccountTransactions";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processPrepareAccountTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processPrepareAccountTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddStudentAccountTransactionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddStudentAccountTransactionsResponse>;
        }));
    }

    protected processPrepareAccountTransactions(response: HttpResponseBase): Observable<AddStudentAccountTransactionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddStudentAccountTransactionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddStudentAccountTransactionsResponse>(null as any);
    }

    downloadFile(request: DownloadResultsFileRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/StudentAccounting/DownloadFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFile(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export interface IStudentClient {
    getStudentPreview(studentId?: number | undefined): Observable<GetStudentPreviewResponse>;
    matchSisId(studentId: number, isApplication?: boolean | undefined): Observable<MatchStudentSisIdResponse>;
    manualMatchSisId(studentId: number, request: ManualMatchStudentSisIdRequest): Observable<ManualMatchStudentSisIdResponse>;
    updateSsn(studentId: number, request: UpdateStudentSsnRequest): Observable<UpdateStudentSsnResponse>;
    updateStudentLastName(studentId: number, request: UpdateStudentLastNameRequest): Observable<UpdateStudentLastNameResponse>;
    updateStudentBirthdate(studentId: number, request: UpdateStudentBirthdateRequest): Observable<UpdateStudentBirthdateResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class StudentClient implements IStudentClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getStudentPreview(studentId?: number | undefined): Observable<GetStudentPreviewResponse> {
        let url_ = this.baseUrl + "/Student/GetStudentPreview?";
        if (studentId === null)
            throw new globalThis.Error("The parameter 'studentId' cannot be null.");
        else if (studentId !== undefined)
            url_ += "studentId=" + encodeURIComponent("" + studentId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetStudentPreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetStudentPreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetStudentPreviewResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetStudentPreviewResponse>;
        }));
    }

    protected processGetStudentPreview(response: HttpResponseBase): Observable<GetStudentPreviewResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetStudentPreviewResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetStudentPreviewResponse>(null as any);
    }

    matchSisId(studentId: number, isApplication?: boolean | undefined): Observable<MatchStudentSisIdResponse> {
        let url_ = this.baseUrl + "/Student/{studentId}/MatchSisId?";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        if (isApplication === null)
            throw new globalThis.Error("The parameter 'isApplication' cannot be null.");
        else if (isApplication !== undefined)
            url_ += "isApplication=" + encodeURIComponent("" + isApplication) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processMatchSisId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processMatchSisId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MatchStudentSisIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MatchStudentSisIdResponse>;
        }));
    }

    protected processMatchSisId(response: HttpResponseBase): Observable<MatchStudentSisIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MatchStudentSisIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<MatchStudentSisIdResponse>(null as any);
    }

    manualMatchSisId(studentId: number, request: ManualMatchStudentSisIdRequest): Observable<ManualMatchStudentSisIdResponse> {
        let url_ = this.baseUrl + "/Student/{studentId}/ManualMatchSisId";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processManualMatchSisId(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processManualMatchSisId(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ManualMatchStudentSisIdResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ManualMatchStudentSisIdResponse>;
        }));
    }

    protected processManualMatchSisId(response: HttpResponseBase): Observable<ManualMatchStudentSisIdResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ManualMatchStudentSisIdResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<ManualMatchStudentSisIdResponse>(null as any);
    }

    updateSsn(studentId: number, request: UpdateStudentSsnRequest): Observable<UpdateStudentSsnResponse> {
        let url_ = this.baseUrl + "/Student/{studentId}/UpdateSsn";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateSsn(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateSsn(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateStudentSsnResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateStudentSsnResponse>;
        }));
    }

    protected processUpdateSsn(response: HttpResponseBase): Observable<UpdateStudentSsnResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateStudentSsnResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateStudentSsnResponse>(null as any);
    }

    updateStudentLastName(studentId: number, request: UpdateStudentLastNameRequest): Observable<UpdateStudentLastNameResponse> {
        let url_ = this.baseUrl + "/Student/{studentId}/UpdateStudentLastName";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStudentLastName(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStudentLastName(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateStudentLastNameResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateStudentLastNameResponse>;
        }));
    }

    protected processUpdateStudentLastName(response: HttpResponseBase): Observable<UpdateStudentLastNameResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateStudentLastNameResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateStudentLastNameResponse>(null as any);
    }

    updateStudentBirthdate(studentId: number, request: UpdateStudentBirthdateRequest): Observable<UpdateStudentBirthdateResponse> {
        let url_ = this.baseUrl + "/Student/{studentId}/UpdateStudentBirthdate";
        if (studentId === undefined || studentId === null)
            throw new globalThis.Error("The parameter 'studentId' must be defined.");
        url_ = url_.replace("{studentId}", encodeURIComponent("" + studentId));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateStudentBirthdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateStudentBirthdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateStudentBirthdateResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateStudentBirthdateResponse>;
        }));
    }

    protected processUpdateStudentBirthdate(response: HttpResponseBase): Observable<UpdateStudentBirthdateResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateStudentBirthdateResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateStudentBirthdateResponse>(null as any);
    }
}

export interface ITransactionCodeClient {
    create(request: CreateTransactionCodesRequest): Observable<CreateTransactionCodesResponse>;
    get(fiscalYearId?: number | undefined): Observable<GetTransactionCodesResponse>;
    update(request: UpdateTransactionCodesRequest): Observable<UpdateTransactionCodesResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TransactionCodeClient implements ITransactionCodeClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    create(request: CreateTransactionCodesRequest): Observable<CreateTransactionCodesResponse> {
        let url_ = this.baseUrl + "/TransactionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CreateTransactionCodesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CreateTransactionCodesResponse>;
        }));
    }

    protected processCreate(response: HttpResponseBase): Observable<CreateTransactionCodesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CreateTransactionCodesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<CreateTransactionCodesResponse>(null as any);
    }

    get(fiscalYearId?: number | undefined): Observable<GetTransactionCodesResponse> {
        let url_ = this.baseUrl + "/TransactionCode?";
        if (fiscalYearId === null)
            throw new globalThis.Error("The parameter 'fiscalYearId' cannot be null.");
        else if (fiscalYearId !== undefined)
            url_ += "fiscalYearId=" + encodeURIComponent("" + fiscalYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionCodesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionCodesResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTransactionCodesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionCodesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionCodesResponse>(null as any);
    }

    update(request: UpdateTransactionCodesRequest): Observable<UpdateTransactionCodesResponse> {
        let url_ = this.baseUrl + "/TransactionCode";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTransactionCodesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTransactionCodesResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateTransactionCodesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTransactionCodesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTransactionCodesResponse>(null as any);
    }
}

export interface ITransactionCodesClient {
    get(fiscalYear: number): Observable<GetTransactionCodesResponse>;
    update(fiscalYear: number, updateTransactionCodesRequest: UpdateTransactionCodesRequest): Observable<UpdateTransactionCodesResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TransactionCodesClient implements ITransactionCodesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(fiscalYear: number): Observable<GetTransactionCodesResponse> {
        let url_ = this.baseUrl + "/TransactionCodes/{fiscalYear}";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new globalThis.Error("The parameter 'fiscalYear' must be defined.");
        url_ = url_.replace("{fiscalYear}", encodeURIComponent("" + fiscalYear));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionCodesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionCodesResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetTransactionCodesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionCodesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionCodesResponse>(null as any);
    }

    update(fiscalYear: number, updateTransactionCodesRequest: UpdateTransactionCodesRequest): Observable<UpdateTransactionCodesResponse> {
        let url_ = this.baseUrl + "/TransactionCodes/{fiscalYear}";
        if (fiscalYear === undefined || fiscalYear === null)
            throw new globalThis.Error("The parameter 'fiscalYear' must be defined.");
        url_ = url_.replace("{fiscalYear}", encodeURIComponent("" + fiscalYear));
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(updateTransactionCodesRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateTransactionCodesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateTransactionCodesResponse>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<UpdateTransactionCodesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateTransactionCodesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateTransactionCodesResponse>(null as any);
    }
}

export interface ITransactionClient {
    getTransactions(accountsMainsId?: number | undefined): Observable<GetTransactionsResponse>;
    addManualTransaction(request: AddManualTransactionRequest): Observable<AddManualTransactionResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class TransactionClient implements ITransactionClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getTransactions(accountsMainsId?: number | undefined): Observable<GetTransactionsResponse> {
        let url_ = this.baseUrl + "/Transaction/GetTransactions?";
        if (accountsMainsId === null)
            throw new globalThis.Error("The parameter 'accountsMainsId' cannot be null.");
        else if (accountsMainsId !== undefined)
            url_ += "accountsMainsId=" + encodeURIComponent("" + accountsMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetTransactions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetTransactions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetTransactionsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetTransactionsResponse>;
        }));
    }

    protected processGetTransactions(response: HttpResponseBase): Observable<GetTransactionsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetTransactionsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetTransactionsResponse>(null as any);
    }

    addManualTransaction(request: AddManualTransactionRequest): Observable<AddManualTransactionResponse> {
        let url_ = this.baseUrl + "/Transaction";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddManualTransaction(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddManualTransaction(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AddManualTransactionResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AddManualTransactionResponse>;
        }));
    }

    protected processAddManualTransaction(response: HttpResponseBase): Observable<AddManualTransactionResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AddManualTransactionResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<AddManualTransactionResponse>(null as any);
    }
}

export interface IUasOutboundClient {
    getUasOutboundPreviews(beginDate?: Date | undefined, endDate?: Date | undefined): Observable<GetUasOutboundPreviewsResponse>;
    getUasOutboundDetail(accountsMainsId?: number | undefined): Observable<GetUasOutboundDetailResponse>;
    downloadUasOutboundFilePreview(accountsMainsIds: number[]): Observable<FileResponse>;
    sendUasOutboundFile(accountsMainsIds: number[]): Observable<SendUasOutboundFileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UasOutboundClient implements IUasOutboundClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getUasOutboundPreviews(beginDate?: Date | undefined, endDate?: Date | undefined): Observable<GetUasOutboundPreviewsResponse> {
        let url_ = this.baseUrl + "/UasOutbound/GetUasOutboundPreviews?";
        if (beginDate === null)
            throw new globalThis.Error("The parameter 'beginDate' cannot be null.");
        else if (beginDate !== undefined)
            url_ += "beginDate=" + encodeURIComponent(beginDate ? "" + beginDate.toISOString() : "") + "&";
        if (endDate === null)
            throw new globalThis.Error("The parameter 'endDate' cannot be null.");
        else if (endDate !== undefined)
            url_ += "endDate=" + encodeURIComponent(endDate ? "" + endDate.toISOString() : "") + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUasOutboundPreviews(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUasOutboundPreviews(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUasOutboundPreviewsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUasOutboundPreviewsResponse>;
        }));
    }

    protected processGetUasOutboundPreviews(response: HttpResponseBase): Observable<GetUasOutboundPreviewsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUasOutboundPreviewsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUasOutboundPreviewsResponse>(null as any);
    }

    getUasOutboundDetail(accountsMainsId?: number | undefined): Observable<GetUasOutboundDetailResponse> {
        let url_ = this.baseUrl + "/UasOutbound/GetUasOutboundDetail?";
        if (accountsMainsId === null)
            throw new globalThis.Error("The parameter 'accountsMainsId' cannot be null.");
        else if (accountsMainsId !== undefined)
            url_ += "accountsMainsId=" + encodeURIComponent("" + accountsMainsId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUasOutboundDetail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUasOutboundDetail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUasOutboundDetailResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUasOutboundDetailResponse>;
        }));
    }

    protected processGetUasOutboundDetail(response: HttpResponseBase): Observable<GetUasOutboundDetailResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUasOutboundDetailResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUasOutboundDetailResponse>(null as any);
    }

    downloadUasOutboundFilePreview(accountsMainsIds: number[]): Observable<FileResponse> {
        let url_ = this.baseUrl + "/UasOutbound/DownloadUasOutboundFilePreview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountsMainsIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadUasOutboundFilePreview(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadUasOutboundFilePreview(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadUasOutboundFilePreview(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    sendUasOutboundFile(accountsMainsIds: number[]): Observable<SendUasOutboundFileResponse> {
        let url_ = this.baseUrl + "/UasOutbound/SendUasOutboundFile";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(accountsMainsIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendUasOutboundFile(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendUasOutboundFile(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<SendUasOutboundFileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<SendUasOutboundFileResponse>;
        }));
    }

    protected processSendUasOutboundFile(response: HttpResponseBase): Observable<SendUasOutboundFileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = SendUasOutboundFileResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<SendUasOutboundFileResponse>(null as any);
    }
}

export interface IUserClient {
    updateUserFromToken(userFromTokenRequest: UpdateUserFromTokenRequest): Observable<FileResponse>;
    getCurrentUserRolePermissions(): Observable<GetUserClaimsResponse>;
    createUser(addUserRequest: AddUserRequest): Observable<void>;
    getAllUsers(): Observable<GetAllUserClaimsResponse>;
    updateUserRoleAndStatus(request: UpdateUserRoleAndStatusRequest): Observable<UpdateUserRoleAndStatusResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UserClient implements IUserClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    updateUserFromToken(userFromTokenRequest: UpdateUserFromTokenRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(userFromTokenRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserFromToken(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserFromToken(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processUpdateUserFromToken(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    getCurrentUserRolePermissions(): Observable<GetUserClaimsResponse> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserRolePermissions(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserRolePermissions(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUserClaimsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUserClaimsResponse>;
        }));
    }

    protected processGetCurrentUserRolePermissions(response: HttpResponseBase): Observable<GetUserClaimsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUserClaimsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUserClaimsResponse>(null as any);
    }

    createUser(addUserRequest: AddUserRequest): Observable<void> {
        let url_ = this.baseUrl + "/User";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(addUserRequest);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<void>;
                }
            } else
                return _observableThrow(response_) as any as Observable<void>;
        }));
    }

    protected processCreateUser(response: HttpResponseBase): Observable<void> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return _observableOf<void>(null as any);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<void>(null as any);
    }

    getAllUsers(): Observable<GetAllUserClaimsResponse> {
        let url_ = this.baseUrl + "/User/GetAllUsers";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetAllUserClaimsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetAllUserClaimsResponse>;
        }));
    }

    protected processGetAllUsers(response: HttpResponseBase): Observable<GetAllUserClaimsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetAllUserClaimsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetAllUserClaimsResponse>(null as any);
    }

    updateUserRoleAndStatus(request: UpdateUserRoleAndStatusRequest): Observable<UpdateUserRoleAndStatusResponse> {
        let url_ = this.baseUrl + "/User/UpdateUserRoleAndStatus";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUserRoleAndStatus(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUserRoleAndStatus(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUserRoleAndStatusResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUserRoleAndStatusResponse>;
        }));
    }

    protected processUpdateUserRoleAndStatus(response: HttpResponseBase): Observable<UpdateUserRoleAndStatusResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUserRoleAndStatusResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUserRoleAndStatusResponse>(null as any);
    }
}

export interface IUtilityClient {
    get(key?: string | null | undefined): Observable<GetUtilitiesResponse>;
    getMultiple(request: GetUtilitiesMultipleRequest): Observable<GetUtilitiesMultipleResponse>;
    getRoles(): Observable<GetRolesResponse2>;
    updateUtilities(request: UpdateUtilitiesRequest): Observable<UpdateUtilitiesResponse>;
    updateMultipleUtilities(request: UpdateUtilitiesMultipleRequest): Observable<UpdateUtilitiesMultipleResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class UtilityClient implements IUtilityClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    get(key?: string | null | undefined): Observable<GetUtilitiesResponse> {
        let url_ = this.baseUrl + "/Utility?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUtilitiesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUtilitiesResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<GetUtilitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUtilitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUtilitiesResponse>(null as any);
    }

    getMultiple(request: GetUtilitiesMultipleRequest): Observable<GetUtilitiesMultipleResponse> {
        let url_ = this.baseUrl + "/Utility/GetMultiple";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMultiple(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMultiple(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUtilitiesMultipleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUtilitiesMultipleResponse>;
        }));
    }

    protected processGetMultiple(response: HttpResponseBase): Observable<GetUtilitiesMultipleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUtilitiesMultipleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUtilitiesMultipleResponse>(null as any);
    }

    getRoles(): Observable<GetRolesResponse2> {
        let url_ = this.baseUrl + "/Utility/GetRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetRolesResponse2>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetRolesResponse2>;
        }));
    }

    protected processGetRoles(response: HttpResponseBase): Observable<GetRolesResponse2> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetRolesResponse2.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetRolesResponse2>(null as any);
    }

    updateUtilities(request: UpdateUtilitiesRequest): Observable<UpdateUtilitiesResponse> {
        let url_ = this.baseUrl + "/Utility/UpdateUtilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateUtilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateUtilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUtilitiesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUtilitiesResponse>;
        }));
    }

    protected processUpdateUtilities(response: HttpResponseBase): Observable<UpdateUtilitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUtilitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUtilitiesResponse>(null as any);
    }

    updateMultipleUtilities(request: UpdateUtilitiesMultipleRequest): Observable<UpdateUtilitiesMultipleResponse> {
        let url_ = this.baseUrl + "/Utility/UpdateMultipleUtilities";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateMultipleUtilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateMultipleUtilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UpdateUtilitiesMultipleResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UpdateUtilitiesMultipleResponse>;
        }));
    }

    protected processUpdateMultipleUtilities(response: HttpResponseBase): Observable<UpdateUtilitiesMultipleResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UpdateUtilitiesMultipleResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UpdateUtilitiesMultipleResponse>(null as any);
    }
}

export interface IPublicClient {
    getCurrentKey(): Observable<GetApiKeyResponse>;
    getUtilities(key?: string | null | undefined): Observable<GetUtilitiesResponse>;
    getFiscalYears(): Observable<GetFiscalYearsResponse>;
    getCosts(fiscalYearId?: number | null | undefined): Observable<GetCostsResponse>;
    getProgramTerms(): Observable<GetProgramTermsResponse>;
    getWorksheetData(request: GenerateWorksheetDataRequest): Observable<GenerateWorksheetDataResponse>;
    addApplication(request: AddApplicationRequest): Observable<FileResponse>;
    uploadDocuments(files?: FileParameter[] | null | undefined): Observable<UploadDocumentsResponse>;
    downloadFpcwPdf(request: GetFpcwPdfRequest): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class PublicClient implements IPublicClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(ApiBaseUrl) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "http://localhost:5000";
    }

    getCurrentKey(): Observable<GetApiKeyResponse> {
        let url_ = this.baseUrl + "/Public/GetCurrentKey";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentKey(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentKey(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetApiKeyResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetApiKeyResponse>;
        }));
    }

    protected processGetCurrentKey(response: HttpResponseBase): Observable<GetApiKeyResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetApiKeyResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetApiKeyResponse>(null as any);
    }

    getUtilities(key?: string | null | undefined): Observable<GetUtilitiesResponse> {
        let url_ = this.baseUrl + "/Public/GetUtilities?";
        if (key !== undefined && key !== null)
            url_ += "key=" + encodeURIComponent("" + key) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetUtilities(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetUtilities(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetUtilitiesResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetUtilitiesResponse>;
        }));
    }

    protected processGetUtilities(response: HttpResponseBase): Observable<GetUtilitiesResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetUtilitiesResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetUtilitiesResponse>(null as any);
    }

    getFiscalYears(): Observable<GetFiscalYearsResponse> {
        let url_ = this.baseUrl + "/Public/GetFiscalYears";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetFiscalYears(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetFiscalYears(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetFiscalYearsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetFiscalYearsResponse>;
        }));
    }

    protected processGetFiscalYears(response: HttpResponseBase): Observable<GetFiscalYearsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetFiscalYearsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetFiscalYearsResponse>(null as any);
    }

    getCosts(fiscalYearId?: number | null | undefined): Observable<GetCostsResponse> {
        let url_ = this.baseUrl + "/Public/GetCosts?";
        if (fiscalYearId !== undefined && fiscalYearId !== null)
            url_ += "fiscalYearId=" + encodeURIComponent("" + fiscalYearId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCosts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCosts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetCostsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetCostsResponse>;
        }));
    }

    protected processGetCosts(response: HttpResponseBase): Observable<GetCostsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetCostsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetCostsResponse>(null as any);
    }

    getProgramTerms(): Observable<GetProgramTermsResponse> {
        let url_ = this.baseUrl + "/Public/program-terms";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProgramTerms(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProgramTerms(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GetProgramTermsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GetProgramTermsResponse>;
        }));
    }

    protected processGetProgramTerms(response: HttpResponseBase): Observable<GetProgramTermsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GetProgramTermsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GetProgramTermsResponse>(null as any);
    }

    getWorksheetData(request: GenerateWorksheetDataRequest): Observable<GenerateWorksheetDataResponse> {
        let url_ = this.baseUrl + "/Public/GetWorksheetData";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetWorksheetData(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetWorksheetData(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<GenerateWorksheetDataResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<GenerateWorksheetDataResponse>;
        }));
    }

    protected processGetWorksheetData(response: HttpResponseBase): Observable<GenerateWorksheetDataResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = GenerateWorksheetDataResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<GenerateWorksheetDataResponse>(null as any);
    }

    addApplication(request: AddApplicationRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Public/AddApplication";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAddApplication(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAddApplication(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processAddApplication(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status === 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result204: any = null;
            let resultData204 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
                result204 = resultData204 !== undefined ? resultData204 : null as any;
    
            return _observableOf(result204);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }

    uploadDocuments(files?: FileParameter[] | null | undefined): Observable<UploadDocumentsResponse> {
        let url_ = this.baseUrl + "/Public/UploadDocuments";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (files !== null && files !== undefined)
            files.forEach(item_ => content_.append("files", item_.data, item_.fileName ? item_.fileName : "files") );

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUploadDocuments(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUploadDocuments(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UploadDocumentsResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UploadDocumentsResponse>;
        }));
    }

    protected processUploadDocuments(response: HttpResponseBase): Observable<UploadDocumentsResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UploadDocumentsResponse.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<UploadDocumentsResponse>(null as any);
    }

    downloadFpcwPdf(request: GetFpcwPdfRequest): Observable<FileResponse> {
        let url_ = this.baseUrl + "/Public/DownloadFpcwPdf";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/octet-stream"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDownloadFpcwPdf(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDownloadFpcwPdf(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processDownloadFpcwPdf(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap(_responseText => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf<FileResponse>(null as any);
    }
}

export class GetAccountResponse implements IGetAccountResponse {
    account?: AccountsMainsViewModel | null;

    constructor(data?: IGetAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.account = _data["account"] ? AccountsMainsViewModel.fromJS(_data["account"]) : null as any;
        }
    }

    static fromJS(data: any): GetAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["account"] = this.account ? this.account.toJSON() : null as any;
        return data;
    }

    clone(): GetAccountResponse {
        const json = this.toJSON();
        let result = new GetAccountResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAccountResponse {
    account?: AccountsMainsViewModel | null;
}

export class AccountsMainsViewModel implements IAccountsMainsViewModel {
    id?: number | null;
    applicationId?: number;
    status?: AccountStatus | null;
    application?: ApplicationViewModel | null;
    borrower?: AccountsBorrowersViewModel | null;
    coBorrower?: AccountsBorrowersViewModel | null;
    student?: AccountsStudentInformationViewModel | null;
    accountPlanInformation?: AccountPlanInformationViewModel | null;
    prepaymentRecords?: PrepaymentRecordViewModel[] | null;

    constructor(data?: IAccountsMainsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.borrower = _data["borrower"] ? AccountsBorrowersViewModel.fromJS(_data["borrower"]) : null as any;
            this.coBorrower = _data["coBorrower"] ? AccountsBorrowersViewModel.fromJS(_data["coBorrower"]) : null as any;
            this.student = _data["student"] ? AccountsStudentInformationViewModel.fromJS(_data["student"]) : null as any;
            this.accountPlanInformation = _data["accountPlanInformation"] ? AccountPlanInformationViewModel.fromJS(_data["accountPlanInformation"]) : null as any;
            if (Array.isArray(_data["prepaymentRecords"])) {
                this.prepaymentRecords = [] as any;
                for (let item of _data["prepaymentRecords"])
                    this.prepaymentRecords!.push(PrepaymentRecordViewModel.fromJS(item));
            }
            else {
                this.prepaymentRecords = null as any;
            }
        }
    }

    static fromJS(data: any): AccountsMainsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsMainsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["borrower"] = this.borrower ? this.borrower.toJSON() : null as any;
        data["coBorrower"] = this.coBorrower ? this.coBorrower.toJSON() : null as any;
        data["student"] = this.student ? this.student.toJSON() : null as any;
        data["accountPlanInformation"] = this.accountPlanInformation ? this.accountPlanInformation.toJSON() : null as any;
        if (Array.isArray(this.prepaymentRecords)) {
            data["prepaymentRecords"] = [];
            for (let item of this.prepaymentRecords)
                data["prepaymentRecords"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AccountsMainsViewModel {
        const json = this.toJSON();
        let result = new AccountsMainsViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountsMainsViewModel {
    id?: number | null;
    applicationId?: number;
    status?: AccountStatus | null;
    application?: ApplicationViewModel | null;
    borrower?: AccountsBorrowersViewModel | null;
    coBorrower?: AccountsBorrowersViewModel | null;
    student?: AccountsStudentInformationViewModel | null;
    accountPlanInformation?: AccountPlanInformationViewModel | null;
    prepaymentRecords?: PrepaymentRecordViewModel[] | null;
}

export enum AccountStatus {
    Active = "Active",
    Cancelled = "Cancelled",
    Closed = "Closed",
}

export class ApplicationViewModel implements IApplicationViewModel {
    id?: number | null;
    createdDate?: Date | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    programTermsId?: number | null;
    programTerms?: ProgramTermsViewModel | null;
    planType?: PlanType;
    applicationStudent?: ApplicationStudentViewModel | null;
    applicationAdditionalInformation?: ApplicationAdditionalInformationViewModel | null;
    applicationPlanParticipation?: ApplicationPlanParticipationViewModel | null;
    applicationUploads?: ApplicationUploadsViewModel[] | null;
    financialData?: FinancialDataViewModel | null;
    applicant?: ApplicantViewModel | null;
    financialSummary?: FinancialSummaryViewModel[] | null;
    coApplicant?: ApplicantViewModel | null;
    applicantSignatureDate?: Date | null;
    coApplicantSignatureDate?: Date | null;
    interestRate?: number | null;
    status?: ApplicationStatus | null;
    approvalNotes?: string | null;
    type?: ApplicationType;
    finalDecision?: boolean | null;
    updateId?: number | null;
    hasAccount?: boolean | null;

    constructor(data?: IApplicationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : null as any;
            this.programTermsId = _data["programTermsId"] !== undefined ? _data["programTermsId"] : null as any;
            this.programTerms = _data["programTerms"] ? ProgramTermsViewModel.fromJS(_data["programTerms"]) : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.applicationStudent = _data["applicationStudent"] ? ApplicationStudentViewModel.fromJS(_data["applicationStudent"]) : null as any;
            this.applicationAdditionalInformation = _data["applicationAdditionalInformation"] ? ApplicationAdditionalInformationViewModel.fromJS(_data["applicationAdditionalInformation"]) : null as any;
            this.applicationPlanParticipation = _data["applicationPlanParticipation"] ? ApplicationPlanParticipationViewModel.fromJS(_data["applicationPlanParticipation"]) : null as any;
            if (Array.isArray(_data["applicationUploads"])) {
                this.applicationUploads = [] as any;
                for (let item of _data["applicationUploads"])
                    this.applicationUploads!.push(ApplicationUploadsViewModel.fromJS(item));
            }
            else {
                this.applicationUploads = null as any;
            }
            this.financialData = _data["financialData"] ? FinancialDataViewModel.fromJS(_data["financialData"]) : null as any;
            this.applicant = _data["applicant"] ? ApplicantViewModel.fromJS(_data["applicant"]) : null as any;
            if (Array.isArray(_data["financialSummary"])) {
                this.financialSummary = [] as any;
                for (let item of _data["financialSummary"])
                    this.financialSummary!.push(FinancialSummaryViewModel.fromJS(item));
            }
            else {
                this.financialSummary = null as any;
            }
            this.coApplicant = _data["coApplicant"] ? ApplicantViewModel.fromJS(_data["coApplicant"]) : null as any;
            this.applicantSignatureDate = _data["applicantSignatureDate"] ? new Date(_data["applicantSignatureDate"].toString()) : null as any;
            this.coApplicantSignatureDate = _data["coApplicantSignatureDate"] ? new Date(_data["coApplicantSignatureDate"].toString()) : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.approvalNotes = _data["approvalNotes"] !== undefined ? _data["approvalNotes"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.finalDecision = _data["finalDecision"] !== undefined ? _data["finalDecision"] : null as any;
            this.updateId = _data["updateId"] !== undefined ? _data["updateId"] : null as any;
            this.hasAccount = _data["hasAccount"] !== undefined ? _data["hasAccount"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["programTermsId"] = this.programTermsId !== undefined ? this.programTermsId : null as any;
        data["programTerms"] = this.programTerms ? this.programTerms.toJSON() : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["applicationStudent"] = this.applicationStudent ? this.applicationStudent.toJSON() : null as any;
        data["applicationAdditionalInformation"] = this.applicationAdditionalInformation ? this.applicationAdditionalInformation.toJSON() : null as any;
        data["applicationPlanParticipation"] = this.applicationPlanParticipation ? this.applicationPlanParticipation.toJSON() : null as any;
        if (Array.isArray(this.applicationUploads)) {
            data["applicationUploads"] = [];
            for (let item of this.applicationUploads)
                data["applicationUploads"].push(item ? item.toJSON() : null as any);
        }
        data["financialData"] = this.financialData ? this.financialData.toJSON() : null as any;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : null as any;
        if (Array.isArray(this.financialSummary)) {
            data["financialSummary"] = [];
            for (let item of this.financialSummary)
                data["financialSummary"].push(item ? item.toJSON() : null as any);
        }
        data["coApplicant"] = this.coApplicant ? this.coApplicant.toJSON() : null as any;
        data["applicantSignatureDate"] = this.applicantSignatureDate ? this.applicantSignatureDate.toISOString() : null as any;
        data["coApplicantSignatureDate"] = this.coApplicantSignatureDate ? this.coApplicantSignatureDate.toISOString() : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["approvalNotes"] = this.approvalNotes !== undefined ? this.approvalNotes : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["finalDecision"] = this.finalDecision !== undefined ? this.finalDecision : null as any;
        data["updateId"] = this.updateId !== undefined ? this.updateId : null as any;
        data["hasAccount"] = this.hasAccount !== undefined ? this.hasAccount : null as any;
        return data;
    }

    clone(): ApplicationViewModel {
        const json = this.toJSON();
        let result = new ApplicationViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationViewModel {
    id?: number | null;
    createdDate?: Date | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    programTermsId?: number | null;
    programTerms?: ProgramTermsViewModel | null;
    planType?: PlanType;
    applicationStudent?: ApplicationStudentViewModel | null;
    applicationAdditionalInformation?: ApplicationAdditionalInformationViewModel | null;
    applicationPlanParticipation?: ApplicationPlanParticipationViewModel | null;
    applicationUploads?: ApplicationUploadsViewModel[] | null;
    financialData?: FinancialDataViewModel | null;
    applicant?: ApplicantViewModel | null;
    financialSummary?: FinancialSummaryViewModel[] | null;
    coApplicant?: ApplicantViewModel | null;
    applicantSignatureDate?: Date | null;
    coApplicantSignatureDate?: Date | null;
    interestRate?: number | null;
    status?: ApplicationStatus | null;
    approvalNotes?: string | null;
    type?: ApplicationType;
    finalDecision?: boolean | null;
    updateId?: number | null;
    hasAccount?: boolean | null;
}

export class FiscalYearViewModel implements IFiscalYearViewModel {
    id?: number | null;
    year?: number;
    costCount?: number | null;
    isSystemFiscalYear?: boolean | null;
    isPepApplicationFiscalYear?: boolean | null;
    isFpcwFiscalYear?: boolean | null;
    createdDate?: Date | null;
    workdayAwardYear?: string | null;

    constructor(data?: IFiscalYearViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.costCount = _data["costCount"] !== undefined ? _data["costCount"] : null as any;
            this.isSystemFiscalYear = _data["isSystemFiscalYear"] !== undefined ? _data["isSystemFiscalYear"] : null as any;
            this.isPepApplicationFiscalYear = _data["isPepApplicationFiscalYear"] !== undefined ? _data["isPepApplicationFiscalYear"] : null as any;
            this.isFpcwFiscalYear = _data["isFpcwFiscalYear"] !== undefined ? _data["isFpcwFiscalYear"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.workdayAwardYear = _data["workdayAwardYear"] !== undefined ? _data["workdayAwardYear"] : null as any;
        }
    }

    static fromJS(data: any): FiscalYearViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FiscalYearViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["costCount"] = this.costCount !== undefined ? this.costCount : null as any;
        data["isSystemFiscalYear"] = this.isSystemFiscalYear !== undefined ? this.isSystemFiscalYear : null as any;
        data["isPepApplicationFiscalYear"] = this.isPepApplicationFiscalYear !== undefined ? this.isPepApplicationFiscalYear : null as any;
        data["isFpcwFiscalYear"] = this.isFpcwFiscalYear !== undefined ? this.isFpcwFiscalYear : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["workdayAwardYear"] = this.workdayAwardYear !== undefined ? this.workdayAwardYear : null as any;
        return data;
    }

    clone(): FiscalYearViewModel {
        const json = this.toJSON();
        let result = new FiscalYearViewModel();
        result.init(json);
        return result;
    }
}

export interface IFiscalYearViewModel {
    id?: number | null;
    year?: number;
    costCount?: number | null;
    isSystemFiscalYear?: boolean | null;
    isPepApplicationFiscalYear?: boolean | null;
    isFpcwFiscalYear?: boolean | null;
    createdDate?: Date | null;
    workdayAwardYear?: string | null;
}

export class ProgramTermsViewModel implements IProgramTermsViewModel {
    id?: number | null;
    fiscalYear?: FiscalYearViewModel | null;
    fiscalYearId?: number;
    planType?: PlanType;
    interestRate?: number;
    originationFee?: number;
    annualFee?: number;
    standardTerm?: number;
    standardTermType?: LengthType;
    paymentsPerYear?: PaymentsPerYear;
    gracePeriod?: number;
    gracePeriodType?: LengthType;
    altLoanId?: string | null;

    constructor(data?: IProgramTermsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.originationFee = _data["originationFee"] !== undefined ? _data["originationFee"] : null as any;
            this.annualFee = _data["annualFee"] !== undefined ? _data["annualFee"] : null as any;
            this.standardTerm = _data["standardTerm"] !== undefined ? _data["standardTerm"] : null as any;
            this.standardTermType = _data["standardTermType"] !== undefined ? _data["standardTermType"] : null as any;
            this.paymentsPerYear = _data["paymentsPerYear"] !== undefined ? _data["paymentsPerYear"] : null as any;
            this.gracePeriod = _data["gracePeriod"] !== undefined ? _data["gracePeriod"] : null as any;
            this.gracePeriodType = _data["gracePeriodType"] !== undefined ? _data["gracePeriodType"] : null as any;
            this.altLoanId = _data["altLoanId"] !== undefined ? _data["altLoanId"] : null as any;
        }
    }

    static fromJS(data: any): ProgramTermsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramTermsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["originationFee"] = this.originationFee !== undefined ? this.originationFee : null as any;
        data["annualFee"] = this.annualFee !== undefined ? this.annualFee : null as any;
        data["standardTerm"] = this.standardTerm !== undefined ? this.standardTerm : null as any;
        data["standardTermType"] = this.standardTermType !== undefined ? this.standardTermType : null as any;
        data["paymentsPerYear"] = this.paymentsPerYear !== undefined ? this.paymentsPerYear : null as any;
        data["gracePeriod"] = this.gracePeriod !== undefined ? this.gracePeriod : null as any;
        data["gracePeriodType"] = this.gracePeriodType !== undefined ? this.gracePeriodType : null as any;
        data["altLoanId"] = this.altLoanId !== undefined ? this.altLoanId : null as any;
        return data;
    }

    clone(): ProgramTermsViewModel {
        const json = this.toJSON();
        let result = new ProgramTermsViewModel();
        result.init(json);
        return result;
    }
}

export interface IProgramTermsViewModel {
    id?: number | null;
    fiscalYear?: FiscalYearViewModel | null;
    fiscalYearId?: number;
    planType?: PlanType;
    interestRate?: number;
    originationFee?: number;
    annualFee?: number;
    standardTerm?: number;
    standardTermType?: LengthType;
    paymentsPerYear?: PaymentsPerYear;
    gracePeriod?: number;
    gracePeriodType?: LengthType;
    altLoanId?: string | null;
}

export enum PlanType {
    PepAnnual = "PepAnnual",
    PepMultiyear = "PepMultiyear",
    PepCombo = "PepCombo",
    PepPrepayment = "PepPrepayment",
    FederalParentPlus = "FederalParentPlus",
    InstallmentPaymentPlan = "InstallmentPaymentPlan",
    Refinance = "Refinance",
}

export enum LengthType {
    Days = "Days",
    Months = "Months",
    Years = "Years",
}

export enum PaymentsPerYear {
    Monthly = "Monthly",
    Quarterly = "Quarterly",
    Annual = "Annual",
}

export class ApplicationStudentViewModel implements IApplicationStudentViewModel {
    id?: number | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    applicationStudentRootId?: number | null;
    applicationStudentRoot?: ApplicationStudentRootViewModel | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;
    isNew?: boolean | null;

    constructor(data?: IApplicationStudentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.applicationStudentRootId = _data["applicationStudentRootId"] !== undefined ? _data["applicationStudentRootId"] : null as any;
            this.applicationStudentRoot = _data["applicationStudentRoot"] ? ApplicationStudentRootViewModel.fromJS(_data["applicationStudentRoot"]) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : null as any;
            this.academicLevel = _data["academicLevel"] !== undefined ? _data["academicLevel"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationStudentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationStudentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["applicationStudentRootId"] = this.applicationStudentRootId !== undefined ? this.applicationStudentRootId : null as any;
        data["applicationStudentRoot"] = this.applicationStudentRoot ? this.applicationStudentRoot.toJSON() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : null as any;
        data["academicLevel"] = this.academicLevel !== undefined ? this.academicLevel : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        return data;
    }

    clone(): ApplicationStudentViewModel {
        const json = this.toJSON();
        let result = new ApplicationStudentViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationStudentViewModel {
    id?: number | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    applicationStudentRootId?: number | null;
    applicationStudentRoot?: ApplicationStudentRootViewModel | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;
    isNew?: boolean | null;
}

export class ApplicationStudentRootViewModel implements IApplicationStudentRootViewModel {
    id?: number | null;
    ssn?: string | null;
    lastFourSsn?: string | null;

    constructor(data?: IApplicationStudentRootViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.lastFourSsn = _data["lastFourSsn"] !== undefined ? _data["lastFourSsn"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationStudentRootViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationStudentRootViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["lastFourSsn"] = this.lastFourSsn !== undefined ? this.lastFourSsn : null as any;
        return data;
    }

    clone(): ApplicationStudentRootViewModel {
        const json = this.toJSON();
        let result = new ApplicationStudentRootViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationStudentRootViewModel {
    id?: number | null;
    ssn?: string | null;
    lastFourSsn?: string | null;
}

export enum AcademicLevel {
    FirstYear = "FirstYear",
    Sophomore = "Sophomore",
    Junior = "Junior",
    Senior = "Senior",
}

export class ApplicationAdditionalInformationViewModel implements IApplicationAdditionalInformationViewModel {
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    financialSituation?: string | null;
    comments?: string | null;

    constructor(data?: IApplicationAdditionalInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.financialSituation = _data["financialSituation"] !== undefined ? _data["financialSituation"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationAdditionalInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAdditionalInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["financialSituation"] = this.financialSituation !== undefined ? this.financialSituation : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        return data;
    }

    clone(): ApplicationAdditionalInformationViewModel {
        const json = this.toJSON();
        let result = new ApplicationAdditionalInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationAdditionalInformationViewModel {
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    financialSituation?: string | null;
    comments?: string | null;
}

export class ApplicationPlanParticipationViewModel implements IApplicationPlanParticipationViewModel {
    id?: number | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    totalAnnualCharges?: number | null;
    financialAidAward?: number | null;
    baseYearTotal?: number | null;
    pepSemesters?: number | null;
    planProjectionAmount?: number | null;
    borrowAmount?: number | null;
    prepayAmount?: number | null;
    estimatedMonthlyPayment?: string | null;
    pepTotal?: number | null;

    constructor(data?: IApplicationPlanParticipationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.tuitionCostId = _data["tuitionCostId"] !== undefined ? _data["tuitionCostId"] : null as any;
            this.tuitionCost = _data["tuitionCost"] ? CostViewModel.fromJS(_data["tuitionCost"]) : null as any;
            this.activityCostId = _data["activityCostId"] !== undefined ? _data["activityCostId"] : null as any;
            this.activityCost = _data["activityCost"] ? CostViewModel.fromJS(_data["activityCost"]) : null as any;
            this.housingCostId = _data["housingCostId"] !== undefined ? _data["housingCostId"] : null as any;
            this.housingCost = _data["housingCost"] ? CostViewModel.fromJS(_data["housingCost"]) : null as any;
            this.foodServiceCostId = _data["foodServiceCostId"] !== undefined ? _data["foodServiceCostId"] : null as any;
            this.foodServiceCost = _data["foodServiceCost"] ? CostViewModel.fromJS(_data["foodServiceCost"]) : null as any;
            this.totalAnnualCharges = _data["totalAnnualCharges"] !== undefined ? _data["totalAnnualCharges"] : null as any;
            this.financialAidAward = _data["financialAidAward"] !== undefined ? _data["financialAidAward"] : null as any;
            this.baseYearTotal = _data["baseYearTotal"] !== undefined ? _data["baseYearTotal"] : null as any;
            this.pepSemesters = _data["pepSemesters"] !== undefined ? _data["pepSemesters"] : null as any;
            this.planProjectionAmount = _data["planProjectionAmount"] !== undefined ? _data["planProjectionAmount"] : null as any;
            this.borrowAmount = _data["borrowAmount"] !== undefined ? _data["borrowAmount"] : null as any;
            this.prepayAmount = _data["prepayAmount"] !== undefined ? _data["prepayAmount"] : null as any;
            this.estimatedMonthlyPayment = _data["estimatedMonthlyPayment"] !== undefined ? _data["estimatedMonthlyPayment"] : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationPlanParticipationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationPlanParticipationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["tuitionCostId"] = this.tuitionCostId !== undefined ? this.tuitionCostId : null as any;
        data["tuitionCost"] = this.tuitionCost ? this.tuitionCost.toJSON() : null as any;
        data["activityCostId"] = this.activityCostId !== undefined ? this.activityCostId : null as any;
        data["activityCost"] = this.activityCost ? this.activityCost.toJSON() : null as any;
        data["housingCostId"] = this.housingCostId !== undefined ? this.housingCostId : null as any;
        data["housingCost"] = this.housingCost ? this.housingCost.toJSON() : null as any;
        data["foodServiceCostId"] = this.foodServiceCostId !== undefined ? this.foodServiceCostId : null as any;
        data["foodServiceCost"] = this.foodServiceCost ? this.foodServiceCost.toJSON() : null as any;
        data["totalAnnualCharges"] = this.totalAnnualCharges !== undefined ? this.totalAnnualCharges : null as any;
        data["financialAidAward"] = this.financialAidAward !== undefined ? this.financialAidAward : null as any;
        data["baseYearTotal"] = this.baseYearTotal !== undefined ? this.baseYearTotal : null as any;
        data["pepSemesters"] = this.pepSemesters !== undefined ? this.pepSemesters : null as any;
        data["planProjectionAmount"] = this.planProjectionAmount !== undefined ? this.planProjectionAmount : null as any;
        data["borrowAmount"] = this.borrowAmount !== undefined ? this.borrowAmount : null as any;
        data["prepayAmount"] = this.prepayAmount !== undefined ? this.prepayAmount : null as any;
        data["estimatedMonthlyPayment"] = this.estimatedMonthlyPayment !== undefined ? this.estimatedMonthlyPayment : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        return data;
    }

    clone(): ApplicationPlanParticipationViewModel {
        const json = this.toJSON();
        let result = new ApplicationPlanParticipationViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationPlanParticipationViewModel {
    id?: number | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    totalAnnualCharges?: number | null;
    financialAidAward?: number | null;
    baseYearTotal?: number | null;
    pepSemesters?: number | null;
    planProjectionAmount?: number | null;
    borrowAmount?: number | null;
    prepayAmount?: number | null;
    estimatedMonthlyPayment?: string | null;
    pepTotal?: number | null;
}

export class CostViewModel implements ICostViewModel {
    id?: number | null;
    fiscalYear?: FiscalYearViewModel | null;
    fiscalYearId?: number | null;
    chargeName?: string | null;
    componentType?: ComponentType;
    menuType?: MenuType;
    semesterAmount?: number;
    annualAmount?: number | null;
    fresh?: boolean;
    nonFresh?: boolean;
    sortOrder?: number;
    copyKey?: string | null;

    constructor(data?: ICostViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.chargeName = _data["chargeName"] !== undefined ? _data["chargeName"] : null as any;
            this.componentType = _data["componentType"] !== undefined ? _data["componentType"] : null as any;
            this.menuType = _data["menuType"] !== undefined ? _data["menuType"] : null as any;
            this.semesterAmount = _data["semesterAmount"] !== undefined ? _data["semesterAmount"] : null as any;
            this.annualAmount = _data["annualAmount"] !== undefined ? _data["annualAmount"] : null as any;
            this.fresh = _data["fresh"] !== undefined ? _data["fresh"] : null as any;
            this.nonFresh = _data["nonFresh"] !== undefined ? _data["nonFresh"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.copyKey = _data["copyKey"] !== undefined ? _data["copyKey"] : null as any;
        }
    }

    static fromJS(data: any): CostViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["chargeName"] = this.chargeName !== undefined ? this.chargeName : null as any;
        data["componentType"] = this.componentType !== undefined ? this.componentType : null as any;
        data["menuType"] = this.menuType !== undefined ? this.menuType : null as any;
        data["semesterAmount"] = this.semesterAmount !== undefined ? this.semesterAmount : null as any;
        data["annualAmount"] = this.annualAmount !== undefined ? this.annualAmount : null as any;
        data["fresh"] = this.fresh !== undefined ? this.fresh : null as any;
        data["nonFresh"] = this.nonFresh !== undefined ? this.nonFresh : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["copyKey"] = this.copyKey !== undefined ? this.copyKey : null as any;
        return data;
    }

    clone(): CostViewModel {
        const json = this.toJSON();
        let result = new CostViewModel();
        result.init(json);
        return result;
    }
}

export interface ICostViewModel {
    id?: number | null;
    fiscalYear?: FiscalYearViewModel | null;
    fiscalYearId?: number | null;
    chargeName?: string | null;
    componentType?: ComponentType;
    menuType?: MenuType;
    semesterAmount?: number;
    annualAmount?: number | null;
    fresh?: boolean;
    nonFresh?: boolean;
    sortOrder?: number;
    copyKey?: string | null;
}

export enum ComponentType {
    Tuition = "Tuition",
    Housing = "Housing",
}

export enum MenuType {
    Tuition = "Tuition",
    Fees = "Fees",
    Housing = "Housing",
    MealPlan = "MealPlan",
}

export class ApplicationUploadsViewModel implements IApplicationUploadsViewModel {
    id?: number | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    fileName?: string | null;
    description?: string | null;

    constructor(data?: IApplicationUploadsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationUploadsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUploadsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): ApplicationUploadsViewModel {
        const json = this.toJSON();
        let result = new ApplicationUploadsViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationUploadsViewModel {
    id?: number | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    fileName?: string | null;
    description?: string | null;
}

export class FinancialDataViewModel implements IFinancialDataViewModel {
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    id?: number | null;
    liquidAssets?: number;
    nonRetirementAssets?: number;
    retirementAssets?: number;
    businessValue?: number;
    realEstateValue?: number;
    isHomeOwner?: boolean;
    grossIncome?: number | null;
    mortgageInterest?: number | null;
    monthlyHousingCost?: number | null;
    disposableIncome?: number | null;
    agiLessDeductions?: number | null;
    totalTax?: number | null;
    otherDeductions?: number | null;
    debtToAssetsRatio?: number | null;
    debtToIncomeRatio?: number | null;
    financialComments?: string | null;
    points?: number | null;

    constructor(data?: IFinancialDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.liquidAssets = _data["liquidAssets"] !== undefined ? _data["liquidAssets"] : null as any;
            this.nonRetirementAssets = _data["nonRetirementAssets"] !== undefined ? _data["nonRetirementAssets"] : null as any;
            this.retirementAssets = _data["retirementAssets"] !== undefined ? _data["retirementAssets"] : null as any;
            this.businessValue = _data["businessValue"] !== undefined ? _data["businessValue"] : null as any;
            this.realEstateValue = _data["realEstateValue"] !== undefined ? _data["realEstateValue"] : null as any;
            this.isHomeOwner = _data["isHomeOwner"] !== undefined ? _data["isHomeOwner"] : null as any;
            this.grossIncome = _data["grossIncome"] !== undefined ? _data["grossIncome"] : null as any;
            this.mortgageInterest = _data["mortgageInterest"] !== undefined ? _data["mortgageInterest"] : null as any;
            this.monthlyHousingCost = _data["monthlyHousingCost"] !== undefined ? _data["monthlyHousingCost"] : null as any;
            this.disposableIncome = _data["disposableIncome"] !== undefined ? _data["disposableIncome"] : null as any;
            this.agiLessDeductions = _data["agiLessDeductions"] !== undefined ? _data["agiLessDeductions"] : null as any;
            this.totalTax = _data["totalTax"] !== undefined ? _data["totalTax"] : null as any;
            this.otherDeductions = _data["otherDeductions"] !== undefined ? _data["otherDeductions"] : null as any;
            this.debtToAssetsRatio = _data["debtToAssetsRatio"] !== undefined ? _data["debtToAssetsRatio"] : null as any;
            this.debtToIncomeRatio = _data["debtToIncomeRatio"] !== undefined ? _data["debtToIncomeRatio"] : null as any;
            this.financialComments = _data["financialComments"] !== undefined ? _data["financialComments"] : null as any;
            this.points = _data["points"] !== undefined ? _data["points"] : null as any;
        }
    }

    static fromJS(data: any): FinancialDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["liquidAssets"] = this.liquidAssets !== undefined ? this.liquidAssets : null as any;
        data["nonRetirementAssets"] = this.nonRetirementAssets !== undefined ? this.nonRetirementAssets : null as any;
        data["retirementAssets"] = this.retirementAssets !== undefined ? this.retirementAssets : null as any;
        data["businessValue"] = this.businessValue !== undefined ? this.businessValue : null as any;
        data["realEstateValue"] = this.realEstateValue !== undefined ? this.realEstateValue : null as any;
        data["isHomeOwner"] = this.isHomeOwner !== undefined ? this.isHomeOwner : null as any;
        data["grossIncome"] = this.grossIncome !== undefined ? this.grossIncome : null as any;
        data["mortgageInterest"] = this.mortgageInterest !== undefined ? this.mortgageInterest : null as any;
        data["monthlyHousingCost"] = this.monthlyHousingCost !== undefined ? this.monthlyHousingCost : null as any;
        data["disposableIncome"] = this.disposableIncome !== undefined ? this.disposableIncome : null as any;
        data["agiLessDeductions"] = this.agiLessDeductions !== undefined ? this.agiLessDeductions : null as any;
        data["totalTax"] = this.totalTax !== undefined ? this.totalTax : null as any;
        data["otherDeductions"] = this.otherDeductions !== undefined ? this.otherDeductions : null as any;
        data["debtToAssetsRatio"] = this.debtToAssetsRatio !== undefined ? this.debtToAssetsRatio : null as any;
        data["debtToIncomeRatio"] = this.debtToIncomeRatio !== undefined ? this.debtToIncomeRatio : null as any;
        data["financialComments"] = this.financialComments !== undefined ? this.financialComments : null as any;
        data["points"] = this.points !== undefined ? this.points : null as any;
        return data;
    }

    clone(): FinancialDataViewModel {
        const json = this.toJSON();
        let result = new FinancialDataViewModel();
        result.init(json);
        return result;
    }
}

export interface IFinancialDataViewModel {
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    id?: number | null;
    liquidAssets?: number;
    nonRetirementAssets?: number;
    retirementAssets?: number;
    businessValue?: number;
    realEstateValue?: number;
    isHomeOwner?: boolean;
    grossIncome?: number | null;
    mortgageInterest?: number | null;
    monthlyHousingCost?: number | null;
    disposableIncome?: number | null;
    agiLessDeductions?: number | null;
    totalTax?: number | null;
    otherDeductions?: number | null;
    debtToAssetsRatio?: number | null;
    debtToIncomeRatio?: number | null;
    financialComments?: string | null;
    points?: number | null;
}

export class ApplicantViewModel implements IApplicantViewModel {
    id?: number | null;
    applicationApplicantRootId?: number | null;
    applicationApplicantRoot?: ApplicationApplicantRootViewModel | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    employmentData?: ApplicantEmploymentDataViewModel | null;
    isNew?: boolean | null;
    isConfirmedNew?: boolean | null;

    constructor(data?: IApplicantViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.applicationApplicantRoot = _data["applicationApplicantRoot"] ? ApplicationApplicantRootViewModel.fromJS(_data["applicationApplicantRoot"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : null as any;
            this.employmentData = _data["employmentData"] ? ApplicantEmploymentDataViewModel.fromJS(_data["employmentData"]) : null as any;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
            this.isConfirmedNew = _data["isConfirmedNew"] !== undefined ? _data["isConfirmedNew"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["applicationApplicantRoot"] = this.applicationApplicantRoot ? this.applicationApplicantRoot.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : null as any;
        data["employmentData"] = this.employmentData ? this.employmentData.toJSON() : null as any;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        data["isConfirmedNew"] = this.isConfirmedNew !== undefined ? this.isConfirmedNew : null as any;
        return data;
    }

    clone(): ApplicantViewModel {
        const json = this.toJSON();
        let result = new ApplicantViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicantViewModel {
    id?: number | null;
    applicationApplicantRootId?: number | null;
    applicationApplicantRoot?: ApplicationApplicantRootViewModel | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    employmentData?: ApplicantEmploymentDataViewModel | null;
    isNew?: boolean | null;
    isConfirmedNew?: boolean | null;
}

export class ApplicationApplicantRootViewModel implements IApplicationApplicantRootViewModel {
    id?: number | null;
    ssn?: string | null;
    lastFourSsn?: string | null;

    constructor(data?: IApplicationApplicantRootViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.lastFourSsn = _data["lastFourSsn"] !== undefined ? _data["lastFourSsn"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationApplicantRootViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationApplicantRootViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["lastFourSsn"] = this.lastFourSsn !== undefined ? this.lastFourSsn : null as any;
        return data;
    }

    clone(): ApplicationApplicantRootViewModel {
        const json = this.toJSON();
        let result = new ApplicationApplicantRootViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationApplicantRootViewModel {
    id?: number | null;
    ssn?: string | null;
    lastFourSsn?: string | null;
}

export enum ApplicantType {
    Primary = "Primary",
    CoApplicant = "CoApplicant",
}

export enum Prefix {
    Mr = "Mr",
    Mrs = "Mrs",
    Ms = "Ms",
    Dr = "Dr",
    Rabbi = "Rabbi",
}

export enum StateAbbreviation {
    AL = "AL",
    AK = "AK",
    AR = "AR",
    AS = "AS",
    AZ = "AZ",
    CA = "CA",
    CO = "CO",
    CT = "CT",
    DC = "DC",
    DE = "DE",
    FL = "FL",
    GA = "GA",
    GU = "GU",
    HI = "HI",
    IA = "IA",
    ID = "ID",
    IL = "IL",
    IN = "IN",
    KS = "KS",
    KY = "KY",
    LA = "LA",
    MA = "MA",
    MD = "MD",
    ME = "ME",
    MI = "MI",
    MN = "MN",
    MO = "MO",
    MS = "MS",
    MT = "MT",
    NC = "NC",
    ND = "ND",
    NE = "NE",
    NH = "NH",
    NJ = "NJ",
    NM = "NM",
    NV = "NV",
    NY = "NY",
    MP = "MP",
    OH = "OH",
    OK = "OK",
    OR = "OR",
    PA = "PA",
    PR = "PR",
    PW = "PW",
    RI = "RI",
    SC = "SC",
    SD = "SD",
    TN = "TN",
    TX = "TX",
    UT = "UT",
    VT = "VT",
    VA = "VA",
    VI = "VI",
    WA = "WA",
    WV = "WV",
    WI = "WI",
    WY = "WY",
    OTHER = "OTHER",
}

export class ApplicantEmploymentDataViewModel implements IApplicantEmploymentDataViewModel {
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    applicant?: ApplicantViewModel | null;
    applicantId?: number | null;

    constructor(data?: IApplicantEmploymentDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : null as any;
            this.employer = _data["employer"] !== undefined ? _data["employer"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.isVerified = _data["isVerified"] !== undefined ? _data["isVerified"] : null as any;
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : null as any;
            this.applicant = _data["applicant"] ? ApplicantViewModel.fromJS(_data["applicant"]) : null as any;
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantEmploymentDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantEmploymentDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occupation"] = this.occupation !== undefined ? this.occupation : null as any;
        data["employer"] = this.employer !== undefined ? this.employer : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["isVerified"] = this.isVerified !== undefined ? this.isVerified : null as any;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : null as any;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : null as any;
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        return data;
    }

    clone(): ApplicantEmploymentDataViewModel {
        const json = this.toJSON();
        let result = new ApplicantEmploymentDataViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicantEmploymentDataViewModel {
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    applicant?: ApplicantViewModel | null;
    applicantId?: number | null;
}

export class FinancialSummaryViewModel implements IFinancialSummaryViewModel {
    id?: number | null;
    pepTotal?: number;
    amountPrepay?: number | null;
    amountBorrow?: number | null;
    programTermsId?: number | null;
    programTerms?: ProgramTermsViewModel | null;
    repaymentPeriod?: number;
    pepMonthlyPayment?: number | null;
    planComments?: string | null;
    interestRate?: number | null;
    approvalStatus?: ApprovalStatus;
    approvalNotes?: string | null;
    riskScore?: number | null;
    finalDecision?: boolean | null;
    decisionDate?: Date | null;
    decisionUserId?: number | null;
    decisionUser?: AppUserViewModel | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    applicantCreditInformation?: ApplicantCreditInformationViewModel | null;
    coApplicantCreditInformation?: ApplicantCreditInformationViewModel | null;
    summaryFinancialData?: FinancialDataViewModel | null;
    createdUserId?: number | null;
    createdUser?: AppUserViewModel | null;
    createdDate?: Date | null;
    initialApprovalStatus?: ApprovalStatus;
    initialDecisionUserId?: number | null;
    initialDecisionUser?: AppUserViewModel | null;
    initialDecisionDate?: Date | null;
    secondaryApprovalStatus?: ApprovalStatus;
    secondaryDecisionUserId?: number | null;
    secondaryDecisionUser?: AppUserViewModel | null;
    secondaryDecisionDate?: Date | null;
    applicationSemesters?: ApplicationSemestersViewModel[] | null;
    accountId?: number | null;

    constructor(data?: IFinancialSummaryViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
            this.amountPrepay = _data["amountPrepay"] !== undefined ? _data["amountPrepay"] : null as any;
            this.amountBorrow = _data["amountBorrow"] !== undefined ? _data["amountBorrow"] : null as any;
            this.programTermsId = _data["programTermsId"] !== undefined ? _data["programTermsId"] : null as any;
            this.programTerms = _data["programTerms"] ? ProgramTermsViewModel.fromJS(_data["programTerms"]) : null as any;
            this.repaymentPeriod = _data["repaymentPeriod"] !== undefined ? _data["repaymentPeriod"] : null as any;
            this.pepMonthlyPayment = _data["pepMonthlyPayment"] !== undefined ? _data["pepMonthlyPayment"] : null as any;
            this.planComments = _data["planComments"] !== undefined ? _data["planComments"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.approvalNotes = _data["approvalNotes"] !== undefined ? _data["approvalNotes"] : null as any;
            this.riskScore = _data["riskScore"] !== undefined ? _data["riskScore"] : null as any;
            this.finalDecision = _data["finalDecision"] !== undefined ? _data["finalDecision"] : null as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : null as any;
            this.decisionUserId = _data["decisionUserId"] !== undefined ? _data["decisionUserId"] : null as any;
            this.decisionUser = _data["decisionUser"] ? AppUserViewModel.fromJS(_data["decisionUser"]) : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.applicantCreditInformation = _data["applicantCreditInformation"] ? ApplicantCreditInformationViewModel.fromJS(_data["applicantCreditInformation"]) : null as any;
            this.coApplicantCreditInformation = _data["coApplicantCreditInformation"] ? ApplicantCreditInformationViewModel.fromJS(_data["coApplicantCreditInformation"]) : null as any;
            this.summaryFinancialData = _data["summaryFinancialData"] ? FinancialDataViewModel.fromJS(_data["summaryFinancialData"]) : null as any;
            this.createdUserId = _data["createdUserId"] !== undefined ? _data["createdUserId"] : null as any;
            this.createdUser = _data["createdUser"] ? AppUserViewModel.fromJS(_data["createdUser"]) : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.initialApprovalStatus = _data["initialApprovalStatus"] !== undefined ? _data["initialApprovalStatus"] : null as any;
            this.initialDecisionUserId = _data["initialDecisionUserId"] !== undefined ? _data["initialDecisionUserId"] : null as any;
            this.initialDecisionUser = _data["initialDecisionUser"] ? AppUserViewModel.fromJS(_data["initialDecisionUser"]) : null as any;
            this.initialDecisionDate = _data["initialDecisionDate"] ? new Date(_data["initialDecisionDate"].toString()) : null as any;
            this.secondaryApprovalStatus = _data["secondaryApprovalStatus"] !== undefined ? _data["secondaryApprovalStatus"] : null as any;
            this.secondaryDecisionUserId = _data["secondaryDecisionUserId"] !== undefined ? _data["secondaryDecisionUserId"] : null as any;
            this.secondaryDecisionUser = _data["secondaryDecisionUser"] ? AppUserViewModel.fromJS(_data["secondaryDecisionUser"]) : null as any;
            this.secondaryDecisionDate = _data["secondaryDecisionDate"] ? new Date(_data["secondaryDecisionDate"].toString()) : null as any;
            if (Array.isArray(_data["applicationSemesters"])) {
                this.applicationSemesters = [] as any;
                for (let item of _data["applicationSemesters"])
                    this.applicationSemesters!.push(ApplicationSemestersViewModel.fromJS(item));
            }
            else {
                this.applicationSemesters = null as any;
            }
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): FinancialSummaryViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialSummaryViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        data["amountPrepay"] = this.amountPrepay !== undefined ? this.amountPrepay : null as any;
        data["amountBorrow"] = this.amountBorrow !== undefined ? this.amountBorrow : null as any;
        data["programTermsId"] = this.programTermsId !== undefined ? this.programTermsId : null as any;
        data["programTerms"] = this.programTerms ? this.programTerms.toJSON() : null as any;
        data["repaymentPeriod"] = this.repaymentPeriod !== undefined ? this.repaymentPeriod : null as any;
        data["pepMonthlyPayment"] = this.pepMonthlyPayment !== undefined ? this.pepMonthlyPayment : null as any;
        data["planComments"] = this.planComments !== undefined ? this.planComments : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["approvalNotes"] = this.approvalNotes !== undefined ? this.approvalNotes : null as any;
        data["riskScore"] = this.riskScore !== undefined ? this.riskScore : null as any;
        data["finalDecision"] = this.finalDecision !== undefined ? this.finalDecision : null as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : null as any;
        data["decisionUserId"] = this.decisionUserId !== undefined ? this.decisionUserId : null as any;
        data["decisionUser"] = this.decisionUser ? this.decisionUser.toJSON() : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["applicantCreditInformation"] = this.applicantCreditInformation ? this.applicantCreditInformation.toJSON() : null as any;
        data["coApplicantCreditInformation"] = this.coApplicantCreditInformation ? this.coApplicantCreditInformation.toJSON() : null as any;
        data["summaryFinancialData"] = this.summaryFinancialData ? this.summaryFinancialData.toJSON() : null as any;
        data["createdUserId"] = this.createdUserId !== undefined ? this.createdUserId : null as any;
        data["createdUser"] = this.createdUser ? this.createdUser.toJSON() : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["initialApprovalStatus"] = this.initialApprovalStatus !== undefined ? this.initialApprovalStatus : null as any;
        data["initialDecisionUserId"] = this.initialDecisionUserId !== undefined ? this.initialDecisionUserId : null as any;
        data["initialDecisionUser"] = this.initialDecisionUser ? this.initialDecisionUser.toJSON() : null as any;
        data["initialDecisionDate"] = this.initialDecisionDate ? this.initialDecisionDate.toISOString() : null as any;
        data["secondaryApprovalStatus"] = this.secondaryApprovalStatus !== undefined ? this.secondaryApprovalStatus : null as any;
        data["secondaryDecisionUserId"] = this.secondaryDecisionUserId !== undefined ? this.secondaryDecisionUserId : null as any;
        data["secondaryDecisionUser"] = this.secondaryDecisionUser ? this.secondaryDecisionUser.toJSON() : null as any;
        data["secondaryDecisionDate"] = this.secondaryDecisionDate ? this.secondaryDecisionDate.toISOString() : null as any;
        if (Array.isArray(this.applicationSemesters)) {
            data["applicationSemesters"] = [];
            for (let item of this.applicationSemesters)
                data["applicationSemesters"].push(item ? item.toJSON() : null as any);
        }
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): FinancialSummaryViewModel {
        const json = this.toJSON();
        let result = new FinancialSummaryViewModel();
        result.init(json);
        return result;
    }
}

export interface IFinancialSummaryViewModel {
    id?: number | null;
    pepTotal?: number;
    amountPrepay?: number | null;
    amountBorrow?: number | null;
    programTermsId?: number | null;
    programTerms?: ProgramTermsViewModel | null;
    repaymentPeriod?: number;
    pepMonthlyPayment?: number | null;
    planComments?: string | null;
    interestRate?: number | null;
    approvalStatus?: ApprovalStatus;
    approvalNotes?: string | null;
    riskScore?: number | null;
    finalDecision?: boolean | null;
    decisionDate?: Date | null;
    decisionUserId?: number | null;
    decisionUser?: AppUserViewModel | null;
    applicationId?: number | null;
    application?: ApplicationViewModel | null;
    applicantCreditInformation?: ApplicantCreditInformationViewModel | null;
    coApplicantCreditInformation?: ApplicantCreditInformationViewModel | null;
    summaryFinancialData?: FinancialDataViewModel | null;
    createdUserId?: number | null;
    createdUser?: AppUserViewModel | null;
    createdDate?: Date | null;
    initialApprovalStatus?: ApprovalStatus;
    initialDecisionUserId?: number | null;
    initialDecisionUser?: AppUserViewModel | null;
    initialDecisionDate?: Date | null;
    secondaryApprovalStatus?: ApprovalStatus;
    secondaryDecisionUserId?: number | null;
    secondaryDecisionUser?: AppUserViewModel | null;
    secondaryDecisionDate?: Date | null;
    applicationSemesters?: ApplicationSemestersViewModel[] | null;
    accountId?: number | null;
}

export enum ApprovalStatus {
    UnderReview = "UnderReview",
    Approved = "Approved",
    ApprovedWithAutoDebitOnly = "ApprovedWithAutoDebitOnly",
    Denied = "Denied",
    Cancelled = "Cancelled",
}

export class AppUserViewModel implements IAppUserViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;

    constructor(data?: IAppUserViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): AppUserViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AppUserViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        return data;
    }

    clone(): AppUserViewModel {
        const json = this.toJSON();
        let result = new AppUserViewModel();
        result.init(json);
        return result;
    }
}

export interface IAppUserViewModel {
    id?: number | null;
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;
}

export class ApplicantCreditInformationViewModel implements IApplicantCreditInformationViewModel {
    id?: number | null;
    applicantId?: number | null;
    applicant?: ApplicantViewModel | null;
    financialSummaryId?: number | null;
    financialSummary?: FinancialSummaryViewModel | null;
    creditCheckDate?: Date;
    creditScore?: number;
    collections?: number;
    collectionsAmount?: number;
    collectionsPaid?: number;
    thirtyDayViolations?: number;
    sixtyDayViolations?: number;
    ninetyDayViolations?: number;
    educationDefault?: boolean;
    previousEducationDefault?: boolean;
    potentialDebt?: number;
    actualDebt?: number;
    previousBankruptcy?: boolean;
    bankruptcyDate?: Date | null;
    mortgageBalance?: number | null;
    mortgageDefault?: boolean | null;
    periodicMonthlyPayments?: number | null;

    constructor(data?: IApplicantCreditInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
            this.applicant = _data["applicant"] ? ApplicantViewModel.fromJS(_data["applicant"]) : null as any;
            this.financialSummaryId = _data["financialSummaryId"] !== undefined ? _data["financialSummaryId"] : null as any;
            this.financialSummary = _data["financialSummary"] ? FinancialSummaryViewModel.fromJS(_data["financialSummary"]) : null as any;
            this.creditCheckDate = _data["creditCheckDate"] ? new Date(_data["creditCheckDate"].toString()) : null as any;
            this.creditScore = _data["creditScore"] !== undefined ? _data["creditScore"] : null as any;
            this.collections = _data["collections"] !== undefined ? _data["collections"] : null as any;
            this.collectionsAmount = _data["collectionsAmount"] !== undefined ? _data["collectionsAmount"] : null as any;
            this.collectionsPaid = _data["collectionsPaid"] !== undefined ? _data["collectionsPaid"] : null as any;
            this.thirtyDayViolations = _data["thirtyDayViolations"] !== undefined ? _data["thirtyDayViolations"] : null as any;
            this.sixtyDayViolations = _data["sixtyDayViolations"] !== undefined ? _data["sixtyDayViolations"] : null as any;
            this.ninetyDayViolations = _data["ninetyDayViolations"] !== undefined ? _data["ninetyDayViolations"] : null as any;
            this.educationDefault = _data["educationDefault"] !== undefined ? _data["educationDefault"] : null as any;
            this.previousEducationDefault = _data["previousEducationDefault"] !== undefined ? _data["previousEducationDefault"] : null as any;
            this.potentialDebt = _data["potentialDebt"] !== undefined ? _data["potentialDebt"] : null as any;
            this.actualDebt = _data["actualDebt"] !== undefined ? _data["actualDebt"] : null as any;
            this.previousBankruptcy = _data["previousBankruptcy"] !== undefined ? _data["previousBankruptcy"] : null as any;
            this.bankruptcyDate = _data["bankruptcyDate"] ? new Date(_data["bankruptcyDate"].toString()) : null as any;
            this.mortgageBalance = _data["mortgageBalance"] !== undefined ? _data["mortgageBalance"] : null as any;
            this.mortgageDefault = _data["mortgageDefault"] !== undefined ? _data["mortgageDefault"] : null as any;
            this.periodicMonthlyPayments = _data["periodicMonthlyPayments"] !== undefined ? _data["periodicMonthlyPayments"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantCreditInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantCreditInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : null as any;
        data["financialSummaryId"] = this.financialSummaryId !== undefined ? this.financialSummaryId : null as any;
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        data["creditCheckDate"] = this.creditCheckDate ? this.creditCheckDate.toISOString() : null as any;
        data["creditScore"] = this.creditScore !== undefined ? this.creditScore : null as any;
        data["collections"] = this.collections !== undefined ? this.collections : null as any;
        data["collectionsAmount"] = this.collectionsAmount !== undefined ? this.collectionsAmount : null as any;
        data["collectionsPaid"] = this.collectionsPaid !== undefined ? this.collectionsPaid : null as any;
        data["thirtyDayViolations"] = this.thirtyDayViolations !== undefined ? this.thirtyDayViolations : null as any;
        data["sixtyDayViolations"] = this.sixtyDayViolations !== undefined ? this.sixtyDayViolations : null as any;
        data["ninetyDayViolations"] = this.ninetyDayViolations !== undefined ? this.ninetyDayViolations : null as any;
        data["educationDefault"] = this.educationDefault !== undefined ? this.educationDefault : null as any;
        data["previousEducationDefault"] = this.previousEducationDefault !== undefined ? this.previousEducationDefault : null as any;
        data["potentialDebt"] = this.potentialDebt !== undefined ? this.potentialDebt : null as any;
        data["actualDebt"] = this.actualDebt !== undefined ? this.actualDebt : null as any;
        data["previousBankruptcy"] = this.previousBankruptcy !== undefined ? this.previousBankruptcy : null as any;
        data["bankruptcyDate"] = this.bankruptcyDate ? this.bankruptcyDate.toISOString() : null as any;
        data["mortgageBalance"] = this.mortgageBalance !== undefined ? this.mortgageBalance : null as any;
        data["mortgageDefault"] = this.mortgageDefault !== undefined ? this.mortgageDefault : null as any;
        data["periodicMonthlyPayments"] = this.periodicMonthlyPayments !== undefined ? this.periodicMonthlyPayments : null as any;
        return data;
    }

    clone(): ApplicantCreditInformationViewModel {
        const json = this.toJSON();
        let result = new ApplicantCreditInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicantCreditInformationViewModel {
    id?: number | null;
    applicantId?: number | null;
    applicant?: ApplicantViewModel | null;
    financialSummaryId?: number | null;
    financialSummary?: FinancialSummaryViewModel | null;
    creditCheckDate?: Date;
    creditScore?: number;
    collections?: number;
    collectionsAmount?: number;
    collectionsPaid?: number;
    thirtyDayViolations?: number;
    sixtyDayViolations?: number;
    ninetyDayViolations?: number;
    educationDefault?: boolean;
    previousEducationDefault?: boolean;
    potentialDebt?: number;
    actualDebt?: number;
    previousBankruptcy?: boolean;
    bankruptcyDate?: Date | null;
    mortgageBalance?: number | null;
    mortgageDefault?: boolean | null;
    periodicMonthlyPayments?: number | null;
}

export class ApplicationSemestersViewModel implements IApplicationSemestersViewModel {
    id?: number | null;
    financialSummaryId?: number | null;
    financialSummary?: FinancialSummaryViewModel | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    actualFoodServiceAmount?: number | null;
    semesterId?: string | null;
    semester?: SemesterViewModel | null;

    constructor(data?: IApplicationSemestersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.financialSummaryId = _data["financialSummaryId"] !== undefined ? _data["financialSummaryId"] : null as any;
            this.financialSummary = _data["financialSummary"] ? FinancialSummaryViewModel.fromJS(_data["financialSummary"]) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : null as any;
            this.participationRate = _data["participationRate"] !== undefined ? _data["participationRate"] : null as any;
            this.totalSemesterCharges = _data["totalSemesterCharges"] !== undefined ? _data["totalSemesterCharges"] : null as any;
            this.tuitionCostId = _data["tuitionCostId"] !== undefined ? _data["tuitionCostId"] : null as any;
            this.tuitionCost = _data["tuitionCost"] ? CostViewModel.fromJS(_data["tuitionCost"]) : null as any;
            this.actualTuitionAmount = _data["actualTuitionAmount"] !== undefined ? _data["actualTuitionAmount"] : null as any;
            this.activityCostId = _data["activityCostId"] !== undefined ? _data["activityCostId"] : null as any;
            this.activityCost = _data["activityCost"] ? CostViewModel.fromJS(_data["activityCost"]) : null as any;
            this.actualActivityAmount = _data["actualActivityAmount"] !== undefined ? _data["actualActivityAmount"] : null as any;
            this.housingCostId = _data["housingCostId"] !== undefined ? _data["housingCostId"] : null as any;
            this.housingCost = _data["housingCost"] ? CostViewModel.fromJS(_data["housingCost"]) : null as any;
            this.actualHousingAmount = _data["actualHousingAmount"] !== undefined ? _data["actualHousingAmount"] : null as any;
            this.foodServiceCostId = _data["foodServiceCostId"] !== undefined ? _data["foodServiceCostId"] : null as any;
            this.foodServiceCost = _data["foodServiceCost"] ? CostViewModel.fromJS(_data["foodServiceCost"]) : null as any;
            this.actualFoodServiceAmount = _data["actualFoodServiceAmount"] !== undefined ? _data["actualFoodServiceAmount"] : null as any;
            this.semesterId = _data["semesterId"] !== undefined ? _data["semesterId"] : null as any;
            this.semester = _data["semester"] ? SemesterViewModel.fromJS(_data["semester"]) : null as any;
        }
    }

    static fromJS(data: any): ApplicationSemestersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSemestersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["financialSummaryId"] = this.financialSummaryId !== undefined ? this.financialSummaryId : null as any;
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["participationRate"] = this.participationRate !== undefined ? this.participationRate : null as any;
        data["totalSemesterCharges"] = this.totalSemesterCharges !== undefined ? this.totalSemesterCharges : null as any;
        data["tuitionCostId"] = this.tuitionCostId !== undefined ? this.tuitionCostId : null as any;
        data["tuitionCost"] = this.tuitionCost ? this.tuitionCost.toJSON() : null as any;
        data["actualTuitionAmount"] = this.actualTuitionAmount !== undefined ? this.actualTuitionAmount : null as any;
        data["activityCostId"] = this.activityCostId !== undefined ? this.activityCostId : null as any;
        data["activityCost"] = this.activityCost ? this.activityCost.toJSON() : null as any;
        data["actualActivityAmount"] = this.actualActivityAmount !== undefined ? this.actualActivityAmount : null as any;
        data["housingCostId"] = this.housingCostId !== undefined ? this.housingCostId : null as any;
        data["housingCost"] = this.housingCost ? this.housingCost.toJSON() : null as any;
        data["actualHousingAmount"] = this.actualHousingAmount !== undefined ? this.actualHousingAmount : null as any;
        data["foodServiceCostId"] = this.foodServiceCostId !== undefined ? this.foodServiceCostId : null as any;
        data["foodServiceCost"] = this.foodServiceCost ? this.foodServiceCost.toJSON() : null as any;
        data["actualFoodServiceAmount"] = this.actualFoodServiceAmount !== undefined ? this.actualFoodServiceAmount : null as any;
        data["semesterId"] = this.semesterId !== undefined ? this.semesterId : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        return data;
    }

    clone(): ApplicationSemestersViewModel {
        const json = this.toJSON();
        let result = new ApplicationSemestersViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicationSemestersViewModel {
    id?: number | null;
    financialSummaryId?: number | null;
    financialSummary?: FinancialSummaryViewModel | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    actualFoodServiceAmount?: number | null;
    semesterId?: string | null;
    semester?: SemesterViewModel | null;
}

export class SemesterViewModel implements ISemesterViewModel {
    semesterCode?: string | null;
    startDate?: Date;
    endDate?: Date;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    workdayAcademicPeriod?: string | null;

    constructor(data?: ISemesterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.semesterCode = _data["semesterCode"] !== undefined ? _data["semesterCode"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : null as any;
            this.workdayAcademicPeriod = _data["workdayAcademicPeriod"] !== undefined ? _data["workdayAcademicPeriod"] : null as any;
        }
    }

    static fromJS(data: any): SemesterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SemesterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["semesterCode"] = this.semesterCode !== undefined ? this.semesterCode : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["workdayAcademicPeriod"] = this.workdayAcademicPeriod !== undefined ? this.workdayAcademicPeriod : null as any;
        return data;
    }

    clone(): SemesterViewModel {
        const json = this.toJSON();
        let result = new SemesterViewModel();
        result.init(json);
        return result;
    }
}

export interface ISemesterViewModel {
    semesterCode?: string | null;
    startDate?: Date;
    endDate?: Date;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    workdayAcademicPeriod?: string | null;
}

export enum ApplicationStatus {
    Submitted = "Submitted",
    UnderReview = "UnderReview",
    Approved = "Approved",
    Denied = "Denied",
    InitialApproval = "InitialApproval",
    InProgress = "InProgress",
    ApprovedWithAutoDebitOnly = "ApprovedWithAutoDebitOnly",
    Cancelled = "Cancelled",
}

export enum ApplicationType {
    New = "New",
    Refinance = "Refinance",
}

export class AccountsBorrowersViewModel implements IAccountsBorrowersViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMainsViewModel?: AccountsMainsViewModel | null;
    applicationApplicantRootId?: number | null;
    applicationApplicantRoot?: ApplicationApplicantRootViewModel | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    employmentData?: AccountsBorrowersEmploymentsViewModel | null;

    constructor(data?: IAccountsBorrowersViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMainsViewModel = _data["accountsMainsViewModel"] ? AccountsMainsViewModel.fromJS(_data["accountsMainsViewModel"]) : null as any;
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.applicationApplicantRoot = _data["applicationApplicantRoot"] ? ApplicationApplicantRootViewModel.fromJS(_data["applicationApplicantRoot"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : null as any;
            this.employmentData = _data["employmentData"] ? AccountsBorrowersEmploymentsViewModel.fromJS(_data["employmentData"]) : null as any;
        }
    }

    static fromJS(data: any): AccountsBorrowersViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsBorrowersViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMainsViewModel"] = this.accountsMainsViewModel ? this.accountsMainsViewModel.toJSON() : null as any;
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["applicationApplicantRoot"] = this.applicationApplicantRoot ? this.applicationApplicantRoot.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : null as any;
        data["employmentData"] = this.employmentData ? this.employmentData.toJSON() : null as any;
        return data;
    }

    clone(): AccountsBorrowersViewModel {
        const json = this.toJSON();
        let result = new AccountsBorrowersViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountsBorrowersViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMainsViewModel?: AccountsMainsViewModel | null;
    applicationApplicantRootId?: number | null;
    applicationApplicantRoot?: ApplicationApplicantRootViewModel | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    employmentData?: AccountsBorrowersEmploymentsViewModel | null;
}

export class AccountsBorrowersEmploymentsViewModel implements IAccountsBorrowersEmploymentsViewModel {
    id?: number | null;
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    borrower?: AccountsBorrowersViewModel | null;
    borrowerId?: number | null;

    constructor(data?: IAccountsBorrowersEmploymentsViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : null as any;
            this.employer = _data["employer"] !== undefined ? _data["employer"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.isVerified = _data["isVerified"] !== undefined ? _data["isVerified"] : null as any;
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : null as any;
            this.borrower = _data["borrower"] ? AccountsBorrowersViewModel.fromJS(_data["borrower"]) : null as any;
            this.borrowerId = _data["borrowerId"] !== undefined ? _data["borrowerId"] : null as any;
        }
    }

    static fromJS(data: any): AccountsBorrowersEmploymentsViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsBorrowersEmploymentsViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["occupation"] = this.occupation !== undefined ? this.occupation : null as any;
        data["employer"] = this.employer !== undefined ? this.employer : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["isVerified"] = this.isVerified !== undefined ? this.isVerified : null as any;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : null as any;
        data["borrower"] = this.borrower ? this.borrower.toJSON() : null as any;
        data["borrowerId"] = this.borrowerId !== undefined ? this.borrowerId : null as any;
        return data;
    }

    clone(): AccountsBorrowersEmploymentsViewModel {
        const json = this.toJSON();
        let result = new AccountsBorrowersEmploymentsViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountsBorrowersEmploymentsViewModel {
    id?: number | null;
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    borrower?: AccountsBorrowersViewModel | null;
    borrowerId?: number | null;
}

export class AccountsStudentInformationViewModel implements IAccountsStudentInformationViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMains?: AccountsMainsViewModel | null;
    applicationStudentRootId?: number | null;
    applicationStudentRoot?: ApplicationStudentRootViewModel | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;

    constructor(data?: IAccountsStudentInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMainsViewModel.fromJS(_data["accountsMains"]) : null as any;
            this.applicationStudentRootId = _data["applicationStudentRootId"] !== undefined ? _data["applicationStudentRootId"] : null as any;
            this.applicationStudentRoot = _data["applicationStudentRoot"] ? ApplicationStudentRootViewModel.fromJS(_data["applicationStudentRoot"]) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : null as any;
            this.academicLevel = _data["academicLevel"] !== undefined ? _data["academicLevel"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
        }
    }

    static fromJS(data: any): AccountsStudentInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsStudentInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["applicationStudentRootId"] = this.applicationStudentRootId !== undefined ? this.applicationStudentRootId : null as any;
        data["applicationStudentRoot"] = this.applicationStudentRoot ? this.applicationStudentRoot.toJSON() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : null as any;
        data["academicLevel"] = this.academicLevel !== undefined ? this.academicLevel : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        return data;
    }

    clone(): AccountsStudentInformationViewModel {
        const json = this.toJSON();
        let result = new AccountsStudentInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountsStudentInformationViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMains?: AccountsMainsViewModel | null;
    applicationStudentRootId?: number | null;
    applicationStudentRoot?: ApplicationStudentRootViewModel | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;
}

export class AccountPlanInformationViewModel implements IAccountPlanInformationViewModel {
    id?: number | null;
    accountsMainId?: number;
    accountsMains?: AccountsMainsViewModel | null;
    programTermsId?: number;
    programTerms?: ProgramTermsViewModel | null;
    pepTotal?: number;
    amountBorrow?: number | null;
    amountPrepay?: number | null;
    serviceLoanId?: number | null;
    loanBalance?: number | null;
    repaymentPeriod?: number | null;
    pepMonthlyPayment?: number | null;
    totalPepSemesters?: number;
    paymentStartDate?: Date | null;
    planComments?: string | null;
    refundName?: RefundName | null;
    isAutoDebitRequired?: boolean;
    paidInFullDate?: Date | null;
    accountCancelled?: boolean;
    accountCancellationDate?: Date | null;
    loanReductionId?: number | null;
    sentServicerDate?: Date | null;
    isOffCampus?: boolean;
    altLoanId?: string | null;
    interestRate?: number | null;
    totalPrepaymentReceived?: number | null;
    totalPrepaymentDifference?: number | null;
    semestersComments?: string | null;
    loanSeqId?: string | null;
    financialAidAward?: number | null;
    fileSeqId?: number | null;

    constructor(data?: IAccountPlanInformationViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountsMainId = _data["accountsMainId"] !== undefined ? _data["accountsMainId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMainsViewModel.fromJS(_data["accountsMains"]) : null as any;
            this.programTermsId = _data["programTermsId"] !== undefined ? _data["programTermsId"] : null as any;
            this.programTerms = _data["programTerms"] ? ProgramTermsViewModel.fromJS(_data["programTerms"]) : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
            this.amountBorrow = _data["amountBorrow"] !== undefined ? _data["amountBorrow"] : null as any;
            this.amountPrepay = _data["amountPrepay"] !== undefined ? _data["amountPrepay"] : null as any;
            this.serviceLoanId = _data["serviceLoanId"] !== undefined ? _data["serviceLoanId"] : null as any;
            this.loanBalance = _data["loanBalance"] !== undefined ? _data["loanBalance"] : null as any;
            this.repaymentPeriod = _data["repaymentPeriod"] !== undefined ? _data["repaymentPeriod"] : null as any;
            this.pepMonthlyPayment = _data["pepMonthlyPayment"] !== undefined ? _data["pepMonthlyPayment"] : null as any;
            this.totalPepSemesters = _data["totalPepSemesters"] !== undefined ? _data["totalPepSemesters"] : null as any;
            this.paymentStartDate = _data["paymentStartDate"] ? new Date(_data["paymentStartDate"].toString()) : null as any;
            this.planComments = _data["planComments"] !== undefined ? _data["planComments"] : null as any;
            this.refundName = _data["refundName"] !== undefined ? _data["refundName"] : null as any;
            this.isAutoDebitRequired = _data["isAutoDebitRequired"] !== undefined ? _data["isAutoDebitRequired"] : null as any;
            this.paidInFullDate = _data["paidInFullDate"] ? new Date(_data["paidInFullDate"].toString()) : null as any;
            this.accountCancelled = _data["accountCancelled"] !== undefined ? _data["accountCancelled"] : null as any;
            this.accountCancellationDate = _data["accountCancellationDate"] ? new Date(_data["accountCancellationDate"].toString()) : null as any;
            this.loanReductionId = _data["loanReductionId"] !== undefined ? _data["loanReductionId"] : null as any;
            this.sentServicerDate = _data["sentServicerDate"] ? new Date(_data["sentServicerDate"].toString()) : null as any;
            this.isOffCampus = _data["isOffCampus"] !== undefined ? _data["isOffCampus"] : null as any;
            this.altLoanId = _data["altLoanId"] !== undefined ? _data["altLoanId"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.totalPrepaymentReceived = _data["totalPrepaymentReceived"] !== undefined ? _data["totalPrepaymentReceived"] : null as any;
            this.totalPrepaymentDifference = _data["totalPrepaymentDifference"] !== undefined ? _data["totalPrepaymentDifference"] : null as any;
            this.semestersComments = _data["semestersComments"] !== undefined ? _data["semestersComments"] : null as any;
            this.loanSeqId = _data["loanSeqId"] !== undefined ? _data["loanSeqId"] : null as any;
            this.financialAidAward = _data["financialAidAward"] !== undefined ? _data["financialAidAward"] : null as any;
            this.fileSeqId = _data["fileSeqId"] !== undefined ? _data["fileSeqId"] : null as any;
        }
    }

    static fromJS(data: any): AccountPlanInformationViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPlanInformationViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountsMainId"] = this.accountsMainId !== undefined ? this.accountsMainId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["programTermsId"] = this.programTermsId !== undefined ? this.programTermsId : null as any;
        data["programTerms"] = this.programTerms ? this.programTerms.toJSON() : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        data["amountBorrow"] = this.amountBorrow !== undefined ? this.amountBorrow : null as any;
        data["amountPrepay"] = this.amountPrepay !== undefined ? this.amountPrepay : null as any;
        data["serviceLoanId"] = this.serviceLoanId !== undefined ? this.serviceLoanId : null as any;
        data["loanBalance"] = this.loanBalance !== undefined ? this.loanBalance : null as any;
        data["repaymentPeriod"] = this.repaymentPeriod !== undefined ? this.repaymentPeriod : null as any;
        data["pepMonthlyPayment"] = this.pepMonthlyPayment !== undefined ? this.pepMonthlyPayment : null as any;
        data["totalPepSemesters"] = this.totalPepSemesters !== undefined ? this.totalPepSemesters : null as any;
        data["paymentStartDate"] = this.paymentStartDate ? this.paymentStartDate.toISOString() : null as any;
        data["planComments"] = this.planComments !== undefined ? this.planComments : null as any;
        data["refundName"] = this.refundName !== undefined ? this.refundName : null as any;
        data["isAutoDebitRequired"] = this.isAutoDebitRequired !== undefined ? this.isAutoDebitRequired : null as any;
        data["paidInFullDate"] = this.paidInFullDate ? this.paidInFullDate.toISOString() : null as any;
        data["accountCancelled"] = this.accountCancelled !== undefined ? this.accountCancelled : null as any;
        data["accountCancellationDate"] = this.accountCancellationDate ? this.accountCancellationDate.toISOString() : null as any;
        data["loanReductionId"] = this.loanReductionId !== undefined ? this.loanReductionId : null as any;
        data["sentServicerDate"] = this.sentServicerDate ? this.sentServicerDate.toISOString() : null as any;
        data["isOffCampus"] = this.isOffCampus !== undefined ? this.isOffCampus : null as any;
        data["altLoanId"] = this.altLoanId !== undefined ? this.altLoanId : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["totalPrepaymentReceived"] = this.totalPrepaymentReceived !== undefined ? this.totalPrepaymentReceived : null as any;
        data["totalPrepaymentDifference"] = this.totalPrepaymentDifference !== undefined ? this.totalPrepaymentDifference : null as any;
        data["semestersComments"] = this.semestersComments !== undefined ? this.semestersComments : null as any;
        data["loanSeqId"] = this.loanSeqId !== undefined ? this.loanSeqId : null as any;
        data["financialAidAward"] = this.financialAidAward !== undefined ? this.financialAidAward : null as any;
        data["fileSeqId"] = this.fileSeqId !== undefined ? this.fileSeqId : null as any;
        return data;
    }

    clone(): AccountPlanInformationViewModel {
        const json = this.toJSON();
        let result = new AccountPlanInformationViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountPlanInformationViewModel {
    id?: number | null;
    accountsMainId?: number;
    accountsMains?: AccountsMainsViewModel | null;
    programTermsId?: number;
    programTerms?: ProgramTermsViewModel | null;
    pepTotal?: number;
    amountBorrow?: number | null;
    amountPrepay?: number | null;
    serviceLoanId?: number | null;
    loanBalance?: number | null;
    repaymentPeriod?: number | null;
    pepMonthlyPayment?: number | null;
    totalPepSemesters?: number;
    paymentStartDate?: Date | null;
    planComments?: string | null;
    refundName?: RefundName | null;
    isAutoDebitRequired?: boolean;
    paidInFullDate?: Date | null;
    accountCancelled?: boolean;
    accountCancellationDate?: Date | null;
    loanReductionId?: number | null;
    sentServicerDate?: Date | null;
    isOffCampus?: boolean;
    altLoanId?: string | null;
    interestRate?: number | null;
    totalPrepaymentReceived?: number | null;
    totalPrepaymentDifference?: number | null;
    semestersComments?: string | null;
    loanSeqId?: string | null;
    financialAidAward?: number | null;
    fileSeqId?: number | null;
}

export enum RefundName {
    Applicant = "Applicant",
    Student = "Student",
    Loan = "Loan",
}

export class PrepaymentRecordViewModel implements IPrepaymentRecordViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    payerName?: string | null;
    checkNumber?: string | null;
    amountApplied?: number;
    totalCheckAmount?: number;
    receivedDate?: Date;
    comments?: string | null;
    semester?: SemesterViewModel | null;
    allowTransaction?: boolean;
    splitTransactions?: SplitTransactionViewModel[] | null;

    constructor(data?: IPrepaymentRecordViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.payerName = _data["payerName"] !== undefined ? _data["payerName"] : null as any;
            this.checkNumber = _data["checkNumber"] !== undefined ? _data["checkNumber"] : null as any;
            this.amountApplied = _data["amountApplied"] !== undefined ? _data["amountApplied"] : null as any;
            this.totalCheckAmount = _data["totalCheckAmount"] !== undefined ? _data["totalCheckAmount"] : null as any;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.semester = _data["semester"] ? SemesterViewModel.fromJS(_data["semester"]) : null as any;
            this.allowTransaction = _data["allowTransaction"] !== undefined ? _data["allowTransaction"] : null as any;
            if (Array.isArray(_data["splitTransactions"])) {
                this.splitTransactions = [] as any;
                for (let item of _data["splitTransactions"])
                    this.splitTransactions!.push(SplitTransactionViewModel.fromJS(item));
            }
            else {
                this.splitTransactions = null as any;
            }
        }
    }

    static fromJS(data: any): PrepaymentRecordViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PrepaymentRecordViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["payerName"] = this.payerName !== undefined ? this.payerName : null as any;
        data["checkNumber"] = this.checkNumber !== undefined ? this.checkNumber : null as any;
        data["amountApplied"] = this.amountApplied !== undefined ? this.amountApplied : null as any;
        data["totalCheckAmount"] = this.totalCheckAmount !== undefined ? this.totalCheckAmount : null as any;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        data["allowTransaction"] = this.allowTransaction !== undefined ? this.allowTransaction : null as any;
        if (Array.isArray(this.splitTransactions)) {
            data["splitTransactions"] = [];
            for (let item of this.splitTransactions)
                data["splitTransactions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): PrepaymentRecordViewModel {
        const json = this.toJSON();
        let result = new PrepaymentRecordViewModel();
        result.init(json);
        return result;
    }
}

export interface IPrepaymentRecordViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    payerName?: string | null;
    checkNumber?: string | null;
    amountApplied?: number;
    totalCheckAmount?: number;
    receivedDate?: Date;
    comments?: string | null;
    semester?: SemesterViewModel | null;
    allowTransaction?: boolean;
    splitTransactions?: SplitTransactionViewModel[] | null;
}

export abstract class BaseModel implements IBaseModel {
    id?: number;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;

    constructor(data?: IBaseModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : null as any;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : null as any;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : null as any;
        }
    }

    static fromJS(data: any): BaseModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : null as any;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : null as any;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : null as any;
        return data;
    }

    clone(): BaseModel {
        throw new Error("The abstract class 'BaseModel' cannot be instantiated.");
    }
}

export interface IBaseModel {
    id?: number;
    createdDate?: Date;
    lastUpdatedDate?: Date;
    updateUserId?: string | null;
}

export class AccountsMains extends BaseModel implements IAccountsMains {
    applicationId?: number;
    application?: Application | null;
    status?: AccountStatus | null;
    hasPepAgreementGenerated?: boolean;
    accountsStudentInformation?: AccountsStudentInformation | null;
    accountPlanInformation?: AccountPlanInformation | null;
    prepaymentRecords?: PrePaymentRecord[] | null;
    accountFinancialAsset?: AccountFinancialAsset | null;
    accountPlanReductions?: AccountPlanReduction[] | null;
    accountDocuments?: AccountDocument[] | null;
    accountApplicantTypes?: AccountApplicantType[] | null;
    legacyAccountsMainsId?: number | null;

    constructor(data?: IAccountsMains) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.hasPepAgreementGenerated = _data["hasPepAgreementGenerated"] !== undefined ? _data["hasPepAgreementGenerated"] : null as any;
            this.accountsStudentInformation = _data["accountsStudentInformation"] ? AccountsStudentInformation.fromJS(_data["accountsStudentInformation"]) : null as any;
            this.accountPlanInformation = _data["accountPlanInformation"] ? AccountPlanInformation.fromJS(_data["accountPlanInformation"]) : null as any;
            if (Array.isArray(_data["prepaymentRecords"])) {
                this.prepaymentRecords = [] as any;
                for (let item of _data["prepaymentRecords"])
                    this.prepaymentRecords!.push(PrePaymentRecord.fromJS(item));
            }
            else {
                this.prepaymentRecords = null as any;
            }
            this.accountFinancialAsset = _data["accountFinancialAsset"] ? AccountFinancialAsset.fromJS(_data["accountFinancialAsset"]) : null as any;
            if (Array.isArray(_data["accountPlanReductions"])) {
                this.accountPlanReductions = [] as any;
                for (let item of _data["accountPlanReductions"])
                    this.accountPlanReductions!.push(AccountPlanReduction.fromJS(item));
            }
            else {
                this.accountPlanReductions = null as any;
            }
            if (Array.isArray(_data["accountDocuments"])) {
                this.accountDocuments = [] as any;
                for (let item of _data["accountDocuments"])
                    this.accountDocuments!.push(AccountDocument.fromJS(item));
            }
            else {
                this.accountDocuments = null as any;
            }
            if (Array.isArray(_data["accountApplicantTypes"])) {
                this.accountApplicantTypes = [] as any;
                for (let item of _data["accountApplicantTypes"])
                    this.accountApplicantTypes!.push(AccountApplicantType.fromJS(item));
            }
            else {
                this.accountApplicantTypes = null as any;
            }
            this.legacyAccountsMainsId = _data["legacyAccountsMainsId"] !== undefined ? _data["legacyAccountsMainsId"] : null as any;
        }
    }

    static fromJS(data: any): AccountsMains {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsMains();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["hasPepAgreementGenerated"] = this.hasPepAgreementGenerated !== undefined ? this.hasPepAgreementGenerated : null as any;
        data["accountsStudentInformation"] = this.accountsStudentInformation ? this.accountsStudentInformation.toJSON() : null as any;
        data["accountPlanInformation"] = this.accountPlanInformation ? this.accountPlanInformation.toJSON() : null as any;
        if (Array.isArray(this.prepaymentRecords)) {
            data["prepaymentRecords"] = [];
            for (let item of this.prepaymentRecords)
                data["prepaymentRecords"].push(item ? item.toJSON() : null as any);
        }
        data["accountFinancialAsset"] = this.accountFinancialAsset ? this.accountFinancialAsset.toJSON() : null as any;
        if (Array.isArray(this.accountPlanReductions)) {
            data["accountPlanReductions"] = [];
            for (let item of this.accountPlanReductions)
                data["accountPlanReductions"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountDocuments)) {
            data["accountDocuments"] = [];
            for (let item of this.accountDocuments)
                data["accountDocuments"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.accountApplicantTypes)) {
            data["accountApplicantTypes"] = [];
            for (let item of this.accountApplicantTypes)
                data["accountApplicantTypes"].push(item ? item.toJSON() : null as any);
        }
        data["legacyAccountsMainsId"] = this.legacyAccountsMainsId !== undefined ? this.legacyAccountsMainsId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountsMains {
        const json = this.toJSON();
        let result = new AccountsMains();
        result.init(json);
        return result;
    }
}

export interface IAccountsMains extends IBaseModel {
    applicationId?: number;
    application?: Application | null;
    status?: AccountStatus | null;
    hasPepAgreementGenerated?: boolean;
    accountsStudentInformation?: AccountsStudentInformation | null;
    accountPlanInformation?: AccountPlanInformation | null;
    prepaymentRecords?: PrePaymentRecord[] | null;
    accountFinancialAsset?: AccountFinancialAsset | null;
    accountPlanReductions?: AccountPlanReduction[] | null;
    accountDocuments?: AccountDocument[] | null;
    accountApplicantTypes?: AccountApplicantType[] | null;
    legacyAccountsMainsId?: number | null;
}

export class Application extends BaseModel implements IApplication {
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    applicationStudent?: ApplicationStudent | null;
    applicationAdditionalInformation?: ApplicationAdditionalInformation | null;
    applicationPlanParticipation?: ApplicationPlanParticipation | null;
    applicationUploads?: ApplicationUploads[] | null;
    financialData?: ApplicationFinancialData | null;
    applicants?: Applicant[] | null;
    applicantSignatureDate?: Date | null;
    coApplicantSignatureDate?: Date | null;
    financialSummary?: FinancialSummary[] | null;
    programTermsId?: number;
    programTerms?: ProgramTerms | null;
    interestRate?: number | null;
    status?: ApplicationStatus | null;
    approvalNotes?: string | null;
    type?: ApplicationType;
    finalDecision?: boolean | null;
    updateId?: number | null;
    pdfBlobName?: string | null;
    isDeleted?: boolean;
    legacyApplicationId?: number | null;

    constructor(data?: IApplication) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYear.fromJS(_data["fiscalYear"]) : null as any;
            this.applicationStudent = _data["applicationStudent"] ? ApplicationStudent.fromJS(_data["applicationStudent"]) : null as any;
            this.applicationAdditionalInformation = _data["applicationAdditionalInformation"] ? ApplicationAdditionalInformation.fromJS(_data["applicationAdditionalInformation"]) : null as any;
            this.applicationPlanParticipation = _data["applicationPlanParticipation"] ? ApplicationPlanParticipation.fromJS(_data["applicationPlanParticipation"]) : null as any;
            if (Array.isArray(_data["applicationUploads"])) {
                this.applicationUploads = [] as any;
                for (let item of _data["applicationUploads"])
                    this.applicationUploads!.push(ApplicationUploads.fromJS(item));
            }
            else {
                this.applicationUploads = null as any;
            }
            this.financialData = _data["financialData"] ? ApplicationFinancialData.fromJS(_data["financialData"]) : null as any;
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(Applicant.fromJS(item));
            }
            else {
                this.applicants = null as any;
            }
            this.applicantSignatureDate = _data["applicantSignatureDate"] ? new Date(_data["applicantSignatureDate"].toString()) : null as any;
            this.coApplicantSignatureDate = _data["coApplicantSignatureDate"] ? new Date(_data["coApplicantSignatureDate"].toString()) : null as any;
            if (Array.isArray(_data["financialSummary"])) {
                this.financialSummary = [] as any;
                for (let item of _data["financialSummary"])
                    this.financialSummary!.push(FinancialSummary.fromJS(item));
            }
            else {
                this.financialSummary = null as any;
            }
            this.programTermsId = _data["programTermsId"] !== undefined ? _data["programTermsId"] : null as any;
            this.programTerms = _data["programTerms"] ? ProgramTerms.fromJS(_data["programTerms"]) : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.approvalNotes = _data["approvalNotes"] !== undefined ? _data["approvalNotes"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.finalDecision = _data["finalDecision"] !== undefined ? _data["finalDecision"] : null as any;
            this.updateId = _data["updateId"] !== undefined ? _data["updateId"] : null as any;
            this.pdfBlobName = _data["pdfBlobName"] !== undefined ? _data["pdfBlobName"] : null as any;
            this.isDeleted = _data["isDeleted"] !== undefined ? _data["isDeleted"] : null as any;
            this.legacyApplicationId = _data["legacyApplicationId"] !== undefined ? _data["legacyApplicationId"] : null as any;
        }
    }

    static fromJS(data: any): Application {
        data = typeof data === 'object' ? data : {};
        let result = new Application();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["applicationStudent"] = this.applicationStudent ? this.applicationStudent.toJSON() : null as any;
        data["applicationAdditionalInformation"] = this.applicationAdditionalInformation ? this.applicationAdditionalInformation.toJSON() : null as any;
        data["applicationPlanParticipation"] = this.applicationPlanParticipation ? this.applicationPlanParticipation.toJSON() : null as any;
        if (Array.isArray(this.applicationUploads)) {
            data["applicationUploads"] = [];
            for (let item of this.applicationUploads)
                data["applicationUploads"].push(item ? item.toJSON() : null as any);
        }
        data["financialData"] = this.financialData ? this.financialData.toJSON() : null as any;
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item ? item.toJSON() : null as any);
        }
        data["applicantSignatureDate"] = this.applicantSignatureDate ? this.applicantSignatureDate.toISOString() : null as any;
        data["coApplicantSignatureDate"] = this.coApplicantSignatureDate ? this.coApplicantSignatureDate.toISOString() : null as any;
        if (Array.isArray(this.financialSummary)) {
            data["financialSummary"] = [];
            for (let item of this.financialSummary)
                data["financialSummary"].push(item ? item.toJSON() : null as any);
        }
        data["programTermsId"] = this.programTermsId !== undefined ? this.programTermsId : null as any;
        data["programTerms"] = this.programTerms ? this.programTerms.toJSON() : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["approvalNotes"] = this.approvalNotes !== undefined ? this.approvalNotes : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["finalDecision"] = this.finalDecision !== undefined ? this.finalDecision : null as any;
        data["updateId"] = this.updateId !== undefined ? this.updateId : null as any;
        data["pdfBlobName"] = this.pdfBlobName !== undefined ? this.pdfBlobName : null as any;
        data["isDeleted"] = this.isDeleted !== undefined ? this.isDeleted : null as any;
        data["legacyApplicationId"] = this.legacyApplicationId !== undefined ? this.legacyApplicationId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Application {
        const json = this.toJSON();
        let result = new Application();
        result.init(json);
        return result;
    }
}

export interface IApplication extends IBaseModel {
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    applicationStudent?: ApplicationStudent | null;
    applicationAdditionalInformation?: ApplicationAdditionalInformation | null;
    applicationPlanParticipation?: ApplicationPlanParticipation | null;
    applicationUploads?: ApplicationUploads[] | null;
    financialData?: ApplicationFinancialData | null;
    applicants?: Applicant[] | null;
    applicantSignatureDate?: Date | null;
    coApplicantSignatureDate?: Date | null;
    financialSummary?: FinancialSummary[] | null;
    programTermsId?: number;
    programTerms?: ProgramTerms | null;
    interestRate?: number | null;
    status?: ApplicationStatus | null;
    approvalNotes?: string | null;
    type?: ApplicationType;
    finalDecision?: boolean | null;
    updateId?: number | null;
    pdfBlobName?: string | null;
    isDeleted?: boolean;
    legacyApplicationId?: number | null;
}

export class FiscalYear extends BaseModel implements IFiscalYear {
    year?: number;
    isSystemFiscalYear?: boolean;
    isPepApplicationFiscalYear?: boolean;
    isFpcwFiscalYear?: boolean;
    costs?: Cost[] | null;
    applications?: Application[] | null;
    semesters?: Semester[] | null;
    programTerms?: ProgramTerms[] | null;
    legacyMigratedFiscalYearId?: number | null;
    workdayAwardYear?: string | null;

    constructor(data?: IFiscalYear) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.year = _data["year"] !== undefined ? _data["year"] : null as any;
            this.isSystemFiscalYear = _data["isSystemFiscalYear"] !== undefined ? _data["isSystemFiscalYear"] : null as any;
            this.isPepApplicationFiscalYear = _data["isPepApplicationFiscalYear"] !== undefined ? _data["isPepApplicationFiscalYear"] : null as any;
            this.isFpcwFiscalYear = _data["isFpcwFiscalYear"] !== undefined ? _data["isFpcwFiscalYear"] : null as any;
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(Cost.fromJS(item));
            }
            else {
                this.costs = null as any;
            }
            if (Array.isArray(_data["applications"])) {
                this.applications = [] as any;
                for (let item of _data["applications"])
                    this.applications!.push(Application.fromJS(item));
            }
            else {
                this.applications = null as any;
            }
            if (Array.isArray(_data["semesters"])) {
                this.semesters = [] as any;
                for (let item of _data["semesters"])
                    this.semesters!.push(Semester.fromJS(item));
            }
            else {
                this.semesters = null as any;
            }
            if (Array.isArray(_data["programTerms"])) {
                this.programTerms = [] as any;
                for (let item of _data["programTerms"])
                    this.programTerms!.push(ProgramTerms.fromJS(item));
            }
            else {
                this.programTerms = null as any;
            }
            this.legacyMigratedFiscalYearId = _data["legacyMigratedFiscalYearId"] !== undefined ? _data["legacyMigratedFiscalYearId"] : null as any;
            this.workdayAwardYear = _data["workdayAwardYear"] !== undefined ? _data["workdayAwardYear"] : null as any;
        }
    }

    static fromJS(data: any): FiscalYear {
        data = typeof data === 'object' ? data : {};
        let result = new FiscalYear();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year !== undefined ? this.year : null as any;
        data["isSystemFiscalYear"] = this.isSystemFiscalYear !== undefined ? this.isSystemFiscalYear : null as any;
        data["isPepApplicationFiscalYear"] = this.isPepApplicationFiscalYear !== undefined ? this.isPepApplicationFiscalYear : null as any;
        data["isFpcwFiscalYear"] = this.isFpcwFiscalYear !== undefined ? this.isFpcwFiscalYear : null as any;
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.applications)) {
            data["applications"] = [];
            for (let item of this.applications)
                data["applications"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.semesters)) {
            data["semesters"] = [];
            for (let item of this.semesters)
                data["semesters"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.programTerms)) {
            data["programTerms"] = [];
            for (let item of this.programTerms)
                data["programTerms"].push(item ? item.toJSON() : null as any);
        }
        data["legacyMigratedFiscalYearId"] = this.legacyMigratedFiscalYearId !== undefined ? this.legacyMigratedFiscalYearId : null as any;
        data["workdayAwardYear"] = this.workdayAwardYear !== undefined ? this.workdayAwardYear : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): FiscalYear {
        const json = this.toJSON();
        let result = new FiscalYear();
        result.init(json);
        return result;
    }
}

export interface IFiscalYear extends IBaseModel {
    year?: number;
    isSystemFiscalYear?: boolean;
    isPepApplicationFiscalYear?: boolean;
    isFpcwFiscalYear?: boolean;
    costs?: Cost[] | null;
    applications?: Application[] | null;
    semesters?: Semester[] | null;
    programTerms?: ProgramTerms[] | null;
    legacyMigratedFiscalYearId?: number | null;
    workdayAwardYear?: string | null;
}

export class Cost extends BaseModel implements ICost {
    lastUpdatedUserId?: number;
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    menuType?: MenuType;
    chargeName?: string | null;
    componentType?: ComponentType;
    amount?: number;
    fresh?: boolean;
    nonFresh?: boolean;
    sortOrder?: number;
    deactivatedDate?: Date | null;
    copyKey?: string | null;

    constructor(data?: ICost) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.lastUpdatedUserId = _data["lastUpdatedUserId"] !== undefined ? _data["lastUpdatedUserId"] : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYear.fromJS(_data["fiscalYear"]) : null as any;
            this.menuType = _data["menuType"] !== undefined ? _data["menuType"] : null as any;
            this.chargeName = _data["chargeName"] !== undefined ? _data["chargeName"] : null as any;
            this.componentType = _data["componentType"] !== undefined ? _data["componentType"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.fresh = _data["fresh"] !== undefined ? _data["fresh"] : null as any;
            this.nonFresh = _data["nonFresh"] !== undefined ? _data["nonFresh"] : null as any;
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.deactivatedDate = _data["deactivatedDate"] ? new Date(_data["deactivatedDate"].toString()) : null as any;
            this.copyKey = _data["copyKey"] !== undefined ? _data["copyKey"] : null as any;
        }
    }

    static fromJS(data: any): Cost {
        data = typeof data === 'object' ? data : {};
        let result = new Cost();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastUpdatedUserId"] = this.lastUpdatedUserId !== undefined ? this.lastUpdatedUserId : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["menuType"] = this.menuType !== undefined ? this.menuType : null as any;
        data["chargeName"] = this.chargeName !== undefined ? this.chargeName : null as any;
        data["componentType"] = this.componentType !== undefined ? this.componentType : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["fresh"] = this.fresh !== undefined ? this.fresh : null as any;
        data["nonFresh"] = this.nonFresh !== undefined ? this.nonFresh : null as any;
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["deactivatedDate"] = this.deactivatedDate ? this.deactivatedDate.toISOString() : null as any;
        data["copyKey"] = this.copyKey !== undefined ? this.copyKey : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Cost {
        const json = this.toJSON();
        let result = new Cost();
        result.init(json);
        return result;
    }
}

export interface ICost extends IBaseModel {
    lastUpdatedUserId?: number;
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    menuType?: MenuType;
    chargeName?: string | null;
    componentType?: ComponentType;
    amount?: number;
    fresh?: boolean;
    nonFresh?: boolean;
    sortOrder?: number;
    deactivatedDate?: Date | null;
    copyKey?: string | null;
}

export class Semester extends BaseModel implements ISemester {
    id?: number;
    semesterCode?: string | null;
    startDate?: Date;
    endDate?: Date;
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    workdayAcademicPeriod?: string | null;

    constructor(data?: ISemester) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.semesterCode = _data["semesterCode"] !== undefined ? _data["semesterCode"] : null as any;
            this.startDate = _data["startDate"] ? new Date(_data["startDate"].toString()) : null as any;
            this.endDate = _data["endDate"] ? new Date(_data["endDate"].toString()) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYear.fromJS(_data["fiscalYear"]) : null as any;
            this.workdayAcademicPeriod = _data["workdayAcademicPeriod"] !== undefined ? _data["workdayAcademicPeriod"] : null as any;
        }
    }

    static fromJS(data: any): Semester {
        data = typeof data === 'object' ? data : {};
        let result = new Semester();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["semesterCode"] = this.semesterCode !== undefined ? this.semesterCode : null as any;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : null as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["workdayAcademicPeriod"] = this.workdayAcademicPeriod !== undefined ? this.workdayAcademicPeriod : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Semester {
        const json = this.toJSON();
        let result = new Semester();
        result.init(json);
        return result;
    }
}

export interface ISemester extends IBaseModel {
    id?: number;
    semesterCode?: string | null;
    startDate?: Date;
    endDate?: Date;
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    workdayAcademicPeriod?: string | null;
}

export class ProgramTerms extends BaseModel implements IProgramTerms {
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    planType?: PlanType;
    interestRate?: number;
    originationFee?: number;
    annualFee?: number;
    standardTerm?: number;
    standardTermType?: LengthType;
    paymentsPerYear?: PaymentsPerYear;
    gracePeriod?: number;
    gracePeriodType?: LengthType;
    altLoanId?: string | null;

    constructor(data?: IProgramTerms) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYear.fromJS(_data["fiscalYear"]) : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.originationFee = _data["originationFee"] !== undefined ? _data["originationFee"] : null as any;
            this.annualFee = _data["annualFee"] !== undefined ? _data["annualFee"] : null as any;
            this.standardTerm = _data["standardTerm"] !== undefined ? _data["standardTerm"] : null as any;
            this.standardTermType = _data["standardTermType"] !== undefined ? _data["standardTermType"] : null as any;
            this.paymentsPerYear = _data["paymentsPerYear"] !== undefined ? _data["paymentsPerYear"] : null as any;
            this.gracePeriod = _data["gracePeriod"] !== undefined ? _data["gracePeriod"] : null as any;
            this.gracePeriodType = _data["gracePeriodType"] !== undefined ? _data["gracePeriodType"] : null as any;
            this.altLoanId = _data["altLoanId"] !== undefined ? _data["altLoanId"] : null as any;
        }
    }

    static fromJS(data: any): ProgramTerms {
        data = typeof data === 'object' ? data : {};
        let result = new ProgramTerms();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["originationFee"] = this.originationFee !== undefined ? this.originationFee : null as any;
        data["annualFee"] = this.annualFee !== undefined ? this.annualFee : null as any;
        data["standardTerm"] = this.standardTerm !== undefined ? this.standardTerm : null as any;
        data["standardTermType"] = this.standardTermType !== undefined ? this.standardTermType : null as any;
        data["paymentsPerYear"] = this.paymentsPerYear !== undefined ? this.paymentsPerYear : null as any;
        data["gracePeriod"] = this.gracePeriod !== undefined ? this.gracePeriod : null as any;
        data["gracePeriodType"] = this.gracePeriodType !== undefined ? this.gracePeriodType : null as any;
        data["altLoanId"] = this.altLoanId !== undefined ? this.altLoanId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ProgramTerms {
        const json = this.toJSON();
        let result = new ProgramTerms();
        result.init(json);
        return result;
    }
}

export interface IProgramTerms extends IBaseModel {
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    planType?: PlanType;
    interestRate?: number;
    originationFee?: number;
    annualFee?: number;
    standardTerm?: number;
    standardTermType?: LengthType;
    paymentsPerYear?: PaymentsPerYear;
    gracePeriod?: number;
    gracePeriodType?: LengthType;
    altLoanId?: string | null;
}

export class ApplicationStudent extends BaseModel implements IApplicationStudent {
    applicationId?: number;
    application?: Application | null;
    applicationStudentRootId?: number;
    applicationStudentRoot?: ApplicationStudentRoot | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;
    isNew?: boolean;
    hasMpStatus?: boolean;

    constructor(data?: IApplicationStudent) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.applicationStudentRootId = _data["applicationStudentRootId"] !== undefined ? _data["applicationStudentRootId"] : null as any;
            this.applicationStudentRoot = _data["applicationStudentRoot"] ? ApplicationStudentRoot.fromJS(_data["applicationStudentRoot"]) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : null as any;
            this.academicLevel = _data["academicLevel"] !== undefined ? _data["academicLevel"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
            this.hasMpStatus = _data["hasMpStatus"] !== undefined ? _data["hasMpStatus"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationStudent {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationStudent();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["applicationStudentRootId"] = this.applicationStudentRootId !== undefined ? this.applicationStudentRootId : null as any;
        data["applicationStudentRoot"] = this.applicationStudentRoot ? this.applicationStudentRoot.toJSON() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : null as any;
        data["academicLevel"] = this.academicLevel !== undefined ? this.academicLevel : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        data["hasMpStatus"] = this.hasMpStatus !== undefined ? this.hasMpStatus : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationStudent {
        const json = this.toJSON();
        let result = new ApplicationStudent();
        result.init(json);
        return result;
    }
}

export interface IApplicationStudent extends IBaseModel {
    applicationId?: number;
    application?: Application | null;
    applicationStudentRootId?: number;
    applicationStudentRoot?: ApplicationStudentRoot | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;
    isNew?: boolean;
    hasMpStatus?: boolean;
}

export class ApplicationStudentRoot extends BaseModel implements IApplicationStudentRoot {
    ssn?: string | null;
    lastFour?: string | null;

    constructor(data?: IApplicationStudentRoot) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.lastFour = _data["lastFour"] !== undefined ? _data["lastFour"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationStudentRoot {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationStudentRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["lastFour"] = this.lastFour !== undefined ? this.lastFour : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationStudentRoot {
        const json = this.toJSON();
        let result = new ApplicationStudentRoot();
        result.init(json);
        return result;
    }
}

export interface IApplicationStudentRoot extends IBaseModel {
    ssn?: string | null;
    lastFour?: string | null;
}

export class ApplicationAdditionalInformation extends BaseModel implements IApplicationAdditionalInformation {
    applicationId?: number;
    application?: Application | null;
    financialSituation?: string | null;
    comments?: string | null;

    constructor(data?: IApplicationAdditionalInformation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.financialSituation = _data["financialSituation"] !== undefined ? _data["financialSituation"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationAdditionalInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationAdditionalInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["financialSituation"] = this.financialSituation !== undefined ? this.financialSituation : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationAdditionalInformation {
        const json = this.toJSON();
        let result = new ApplicationAdditionalInformation();
        result.init(json);
        return result;
    }
}

export interface IApplicationAdditionalInformation extends IBaseModel {
    applicationId?: number;
    application?: Application | null;
    financialSituation?: string | null;
    comments?: string | null;
}

export class ApplicationPlanParticipation extends BaseModel implements IApplicationPlanParticipation {
    applicationId?: number;
    application?: Application | null;
    tuitionCostId?: number | null;
    tuitionCost?: Cost | null;
    activityCostId?: number | null;
    activityCost?: Cost | null;
    housingCostId?: number | null;
    housingCost?: Cost | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: Cost | null;
    totalAnnualCharges?: number;
    financialAidAward?: number;
    baseYearTotal?: number;
    pepSemesters?: number;
    planProjectionAmount?: number;
    borrowAmount?: number | null;
    prepayAmount?: number | null;
    pepTotal?: number;

    constructor(data?: IApplicationPlanParticipation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.tuitionCostId = _data["tuitionCostId"] !== undefined ? _data["tuitionCostId"] : null as any;
            this.tuitionCost = _data["tuitionCost"] ? Cost.fromJS(_data["tuitionCost"]) : null as any;
            this.activityCostId = _data["activityCostId"] !== undefined ? _data["activityCostId"] : null as any;
            this.activityCost = _data["activityCost"] ? Cost.fromJS(_data["activityCost"]) : null as any;
            this.housingCostId = _data["housingCostId"] !== undefined ? _data["housingCostId"] : null as any;
            this.housingCost = _data["housingCost"] ? Cost.fromJS(_data["housingCost"]) : null as any;
            this.foodServiceCostId = _data["foodServiceCostId"] !== undefined ? _data["foodServiceCostId"] : null as any;
            this.foodServiceCost = _data["foodServiceCost"] ? Cost.fromJS(_data["foodServiceCost"]) : null as any;
            this.totalAnnualCharges = _data["totalAnnualCharges"] !== undefined ? _data["totalAnnualCharges"] : null as any;
            this.financialAidAward = _data["financialAidAward"] !== undefined ? _data["financialAidAward"] : null as any;
            this.baseYearTotal = _data["baseYearTotal"] !== undefined ? _data["baseYearTotal"] : null as any;
            this.pepSemesters = _data["pepSemesters"] !== undefined ? _data["pepSemesters"] : null as any;
            this.planProjectionAmount = _data["planProjectionAmount"] !== undefined ? _data["planProjectionAmount"] : null as any;
            this.borrowAmount = _data["borrowAmount"] !== undefined ? _data["borrowAmount"] : null as any;
            this.prepayAmount = _data["prepayAmount"] !== undefined ? _data["prepayAmount"] : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationPlanParticipation {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationPlanParticipation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["tuitionCostId"] = this.tuitionCostId !== undefined ? this.tuitionCostId : null as any;
        data["tuitionCost"] = this.tuitionCost ? this.tuitionCost.toJSON() : null as any;
        data["activityCostId"] = this.activityCostId !== undefined ? this.activityCostId : null as any;
        data["activityCost"] = this.activityCost ? this.activityCost.toJSON() : null as any;
        data["housingCostId"] = this.housingCostId !== undefined ? this.housingCostId : null as any;
        data["housingCost"] = this.housingCost ? this.housingCost.toJSON() : null as any;
        data["foodServiceCostId"] = this.foodServiceCostId !== undefined ? this.foodServiceCostId : null as any;
        data["foodServiceCost"] = this.foodServiceCost ? this.foodServiceCost.toJSON() : null as any;
        data["totalAnnualCharges"] = this.totalAnnualCharges !== undefined ? this.totalAnnualCharges : null as any;
        data["financialAidAward"] = this.financialAidAward !== undefined ? this.financialAidAward : null as any;
        data["baseYearTotal"] = this.baseYearTotal !== undefined ? this.baseYearTotal : null as any;
        data["pepSemesters"] = this.pepSemesters !== undefined ? this.pepSemesters : null as any;
        data["planProjectionAmount"] = this.planProjectionAmount !== undefined ? this.planProjectionAmount : null as any;
        data["borrowAmount"] = this.borrowAmount !== undefined ? this.borrowAmount : null as any;
        data["prepayAmount"] = this.prepayAmount !== undefined ? this.prepayAmount : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationPlanParticipation {
        const json = this.toJSON();
        let result = new ApplicationPlanParticipation();
        result.init(json);
        return result;
    }
}

export interface IApplicationPlanParticipation extends IBaseModel {
    applicationId?: number;
    application?: Application | null;
    tuitionCostId?: number | null;
    tuitionCost?: Cost | null;
    activityCostId?: number | null;
    activityCost?: Cost | null;
    housingCostId?: number | null;
    housingCost?: Cost | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: Cost | null;
    totalAnnualCharges?: number;
    financialAidAward?: number;
    baseYearTotal?: number;
    pepSemesters?: number;
    planProjectionAmount?: number;
    borrowAmount?: number | null;
    prepayAmount?: number | null;
    pepTotal?: number;
}

export class ApplicationUploads extends BaseModel implements IApplicationUploads {
    applicationId?: number;
    application?: Application | null;
    fileName?: string | null;
    description?: string | null;

    constructor(data?: IApplicationUploads) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationUploads {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationUploads();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationUploads {
        const json = this.toJSON();
        let result = new ApplicationUploads();
        result.init(json);
        return result;
    }
}

export interface IApplicationUploads extends IBaseModel {
    applicationId?: number;
    application?: Application | null;
    fileName?: string | null;
    description?: string | null;
}

export class FinancialData extends BaseModel implements IFinancialData {
    applicationId?: number | null;
    application?: Application | null;
    financialSummaryId?: number | null;
    financialSummary?: FinancialSummary | null;
    liquidAssets?: number;
    nonRetirementAssets?: number;
    retirementAssets?: number;
    businessValue?: number;
    realEstateValue?: number;
    isHomeOwner?: boolean;
    grossIncome?: number | null;
    mortgageInterest?: number | null;
    monthlyHousingCost?: number | null;
    disposableIncome?: number | null;
    agiLessDeductions?: number | null;
    totalTax?: number | null;
    otherDeductions?: number | null;
    debtToAssetsRatio?: number | null;
    debtToIncomeRatio?: number | null;
    financialComments?: string | null;
    discriminator?: string | null;
    points?: number | null;

    constructor(data?: IFinancialData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.financialSummaryId = _data["financialSummaryId"] !== undefined ? _data["financialSummaryId"] : null as any;
            this.financialSummary = _data["financialSummary"] ? FinancialSummary.fromJS(_data["financialSummary"]) : null as any;
            this.liquidAssets = _data["liquidAssets"] !== undefined ? _data["liquidAssets"] : null as any;
            this.nonRetirementAssets = _data["nonRetirementAssets"] !== undefined ? _data["nonRetirementAssets"] : null as any;
            this.retirementAssets = _data["retirementAssets"] !== undefined ? _data["retirementAssets"] : null as any;
            this.businessValue = _data["businessValue"] !== undefined ? _data["businessValue"] : null as any;
            this.realEstateValue = _data["realEstateValue"] !== undefined ? _data["realEstateValue"] : null as any;
            this.isHomeOwner = _data["isHomeOwner"] !== undefined ? _data["isHomeOwner"] : null as any;
            this.grossIncome = _data["grossIncome"] !== undefined ? _data["grossIncome"] : null as any;
            this.mortgageInterest = _data["mortgageInterest"] !== undefined ? _data["mortgageInterest"] : null as any;
            this.monthlyHousingCost = _data["monthlyHousingCost"] !== undefined ? _data["monthlyHousingCost"] : null as any;
            this.disposableIncome = _data["disposableIncome"] !== undefined ? _data["disposableIncome"] : null as any;
            this.agiLessDeductions = _data["agiLessDeductions"] !== undefined ? _data["agiLessDeductions"] : null as any;
            this.totalTax = _data["totalTax"] !== undefined ? _data["totalTax"] : null as any;
            this.otherDeductions = _data["otherDeductions"] !== undefined ? _data["otherDeductions"] : null as any;
            this.debtToAssetsRatio = _data["debtToAssetsRatio"] !== undefined ? _data["debtToAssetsRatio"] : null as any;
            this.debtToIncomeRatio = _data["debtToIncomeRatio"] !== undefined ? _data["debtToIncomeRatio"] : null as any;
            this.financialComments = _data["financialComments"] !== undefined ? _data["financialComments"] : null as any;
            this.discriminator = _data["discriminator"] !== undefined ? _data["discriminator"] : null as any;
            this.points = _data["points"] !== undefined ? _data["points"] : null as any;
        }
    }

    static fromJS(data: any): FinancialData {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["financialSummaryId"] = this.financialSummaryId !== undefined ? this.financialSummaryId : null as any;
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        data["liquidAssets"] = this.liquidAssets !== undefined ? this.liquidAssets : null as any;
        data["nonRetirementAssets"] = this.nonRetirementAssets !== undefined ? this.nonRetirementAssets : null as any;
        data["retirementAssets"] = this.retirementAssets !== undefined ? this.retirementAssets : null as any;
        data["businessValue"] = this.businessValue !== undefined ? this.businessValue : null as any;
        data["realEstateValue"] = this.realEstateValue !== undefined ? this.realEstateValue : null as any;
        data["isHomeOwner"] = this.isHomeOwner !== undefined ? this.isHomeOwner : null as any;
        data["grossIncome"] = this.grossIncome !== undefined ? this.grossIncome : null as any;
        data["mortgageInterest"] = this.mortgageInterest !== undefined ? this.mortgageInterest : null as any;
        data["monthlyHousingCost"] = this.monthlyHousingCost !== undefined ? this.monthlyHousingCost : null as any;
        data["disposableIncome"] = this.disposableIncome !== undefined ? this.disposableIncome : null as any;
        data["agiLessDeductions"] = this.agiLessDeductions !== undefined ? this.agiLessDeductions : null as any;
        data["totalTax"] = this.totalTax !== undefined ? this.totalTax : null as any;
        data["otherDeductions"] = this.otherDeductions !== undefined ? this.otherDeductions : null as any;
        data["debtToAssetsRatio"] = this.debtToAssetsRatio !== undefined ? this.debtToAssetsRatio : null as any;
        data["debtToIncomeRatio"] = this.debtToIncomeRatio !== undefined ? this.debtToIncomeRatio : null as any;
        data["financialComments"] = this.financialComments !== undefined ? this.financialComments : null as any;
        data["discriminator"] = this.discriminator !== undefined ? this.discriminator : null as any;
        data["points"] = this.points !== undefined ? this.points : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): FinancialData {
        const json = this.toJSON();
        let result = new FinancialData();
        result.init(json);
        return result;
    }
}

export interface IFinancialData extends IBaseModel {
    applicationId?: number | null;
    application?: Application | null;
    financialSummaryId?: number | null;
    financialSummary?: FinancialSummary | null;
    liquidAssets?: number;
    nonRetirementAssets?: number;
    retirementAssets?: number;
    businessValue?: number;
    realEstateValue?: number;
    isHomeOwner?: boolean;
    grossIncome?: number | null;
    mortgageInterest?: number | null;
    monthlyHousingCost?: number | null;
    disposableIncome?: number | null;
    agiLessDeductions?: number | null;
    totalTax?: number | null;
    otherDeductions?: number | null;
    debtToAssetsRatio?: number | null;
    debtToIncomeRatio?: number | null;
    financialComments?: string | null;
    discriminator?: string | null;
    points?: number | null;
}

export class ApplicationFinancialData extends FinancialData implements IApplicationFinancialData {

    constructor(data?: IApplicationFinancialData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): ApplicationFinancialData {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationFinancialData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationFinancialData {
        const json = this.toJSON();
        let result = new ApplicationFinancialData();
        result.init(json);
        return result;
    }
}

export interface IApplicationFinancialData extends IFinancialData {
}

export class FinancialSummary extends BaseModel implements IFinancialSummary {
    pepTotal?: number;
    amountPrepay?: number | null;
    amountBorrow?: number | null;
    programTermsId?: number;
    programTerms?: ProgramTerms | null;
    repaymentPeriod?: number;
    pepMonthlyPayment?: number | null;
    planComments?: string | null;
    interestRate?: number | null;
    approvalStatus?: ApprovalStatus;
    approvalNotes?: string | null;
    riskScore?: number | null;
    finalDecision?: boolean | null;
    decisionDate?: Date | null;
    decisionUserId?: number | null;
    decisionUser?: AppUser | null;
    applicationId?: number;
    application?: Application | null;
    createdUserId?: number | null;
    createdUser?: AppUser | null;
    initialApprovalStatus?: ApprovalStatus;
    initialDecisionUserId?: number | null;
    initialDecisionUser?: AppUser | null;
    initialDecisionDate?: Date | null;
    secondaryApprovalStatus?: ApprovalStatus;
    secondaryDecisionUserId?: number | null;
    secondaryDecisionUser?: AppUser | null;
    secondaryDecisionDate?: Date | null;
    applicantCreditInformation?: ApplicantCreditInformation[] | null;
    summaryFinancialData?: SummaryFinancialData | null;
    applicationSemesters?: ApplicationSemesters[] | null;

    constructor(data?: IFinancialSummary) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
            this.amountPrepay = _data["amountPrepay"] !== undefined ? _data["amountPrepay"] : null as any;
            this.amountBorrow = _data["amountBorrow"] !== undefined ? _data["amountBorrow"] : null as any;
            this.programTermsId = _data["programTermsId"] !== undefined ? _data["programTermsId"] : null as any;
            this.programTerms = _data["programTerms"] ? ProgramTerms.fromJS(_data["programTerms"]) : null as any;
            this.repaymentPeriod = _data["repaymentPeriod"] !== undefined ? _data["repaymentPeriod"] : null as any;
            this.pepMonthlyPayment = _data["pepMonthlyPayment"] !== undefined ? _data["pepMonthlyPayment"] : null as any;
            this.planComments = _data["planComments"] !== undefined ? _data["planComments"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
            this.approvalNotes = _data["approvalNotes"] !== undefined ? _data["approvalNotes"] : null as any;
            this.riskScore = _data["riskScore"] !== undefined ? _data["riskScore"] : null as any;
            this.finalDecision = _data["finalDecision"] !== undefined ? _data["finalDecision"] : null as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : null as any;
            this.decisionUserId = _data["decisionUserId"] !== undefined ? _data["decisionUserId"] : null as any;
            this.decisionUser = _data["decisionUser"] ? AppUser.fromJS(_data["decisionUser"]) : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.createdUserId = _data["createdUserId"] !== undefined ? _data["createdUserId"] : null as any;
            this.createdUser = _data["createdUser"] ? AppUser.fromJS(_data["createdUser"]) : null as any;
            this.initialApprovalStatus = _data["initialApprovalStatus"] !== undefined ? _data["initialApprovalStatus"] : null as any;
            this.initialDecisionUserId = _data["initialDecisionUserId"] !== undefined ? _data["initialDecisionUserId"] : null as any;
            this.initialDecisionUser = _data["initialDecisionUser"] ? AppUser.fromJS(_data["initialDecisionUser"]) : null as any;
            this.initialDecisionDate = _data["initialDecisionDate"] ? new Date(_data["initialDecisionDate"].toString()) : null as any;
            this.secondaryApprovalStatus = _data["secondaryApprovalStatus"] !== undefined ? _data["secondaryApprovalStatus"] : null as any;
            this.secondaryDecisionUserId = _data["secondaryDecisionUserId"] !== undefined ? _data["secondaryDecisionUserId"] : null as any;
            this.secondaryDecisionUser = _data["secondaryDecisionUser"] ? AppUser.fromJS(_data["secondaryDecisionUser"]) : null as any;
            this.secondaryDecisionDate = _data["secondaryDecisionDate"] ? new Date(_data["secondaryDecisionDate"].toString()) : null as any;
            if (Array.isArray(_data["applicantCreditInformation"])) {
                this.applicantCreditInformation = [] as any;
                for (let item of _data["applicantCreditInformation"])
                    this.applicantCreditInformation!.push(ApplicantCreditInformation.fromJS(item));
            }
            else {
                this.applicantCreditInformation = null as any;
            }
            this.summaryFinancialData = _data["summaryFinancialData"] ? SummaryFinancialData.fromJS(_data["summaryFinancialData"]) : null as any;
            if (Array.isArray(_data["applicationSemesters"])) {
                this.applicationSemesters = [] as any;
                for (let item of _data["applicationSemesters"])
                    this.applicationSemesters!.push(ApplicationSemesters.fromJS(item));
            }
            else {
                this.applicationSemesters = null as any;
            }
        }
    }

    static fromJS(data: any): FinancialSummary {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialSummary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        data["amountPrepay"] = this.amountPrepay !== undefined ? this.amountPrepay : null as any;
        data["amountBorrow"] = this.amountBorrow !== undefined ? this.amountBorrow : null as any;
        data["programTermsId"] = this.programTermsId !== undefined ? this.programTermsId : null as any;
        data["programTerms"] = this.programTerms ? this.programTerms.toJSON() : null as any;
        data["repaymentPeriod"] = this.repaymentPeriod !== undefined ? this.repaymentPeriod : null as any;
        data["pepMonthlyPayment"] = this.pepMonthlyPayment !== undefined ? this.pepMonthlyPayment : null as any;
        data["planComments"] = this.planComments !== undefined ? this.planComments : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        data["approvalNotes"] = this.approvalNotes !== undefined ? this.approvalNotes : null as any;
        data["riskScore"] = this.riskScore !== undefined ? this.riskScore : null as any;
        data["finalDecision"] = this.finalDecision !== undefined ? this.finalDecision : null as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : null as any;
        data["decisionUserId"] = this.decisionUserId !== undefined ? this.decisionUserId : null as any;
        data["decisionUser"] = this.decisionUser ? this.decisionUser.toJSON() : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["createdUserId"] = this.createdUserId !== undefined ? this.createdUserId : null as any;
        data["createdUser"] = this.createdUser ? this.createdUser.toJSON() : null as any;
        data["initialApprovalStatus"] = this.initialApprovalStatus !== undefined ? this.initialApprovalStatus : null as any;
        data["initialDecisionUserId"] = this.initialDecisionUserId !== undefined ? this.initialDecisionUserId : null as any;
        data["initialDecisionUser"] = this.initialDecisionUser ? this.initialDecisionUser.toJSON() : null as any;
        data["initialDecisionDate"] = this.initialDecisionDate ? this.initialDecisionDate.toISOString() : null as any;
        data["secondaryApprovalStatus"] = this.secondaryApprovalStatus !== undefined ? this.secondaryApprovalStatus : null as any;
        data["secondaryDecisionUserId"] = this.secondaryDecisionUserId !== undefined ? this.secondaryDecisionUserId : null as any;
        data["secondaryDecisionUser"] = this.secondaryDecisionUser ? this.secondaryDecisionUser.toJSON() : null as any;
        data["secondaryDecisionDate"] = this.secondaryDecisionDate ? this.secondaryDecisionDate.toISOString() : null as any;
        if (Array.isArray(this.applicantCreditInformation)) {
            data["applicantCreditInformation"] = [];
            for (let item of this.applicantCreditInformation)
                data["applicantCreditInformation"].push(item ? item.toJSON() : null as any);
        }
        data["summaryFinancialData"] = this.summaryFinancialData ? this.summaryFinancialData.toJSON() : null as any;
        if (Array.isArray(this.applicationSemesters)) {
            data["applicationSemesters"] = [];
            for (let item of this.applicationSemesters)
                data["applicationSemesters"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): FinancialSummary {
        const json = this.toJSON();
        let result = new FinancialSummary();
        result.init(json);
        return result;
    }
}

export interface IFinancialSummary extends IBaseModel {
    pepTotal?: number;
    amountPrepay?: number | null;
    amountBorrow?: number | null;
    programTermsId?: number;
    programTerms?: ProgramTerms | null;
    repaymentPeriod?: number;
    pepMonthlyPayment?: number | null;
    planComments?: string | null;
    interestRate?: number | null;
    approvalStatus?: ApprovalStatus;
    approvalNotes?: string | null;
    riskScore?: number | null;
    finalDecision?: boolean | null;
    decisionDate?: Date | null;
    decisionUserId?: number | null;
    decisionUser?: AppUser | null;
    applicationId?: number;
    application?: Application | null;
    createdUserId?: number | null;
    createdUser?: AppUser | null;
    initialApprovalStatus?: ApprovalStatus;
    initialDecisionUserId?: number | null;
    initialDecisionUser?: AppUser | null;
    initialDecisionDate?: Date | null;
    secondaryApprovalStatus?: ApprovalStatus;
    secondaryDecisionUserId?: number | null;
    secondaryDecisionUser?: AppUser | null;
    secondaryDecisionDate?: Date | null;
    applicantCreditInformation?: ApplicantCreditInformation[] | null;
    summaryFinancialData?: SummaryFinancialData | null;
    applicationSemesters?: ApplicationSemesters[] | null;
}

export abstract class BaseUser extends BaseModel implements IBaseUser {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;

    constructor(data?: IBaseUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
        }
    }

    static fromJS(data: any): BaseUser {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseUser' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): BaseUser {
        throw new Error("The abstract class 'BaseUser' cannot be instantiated.");
    }
}

export interface IBaseUser extends IBaseModel {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
}

export class AppUser extends BaseUser implements IAppUser {
    role?: string | null;
    isActive?: boolean;

    constructor(data?: IAppUser) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
        }
    }

    static fromJS(data: any): AppUser {
        data = typeof data === 'object' ? data : {};
        let result = new AppUser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AppUser {
        const json = this.toJSON();
        let result = new AppUser();
        result.init(json);
        return result;
    }
}

export interface IAppUser extends IBaseUser {
    role?: string | null;
    isActive?: boolean;
}

export class ApplicantCreditInformation extends BaseModel implements IApplicantCreditInformation {
    applicantId?: number;
    applicant?: Applicant | null;
    financialSummaryId?: number;
    financialSummary?: FinancialSummary | null;
    creditCheckDate?: Date;
    creditScore?: number;
    collections?: number;
    collectionsAmount?: number;
    collectionsPaid?: number;
    thirtyDayViolations?: number;
    sixtyDayViolations?: number;
    ninetyDayViolations?: number;
    educationDefault?: boolean;
    previousEducationDefault?: boolean;
    potentialDebt?: number;
    actualDebt?: number;
    previousBankruptcy?: boolean;
    bankruptcyDate?: Date | null;
    mortgageBalance?: number | null;
    mortgageDefault?: boolean | null;
    periodicMonthlyPayments?: number | null;

    constructor(data?: IApplicantCreditInformation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
            this.applicant = _data["applicant"] ? Applicant.fromJS(_data["applicant"]) : null as any;
            this.financialSummaryId = _data["financialSummaryId"] !== undefined ? _data["financialSummaryId"] : null as any;
            this.financialSummary = _data["financialSummary"] ? FinancialSummary.fromJS(_data["financialSummary"]) : null as any;
            this.creditCheckDate = _data["creditCheckDate"] ? new Date(_data["creditCheckDate"].toString()) : null as any;
            this.creditScore = _data["creditScore"] !== undefined ? _data["creditScore"] : null as any;
            this.collections = _data["collections"] !== undefined ? _data["collections"] : null as any;
            this.collectionsAmount = _data["collectionsAmount"] !== undefined ? _data["collectionsAmount"] : null as any;
            this.collectionsPaid = _data["collectionsPaid"] !== undefined ? _data["collectionsPaid"] : null as any;
            this.thirtyDayViolations = _data["thirtyDayViolations"] !== undefined ? _data["thirtyDayViolations"] : null as any;
            this.sixtyDayViolations = _data["sixtyDayViolations"] !== undefined ? _data["sixtyDayViolations"] : null as any;
            this.ninetyDayViolations = _data["ninetyDayViolations"] !== undefined ? _data["ninetyDayViolations"] : null as any;
            this.educationDefault = _data["educationDefault"] !== undefined ? _data["educationDefault"] : null as any;
            this.previousEducationDefault = _data["previousEducationDefault"] !== undefined ? _data["previousEducationDefault"] : null as any;
            this.potentialDebt = _data["potentialDebt"] !== undefined ? _data["potentialDebt"] : null as any;
            this.actualDebt = _data["actualDebt"] !== undefined ? _data["actualDebt"] : null as any;
            this.previousBankruptcy = _data["previousBankruptcy"] !== undefined ? _data["previousBankruptcy"] : null as any;
            this.bankruptcyDate = _data["bankruptcyDate"] ? new Date(_data["bankruptcyDate"].toString()) : null as any;
            this.mortgageBalance = _data["mortgageBalance"] !== undefined ? _data["mortgageBalance"] : null as any;
            this.mortgageDefault = _data["mortgageDefault"] !== undefined ? _data["mortgageDefault"] : null as any;
            this.periodicMonthlyPayments = _data["periodicMonthlyPayments"] !== undefined ? _data["periodicMonthlyPayments"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantCreditInformation {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantCreditInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : null as any;
        data["financialSummaryId"] = this.financialSummaryId !== undefined ? this.financialSummaryId : null as any;
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        data["creditCheckDate"] = this.creditCheckDate ? this.creditCheckDate.toISOString() : null as any;
        data["creditScore"] = this.creditScore !== undefined ? this.creditScore : null as any;
        data["collections"] = this.collections !== undefined ? this.collections : null as any;
        data["collectionsAmount"] = this.collectionsAmount !== undefined ? this.collectionsAmount : null as any;
        data["collectionsPaid"] = this.collectionsPaid !== undefined ? this.collectionsPaid : null as any;
        data["thirtyDayViolations"] = this.thirtyDayViolations !== undefined ? this.thirtyDayViolations : null as any;
        data["sixtyDayViolations"] = this.sixtyDayViolations !== undefined ? this.sixtyDayViolations : null as any;
        data["ninetyDayViolations"] = this.ninetyDayViolations !== undefined ? this.ninetyDayViolations : null as any;
        data["educationDefault"] = this.educationDefault !== undefined ? this.educationDefault : null as any;
        data["previousEducationDefault"] = this.previousEducationDefault !== undefined ? this.previousEducationDefault : null as any;
        data["potentialDebt"] = this.potentialDebt !== undefined ? this.potentialDebt : null as any;
        data["actualDebt"] = this.actualDebt !== undefined ? this.actualDebt : null as any;
        data["previousBankruptcy"] = this.previousBankruptcy !== undefined ? this.previousBankruptcy : null as any;
        data["bankruptcyDate"] = this.bankruptcyDate ? this.bankruptcyDate.toISOString() : null as any;
        data["mortgageBalance"] = this.mortgageBalance !== undefined ? this.mortgageBalance : null as any;
        data["mortgageDefault"] = this.mortgageDefault !== undefined ? this.mortgageDefault : null as any;
        data["periodicMonthlyPayments"] = this.periodicMonthlyPayments !== undefined ? this.periodicMonthlyPayments : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicantCreditInformation {
        const json = this.toJSON();
        let result = new ApplicantCreditInformation();
        result.init(json);
        return result;
    }
}

export interface IApplicantCreditInformation extends IBaseModel {
    applicantId?: number;
    applicant?: Applicant | null;
    financialSummaryId?: number;
    financialSummary?: FinancialSummary | null;
    creditCheckDate?: Date;
    creditScore?: number;
    collections?: number;
    collectionsAmount?: number;
    collectionsPaid?: number;
    thirtyDayViolations?: number;
    sixtyDayViolations?: number;
    ninetyDayViolations?: number;
    educationDefault?: boolean;
    previousEducationDefault?: boolean;
    potentialDebt?: number;
    actualDebt?: number;
    previousBankruptcy?: boolean;
    bankruptcyDate?: Date | null;
    mortgageBalance?: number | null;
    mortgageDefault?: boolean | null;
    periodicMonthlyPayments?: number | null;
}

export class Applicant extends BaseModel implements IApplicant {
    applicationApplicantRootId?: number | null;
    applicationApplicantRoot?: ApplicationApplicantRoot | null;
    applicationId?: number;
    application?: Application | null;
    applicantCreditInformation?: ApplicantCreditInformation | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    employmentData?: ApplicantEmploymentData | null;
    isNew?: boolean;
    isConfirmed?: boolean;
    comments?: string | null;

    constructor(data?: IApplicant) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.applicationApplicantRoot = _data["applicationApplicantRoot"] ? ApplicationApplicantRoot.fromJS(_data["applicationApplicantRoot"]) : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.application = _data["application"] ? Application.fromJS(_data["application"]) : null as any;
            this.applicantCreditInformation = _data["applicantCreditInformation"] ? ApplicantCreditInformation.fromJS(_data["applicantCreditInformation"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : null as any;
            this.employmentData = _data["employmentData"] ? ApplicantEmploymentData.fromJS(_data["employmentData"]) : null as any;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
        }
    }

    static fromJS(data: any): Applicant {
        data = typeof data === 'object' ? data : {};
        let result = new Applicant();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["applicationApplicantRoot"] = this.applicationApplicantRoot ? this.applicationApplicantRoot.toJSON() : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["applicantCreditInformation"] = this.applicantCreditInformation ? this.applicantCreditInformation.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : null as any;
        data["employmentData"] = this.employmentData ? this.employmentData.toJSON() : null as any;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): Applicant {
        const json = this.toJSON();
        let result = new Applicant();
        result.init(json);
        return result;
    }
}

export interface IApplicant extends IBaseModel {
    applicationApplicantRootId?: number | null;
    applicationApplicantRoot?: ApplicationApplicantRoot | null;
    applicationId?: number;
    application?: Application | null;
    applicantCreditInformation?: ApplicantCreditInformation | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    employmentData?: ApplicantEmploymentData | null;
    isNew?: boolean;
    isConfirmed?: boolean;
    comments?: string | null;
}

export class ApplicationApplicantRoot extends BaseModel implements IApplicationApplicantRoot {
    ssn?: string | null;
    lastFour?: string | null;
    applicantDetail?: ApplicantDetail | null;
    accountApplicantTypes?: AccountApplicantType[] | null;

    constructor(data?: IApplicationApplicantRoot) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.lastFour = _data["lastFour"] !== undefined ? _data["lastFour"] : null as any;
            this.applicantDetail = _data["applicantDetail"] ? ApplicantDetail.fromJS(_data["applicantDetail"]) : null as any;
            if (Array.isArray(_data["accountApplicantTypes"])) {
                this.accountApplicantTypes = [] as any;
                for (let item of _data["accountApplicantTypes"])
                    this.accountApplicantTypes!.push(AccountApplicantType.fromJS(item));
            }
            else {
                this.accountApplicantTypes = null as any;
            }
        }
    }

    static fromJS(data: any): ApplicationApplicantRoot {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationApplicantRoot();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["lastFour"] = this.lastFour !== undefined ? this.lastFour : null as any;
        data["applicantDetail"] = this.applicantDetail ? this.applicantDetail.toJSON() : null as any;
        if (Array.isArray(this.accountApplicantTypes)) {
            data["accountApplicantTypes"] = [];
            for (let item of this.accountApplicantTypes)
                data["accountApplicantTypes"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationApplicantRoot {
        const json = this.toJSON();
        let result = new ApplicationApplicantRoot();
        result.init(json);
        return result;
    }
}

export interface IApplicationApplicantRoot extends IBaseModel {
    ssn?: string | null;
    lastFour?: string | null;
    applicantDetail?: ApplicantDetail | null;
    accountApplicantTypes?: AccountApplicantType[] | null;
}

export class ApplicantDetail extends BaseModel implements IApplicantDetail {
    applicationApplicantRootId?: number;
    applicationApplicantRoot?: ApplicationApplicantRoot | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    comments?: string | null;
    applicantDetailEmploymentData?: ApplicantDetailEmploymentData | null;
    history?: ApplicantDetailHistory[] | null;

    constructor(data?: IApplicantDetail) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.applicationApplicantRoot = _data["applicationApplicantRoot"] ? ApplicationApplicantRoot.fromJS(_data["applicationApplicantRoot"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.applicantDetailEmploymentData = _data["applicantDetailEmploymentData"] ? ApplicantDetailEmploymentData.fromJS(_data["applicantDetailEmploymentData"]) : null as any;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ApplicantDetailHistory.fromJS(item));
            }
            else {
                this.history = null as any;
            }
        }
    }

    static fromJS(data: any): ApplicantDetail {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetail();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["applicationApplicantRoot"] = this.applicationApplicantRoot ? this.applicationApplicantRoot.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["applicantDetailEmploymentData"] = this.applicantDetailEmploymentData ? this.applicantDetailEmploymentData.toJSON() : null as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ApplicantDetail {
        const json = this.toJSON();
        let result = new ApplicantDetail();
        result.init(json);
        return result;
    }
}

export interface IApplicantDetail extends IBaseModel {
    applicationApplicantRootId?: number;
    applicationApplicantRoot?: ApplicationApplicantRoot | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    comments?: string | null;
    applicantDetailEmploymentData?: ApplicantDetailEmploymentData | null;
    history?: ApplicantDetailHistory[] | null;
}

export class ApplicantDetailEmploymentData extends BaseModel implements IApplicantDetailEmploymentData {
    applicantDetailId?: number;
    applicantDetail?: ApplicantDetail | null;
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    history?: ApplicantDetailEmploymentDataHistory[] | null;

    constructor(data?: IApplicantDetailEmploymentData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicantDetailId = _data["applicantDetailId"] !== undefined ? _data["applicantDetailId"] : null as any;
            this.applicantDetail = _data["applicantDetail"] ? ApplicantDetail.fromJS(_data["applicantDetail"]) : null as any;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : null as any;
            this.employer = _data["employer"] !== undefined ? _data["employer"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ApplicantDetailEmploymentDataHistory.fromJS(item));
            }
            else {
                this.history = null as any;
            }
        }
    }

    static fromJS(data: any): ApplicantDetailEmploymentData {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetailEmploymentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantDetailId"] = this.applicantDetailId !== undefined ? this.applicantDetailId : null as any;
        data["applicantDetail"] = this.applicantDetail ? this.applicantDetail.toJSON() : null as any;
        data["occupation"] = this.occupation !== undefined ? this.occupation : null as any;
        data["employer"] = this.employer !== undefined ? this.employer : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        super.toJSON(data);
        return data;
    }

    clone(): ApplicantDetailEmploymentData {
        const json = this.toJSON();
        let result = new ApplicantDetailEmploymentData();
        result.init(json);
        return result;
    }
}

export interface IApplicantDetailEmploymentData extends IBaseModel {
    applicantDetailId?: number;
    applicantDetail?: ApplicantDetail | null;
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    history?: ApplicantDetailEmploymentDataHistory[] | null;
}

export class ApplicantDetailEmploymentDataHistory extends BaseModel implements IApplicantDetailEmploymentDataHistory {
    applicantDetailEmploymentDataId?: number;
    applicantDetailEmploymentData?: ApplicantDetailEmploymentData | null;
    applicantDetailHistoryId?: number;
    applicantDetailHistory?: ApplicantDetailHistory | null;
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;

    constructor(data?: IApplicantDetailEmploymentDataHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicantDetailEmploymentDataId = _data["applicantDetailEmploymentDataId"] !== undefined ? _data["applicantDetailEmploymentDataId"] : null as any;
            this.applicantDetailEmploymentData = _data["applicantDetailEmploymentData"] ? ApplicantDetailEmploymentData.fromJS(_data["applicantDetailEmploymentData"]) : null as any;
            this.applicantDetailHistoryId = _data["applicantDetailHistoryId"] !== undefined ? _data["applicantDetailHistoryId"] : null as any;
            this.applicantDetailHistory = _data["applicantDetailHistory"] ? ApplicantDetailHistory.fromJS(_data["applicantDetailHistory"]) : null as any;
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : null as any;
            this.employer = _data["employer"] !== undefined ? _data["employer"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantDetailEmploymentDataHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetailEmploymentDataHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantDetailEmploymentDataId"] = this.applicantDetailEmploymentDataId !== undefined ? this.applicantDetailEmploymentDataId : null as any;
        data["applicantDetailEmploymentData"] = this.applicantDetailEmploymentData ? this.applicantDetailEmploymentData.toJSON() : null as any;
        data["applicantDetailHistoryId"] = this.applicantDetailHistoryId !== undefined ? this.applicantDetailHistoryId : null as any;
        data["applicantDetailHistory"] = this.applicantDetailHistory ? this.applicantDetailHistory.toJSON() : null as any;
        data["occupation"] = this.occupation !== undefined ? this.occupation : null as any;
        data["employer"] = this.employer !== undefined ? this.employer : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicantDetailEmploymentDataHistory {
        const json = this.toJSON();
        let result = new ApplicantDetailEmploymentDataHistory();
        result.init(json);
        return result;
    }
}

export interface IApplicantDetailEmploymentDataHistory extends IBaseModel {
    applicantDetailEmploymentDataId?: number;
    applicantDetailEmploymentData?: ApplicantDetailEmploymentData | null;
    applicantDetailHistoryId?: number;
    applicantDetailHistory?: ApplicantDetailHistory | null;
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
}

export class ApplicantDetailHistory extends BaseModel implements IApplicantDetailHistory {
    applicantDetailId?: number;
    applicantDetail?: ApplicantDetail | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    comments?: string | null;

    constructor(data?: IApplicantDetailHistory) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.applicantDetailId = _data["applicantDetailId"] !== undefined ? _data["applicantDetailId"] : null as any;
            this.applicantDetail = _data["applicantDetail"] ? ApplicantDetail.fromJS(_data["applicantDetail"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantDetailHistory {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetailHistory();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantDetailId"] = this.applicantDetailId !== undefined ? this.applicantDetailId : null as any;
        data["applicantDetail"] = this.applicantDetail ? this.applicantDetail.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicantDetailHistory {
        const json = this.toJSON();
        let result = new ApplicantDetailHistory();
        result.init(json);
        return result;
    }
}

export interface IApplicantDetailHistory extends IBaseModel {
    applicantDetailId?: number;
    applicantDetail?: ApplicantDetail | null;
    type?: ApplicantType;
    prefix?: Prefix | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    emailAddress?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    comments?: string | null;
}

export class AccountApplicantType extends BaseModel implements IAccountApplicantType {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    applicationApplicantRootId?: number;
    applicationApplicantRoot?: ApplicationApplicantRoot | null;
    type?: ApplicantType;

    constructor(data?: IAccountApplicantType) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.applicationApplicantRoot = _data["applicationApplicantRoot"] ? ApplicationApplicantRoot.fromJS(_data["applicationApplicantRoot"]) : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): AccountApplicantType {
        data = typeof data === 'object' ? data : {};
        let result = new AccountApplicantType();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["applicationApplicantRoot"] = this.applicationApplicantRoot ? this.applicationApplicantRoot.toJSON() : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountApplicantType {
        const json = this.toJSON();
        let result = new AccountApplicantType();
        result.init(json);
        return result;
    }
}

export interface IAccountApplicantType extends IBaseModel {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    applicationApplicantRootId?: number;
    applicationApplicantRoot?: ApplicationApplicantRoot | null;
    type?: ApplicantType;
}

export class ApplicantEmploymentData extends BaseModel implements IApplicantEmploymentData {
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    applicant?: Applicant | null;
    applicantId?: number;

    constructor(data?: IApplicantEmploymentData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : null as any;
            this.employer = _data["employer"] !== undefined ? _data["employer"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.isVerified = _data["isVerified"] !== undefined ? _data["isVerified"] : null as any;
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : null as any;
            this.applicant = _data["applicant"] ? Applicant.fromJS(_data["applicant"]) : null as any;
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantEmploymentData {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantEmploymentData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occupation"] = this.occupation !== undefined ? this.occupation : null as any;
        data["employer"] = this.employer !== undefined ? this.employer : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["isVerified"] = this.isVerified !== undefined ? this.isVerified : null as any;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : null as any;
        data["applicant"] = this.applicant ? this.applicant.toJSON() : null as any;
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicantEmploymentData {
        const json = this.toJSON();
        let result = new ApplicantEmploymentData();
        result.init(json);
        return result;
    }
}

export interface IApplicantEmploymentData extends IBaseModel {
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    applicant?: Applicant | null;
    applicantId?: number;
}

export class SummaryFinancialData extends FinancialData implements ISummaryFinancialData {

    constructor(data?: ISummaryFinancialData) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
    }

    static fromJS(data: any): SummaryFinancialData {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryFinancialData();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }

    clone(): SummaryFinancialData {
        const json = this.toJSON();
        let result = new SummaryFinancialData();
        result.init(json);
        return result;
    }
}

export interface ISummaryFinancialData extends IFinancialData {
}

export class ApplicationSemesters extends BaseModel implements IApplicationSemesters {
    financialSummaryId?: number;
    financialSummary?: FinancialSummary | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: Cost | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: Cost | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: Cost | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: Cost | null;
    actualFoodServiceAmount?: number | null;
    semesterId?: string | null;
    semester?: Semester | null;

    constructor(data?: IApplicationSemesters) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.financialSummaryId = _data["financialSummaryId"] !== undefined ? _data["financialSummaryId"] : null as any;
            this.financialSummary = _data["financialSummary"] ? FinancialSummary.fromJS(_data["financialSummary"]) : null as any;
            this.participationRate = _data["participationRate"] !== undefined ? _data["participationRate"] : null as any;
            this.totalSemesterCharges = _data["totalSemesterCharges"] !== undefined ? _data["totalSemesterCharges"] : null as any;
            this.tuitionCostId = _data["tuitionCostId"] !== undefined ? _data["tuitionCostId"] : null as any;
            this.tuitionCost = _data["tuitionCost"] ? Cost.fromJS(_data["tuitionCost"]) : null as any;
            this.actualTuitionAmount = _data["actualTuitionAmount"] !== undefined ? _data["actualTuitionAmount"] : null as any;
            this.activityCostId = _data["activityCostId"] !== undefined ? _data["activityCostId"] : null as any;
            this.activityCost = _data["activityCost"] ? Cost.fromJS(_data["activityCost"]) : null as any;
            this.actualActivityAmount = _data["actualActivityAmount"] !== undefined ? _data["actualActivityAmount"] : null as any;
            this.housingCostId = _data["housingCostId"] !== undefined ? _data["housingCostId"] : null as any;
            this.housingCost = _data["housingCost"] ? Cost.fromJS(_data["housingCost"]) : null as any;
            this.actualHousingAmount = _data["actualHousingAmount"] !== undefined ? _data["actualHousingAmount"] : null as any;
            this.foodServiceCostId = _data["foodServiceCostId"] !== undefined ? _data["foodServiceCostId"] : null as any;
            this.foodServiceCost = _data["foodServiceCost"] ? Cost.fromJS(_data["foodServiceCost"]) : null as any;
            this.actualFoodServiceAmount = _data["actualFoodServiceAmount"] !== undefined ? _data["actualFoodServiceAmount"] : null as any;
            this.semesterId = _data["semesterId"] !== undefined ? _data["semesterId"] : null as any;
            this.semester = _data["semester"] ? Semester.fromJS(_data["semester"]) : null as any;
        }
    }

    static fromJS(data: any): ApplicationSemesters {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationSemesters();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialSummaryId"] = this.financialSummaryId !== undefined ? this.financialSummaryId : null as any;
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        data["participationRate"] = this.participationRate !== undefined ? this.participationRate : null as any;
        data["totalSemesterCharges"] = this.totalSemesterCharges !== undefined ? this.totalSemesterCharges : null as any;
        data["tuitionCostId"] = this.tuitionCostId !== undefined ? this.tuitionCostId : null as any;
        data["tuitionCost"] = this.tuitionCost ? this.tuitionCost.toJSON() : null as any;
        data["actualTuitionAmount"] = this.actualTuitionAmount !== undefined ? this.actualTuitionAmount : null as any;
        data["activityCostId"] = this.activityCostId !== undefined ? this.activityCostId : null as any;
        data["activityCost"] = this.activityCost ? this.activityCost.toJSON() : null as any;
        data["actualActivityAmount"] = this.actualActivityAmount !== undefined ? this.actualActivityAmount : null as any;
        data["housingCostId"] = this.housingCostId !== undefined ? this.housingCostId : null as any;
        data["housingCost"] = this.housingCost ? this.housingCost.toJSON() : null as any;
        data["actualHousingAmount"] = this.actualHousingAmount !== undefined ? this.actualHousingAmount : null as any;
        data["foodServiceCostId"] = this.foodServiceCostId !== undefined ? this.foodServiceCostId : null as any;
        data["foodServiceCost"] = this.foodServiceCost ? this.foodServiceCost.toJSON() : null as any;
        data["actualFoodServiceAmount"] = this.actualFoodServiceAmount !== undefined ? this.actualFoodServiceAmount : null as any;
        data["semesterId"] = this.semesterId !== undefined ? this.semesterId : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): ApplicationSemesters {
        const json = this.toJSON();
        let result = new ApplicationSemesters();
        result.init(json);
        return result;
    }
}

export interface IApplicationSemesters extends IBaseModel {
    financialSummaryId?: number;
    financialSummary?: FinancialSummary | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: Cost | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: Cost | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: Cost | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: Cost | null;
    actualFoodServiceAmount?: number | null;
    semesterId?: string | null;
    semester?: Semester | null;
}

export class AccountsStudentInformation extends BaseModel implements IAccountsStudentInformation {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    applicationStudentRootId?: number | null;
    applicationStudentRoot?: ApplicationStudentRoot | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;
    hasMpStatus?: boolean;

    constructor(data?: IAccountsStudentInformation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.applicationStudentRootId = _data["applicationStudentRootId"] !== undefined ? _data["applicationStudentRootId"] : null as any;
            this.applicationStudentRoot = _data["applicationStudentRoot"] ? ApplicationStudentRoot.fromJS(_data["applicationStudentRoot"]) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : null as any;
            this.academicLevel = _data["academicLevel"] !== undefined ? _data["academicLevel"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.hasMpStatus = _data["hasMpStatus"] !== undefined ? _data["hasMpStatus"] : null as any;
        }
    }

    static fromJS(data: any): AccountsStudentInformation {
        data = typeof data === 'object' ? data : {};
        let result = new AccountsStudentInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["applicationStudentRootId"] = this.applicationStudentRootId !== undefined ? this.applicationStudentRootId : null as any;
        data["applicationStudentRoot"] = this.applicationStudentRoot ? this.applicationStudentRoot.toJSON() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : null as any;
        data["academicLevel"] = this.academicLevel !== undefined ? this.academicLevel : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["hasMpStatus"] = this.hasMpStatus !== undefined ? this.hasMpStatus : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountsStudentInformation {
        const json = this.toJSON();
        let result = new AccountsStudentInformation();
        result.init(json);
        return result;
    }
}

export interface IAccountsStudentInformation extends IBaseModel {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    applicationStudentRootId?: number | null;
    applicationStudentRoot?: ApplicationStudentRoot | null;
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    dateOfBirth?: Date;
    academicLevel?: AcademicLevel | null;
    sisId?: number | null;
    hasMpStatus?: boolean;
}

export class AccountPlanInformation extends BaseModel implements IAccountPlanInformation {
    accountsMainId?: number;
    accountsMains?: AccountsMains | null;
    programTermsId?: number;
    programTerms?: ProgramTerms | null;
    pepTotal?: number;
    amountBorrow?: number | null;
    amountPrepay?: number | null;
    serviceLoanId?: number | null;
    loanBalance?: number | null;
    repaymentPeriod?: number | null;
    pepMonthlyPayment?: number | null;
    totalPepSemesters?: number;
    paymentStartDate?: Date | null;
    planComments?: string | null;
    refundName?: RefundName | null;
    isAutoDebitRequired?: boolean;
    accountCancelled?: boolean;
    accountCancellationDate?: Date | null;
    loanReductionId?: number | null;
    sentServicerDate?: Date | null;
    isOffCampus?: boolean;
    altLoanId?: string | null;
    interestRate?: number | null;
    paidInFullDate?: Date | null;
    programClientId?: string | null;
    loanSeqId?: string | null;
    loanStage?: string | null;
    loanClientId?: string | null;
    repaymentRemaining?: number | null;
    lastPaymentDate?: Date | null;
    lastStatementDate?: Date | null;
    totalPrepaymentReceived?: number | null;
    totalPrepaymentDifference?: number | null;
    financialAidAward?: number | null;
    accountSemesters?: AccountSemester[] | null;
    semestersComments?: string | null;
    fileSeqId?: number | null;

    constructor(data?: IAccountPlanInformation) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountsMainId = _data["accountsMainId"] !== undefined ? _data["accountsMainId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.programTermsId = _data["programTermsId"] !== undefined ? _data["programTermsId"] : null as any;
            this.programTerms = _data["programTerms"] ? ProgramTerms.fromJS(_data["programTerms"]) : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
            this.amountBorrow = _data["amountBorrow"] !== undefined ? _data["amountBorrow"] : null as any;
            this.amountPrepay = _data["amountPrepay"] !== undefined ? _data["amountPrepay"] : null as any;
            this.serviceLoanId = _data["serviceLoanId"] !== undefined ? _data["serviceLoanId"] : null as any;
            this.loanBalance = _data["loanBalance"] !== undefined ? _data["loanBalance"] : null as any;
            this.repaymentPeriod = _data["repaymentPeriod"] !== undefined ? _data["repaymentPeriod"] : null as any;
            this.pepMonthlyPayment = _data["pepMonthlyPayment"] !== undefined ? _data["pepMonthlyPayment"] : null as any;
            this.totalPepSemesters = _data["totalPepSemesters"] !== undefined ? _data["totalPepSemesters"] : null as any;
            this.paymentStartDate = _data["paymentStartDate"] ? new Date(_data["paymentStartDate"].toString()) : null as any;
            this.planComments = _data["planComments"] !== undefined ? _data["planComments"] : null as any;
            this.refundName = _data["refundName"] !== undefined ? _data["refundName"] : null as any;
            this.isAutoDebitRequired = _data["isAutoDebitRequired"] !== undefined ? _data["isAutoDebitRequired"] : null as any;
            this.accountCancelled = _data["accountCancelled"] !== undefined ? _data["accountCancelled"] : null as any;
            this.accountCancellationDate = _data["accountCancellationDate"] ? new Date(_data["accountCancellationDate"].toString()) : null as any;
            this.loanReductionId = _data["loanReductionId"] !== undefined ? _data["loanReductionId"] : null as any;
            this.sentServicerDate = _data["sentServicerDate"] ? new Date(_data["sentServicerDate"].toString()) : null as any;
            this.isOffCampus = _data["isOffCampus"] !== undefined ? _data["isOffCampus"] : null as any;
            this.altLoanId = _data["altLoanId"] !== undefined ? _data["altLoanId"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.paidInFullDate = _data["paidInFullDate"] ? new Date(_data["paidInFullDate"].toString()) : null as any;
            this.programClientId = _data["programClientId"] !== undefined ? _data["programClientId"] : null as any;
            this.loanSeqId = _data["loanSeqId"] !== undefined ? _data["loanSeqId"] : null as any;
            this.loanStage = _data["loanStage"] !== undefined ? _data["loanStage"] : null as any;
            this.loanClientId = _data["loanClientId"] !== undefined ? _data["loanClientId"] : null as any;
            this.repaymentRemaining = _data["repaymentRemaining"] !== undefined ? _data["repaymentRemaining"] : null as any;
            this.lastPaymentDate = _data["lastPaymentDate"] ? new Date(_data["lastPaymentDate"].toString()) : null as any;
            this.lastStatementDate = _data["lastStatementDate"] ? new Date(_data["lastStatementDate"].toString()) : null as any;
            this.totalPrepaymentReceived = _data["totalPrepaymentReceived"] !== undefined ? _data["totalPrepaymentReceived"] : null as any;
            this.totalPrepaymentDifference = _data["totalPrepaymentDifference"] !== undefined ? _data["totalPrepaymentDifference"] : null as any;
            this.financialAidAward = _data["financialAidAward"] !== undefined ? _data["financialAidAward"] : null as any;
            if (Array.isArray(_data["accountSemesters"])) {
                this.accountSemesters = [] as any;
                for (let item of _data["accountSemesters"])
                    this.accountSemesters!.push(AccountSemester.fromJS(item));
            }
            else {
                this.accountSemesters = null as any;
            }
            this.semestersComments = _data["semestersComments"] !== undefined ? _data["semestersComments"] : null as any;
            this.fileSeqId = _data["fileSeqId"] !== undefined ? _data["fileSeqId"] : null as any;
        }
    }

    static fromJS(data: any): AccountPlanInformation {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPlanInformation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainId"] = this.accountsMainId !== undefined ? this.accountsMainId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["programTermsId"] = this.programTermsId !== undefined ? this.programTermsId : null as any;
        data["programTerms"] = this.programTerms ? this.programTerms.toJSON() : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        data["amountBorrow"] = this.amountBorrow !== undefined ? this.amountBorrow : null as any;
        data["amountPrepay"] = this.amountPrepay !== undefined ? this.amountPrepay : null as any;
        data["serviceLoanId"] = this.serviceLoanId !== undefined ? this.serviceLoanId : null as any;
        data["loanBalance"] = this.loanBalance !== undefined ? this.loanBalance : null as any;
        data["repaymentPeriod"] = this.repaymentPeriod !== undefined ? this.repaymentPeriod : null as any;
        data["pepMonthlyPayment"] = this.pepMonthlyPayment !== undefined ? this.pepMonthlyPayment : null as any;
        data["totalPepSemesters"] = this.totalPepSemesters !== undefined ? this.totalPepSemesters : null as any;
        data["paymentStartDate"] = this.paymentStartDate ? this.paymentStartDate.toISOString() : null as any;
        data["planComments"] = this.planComments !== undefined ? this.planComments : null as any;
        data["refundName"] = this.refundName !== undefined ? this.refundName : null as any;
        data["isAutoDebitRequired"] = this.isAutoDebitRequired !== undefined ? this.isAutoDebitRequired : null as any;
        data["accountCancelled"] = this.accountCancelled !== undefined ? this.accountCancelled : null as any;
        data["accountCancellationDate"] = this.accountCancellationDate ? this.accountCancellationDate.toISOString() : null as any;
        data["loanReductionId"] = this.loanReductionId !== undefined ? this.loanReductionId : null as any;
        data["sentServicerDate"] = this.sentServicerDate ? this.sentServicerDate.toISOString() : null as any;
        data["isOffCampus"] = this.isOffCampus !== undefined ? this.isOffCampus : null as any;
        data["altLoanId"] = this.altLoanId !== undefined ? this.altLoanId : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["paidInFullDate"] = this.paidInFullDate ? this.paidInFullDate.toISOString() : null as any;
        data["programClientId"] = this.programClientId !== undefined ? this.programClientId : null as any;
        data["loanSeqId"] = this.loanSeqId !== undefined ? this.loanSeqId : null as any;
        data["loanStage"] = this.loanStage !== undefined ? this.loanStage : null as any;
        data["loanClientId"] = this.loanClientId !== undefined ? this.loanClientId : null as any;
        data["repaymentRemaining"] = this.repaymentRemaining !== undefined ? this.repaymentRemaining : null as any;
        data["lastPaymentDate"] = this.lastPaymentDate ? this.lastPaymentDate.toISOString() : null as any;
        data["lastStatementDate"] = this.lastStatementDate ? this.lastStatementDate.toISOString() : null as any;
        data["totalPrepaymentReceived"] = this.totalPrepaymentReceived !== undefined ? this.totalPrepaymentReceived : null as any;
        data["totalPrepaymentDifference"] = this.totalPrepaymentDifference !== undefined ? this.totalPrepaymentDifference : null as any;
        data["financialAidAward"] = this.financialAidAward !== undefined ? this.financialAidAward : null as any;
        if (Array.isArray(this.accountSemesters)) {
            data["accountSemesters"] = [];
            for (let item of this.accountSemesters)
                data["accountSemesters"].push(item ? item.toJSON() : null as any);
        }
        data["semestersComments"] = this.semestersComments !== undefined ? this.semestersComments : null as any;
        data["fileSeqId"] = this.fileSeqId !== undefined ? this.fileSeqId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountPlanInformation {
        const json = this.toJSON();
        let result = new AccountPlanInformation();
        result.init(json);
        return result;
    }
}

export interface IAccountPlanInformation extends IBaseModel {
    accountsMainId?: number;
    accountsMains?: AccountsMains | null;
    programTermsId?: number;
    programTerms?: ProgramTerms | null;
    pepTotal?: number;
    amountBorrow?: number | null;
    amountPrepay?: number | null;
    serviceLoanId?: number | null;
    loanBalance?: number | null;
    repaymentPeriod?: number | null;
    pepMonthlyPayment?: number | null;
    totalPepSemesters?: number;
    paymentStartDate?: Date | null;
    planComments?: string | null;
    refundName?: RefundName | null;
    isAutoDebitRequired?: boolean;
    accountCancelled?: boolean;
    accountCancellationDate?: Date | null;
    loanReductionId?: number | null;
    sentServicerDate?: Date | null;
    isOffCampus?: boolean;
    altLoanId?: string | null;
    interestRate?: number | null;
    paidInFullDate?: Date | null;
    programClientId?: string | null;
    loanSeqId?: string | null;
    loanStage?: string | null;
    loanClientId?: string | null;
    repaymentRemaining?: number | null;
    lastPaymentDate?: Date | null;
    lastStatementDate?: Date | null;
    totalPrepaymentReceived?: number | null;
    totalPrepaymentDifference?: number | null;
    financialAidAward?: number | null;
    accountSemesters?: AccountSemester[] | null;
    semestersComments?: string | null;
    fileSeqId?: number | null;
}

export class AccountSemester extends BaseModel implements IAccountSemester {
    accountPlanInformationId?: number;
    accountPlanInformation?: AccountPlanInformation | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    semesterId?: string | null;
    semester?: Semester | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: Cost | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: Cost | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: Cost | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: Cost | null;
    actualFoodServiceAmount?: number | null;
    postedToAccount?: boolean;

    constructor(data?: IAccountSemester) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountPlanInformationId = _data["accountPlanInformationId"] !== undefined ? _data["accountPlanInformationId"] : null as any;
            this.accountPlanInformation = _data["accountPlanInformation"] ? AccountPlanInformation.fromJS(_data["accountPlanInformation"]) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYear.fromJS(_data["fiscalYear"]) : null as any;
            this.semesterId = _data["semesterId"] !== undefined ? _data["semesterId"] : null as any;
            this.semester = _data["semester"] ? Semester.fromJS(_data["semester"]) : null as any;
            this.participationRate = _data["participationRate"] !== undefined ? _data["participationRate"] : null as any;
            this.totalSemesterCharges = _data["totalSemesterCharges"] !== undefined ? _data["totalSemesterCharges"] : null as any;
            this.tuitionCostId = _data["tuitionCostId"] !== undefined ? _data["tuitionCostId"] : null as any;
            this.tuitionCost = _data["tuitionCost"] ? Cost.fromJS(_data["tuitionCost"]) : null as any;
            this.actualTuitionAmount = _data["actualTuitionAmount"] !== undefined ? _data["actualTuitionAmount"] : null as any;
            this.activityCostId = _data["activityCostId"] !== undefined ? _data["activityCostId"] : null as any;
            this.activityCost = _data["activityCost"] ? Cost.fromJS(_data["activityCost"]) : null as any;
            this.actualActivityAmount = _data["actualActivityAmount"] !== undefined ? _data["actualActivityAmount"] : null as any;
            this.housingCostId = _data["housingCostId"] !== undefined ? _data["housingCostId"] : null as any;
            this.housingCost = _data["housingCost"] ? Cost.fromJS(_data["housingCost"]) : null as any;
            this.actualHousingAmount = _data["actualHousingAmount"] !== undefined ? _data["actualHousingAmount"] : null as any;
            this.foodServiceCostId = _data["foodServiceCostId"] !== undefined ? _data["foodServiceCostId"] : null as any;
            this.foodServiceCost = _data["foodServiceCost"] ? Cost.fromJS(_data["foodServiceCost"]) : null as any;
            this.actualFoodServiceAmount = _data["actualFoodServiceAmount"] !== undefined ? _data["actualFoodServiceAmount"] : null as any;
            this.postedToAccount = _data["postedToAccount"] !== undefined ? _data["postedToAccount"] : null as any;
        }
    }

    static fromJS(data: any): AccountSemester {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSemester();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountPlanInformationId"] = this.accountPlanInformationId !== undefined ? this.accountPlanInformationId : null as any;
        data["accountPlanInformation"] = this.accountPlanInformation ? this.accountPlanInformation.toJSON() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["semesterId"] = this.semesterId !== undefined ? this.semesterId : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        data["participationRate"] = this.participationRate !== undefined ? this.participationRate : null as any;
        data["totalSemesterCharges"] = this.totalSemesterCharges !== undefined ? this.totalSemesterCharges : null as any;
        data["tuitionCostId"] = this.tuitionCostId !== undefined ? this.tuitionCostId : null as any;
        data["tuitionCost"] = this.tuitionCost ? this.tuitionCost.toJSON() : null as any;
        data["actualTuitionAmount"] = this.actualTuitionAmount !== undefined ? this.actualTuitionAmount : null as any;
        data["activityCostId"] = this.activityCostId !== undefined ? this.activityCostId : null as any;
        data["activityCost"] = this.activityCost ? this.activityCost.toJSON() : null as any;
        data["actualActivityAmount"] = this.actualActivityAmount !== undefined ? this.actualActivityAmount : null as any;
        data["housingCostId"] = this.housingCostId !== undefined ? this.housingCostId : null as any;
        data["housingCost"] = this.housingCost ? this.housingCost.toJSON() : null as any;
        data["actualHousingAmount"] = this.actualHousingAmount !== undefined ? this.actualHousingAmount : null as any;
        data["foodServiceCostId"] = this.foodServiceCostId !== undefined ? this.foodServiceCostId : null as any;
        data["foodServiceCost"] = this.foodServiceCost ? this.foodServiceCost.toJSON() : null as any;
        data["actualFoodServiceAmount"] = this.actualFoodServiceAmount !== undefined ? this.actualFoodServiceAmount : null as any;
        data["postedToAccount"] = this.postedToAccount !== undefined ? this.postedToAccount : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountSemester {
        const json = this.toJSON();
        let result = new AccountSemester();
        result.init(json);
        return result;
    }
}

export interface IAccountSemester extends IBaseModel {
    accountPlanInformationId?: number;
    accountPlanInformation?: AccountPlanInformation | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYear | null;
    semesterId?: string | null;
    semester?: Semester | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: Cost | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: Cost | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: Cost | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: Cost | null;
    actualFoodServiceAmount?: number | null;
    postedToAccount?: boolean;
}

export class PrePaymentRecord extends BaseModel implements IPrePaymentRecord {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    semesterCode?: string | null;
    semester?: Semester | null;
    payerName?: string | null;
    totalCheckAmount?: number;
    receivedDate?: Date;
    checkNumber?: string | null;
    amountApplied?: number;
    comments?: string | null;
    dateDeposited?: Date | null;
    customer?: string | null;
    project?: string | null;
    revenueCategory?: string | null;
    costCenter?: string | null;

    constructor(data?: IPrePaymentRecord) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.semesterCode = _data["semesterCode"] !== undefined ? _data["semesterCode"] : null as any;
            this.semester = _data["semester"] ? Semester.fromJS(_data["semester"]) : null as any;
            this.payerName = _data["payerName"] !== undefined ? _data["payerName"] : null as any;
            this.totalCheckAmount = _data["totalCheckAmount"] !== undefined ? _data["totalCheckAmount"] : null as any;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : null as any;
            this.checkNumber = _data["checkNumber"] !== undefined ? _data["checkNumber"] : null as any;
            this.amountApplied = _data["amountApplied"] !== undefined ? _data["amountApplied"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.dateDeposited = _data["dateDeposited"] ? new Date(_data["dateDeposited"].toString()) : null as any;
            this.customer = _data["customer"] !== undefined ? _data["customer"] : null as any;
            this.project = _data["project"] !== undefined ? _data["project"] : null as any;
            this.revenueCategory = _data["revenueCategory"] !== undefined ? _data["revenueCategory"] : null as any;
            this.costCenter = _data["costCenter"] !== undefined ? _data["costCenter"] : null as any;
        }
    }

    static fromJS(data: any): PrePaymentRecord {
        data = typeof data === 'object' ? data : {};
        let result = new PrePaymentRecord();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["semesterCode"] = this.semesterCode !== undefined ? this.semesterCode : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        data["payerName"] = this.payerName !== undefined ? this.payerName : null as any;
        data["totalCheckAmount"] = this.totalCheckAmount !== undefined ? this.totalCheckAmount : null as any;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : null as any;
        data["checkNumber"] = this.checkNumber !== undefined ? this.checkNumber : null as any;
        data["amountApplied"] = this.amountApplied !== undefined ? this.amountApplied : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["dateDeposited"] = this.dateDeposited ? this.dateDeposited.toISOString() : null as any;
        data["customer"] = this.customer !== undefined ? this.customer : null as any;
        data["project"] = this.project !== undefined ? this.project : null as any;
        data["revenueCategory"] = this.revenueCategory !== undefined ? this.revenueCategory : null as any;
        data["costCenter"] = this.costCenter !== undefined ? this.costCenter : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): PrePaymentRecord {
        const json = this.toJSON();
        let result = new PrePaymentRecord();
        result.init(json);
        return result;
    }
}

export interface IPrePaymentRecord extends IBaseModel {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    semesterCode?: string | null;
    semester?: Semester | null;
    payerName?: string | null;
    totalCheckAmount?: number;
    receivedDate?: Date;
    checkNumber?: string | null;
    amountApplied?: number;
    comments?: string | null;
    dateDeposited?: Date | null;
    customer?: string | null;
    project?: string | null;
    revenueCategory?: string | null;
    costCenter?: string | null;
}

export class AccountFinancialAsset extends BaseModel implements IAccountFinancialAsset {
    accountsMainId?: number;
    accountsMains?: AccountsMains | null;
    liquidAssets?: number;
    nonRetirementAssets?: number;
    retirementAssets?: number;
    businessValue?: number;
    realEstateValue?: number;
    isHomeOwner?: boolean;
    monthlyHousingCost?: number | null;
    grossIncome?: number | null;
    mortgageRate?: number;
    disposableIncome?: number | null;
    agiLessDeductions?: number | null;
    otherDeductions?: number | null;
    debtToAssetsRatio?: number | null;
    financialComments?: string | null;

    constructor(data?: IAccountFinancialAsset) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountsMainId = _data["accountsMainId"] !== undefined ? _data["accountsMainId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.liquidAssets = _data["liquidAssets"] !== undefined ? _data["liquidAssets"] : null as any;
            this.nonRetirementAssets = _data["nonRetirementAssets"] !== undefined ? _data["nonRetirementAssets"] : null as any;
            this.retirementAssets = _data["retirementAssets"] !== undefined ? _data["retirementAssets"] : null as any;
            this.businessValue = _data["businessValue"] !== undefined ? _data["businessValue"] : null as any;
            this.realEstateValue = _data["realEstateValue"] !== undefined ? _data["realEstateValue"] : null as any;
            this.isHomeOwner = _data["isHomeOwner"] !== undefined ? _data["isHomeOwner"] : null as any;
            this.monthlyHousingCost = _data["monthlyHousingCost"] !== undefined ? _data["monthlyHousingCost"] : null as any;
            this.grossIncome = _data["grossIncome"] !== undefined ? _data["grossIncome"] : null as any;
            this.mortgageRate = _data["mortgageRate"] !== undefined ? _data["mortgageRate"] : null as any;
            this.disposableIncome = _data["disposableIncome"] !== undefined ? _data["disposableIncome"] : null as any;
            this.agiLessDeductions = _data["agiLessDeductions"] !== undefined ? _data["agiLessDeductions"] : null as any;
            this.otherDeductions = _data["otherDeductions"] !== undefined ? _data["otherDeductions"] : null as any;
            this.debtToAssetsRatio = _data["debtToAssetsRatio"] !== undefined ? _data["debtToAssetsRatio"] : null as any;
            this.financialComments = _data["financialComments"] !== undefined ? _data["financialComments"] : null as any;
        }
    }

    static fromJS(data: any): AccountFinancialAsset {
        data = typeof data === 'object' ? data : {};
        let result = new AccountFinancialAsset();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainId"] = this.accountsMainId !== undefined ? this.accountsMainId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["liquidAssets"] = this.liquidAssets !== undefined ? this.liquidAssets : null as any;
        data["nonRetirementAssets"] = this.nonRetirementAssets !== undefined ? this.nonRetirementAssets : null as any;
        data["retirementAssets"] = this.retirementAssets !== undefined ? this.retirementAssets : null as any;
        data["businessValue"] = this.businessValue !== undefined ? this.businessValue : null as any;
        data["realEstateValue"] = this.realEstateValue !== undefined ? this.realEstateValue : null as any;
        data["isHomeOwner"] = this.isHomeOwner !== undefined ? this.isHomeOwner : null as any;
        data["monthlyHousingCost"] = this.monthlyHousingCost !== undefined ? this.monthlyHousingCost : null as any;
        data["grossIncome"] = this.grossIncome !== undefined ? this.grossIncome : null as any;
        data["mortgageRate"] = this.mortgageRate !== undefined ? this.mortgageRate : null as any;
        data["disposableIncome"] = this.disposableIncome !== undefined ? this.disposableIncome : null as any;
        data["agiLessDeductions"] = this.agiLessDeductions !== undefined ? this.agiLessDeductions : null as any;
        data["otherDeductions"] = this.otherDeductions !== undefined ? this.otherDeductions : null as any;
        data["debtToAssetsRatio"] = this.debtToAssetsRatio !== undefined ? this.debtToAssetsRatio : null as any;
        data["financialComments"] = this.financialComments !== undefined ? this.financialComments : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountFinancialAsset {
        const json = this.toJSON();
        let result = new AccountFinancialAsset();
        result.init(json);
        return result;
    }
}

export interface IAccountFinancialAsset extends IBaseModel {
    accountsMainId?: number;
    accountsMains?: AccountsMains | null;
    liquidAssets?: number;
    nonRetirementAssets?: number;
    retirementAssets?: number;
    businessValue?: number;
    realEstateValue?: number;
    isHomeOwner?: boolean;
    monthlyHousingCost?: number | null;
    grossIncome?: number | null;
    mortgageRate?: number;
    disposableIncome?: number | null;
    agiLessDeductions?: number | null;
    otherDeductions?: number | null;
    debtToAssetsRatio?: number | null;
    financialComments?: string | null;
}

export class AccountPlanReduction extends BaseModel implements IAccountPlanReduction {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    semesterCode?: string | null;
    semester?: Semester | null;
    processedDate?: Date | null;
    interestAdjustmentAmount?: number;
    beginningInterestAccrualDate?: Date | null;
    lastInterestPaid?: Date | null;
    numberMonthsPaid?: number | null;
    principalReductionAmount?: number;
    interestRate?: number | null;
    totalReduction?: number;
    servPrincipalBalance?: number | null;
    remainingPrincipalBalance?: number | null;
    currentMonthlyInterestDue?: number | null;
    payoffAmount?: number | null;
    remainingRepaymentPeriod?: number | null;
    reAmortizedMonthlyPayment?: number | null;
    originalMonthlyPayment?: number | null;
    comments?: string | null;
    numberDaysPaid?: number | null;
    interestPaidToDate?: number;
    loanSeqId?: string | null;
    estimatedResultingMonthlyPayment?: number;
    calculatorRepaymentMonthsRemaining?: number | null;

    constructor(data?: IAccountPlanReduction) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.semesterCode = _data["semesterCode"] !== undefined ? _data["semesterCode"] : null as any;
            this.semester = _data["semester"] ? Semester.fromJS(_data["semester"]) : null as any;
            this.processedDate = _data["processedDate"] ? new Date(_data["processedDate"].toString()) : null as any;
            this.interestAdjustmentAmount = _data["interestAdjustmentAmount"] !== undefined ? _data["interestAdjustmentAmount"] : null as any;
            this.beginningInterestAccrualDate = _data["beginningInterestAccrualDate"] ? new Date(_data["beginningInterestAccrualDate"].toString()) : null as any;
            this.lastInterestPaid = _data["lastInterestPaid"] ? new Date(_data["lastInterestPaid"].toString()) : null as any;
            this.numberMonthsPaid = _data["numberMonthsPaid"] !== undefined ? _data["numberMonthsPaid"] : null as any;
            this.principalReductionAmount = _data["principalReductionAmount"] !== undefined ? _data["principalReductionAmount"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.totalReduction = _data["totalReduction"] !== undefined ? _data["totalReduction"] : null as any;
            this.servPrincipalBalance = _data["servPrincipalBalance"] !== undefined ? _data["servPrincipalBalance"] : null as any;
            this.remainingPrincipalBalance = _data["remainingPrincipalBalance"] !== undefined ? _data["remainingPrincipalBalance"] : null as any;
            this.currentMonthlyInterestDue = _data["currentMonthlyInterestDue"] !== undefined ? _data["currentMonthlyInterestDue"] : null as any;
            this.payoffAmount = _data["payoffAmount"] !== undefined ? _data["payoffAmount"] : null as any;
            this.remainingRepaymentPeriod = _data["remainingRepaymentPeriod"] !== undefined ? _data["remainingRepaymentPeriod"] : null as any;
            this.reAmortizedMonthlyPayment = _data["reAmortizedMonthlyPayment"] !== undefined ? _data["reAmortizedMonthlyPayment"] : null as any;
            this.originalMonthlyPayment = _data["originalMonthlyPayment"] !== undefined ? _data["originalMonthlyPayment"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.numberDaysPaid = _data["numberDaysPaid"] !== undefined ? _data["numberDaysPaid"] : null as any;
            this.interestPaidToDate = _data["interestPaidToDate"] !== undefined ? _data["interestPaidToDate"] : null as any;
            this.loanSeqId = _data["loanSeqId"] !== undefined ? _data["loanSeqId"] : null as any;
            this.estimatedResultingMonthlyPayment = _data["estimatedResultingMonthlyPayment"] !== undefined ? _data["estimatedResultingMonthlyPayment"] : null as any;
            this.calculatorRepaymentMonthsRemaining = _data["calculatorRepaymentMonthsRemaining"] !== undefined ? _data["calculatorRepaymentMonthsRemaining"] : null as any;
        }
    }

    static fromJS(data: any): AccountPlanReduction {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPlanReduction();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["semesterCode"] = this.semesterCode !== undefined ? this.semesterCode : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        data["processedDate"] = this.processedDate ? this.processedDate.toISOString() : null as any;
        data["interestAdjustmentAmount"] = this.interestAdjustmentAmount !== undefined ? this.interestAdjustmentAmount : null as any;
        data["beginningInterestAccrualDate"] = this.beginningInterestAccrualDate ? this.beginningInterestAccrualDate.toISOString() : null as any;
        data["lastInterestPaid"] = this.lastInterestPaid ? this.lastInterestPaid.toISOString() : null as any;
        data["numberMonthsPaid"] = this.numberMonthsPaid !== undefined ? this.numberMonthsPaid : null as any;
        data["principalReductionAmount"] = this.principalReductionAmount !== undefined ? this.principalReductionAmount : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["totalReduction"] = this.totalReduction !== undefined ? this.totalReduction : null as any;
        data["servPrincipalBalance"] = this.servPrincipalBalance !== undefined ? this.servPrincipalBalance : null as any;
        data["remainingPrincipalBalance"] = this.remainingPrincipalBalance !== undefined ? this.remainingPrincipalBalance : null as any;
        data["currentMonthlyInterestDue"] = this.currentMonthlyInterestDue !== undefined ? this.currentMonthlyInterestDue : null as any;
        data["payoffAmount"] = this.payoffAmount !== undefined ? this.payoffAmount : null as any;
        data["remainingRepaymentPeriod"] = this.remainingRepaymentPeriod !== undefined ? this.remainingRepaymentPeriod : null as any;
        data["reAmortizedMonthlyPayment"] = this.reAmortizedMonthlyPayment !== undefined ? this.reAmortizedMonthlyPayment : null as any;
        data["originalMonthlyPayment"] = this.originalMonthlyPayment !== undefined ? this.originalMonthlyPayment : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["numberDaysPaid"] = this.numberDaysPaid !== undefined ? this.numberDaysPaid : null as any;
        data["interestPaidToDate"] = this.interestPaidToDate !== undefined ? this.interestPaidToDate : null as any;
        data["loanSeqId"] = this.loanSeqId !== undefined ? this.loanSeqId : null as any;
        data["estimatedResultingMonthlyPayment"] = this.estimatedResultingMonthlyPayment !== undefined ? this.estimatedResultingMonthlyPayment : null as any;
        data["calculatorRepaymentMonthsRemaining"] = this.calculatorRepaymentMonthsRemaining !== undefined ? this.calculatorRepaymentMonthsRemaining : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountPlanReduction {
        const json = this.toJSON();
        let result = new AccountPlanReduction();
        result.init(json);
        return result;
    }
}

export interface IAccountPlanReduction extends IBaseModel {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    semesterCode?: string | null;
    semester?: Semester | null;
    processedDate?: Date | null;
    interestAdjustmentAmount?: number;
    beginningInterestAccrualDate?: Date | null;
    lastInterestPaid?: Date | null;
    numberMonthsPaid?: number | null;
    principalReductionAmount?: number;
    interestRate?: number | null;
    totalReduction?: number;
    servPrincipalBalance?: number | null;
    remainingPrincipalBalance?: number | null;
    currentMonthlyInterestDue?: number | null;
    payoffAmount?: number | null;
    remainingRepaymentPeriod?: number | null;
    reAmortizedMonthlyPayment?: number | null;
    originalMonthlyPayment?: number | null;
    comments?: string | null;
    numberDaysPaid?: number | null;
    interestPaidToDate?: number;
    loanSeqId?: string | null;
    estimatedResultingMonthlyPayment?: number;
    calculatorRepaymentMonthsRemaining?: number | null;
}

export class AccountDocument extends BaseModel implements IAccountDocument {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    sentDate?: Date;
    documentType?: DocumentType;
    receivedDate?: Date | null;
    active?: boolean;
    complete?: boolean;
    sentFilePath?: string | null;
    receivedFilePath?: string | null;
    comments?: string | null;
    fileName?: string | null;
    fileDescription?: string | null;

    constructor(data?: IAccountDocument) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : null as any;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : null as any;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : null as any;
            this.sentFilePath = _data["sentFilePath"] !== undefined ? _data["sentFilePath"] : null as any;
            this.receivedFilePath = _data["receivedFilePath"] !== undefined ? _data["receivedFilePath"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileDescription = _data["fileDescription"] !== undefined ? _data["fileDescription"] : null as any;
        }
    }

    static fromJS(data: any): AccountDocument {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDocument();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : null as any;
        data["documentType"] = this.documentType !== undefined ? this.documentType : null as any;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["complete"] = this.complete !== undefined ? this.complete : null as any;
        data["sentFilePath"] = this.sentFilePath !== undefined ? this.sentFilePath : null as any;
        data["receivedFilePath"] = this.receivedFilePath !== undefined ? this.receivedFilePath : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileDescription"] = this.fileDescription !== undefined ? this.fileDescription : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountDocument {
        const json = this.toJSON();
        let result = new AccountDocument();
        result.init(json);
        return result;
    }
}

export interface IAccountDocument extends IBaseModel {
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    sentDate?: Date;
    documentType?: DocumentType;
    receivedDate?: Date | null;
    active?: boolean;
    complete?: boolean;
    sentFilePath?: string | null;
    receivedFilePath?: string | null;
    comments?: string | null;
    fileName?: string | null;
    fileDescription?: string | null;
}

export enum DocumentType {
    AutoDebitAgreement = "AutoDebitAgreement",
    PepDenial = "PepDenial",
    PepPaidInFull = "PepPaidInFull",
    RefinanceAgreement = "RefinanceAgreement",
    PepAgreement = "PepAgreement",
    PEPREFUND = "PEPREFUND",
    PEPREDUCE = "PEPREDUCE",
    PEPAPPDISC = "PEPAPPDISC",
    PEPREMINDER = "PEPREMINDER",
    PEPCERT = "PEPCERT",
    PEPACK = "PEPACK",
    PEPINVOICE = "PEPINVOICE",
    PEPCANCEL = "PEPCANCEL",
    PEPREMIND = "PEPREMIND",
    PEPIOA = "PEPIOA",
    PEPFINAL = "PEPFINAL",
    Misc = "Misc",
}

export class SplitTransactionViewModel implements ISplitTransactionViewModel {
    transactionId?: number | null;
    coverageCode?: string | null;
    componentType?: string | null;
    transactionAmount?: number;

    constructor(data?: ISplitTransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.transactionId = _data["transactionId"] !== undefined ? _data["transactionId"] : null as any;
            this.coverageCode = _data["coverageCode"] !== undefined ? _data["coverageCode"] : null as any;
            this.componentType = _data["componentType"] !== undefined ? _data["componentType"] : null as any;
            this.transactionAmount = _data["transactionAmount"] !== undefined ? _data["transactionAmount"] : null as any;
        }
    }

    static fromJS(data: any): SplitTransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SplitTransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transactionId"] = this.transactionId !== undefined ? this.transactionId : null as any;
        data["coverageCode"] = this.coverageCode !== undefined ? this.coverageCode : null as any;
        data["componentType"] = this.componentType !== undefined ? this.componentType : null as any;
        data["transactionAmount"] = this.transactionAmount !== undefined ? this.transactionAmount : null as any;
        return data;
    }

    clone(): SplitTransactionViewModel {
        const json = this.toJSON();
        let result = new SplitTransactionViewModel();
        result.init(json);
        return result;
    }
}

export interface ISplitTransactionViewModel {
    transactionId?: number | null;
    coverageCode?: string | null;
    componentType?: string | null;
    transactionAmount?: number;
}

export class UpdateAccountPlanInformationResponse implements IUpdateAccountPlanInformationResponse {
    id?: number;

    constructor(data?: IUpdateAccountPlanInformationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): UpdateAccountPlanInformationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountPlanInformationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): UpdateAccountPlanInformationResponse {
        const json = this.toJSON();
        let result = new UpdateAccountPlanInformationResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateAccountPlanInformationResponse {
    id?: number;
}

export class UpdateAccountPlanInformationRequest implements IUpdateAccountPlanInformationRequest {
    accountPlanInformationViewModel?: AccountPlanInformationViewModel | null;

    constructor(data?: IUpdateAccountPlanInformationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountPlanInformationViewModel = _data["accountPlanInformationViewModel"] ? AccountPlanInformationViewModel.fromJS(_data["accountPlanInformationViewModel"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateAccountPlanInformationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountPlanInformationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountPlanInformationViewModel"] = this.accountPlanInformationViewModel ? this.accountPlanInformationViewModel.toJSON() : null as any;
        return data;
    }

    clone(): UpdateAccountPlanInformationRequest {
        const json = this.toJSON();
        let result = new UpdateAccountPlanInformationRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateAccountPlanInformationRequest {
    accountPlanInformationViewModel?: AccountPlanInformationViewModel | null;
}

export class SwapAccountApplicantTypesResponse implements ISwapAccountApplicantTypesResponse {

    constructor(data?: ISwapAccountApplicantTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): SwapAccountApplicantTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SwapAccountApplicantTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): SwapAccountApplicantTypesResponse {
        const json = this.toJSON();
        let result = new SwapAccountApplicantTypesResponse();
        result.init(json);
        return result;
    }
}

export interface ISwapAccountApplicantTypesResponse {
}

export class SwapAccountApplicantTypesRequest implements ISwapAccountApplicantTypesRequest {
    accountId?: number;

    constructor(data?: ISwapAccountApplicantTypesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): SwapAccountApplicantTypesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SwapAccountApplicantTypesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): SwapAccountApplicantTypesRequest {
        const json = this.toJSON();
        let result = new SwapAccountApplicantTypesRequest();
        result.init(json);
        return result;
    }
}

export interface ISwapAccountApplicantTypesRequest {
    accountId?: number;
}

export class GetAccountSemestersResponse implements IGetAccountSemestersResponse {
    fiscalYearId?: number;
    accountPlanInformationId?: number;
    semesters?: AccountSemesterViewModel[] | null;
    comments?: string | null;
    versions?: AccountSemesterPlanVersionViewModel[] | null;

    constructor(data?: IGetAccountSemestersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.accountPlanInformationId = _data["accountPlanInformationId"] !== undefined ? _data["accountPlanInformationId"] : null as any;
            if (Array.isArray(_data["semesters"])) {
                this.semesters = [] as any;
                for (let item of _data["semesters"])
                    this.semesters!.push(AccountSemesterViewModel.fromJS(item));
            }
            else {
                this.semesters = null as any;
            }
            this.comments = _data["comments"] !== undefined ? _data["comments"] : <any>null;
            if (Array.isArray(_data["versions"])) {
                this.versions = [] as any;
                for (let item of _data["versions"])
                    this.versions!.push(AccountSemesterPlanVersionViewModel.fromJS(item));
            }
            else {
                this.versions = <any>null;
            }
        }
    }

    static fromJS(data: any): GetAccountSemestersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountSemestersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["accountPlanInformationId"] = this.accountPlanInformationId !== undefined ? this.accountPlanInformationId : null as any;
        if (Array.isArray(this.semesters)) {
            data["semesters"] = [];
            for (let item of this.semesters)
                data["semesters"].push(item ? item.toJSON() : null as any);
        }
        data["comments"] = this.comments !== undefined ? this.comments : <any>null;
        if (Array.isArray(this.versions)) {
            data["versions"] = [];
            for (let item of this.versions)
                data["versions"].push(item.toJSON());
        }
        return data;
    }

    clone(): GetAccountSemestersResponse {
        const json = this.toJSON();
        let result = new GetAccountSemestersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAccountSemestersResponse {
    fiscalYearId?: number;
    accountPlanInformationId?: number;
    semesters?: AccountSemesterViewModel[] | null;
    comments?: string | null;
    versions?: AccountSemesterPlanVersionViewModel[] | null;
}

export class AccountSemesterPlanVersionViewModel implements IAccountSemesterPlanVersionViewModel {
    id?: number;
    accountPlanInformationId?: number;
    versionNumber?: number;
    isCurrent?: boolean;
    versionComments?: string | null;
    supersededDate?: Date | null;
    createdDate?: Date;
    updateUserId?: string | null;
    updateUserName?: string | null;
    details?: AccountSemesterVersionDetailViewModel[] | null;

    constructor(data?: IAccountSemesterPlanVersionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.accountPlanInformationId = _data["accountPlanInformationId"] !== undefined ? _data["accountPlanInformationId"] : <any>null;
            this.versionNumber = _data["versionNumber"] !== undefined ? _data["versionNumber"] : <any>null;
            this.isCurrent = _data["isCurrent"] !== undefined ? _data["isCurrent"] : <any>null;
            this.versionComments = _data["versionComments"] !== undefined ? _data["versionComments"] : <any>null;
            this.supersededDate = _data["supersededDate"] ? new Date(_data["supersededDate"].toString()) : <any>null;
            this.createdDate = _data["createdDate"] ? new Date(_data["createdDate"].toString()) : <any>null;
            this.updateUserId = _data["updateUserId"] !== undefined ? _data["updateUserId"] : <any>null;
            this.updateUserName = _data["updateUserName"] !== undefined ? _data["updateUserName"] : <any>null;
            if (Array.isArray(_data["details"])) {
                this.details = [] as any;
                for (let item of _data["details"])
                    this.details!.push(AccountSemesterVersionDetailViewModel.fromJS(item));
            }
            else {
                this.details = <any>null;
            }
        }
    }

    static fromJS(data: any): AccountSemesterPlanVersionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSemesterPlanVersionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["accountPlanInformationId"] = this.accountPlanInformationId !== undefined ? this.accountPlanInformationId : <any>null;
        data["versionNumber"] = this.versionNumber !== undefined ? this.versionNumber : <any>null;
        data["isCurrent"] = this.isCurrent !== undefined ? this.isCurrent : <any>null;
        data["versionComments"] = this.versionComments !== undefined ? this.versionComments : <any>null;
        data["supersededDate"] = this.supersededDate ? this.supersededDate.toISOString() : <any>null;
        data["createdDate"] = this.createdDate ? this.createdDate.toISOString() : <any>null;
        data["updateUserId"] = this.updateUserId !== undefined ? this.updateUserId : <any>null;
        data["updateUserName"] = this.updateUserName !== undefined ? this.updateUserName : <any>null;
        if (Array.isArray(this.details)) {
            data["details"] = [];
            for (let item of this.details)
                data["details"].push(item.toJSON());
        }
        return data;
    }

    clone(): AccountSemesterPlanVersionViewModel {
        const json = this.toJSON();
        let result = new AccountSemesterPlanVersionViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountSemesterPlanVersionViewModel {
    id?: number;
    accountPlanInformationId?: number;
    versionNumber?: number;
    isCurrent?: boolean;
    versionComments?: string | null;
    supersededDate?: Date | null;
    createdDate?: Date;
    updateUserId?: string | null;
    updateUserName?: string | null;
    details?: AccountSemesterVersionDetailViewModel[] | null;
}

export class AccountSemesterVersionDetailViewModel implements IAccountSemesterVersionDetailViewModel {
    id?: number;
    accountSemesterPlanVersionId?: number;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    semesterId?: string | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    actualFoodServiceAmount?: number | null;
    postedToAccount?: boolean;

    constructor(data?: IAccountSemesterVersionDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : <any>null;
            this.accountSemesterPlanVersionId = _data["accountSemesterPlanVersionId"] !== undefined ? _data["accountSemesterPlanVersionId"] : <any>null;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : <any>null;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : <any>null;
            this.semesterId = _data["semesterId"] !== undefined ? _data["semesterId"] : <any>null;
            this.participationRate = _data["participationRate"] !== undefined ? _data["participationRate"] : <any>null;
            this.totalSemesterCharges = _data["totalSemesterCharges"] !== undefined ? _data["totalSemesterCharges"] : <any>null;
            this.tuitionCostId = _data["tuitionCostId"] !== undefined ? _data["tuitionCostId"] : <any>null;
            this.tuitionCost = _data["tuitionCost"] ? CostViewModel.fromJS(_data["tuitionCost"]) : <any>null;
            this.actualTuitionAmount = _data["actualTuitionAmount"] !== undefined ? _data["actualTuitionAmount"] : <any>null;
            this.activityCostId = _data["activityCostId"] !== undefined ? _data["activityCostId"] : <any>null;
            this.activityCost = _data["activityCost"] ? CostViewModel.fromJS(_data["activityCost"]) : <any>null;
            this.actualActivityAmount = _data["actualActivityAmount"] !== undefined ? _data["actualActivityAmount"] : <any>null;
            this.housingCostId = _data["housingCostId"] !== undefined ? _data["housingCostId"] : <any>null;
            this.housingCost = _data["housingCost"] ? CostViewModel.fromJS(_data["housingCost"]) : <any>null;
            this.actualHousingAmount = _data["actualHousingAmount"] !== undefined ? _data["actualHousingAmount"] : <any>null;
            this.foodServiceCostId = _data["foodServiceCostId"] !== undefined ? _data["foodServiceCostId"] : <any>null;
            this.foodServiceCost = _data["foodServiceCost"] ? CostViewModel.fromJS(_data["foodServiceCost"]) : <any>null;
            this.actualFoodServiceAmount = _data["actualFoodServiceAmount"] !== undefined ? _data["actualFoodServiceAmount"] : <any>null;
            this.postedToAccount = _data["postedToAccount"] !== undefined ? _data["postedToAccount"] : <any>null;
        }
    }

    static fromJS(data: any): AccountSemesterVersionDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSemesterVersionDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : <any>null;
        data["accountSemesterPlanVersionId"] = this.accountSemesterPlanVersionId !== undefined ? this.accountSemesterPlanVersionId : <any>null;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : <any>null;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : <any>null;
        data["semesterId"] = this.semesterId !== undefined ? this.semesterId : <any>null;
        data["participationRate"] = this.participationRate !== undefined ? this.participationRate : <any>null;
        data["totalSemesterCharges"] = this.totalSemesterCharges !== undefined ? this.totalSemesterCharges : <any>null;
        data["tuitionCostId"] = this.tuitionCostId !== undefined ? this.tuitionCostId : <any>null;
        data["tuitionCost"] = this.tuitionCost ? this.tuitionCost.toJSON() : <any>null;
        data["actualTuitionAmount"] = this.actualTuitionAmount !== undefined ? this.actualTuitionAmount : <any>null;
        data["activityCostId"] = this.activityCostId !== undefined ? this.activityCostId : <any>null;
        data["activityCost"] = this.activityCost ? this.activityCost.toJSON() : <any>null;
        data["actualActivityAmount"] = this.actualActivityAmount !== undefined ? this.actualActivityAmount : <any>null;
        data["housingCostId"] = this.housingCostId !== undefined ? this.housingCostId : <any>null;
        data["housingCost"] = this.housingCost ? this.housingCost.toJSON() : <any>null;
        data["actualHousingAmount"] = this.actualHousingAmount !== undefined ? this.actualHousingAmount : <any>null;
        data["foodServiceCostId"] = this.foodServiceCostId !== undefined ? this.foodServiceCostId : <any>null;
        data["foodServiceCost"] = this.foodServiceCost ? this.foodServiceCost.toJSON() : <any>null;
        data["actualFoodServiceAmount"] = this.actualFoodServiceAmount !== undefined ? this.actualFoodServiceAmount : <any>null;
        data["postedToAccount"] = this.postedToAccount !== undefined ? this.postedToAccount : <any>null;
        return data;
    }

    clone(): AccountSemesterVersionDetailViewModel {
        const json = this.toJSON();
        let result = new AccountSemesterVersionDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountSemesterVersionDetailViewModel {
    id?: number;
    accountSemesterPlanVersionId?: number;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    semesterId?: string | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    actualFoodServiceAmount?: number | null;
    postedToAccount?: boolean;
}

export class AccountSemesterViewModel implements IAccountSemesterViewModel {
    id?: number | null;
    accountPlanInformationId?: number;
    accountPlanInformation?: AccountPlanInformationViewModel | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    semesterId?: string | null;
    semester?: SemesterViewModel | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    actualFoodServiceAmount?: number | null;
    postedToAccount?: boolean;

    constructor(data?: IAccountSemesterViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountPlanInformationId = _data["accountPlanInformationId"] !== undefined ? _data["accountPlanInformationId"] : null as any;
            this.accountPlanInformation = _data["accountPlanInformation"] ? AccountPlanInformationViewModel.fromJS(_data["accountPlanInformation"]) : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : null as any;
            this.semesterId = _data["semesterId"] !== undefined ? _data["semesterId"] : null as any;
            this.semester = _data["semester"] ? SemesterViewModel.fromJS(_data["semester"]) : null as any;
            this.participationRate = _data["participationRate"] !== undefined ? _data["participationRate"] : null as any;
            this.totalSemesterCharges = _data["totalSemesterCharges"] !== undefined ? _data["totalSemesterCharges"] : null as any;
            this.tuitionCostId = _data["tuitionCostId"] !== undefined ? _data["tuitionCostId"] : null as any;
            this.tuitionCost = _data["tuitionCost"] ? CostViewModel.fromJS(_data["tuitionCost"]) : null as any;
            this.actualTuitionAmount = _data["actualTuitionAmount"] !== undefined ? _data["actualTuitionAmount"] : null as any;
            this.activityCostId = _data["activityCostId"] !== undefined ? _data["activityCostId"] : null as any;
            this.activityCost = _data["activityCost"] ? CostViewModel.fromJS(_data["activityCost"]) : null as any;
            this.actualActivityAmount = _data["actualActivityAmount"] !== undefined ? _data["actualActivityAmount"] : null as any;
            this.housingCostId = _data["housingCostId"] !== undefined ? _data["housingCostId"] : null as any;
            this.housingCost = _data["housingCost"] ? CostViewModel.fromJS(_data["housingCost"]) : null as any;
            this.actualHousingAmount = _data["actualHousingAmount"] !== undefined ? _data["actualHousingAmount"] : null as any;
            this.foodServiceCostId = _data["foodServiceCostId"] !== undefined ? _data["foodServiceCostId"] : null as any;
            this.foodServiceCost = _data["foodServiceCost"] ? CostViewModel.fromJS(_data["foodServiceCost"]) : null as any;
            this.actualFoodServiceAmount = _data["actualFoodServiceAmount"] !== undefined ? _data["actualFoodServiceAmount"] : null as any;
            this.postedToAccount = _data["postedToAccount"] !== undefined ? _data["postedToAccount"] : null as any;
        }
    }

    static fromJS(data: any): AccountSemesterViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountSemesterViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountPlanInformationId"] = this.accountPlanInformationId !== undefined ? this.accountPlanInformationId : null as any;
        data["accountPlanInformation"] = this.accountPlanInformation ? this.accountPlanInformation.toJSON() : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        data["semesterId"] = this.semesterId !== undefined ? this.semesterId : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        data["participationRate"] = this.participationRate !== undefined ? this.participationRate : null as any;
        data["totalSemesterCharges"] = this.totalSemesterCharges !== undefined ? this.totalSemesterCharges : null as any;
        data["tuitionCostId"] = this.tuitionCostId !== undefined ? this.tuitionCostId : null as any;
        data["tuitionCost"] = this.tuitionCost ? this.tuitionCost.toJSON() : null as any;
        data["actualTuitionAmount"] = this.actualTuitionAmount !== undefined ? this.actualTuitionAmount : null as any;
        data["activityCostId"] = this.activityCostId !== undefined ? this.activityCostId : null as any;
        data["activityCost"] = this.activityCost ? this.activityCost.toJSON() : null as any;
        data["actualActivityAmount"] = this.actualActivityAmount !== undefined ? this.actualActivityAmount : null as any;
        data["housingCostId"] = this.housingCostId !== undefined ? this.housingCostId : null as any;
        data["housingCost"] = this.housingCost ? this.housingCost.toJSON() : null as any;
        data["actualHousingAmount"] = this.actualHousingAmount !== undefined ? this.actualHousingAmount : null as any;
        data["foodServiceCostId"] = this.foodServiceCostId !== undefined ? this.foodServiceCostId : null as any;
        data["foodServiceCost"] = this.foodServiceCost ? this.foodServiceCost.toJSON() : null as any;
        data["actualFoodServiceAmount"] = this.actualFoodServiceAmount !== undefined ? this.actualFoodServiceAmount : null as any;
        data["postedToAccount"] = this.postedToAccount !== undefined ? this.postedToAccount : null as any;
        return data;
    }

    clone(): AccountSemesterViewModel {
        const json = this.toJSON();
        let result = new AccountSemesterViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountSemesterViewModel {
    id?: number | null;
    accountPlanInformationId?: number;
    accountPlanInformation?: AccountPlanInformationViewModel | null;
    fiscalYearId?: number;
    fiscalYear?: FiscalYearViewModel | null;
    semesterId?: string | null;
    semester?: SemesterViewModel | null;
    participationRate?: number | null;
    totalSemesterCharges?: number | null;
    tuitionCostId?: number | null;
    tuitionCost?: CostViewModel | null;
    actualTuitionAmount?: number | null;
    activityCostId?: number | null;
    activityCost?: CostViewModel | null;
    actualActivityAmount?: number | null;
    housingCostId?: number | null;
    housingCost?: CostViewModel | null;
    actualHousingAmount?: number | null;
    foodServiceCostId?: number | null;
    foodServiceCost?: CostViewModel | null;
    actualFoodServiceAmount?: number | null;
    postedToAccount?: boolean;
}

export class UpdateAccountSemestersResponse implements IUpdateAccountSemestersResponse {
    totalMismatchWarning?: boolean;

    constructor(data?: IUpdateAccountSemestersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalMismatchWarning = _data["totalMismatchWarning"] !== undefined ? _data["totalMismatchWarning"] : <any>null;
        }
    }

    static fromJS(data: any): UpdateAccountSemestersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountSemestersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalMismatchWarning"] = this.totalMismatchWarning !== undefined ? this.totalMismatchWarning : <any>null;
        return data;
    }

    clone(): UpdateAccountSemestersResponse {
        const json = this.toJSON();
        let result = new UpdateAccountSemestersResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateAccountSemestersResponse {
    totalMismatchWarning?: boolean;
}

export class UpdateAccountSemestersRequest implements IUpdateAccountSemestersRequest {
    accountPlanInformationId?: number;
    semesters?: AccountSemesterViewModel[] | null;
    comments?: string | null;

    constructor(data?: IUpdateAccountSemestersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountPlanInformationId = _data["accountPlanInformationId"] !== undefined ? _data["accountPlanInformationId"] : null as any;
            if (Array.isArray(_data["semesters"])) {
                this.semesters = [] as any;
                for (let item of _data["semesters"])
                    this.semesters!.push(AccountSemesterViewModel.fromJS(item));
            }
            else {
                this.semesters = null as any;
            }
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
        }
    }

    static fromJS(data: any): UpdateAccountSemestersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountSemestersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountPlanInformationId"] = this.accountPlanInformationId !== undefined ? this.accountPlanInformationId : null as any;
        if (Array.isArray(this.semesters)) {
            data["semesters"] = [];
            for (let item of this.semesters)
                data["semesters"].push(item ? item.toJSON() : null as any);
        }
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        return data;
    }

    clone(): UpdateAccountSemestersRequest {
        const json = this.toJSON();
        let result = new UpdateAccountSemestersRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateAccountSemestersRequest {
    accountPlanInformationId?: number;
    semesters?: AccountSemesterViewModel[] | null;
    comments?: string | null;
}

export class DeleteAccountResponse implements IDeleteAccountResponse {
    result?: boolean;

    constructor(data?: IDeleteAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): DeleteAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }

    clone(): DeleteAccountResponse {
        const json = this.toJSON();
        let result = new DeleteAccountResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteAccountResponse {
    result?: boolean;
}

export class CancelAccountResponse implements ICancelAccountResponse {
    responseCode?: AccountCancellationResponseCode;

    constructor(data?: ICancelAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.responseCode = _data["responseCode"] !== undefined ? _data["responseCode"] : null as any;
        }
    }

    static fromJS(data: any): CancelAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CancelAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["responseCode"] = this.responseCode !== undefined ? this.responseCode : null as any;
        return data;
    }

    clone(): CancelAccountResponse {
        const json = this.toJSON();
        let result = new CancelAccountResponse();
        result.init(json);
        return result;
    }
}

export interface ICancelAccountResponse {
    responseCode?: AccountCancellationResponseCode;
}

export enum AccountCancellationResponseCode {
    Successful = "Successful",
    AccountNotFound = "AccountNotFound",
}

export class CancelAccountRequest implements ICancelAccountRequest {
    accountId?: number;

    constructor(data?: ICancelAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): CancelAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CancelAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): CancelAccountRequest {
        const json = this.toJSON();
        let result = new CancelAccountRequest();
        result.init(json);
        return result;
    }
}

export interface ICancelAccountRequest {
    accountId?: number;
}

export class GetApplicationAccountSemestersResponse implements IGetApplicationAccountSemestersResponse {
    semestersPreviews?: SemestersPreview[] | null;
    tuitionTotalPepPurchase?: number | null;
    feesTotalPepPurchase?: number | null;
    housingTotalPepPurchase?: number | null;
    foodServiceTotalPepPurchase?: number | null;
    totalPepPurchase?: number | null;
    housingAndMealTotal?: number | null;
    tuitionAndFeesTotal?: number | null;
    studentName?: string | null;

    constructor(data?: IGetApplicationAccountSemestersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["semestersPreviews"])) {
                this.semestersPreviews = [] as any;
                for (let item of _data["semestersPreviews"])
                    this.semestersPreviews!.push(SemestersPreview.fromJS(item));
            }
            else {
                this.semestersPreviews = null as any;
            }
            this.tuitionTotalPepPurchase = _data["tuitionTotalPepPurchase"] !== undefined ? _data["tuitionTotalPepPurchase"] : null as any;
            this.feesTotalPepPurchase = _data["feesTotalPepPurchase"] !== undefined ? _data["feesTotalPepPurchase"] : null as any;
            this.housingTotalPepPurchase = _data["housingTotalPepPurchase"] !== undefined ? _data["housingTotalPepPurchase"] : null as any;
            this.foodServiceTotalPepPurchase = _data["foodServiceTotalPepPurchase"] !== undefined ? _data["foodServiceTotalPepPurchase"] : null as any;
            this.totalPepPurchase = _data["totalPepPurchase"] !== undefined ? _data["totalPepPurchase"] : null as any;
            this.housingAndMealTotal = _data["housingAndMealTotal"] !== undefined ? _data["housingAndMealTotal"] : null as any;
            this.tuitionAndFeesTotal = _data["tuitionAndFeesTotal"] !== undefined ? _data["tuitionAndFeesTotal"] : null as any;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : null as any;
        }
    }

    static fromJS(data: any): GetApplicationAccountSemestersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationAccountSemestersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.semestersPreviews)) {
            data["semestersPreviews"] = [];
            for (let item of this.semestersPreviews)
                data["semestersPreviews"].push(item ? item.toJSON() : null as any);
        }
        data["tuitionTotalPepPurchase"] = this.tuitionTotalPepPurchase !== undefined ? this.tuitionTotalPepPurchase : null as any;
        data["feesTotalPepPurchase"] = this.feesTotalPepPurchase !== undefined ? this.feesTotalPepPurchase : null as any;
        data["housingTotalPepPurchase"] = this.housingTotalPepPurchase !== undefined ? this.housingTotalPepPurchase : null as any;
        data["foodServiceTotalPepPurchase"] = this.foodServiceTotalPepPurchase !== undefined ? this.foodServiceTotalPepPurchase : null as any;
        data["totalPepPurchase"] = this.totalPepPurchase !== undefined ? this.totalPepPurchase : null as any;
        data["housingAndMealTotal"] = this.housingAndMealTotal !== undefined ? this.housingAndMealTotal : null as any;
        data["tuitionAndFeesTotal"] = this.tuitionAndFeesTotal !== undefined ? this.tuitionAndFeesTotal : null as any;
        data["studentName"] = this.studentName !== undefined ? this.studentName : null as any;
        return data;
    }

    clone(): GetApplicationAccountSemestersResponse {
        const json = this.toJSON();
        let result = new GetApplicationAccountSemestersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicationAccountSemestersResponse {
    semestersPreviews?: SemestersPreview[] | null;
    tuitionTotalPepPurchase?: number | null;
    feesTotalPepPurchase?: number | null;
    housingTotalPepPurchase?: number | null;
    foodServiceTotalPepPurchase?: number | null;
    totalPepPurchase?: number | null;
    housingAndMealTotal?: number | null;
    tuitionAndFeesTotal?: number | null;
    studentName?: string | null;
}

export class SemestersPreview implements ISemestersPreview {
    fallSemesterCode?: string | null;
    springSemesterCode?: string | null;
    fallTuitionAmount?: number | null;
    springTuitionAmount?: number | null;
    fallFeesAmount?: number | null;
    springFeesAmount?: number | null;
    fallHousingAmount?: number | null;
    springHousingAmount?: number | null;
    fallHousingName?: string | null;
    springHousingName?: string | null;
    fallFoodServiceAmount?: number | null;
    springFoodServiceAmount?: number | null;
    fallFoodServiceName?: string | null;
    springFoodServiceName?: string | null;
    fallTotalAmount?: number | null;
    springTotalAmount?: number | null;
    fallParticipationRate?: number | null;
    springParticipationRate?: number | null;
    tuitionTotal?: number | null;
    feesTotal?: number | null;
    housingTotal?: number | null;
    foodServiceTotal?: number | null;
    total?: number | null;

    constructor(data?: ISemestersPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fallSemesterCode = _data["fallSemesterCode"] !== undefined ? _data["fallSemesterCode"] : null as any;
            this.springSemesterCode = _data["springSemesterCode"] !== undefined ? _data["springSemesterCode"] : null as any;
            this.fallTuitionAmount = _data["fallTuitionAmount"] !== undefined ? _data["fallTuitionAmount"] : null as any;
            this.springTuitionAmount = _data["springTuitionAmount"] !== undefined ? _data["springTuitionAmount"] : null as any;
            this.fallFeesAmount = _data["fallFeesAmount"] !== undefined ? _data["fallFeesAmount"] : null as any;
            this.springFeesAmount = _data["springFeesAmount"] !== undefined ? _data["springFeesAmount"] : null as any;
            this.fallHousingAmount = _data["fallHousingAmount"] !== undefined ? _data["fallHousingAmount"] : null as any;
            this.springHousingAmount = _data["springHousingAmount"] !== undefined ? _data["springHousingAmount"] : null as any;
            this.fallHousingName = _data["fallHousingName"] !== undefined ? _data["fallHousingName"] : null as any;
            this.springHousingName = _data["springHousingName"] !== undefined ? _data["springHousingName"] : null as any;
            this.fallFoodServiceAmount = _data["fallFoodServiceAmount"] !== undefined ? _data["fallFoodServiceAmount"] : null as any;
            this.springFoodServiceAmount = _data["springFoodServiceAmount"] !== undefined ? _data["springFoodServiceAmount"] : null as any;
            this.fallFoodServiceName = _data["fallFoodServiceName"] !== undefined ? _data["fallFoodServiceName"] : null as any;
            this.springFoodServiceName = _data["springFoodServiceName"] !== undefined ? _data["springFoodServiceName"] : null as any;
            this.fallTotalAmount = _data["fallTotalAmount"] !== undefined ? _data["fallTotalAmount"] : null as any;
            this.springTotalAmount = _data["springTotalAmount"] !== undefined ? _data["springTotalAmount"] : null as any;
            this.fallParticipationRate = _data["fallParticipationRate"] !== undefined ? _data["fallParticipationRate"] : null as any;
            this.springParticipationRate = _data["springParticipationRate"] !== undefined ? _data["springParticipationRate"] : null as any;
            this.tuitionTotal = _data["tuitionTotal"] !== undefined ? _data["tuitionTotal"] : null as any;
            this.feesTotal = _data["feesTotal"] !== undefined ? _data["feesTotal"] : null as any;
            this.housingTotal = _data["housingTotal"] !== undefined ? _data["housingTotal"] : null as any;
            this.foodServiceTotal = _data["foodServiceTotal"] !== undefined ? _data["foodServiceTotal"] : null as any;
            this.total = _data["total"] !== undefined ? _data["total"] : null as any;
        }
    }

    static fromJS(data: any): SemestersPreview {
        data = typeof data === 'object' ? data : {};
        let result = new SemestersPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fallSemesterCode"] = this.fallSemesterCode !== undefined ? this.fallSemesterCode : null as any;
        data["springSemesterCode"] = this.springSemesterCode !== undefined ? this.springSemesterCode : null as any;
        data["fallTuitionAmount"] = this.fallTuitionAmount !== undefined ? this.fallTuitionAmount : null as any;
        data["springTuitionAmount"] = this.springTuitionAmount !== undefined ? this.springTuitionAmount : null as any;
        data["fallFeesAmount"] = this.fallFeesAmount !== undefined ? this.fallFeesAmount : null as any;
        data["springFeesAmount"] = this.springFeesAmount !== undefined ? this.springFeesAmount : null as any;
        data["fallHousingAmount"] = this.fallHousingAmount !== undefined ? this.fallHousingAmount : null as any;
        data["springHousingAmount"] = this.springHousingAmount !== undefined ? this.springHousingAmount : null as any;
        data["fallHousingName"] = this.fallHousingName !== undefined ? this.fallHousingName : null as any;
        data["springHousingName"] = this.springHousingName !== undefined ? this.springHousingName : null as any;
        data["fallFoodServiceAmount"] = this.fallFoodServiceAmount !== undefined ? this.fallFoodServiceAmount : null as any;
        data["springFoodServiceAmount"] = this.springFoodServiceAmount !== undefined ? this.springFoodServiceAmount : null as any;
        data["fallFoodServiceName"] = this.fallFoodServiceName !== undefined ? this.fallFoodServiceName : null as any;
        data["springFoodServiceName"] = this.springFoodServiceName !== undefined ? this.springFoodServiceName : null as any;
        data["fallTotalAmount"] = this.fallTotalAmount !== undefined ? this.fallTotalAmount : null as any;
        data["springTotalAmount"] = this.springTotalAmount !== undefined ? this.springTotalAmount : null as any;
        data["fallParticipationRate"] = this.fallParticipationRate !== undefined ? this.fallParticipationRate : null as any;
        data["springParticipationRate"] = this.springParticipationRate !== undefined ? this.springParticipationRate : null as any;
        data["tuitionTotal"] = this.tuitionTotal !== undefined ? this.tuitionTotal : null as any;
        data["feesTotal"] = this.feesTotal !== undefined ? this.feesTotal : null as any;
        data["housingTotal"] = this.housingTotal !== undefined ? this.housingTotal : null as any;
        data["foodServiceTotal"] = this.foodServiceTotal !== undefined ? this.foodServiceTotal : null as any;
        data["total"] = this.total !== undefined ? this.total : null as any;
        return data;
    }

    clone(): SemestersPreview {
        const json = this.toJSON();
        let result = new SemestersPreview();
        result.init(json);
        return result;
    }
}

export interface ISemestersPreview {
    fallSemesterCode?: string | null;
    springSemesterCode?: string | null;
    fallTuitionAmount?: number | null;
    springTuitionAmount?: number | null;
    fallFeesAmount?: number | null;
    springFeesAmount?: number | null;
    fallHousingAmount?: number | null;
    springHousingAmount?: number | null;
    fallHousingName?: string | null;
    springHousingName?: string | null;
    fallFoodServiceAmount?: number | null;
    springFoodServiceAmount?: number | null;
    fallFoodServiceName?: string | null;
    springFoodServiceName?: string | null;
    fallTotalAmount?: number | null;
    springTotalAmount?: number | null;
    fallParticipationRate?: number | null;
    springParticipationRate?: number | null;
    tuitionTotal?: number | null;
    feesTotal?: number | null;
    housingTotal?: number | null;
    foodServiceTotal?: number | null;
    total?: number | null;
}

export class GetApplicantDetailResponse implements IGetApplicantDetailResponse {
    applicantDetail?: ApplicantDetailViewModel | null;

    constructor(data?: IGetApplicantDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantDetail = _data["applicantDetail"] ? ApplicantDetailViewModel.fromJS(_data["applicantDetail"]) : null as any;
        }
    }

    static fromJS(data: any): GetApplicantDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicantDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantDetail"] = this.applicantDetail ? this.applicantDetail.toJSON() : null as any;
        return data;
    }

    clone(): GetApplicantDetailResponse {
        const json = this.toJSON();
        let result = new GetApplicantDetailResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicantDetailResponse {
    applicantDetail?: ApplicantDetailViewModel | null;
}

export class ApplicantDetailViewModel implements IApplicantDetailViewModel {
    applicationApplicantRootId?: number;
    ssn?: string | null;
    lastFourSsn?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    prefix?: Prefix | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    workPhone?: string | null;
    emailAddress?: string | null;
    lastUpdatedDate?: Date | null;
    comments?: string | null;
    planType?: PlanType;
    type?: ApplicantType;
    source?: ApplicantSource | null;
    employmentData?: ApplicantDetailEmploymentDataViewModel | null;

    constructor(data?: IApplicantDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.lastFourSsn = _data["lastFourSsn"] !== undefined ? _data["lastFourSsn"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.employmentData = _data["employmentData"] ? ApplicantDetailEmploymentDataViewModel.fromJS(_data["employmentData"]) : null as any;
        }
    }

    static fromJS(data: any): ApplicantDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["lastFourSsn"] = this.lastFourSsn !== undefined ? this.lastFourSsn : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["employmentData"] = this.employmentData ? this.employmentData.toJSON() : null as any;
        return data;
    }

    clone(): ApplicantDetailViewModel {
        const json = this.toJSON();
        let result = new ApplicantDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicantDetailViewModel {
    applicationApplicantRootId?: number;
    ssn?: string | null;
    lastFourSsn?: string | null;
    lastName?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    prefix?: Prefix | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    workPhone?: string | null;
    emailAddress?: string | null;
    lastUpdatedDate?: Date | null;
    comments?: string | null;
    planType?: PlanType;
    type?: ApplicantType;
    source?: ApplicantSource | null;
    employmentData?: ApplicantDetailEmploymentDataViewModel | null;
}

export enum ApplicantSource {
    Applicant = "Applicant",
    Borrower = "Borrower",
}

export class ApplicantDetailEmploymentDataViewModel implements IApplicantDetailEmploymentDataViewModel {
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    applicantDetail?: ApplicantDetailViewModel | null;
    applicantDetailId?: number | null;

    constructor(data?: IApplicantDetailEmploymentDataViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.occupation = _data["occupation"] !== undefined ? _data["occupation"] : null as any;
            this.employer = _data["employer"] !== undefined ? _data["employer"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.country = _data["country"] !== undefined ? _data["country"] : null as any;
            this.isVerified = _data["isVerified"] !== undefined ? _data["isVerified"] : null as any;
            this.verifiedDate = _data["verifiedDate"] ? new Date(_data["verifiedDate"].toString()) : null as any;
            this.applicantDetail = _data["applicantDetail"] ? ApplicantDetailViewModel.fromJS(_data["applicantDetail"]) : null as any;
            this.applicantDetailId = _data["applicantDetailId"] !== undefined ? _data["applicantDetailId"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantDetailEmploymentDataViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetailEmploymentDataViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["occupation"] = this.occupation !== undefined ? this.occupation : null as any;
        data["employer"] = this.employer !== undefined ? this.employer : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["country"] = this.country !== undefined ? this.country : null as any;
        data["isVerified"] = this.isVerified !== undefined ? this.isVerified : null as any;
        data["verifiedDate"] = this.verifiedDate ? this.verifiedDate.toISOString() : null as any;
        data["applicantDetail"] = this.applicantDetail ? this.applicantDetail.toJSON() : null as any;
        data["applicantDetailId"] = this.applicantDetailId !== undefined ? this.applicantDetailId : null as any;
        return data;
    }

    clone(): ApplicantDetailEmploymentDataViewModel {
        const json = this.toJSON();
        let result = new ApplicantDetailEmploymentDataViewModel();
        result.init(json);
        return result;
    }
}

export interface IApplicantDetailEmploymentDataViewModel {
    occupation?: string | null;
    employer?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    workPhone?: string | null;
    country?: string | null;
    isVerified?: boolean | null;
    verifiedDate?: Date | null;
    applicantDetail?: ApplicantDetailViewModel | null;
    applicantDetailId?: number | null;
}

export class UpdateApplicantDetailResponse implements IUpdateApplicantDetailResponse {
    applicantId?: number;

    constructor(data?: IUpdateApplicantDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateApplicantDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApplicantDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        return data;
    }

    clone(): UpdateApplicantDetailResponse {
        const json = this.toJSON();
        let result = new UpdateApplicantDetailResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateApplicantDetailResponse {
    applicantId?: number;
}

export class UpdateApplicantDetailRequest implements IUpdateApplicantDetailRequest {
    applicantDetail?: ApplicantDetailViewModel | null;

    constructor(data?: IUpdateApplicantDetailRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantDetail = _data["applicantDetail"] ? ApplicantDetailViewModel.fromJS(_data["applicantDetail"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateApplicantDetailRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApplicantDetailRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantDetail"] = this.applicantDetail ? this.applicantDetail.toJSON() : null as any;
        return data;
    }

    clone(): UpdateApplicantDetailRequest {
        const json = this.toJSON();
        let result = new UpdateApplicantDetailRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateApplicantDetailRequest {
    applicantDetail?: ApplicantDetailViewModel | null;
}

export class GetFinancialSummaryPreviewsResponse implements IGetFinancialSummaryPreviewsResponse {
    financialSummaryPreviews?: FinancialSummaryPreview[] | null;

    constructor(data?: IGetFinancialSummaryPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["financialSummaryPreviews"])) {
                this.financialSummaryPreviews = [] as any;
                for (let item of _data["financialSummaryPreviews"])
                    this.financialSummaryPreviews!.push(FinancialSummaryPreview.fromJS(item));
            }
            else {
                this.financialSummaryPreviews = null as any;
            }
        }
    }

    static fromJS(data: any): GetFinancialSummaryPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialSummaryPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.financialSummaryPreviews)) {
            data["financialSummaryPreviews"] = [];
            for (let item of this.financialSummaryPreviews)
                data["financialSummaryPreviews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetFinancialSummaryPreviewsResponse {
        const json = this.toJSON();
        let result = new GetFinancialSummaryPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFinancialSummaryPreviewsResponse {
    financialSummaryPreviews?: FinancialSummaryPreview[] | null;
}

export class FinancialSummaryPreview implements IFinancialSummaryPreview {
    id?: number | null;
    applicationId?: number | null;
    decisionDate?: Date | null;
    decisionUser?: AppUserViewModel | null;
    totalPepPurchase?: number;
    approvalStatus?: ApprovalStatus;

    constructor(data?: IFinancialSummaryPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : null as any;
            this.decisionUser = _data["decisionUser"] ? AppUserViewModel.fromJS(_data["decisionUser"]) : null as any;
            this.totalPepPurchase = _data["totalPepPurchase"] !== undefined ? _data["totalPepPurchase"] : null as any;
            this.approvalStatus = _data["approvalStatus"] !== undefined ? _data["approvalStatus"] : null as any;
        }
    }

    static fromJS(data: any): FinancialSummaryPreview {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialSummaryPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : null as any;
        data["decisionUser"] = this.decisionUser ? this.decisionUser.toJSON() : null as any;
        data["totalPepPurchase"] = this.totalPepPurchase !== undefined ? this.totalPepPurchase : null as any;
        data["approvalStatus"] = this.approvalStatus !== undefined ? this.approvalStatus : null as any;
        return data;
    }

    clone(): FinancialSummaryPreview {
        const json = this.toJSON();
        let result = new FinancialSummaryPreview();
        result.init(json);
        return result;
    }
}

export interface IFinancialSummaryPreview {
    id?: number | null;
    applicationId?: number | null;
    decisionDate?: Date | null;
    decisionUser?: AppUserViewModel | null;
    totalPepPurchase?: number;
    approvalStatus?: ApprovalStatus;
}

export class GetApplicationPreviewsResponse implements IGetApplicationPreviewsResponse {
    applicationPreviews?: ApplicationPreview[] | null;

    constructor(data?: IGetApplicationPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationPreviews"])) {
                this.applicationPreviews = [] as any;
                for (let item of _data["applicationPreviews"])
                    this.applicationPreviews!.push(ApplicationPreview.fromJS(item));
            }
            else {
                this.applicationPreviews = null as any;
            }
        }
    }

    static fromJS(data: any): GetApplicationPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationPreviews)) {
            data["applicationPreviews"] = [];
            for (let item of this.applicationPreviews)
                data["applicationPreviews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetApplicationPreviewsResponse {
        const json = this.toJSON();
        let result = new GetApplicationPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicationPreviewsResponse {
    applicationPreviews?: ApplicationPreview[] | null;
}

export class ApplicationPreview implements IApplicationPreview {
    id?: number;
    applicationApplicantRootId?: number;
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    planType?: PlanType;
    studentFirstName?: string | null;
    studentLastName?: string | null;
    pepTotal?: number | null;
    submissionDate?: Date;
    status?: ApplicationStatus | null;
    fiscalYearId?: number;

    constructor(data?: IApplicationPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.applicantFirstName = _data["applicantFirstName"] !== undefined ? _data["applicantFirstName"] : null as any;
            this.applicantLastName = _data["applicantLastName"] !== undefined ? _data["applicantLastName"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.studentFirstName = _data["studentFirstName"] !== undefined ? _data["studentFirstName"] : null as any;
            this.studentLastName = _data["studentLastName"] !== undefined ? _data["studentLastName"] : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
        }
    }

    static fromJS(data: any): ApplicationPreview {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["applicantFirstName"] = this.applicantFirstName !== undefined ? this.applicantFirstName : null as any;
        data["applicantLastName"] = this.applicantLastName !== undefined ? this.applicantLastName : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["studentFirstName"] = this.studentFirstName !== undefined ? this.studentFirstName : null as any;
        data["studentLastName"] = this.studentLastName !== undefined ? this.studentLastName : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        return data;
    }

    clone(): ApplicationPreview {
        const json = this.toJSON();
        let result = new ApplicationPreview();
        result.init(json);
        return result;
    }
}

export interface IApplicationPreview {
    id?: number;
    applicationApplicantRootId?: number;
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    planType?: PlanType;
    studentFirstName?: string | null;
    studentLastName?: string | null;
    pepTotal?: number | null;
    submissionDate?: Date;
    status?: ApplicationStatus | null;
    fiscalYearId?: number;
}

export class GetAccountPreviewsResponse implements IGetAccountPreviewsResponse {
    accountPreviews?: AccountPreview[] | null;

    constructor(data?: IGetAccountPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountPreviews"])) {
                this.accountPreviews = [] as any;
                for (let item of _data["accountPreviews"])
                    this.accountPreviews!.push(AccountPreview.fromJS(item));
            }
            else {
                this.accountPreviews = null as any;
            }
        }
    }

    static fromJS(data: any): GetAccountPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountPreviews)) {
            data["accountPreviews"] = [];
            for (let item of this.accountPreviews)
                data["accountPreviews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetAccountPreviewsResponse {
        const json = this.toJSON();
        let result = new GetAccountPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAccountPreviewsResponse {
    accountPreviews?: AccountPreview[] | null;
}

export class AccountPreview implements IAccountPreview {
    accountId?: number;
    fiscalYear?: number;
    planType?: PlanType;
    borrowerType?: ApplicantType;
    pepTotal?: number;
    status?: AccountStatus | null;

    constructor(data?: IAccountPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.borrowerType = _data["borrowerType"] !== undefined ? _data["borrowerType"] : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
        }
    }

    static fromJS(data: any): AccountPreview {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["borrowerType"] = this.borrowerType !== undefined ? this.borrowerType : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        return data;
    }

    clone(): AccountPreview {
        const json = this.toJSON();
        let result = new AccountPreview();
        result.init(json);
        return result;
    }
}

export interface IAccountPreview {
    accountId?: number;
    fiscalYear?: number;
    planType?: PlanType;
    borrowerType?: ApplicantType;
    pepTotal?: number;
    status?: AccountStatus | null;
}

export class SearchApplicantPreviewsResponse implements ISearchApplicantPreviewsResponse {
    applicantPreviews?: ApplicantPreview[] | null;

    constructor(data?: ISearchApplicantPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicantPreviews"])) {
                this.applicantPreviews = [] as any;
                for (let item of _data["applicantPreviews"])
                    this.applicantPreviews!.push(ApplicantPreview.fromJS(item));
            }
            else {
                this.applicantPreviews = null as any;
            }
        }
    }

    static fromJS(data: any): SearchApplicantPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicantPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicantPreviews)) {
            data["applicantPreviews"] = [];
            for (let item of this.applicantPreviews)
                data["applicantPreviews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): SearchApplicantPreviewsResponse {
        const json = this.toJSON();
        let result = new SearchApplicantPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicantPreviewsResponse {
    applicantPreviews?: ApplicantPreview[] | null;
}

export class ApplicantPreview implements IApplicantPreview {
    id?: number;
    applicantRootId?: number | null;
    fullName?: string | null;
    email?: string | null;
    isNew?: boolean;
    lastFourSsn?: string | null;
    isConfirmed?: boolean;
    matchingAccountIds?: number[] | null;

    constructor(data?: IApplicantPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicantRootId = _data["applicantRootId"] !== undefined ? _data["applicantRootId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
            this.lastFourSsn = _data["lastFourSsn"] !== undefined ? _data["lastFourSsn"] : null as any;
            this.isConfirmed = _data["isConfirmed"] !== undefined ? _data["isConfirmed"] : null as any;
            if (Array.isArray(_data["matchingAccountIds"])) {
                this.matchingAccountIds = [] as any;
                for (let item of _data["matchingAccountIds"])
                    this.matchingAccountIds!.push(item);
            }
            else {
                this.matchingAccountIds = null as any;
            }
        }
    }

    static fromJS(data: any): ApplicantPreview {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicantRootId"] = this.applicantRootId !== undefined ? this.applicantRootId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        data["lastFourSsn"] = this.lastFourSsn !== undefined ? this.lastFourSsn : null as any;
        data["isConfirmed"] = this.isConfirmed !== undefined ? this.isConfirmed : null as any;
        if (Array.isArray(this.matchingAccountIds)) {
            data["matchingAccountIds"] = [];
            for (let item of this.matchingAccountIds)
                data["matchingAccountIds"].push(item);
        }
        return data;
    }

    clone(): ApplicantPreview {
        const json = this.toJSON();
        let result = new ApplicantPreview();
        result.init(json);
        return result;
    }
}

export interface IApplicantPreview {
    id?: number;
    applicantRootId?: number | null;
    fullName?: string | null;
    email?: string | null;
    isNew?: boolean;
    lastFourSsn?: string | null;
    isConfirmed?: boolean;
    matchingAccountIds?: number[] | null;
}

export class SearchApplicantPreviewsRequest implements ISearchApplicantPreviewsRequest {
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    applicantEmail?: string | null;

    constructor(data?: ISearchApplicantPreviewsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantFirstName = _data["applicantFirstName"] !== undefined ? _data["applicantFirstName"] : null as any;
            this.applicantLastName = _data["applicantLastName"] !== undefined ? _data["applicantLastName"] : null as any;
            this.applicantEmail = _data["applicantEmail"] !== undefined ? _data["applicantEmail"] : null as any;
        }
    }

    static fromJS(data: any): SearchApplicantPreviewsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicantPreviewsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantFirstName"] = this.applicantFirstName !== undefined ? this.applicantFirstName : null as any;
        data["applicantLastName"] = this.applicantLastName !== undefined ? this.applicantLastName : null as any;
        data["applicantEmail"] = this.applicantEmail !== undefined ? this.applicantEmail : null as any;
        return data;
    }

    clone(): SearchApplicantPreviewsRequest {
        const json = this.toJSON();
        let result = new SearchApplicantPreviewsRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicantPreviewsRequest {
    applicantFirstName?: string | null;
    applicantLastName?: string | null;
    applicantEmail?: string | null;
}

export class UpdateApplicantRootIdResponse implements IUpdateApplicantRootIdResponse {
    applicantRootId?: number | null;

    constructor(data?: IUpdateApplicantRootIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantRootId = _data["applicantRootId"] !== undefined ? _data["applicantRootId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateApplicantRootIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApplicantRootIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantRootId"] = this.applicantRootId !== undefined ? this.applicantRootId : null as any;
        return data;
    }

    clone(): UpdateApplicantRootIdResponse {
        const json = this.toJSON();
        let result = new UpdateApplicantRootIdResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateApplicantRootIdResponse {
    applicantRootId?: number | null;
}

export class UpdateApplicantRootIdRequest implements IUpdateApplicantRootIdRequest {
    applicantId?: number;
    newRootId?: number | null;

    constructor(data?: IUpdateApplicantRootIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
            this.newRootId = _data["newRootId"] !== undefined ? _data["newRootId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateApplicantRootIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateApplicantRootIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        data["newRootId"] = this.newRootId !== undefined ? this.newRootId : null as any;
        return data;
    }

    clone(): UpdateApplicantRootIdRequest {
        const json = this.toJSON();
        let result = new UpdateApplicantRootIdRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateApplicantRootIdRequest {
    applicantId?: number;
    newRootId?: number | null;
}

export class GetApplicantPreviewResponse implements IGetApplicantPreviewResponse {
    applicantPreview?: ApplicantPreview | null;

    constructor(data?: IGetApplicantPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantPreview = _data["applicantPreview"] ? ApplicantPreview.fromJS(_data["applicantPreview"]) : null as any;
        }
    }

    static fromJS(data: any): GetApplicantPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicantPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantPreview"] = this.applicantPreview ? this.applicantPreview.toJSON() : null as any;
        return data;
    }

    clone(): GetApplicantPreviewResponse {
        const json = this.toJSON();
        let result = new GetApplicantPreviewResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicantPreviewResponse {
    applicantPreview?: ApplicantPreview | null;
}

export class UpdateSsnResponse implements IUpdateSsnResponse {
    applicantRootId?: number;

    constructor(data?: IUpdateSsnResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantRootId = _data["applicantRootId"] !== undefined ? _data["applicantRootId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateSsnResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSsnResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantRootId"] = this.applicantRootId !== undefined ? this.applicantRootId : null as any;
        return data;
    }

    clone(): UpdateSsnResponse {
        const json = this.toJSON();
        let result = new UpdateSsnResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateSsnResponse {
    applicantRootId?: number;
}

export class UpdateSsnRequest implements IUpdateSsnRequest {
    applicantRootId?: number;
    matchingApplicantPreviews?: MatchingApplicantPreview[] | null;
    newSsn?: string | null;

    constructor(data?: IUpdateSsnRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicantRootId = _data["applicantRootId"] !== undefined ? _data["applicantRootId"] : null as any;
            if (Array.isArray(_data["matchingApplicantPreviews"])) {
                this.matchingApplicantPreviews = [] as any;
                for (let item of _data["matchingApplicantPreviews"])
                    this.matchingApplicantPreviews!.push(MatchingApplicantPreview.fromJS(item));
            }
            else {
                this.matchingApplicantPreviews = null as any;
            }
            this.newSsn = _data["newSsn"] !== undefined ? _data["newSsn"] : null as any;
        }
    }

    static fromJS(data: any): UpdateSsnRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSsnRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicantRootId"] = this.applicantRootId !== undefined ? this.applicantRootId : null as any;
        if (Array.isArray(this.matchingApplicantPreviews)) {
            data["matchingApplicantPreviews"] = [];
            for (let item of this.matchingApplicantPreviews)
                data["matchingApplicantPreviews"].push(item ? item.toJSON() : null as any);
        }
        data["newSsn"] = this.newSsn !== undefined ? this.newSsn : null as any;
        return data;
    }

    clone(): UpdateSsnRequest {
        const json = this.toJSON();
        let result = new UpdateSsnRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateSsnRequest {
    applicantRootId?: number;
    matchingApplicantPreviews?: MatchingApplicantPreview[] | null;
    newSsn?: string | null;
}

export class MatchingApplicantPreview implements IMatchingApplicantPreview {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    birthdate?: Date | null;
    accountId?: number;

    constructor(data?: IMatchingApplicantPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.birthdate = _data["birthdate"] ? new Date(_data["birthdate"].toString()) : null as any;
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): MatchingApplicantPreview {
        data = typeof data === 'object' ? data : {};
        let result = new MatchingApplicantPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["birthdate"] = this.birthdate ? this.birthdate.toISOString() : null as any;
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): MatchingApplicantPreview {
        const json = this.toJSON();
        let result = new MatchingApplicantPreview();
        result.init(json);
        return result;
    }
}

export interface IMatchingApplicantPreview {
    id?: number;
    firstName?: string | null;
    lastName?: string | null;
    birthdate?: Date | null;
    accountId?: number;
}

export class GetAllMatchingRootApplicantsResponse implements IGetAllMatchingRootApplicantsResponse {
    applicants?: MatchingApplicantPreview[] | null;

    constructor(data?: IGetAllMatchingRootApplicantsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicants"])) {
                this.applicants = [] as any;
                for (let item of _data["applicants"])
                    this.applicants!.push(MatchingApplicantPreview.fromJS(item));
            }
            else {
                this.applicants = null as any;
            }
        }
    }

    static fromJS(data: any): GetAllMatchingRootApplicantsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllMatchingRootApplicantsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicants)) {
            data["applicants"] = [];
            for (let item of this.applicants)
                data["applicants"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetAllMatchingRootApplicantsResponse {
        const json = this.toJSON();
        let result = new GetAllMatchingRootApplicantsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllMatchingRootApplicantsResponse {
    applicants?: MatchingApplicantPreview[] | null;
}

export class AccountQuickNavigationResponse implements IAccountQuickNavigationResponse {
    accounts?: AccountQuickNavigation[] | null;

    constructor(data?: IAccountQuickNavigationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accounts"])) {
                this.accounts = [] as any;
                for (let item of _data["accounts"])
                    this.accounts!.push(AccountQuickNavigation.fromJS(item));
            }
            else {
                this.accounts = null as any;
            }
        }
    }

    static fromJS(data: any): AccountQuickNavigationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AccountQuickNavigationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accounts)) {
            data["accounts"] = [];
            for (let item of this.accounts)
                data["accounts"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AccountQuickNavigationResponse {
        const json = this.toJSON();
        let result = new AccountQuickNavigationResponse();
        result.init(json);
        return result;
    }
}

export interface IAccountQuickNavigationResponse {
    accounts?: AccountQuickNavigation[] | null;
}

export class AccountQuickNavigation implements IAccountQuickNavigation {
    id?: number;
    applicantName?: string | null;
    rootId?: number | null;
    fiscalYear?: number;
    planType?: PlanType;
    studentName?: string | null;
    sisId?: number | null;
    pepTotal?: number;

    constructor(data?: IAccountQuickNavigation) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicantName = _data["applicantName"] !== undefined ? _data["applicantName"] : null as any;
            this.rootId = _data["rootId"] !== undefined ? _data["rootId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
        }
    }

    static fromJS(data: any): AccountQuickNavigation {
        data = typeof data === 'object' ? data : {};
        let result = new AccountQuickNavigation();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicantName"] = this.applicantName !== undefined ? this.applicantName : null as any;
        data["rootId"] = this.rootId !== undefined ? this.rootId : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["studentName"] = this.studentName !== undefined ? this.studentName : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        return data;
    }

    clone(): AccountQuickNavigation {
        const json = this.toJSON();
        let result = new AccountQuickNavigation();
        result.init(json);
        return result;
    }
}

export interface IAccountQuickNavigation {
    id?: number;
    applicantName?: string | null;
    rootId?: number | null;
    fiscalYear?: number;
    planType?: PlanType;
    studentName?: string | null;
    sisId?: number | null;
    pepTotal?: number;
}

export class GetApplicantDetailHistoryResponse implements IGetApplicantDetailHistoryResponse {
    history?: ApplicantDetailHistoryPreview[] | null;

    constructor(data?: IGetApplicantDetailHistoryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["history"])) {
                this.history = [] as any;
                for (let item of _data["history"])
                    this.history!.push(ApplicantDetailHistoryPreview.fromJS(item));
            }
            else {
                this.history = null as any;
            }
        }
    }

    static fromJS(data: any): GetApplicantDetailHistoryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicantDetailHistoryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.history)) {
            data["history"] = [];
            for (let item of this.history)
                data["history"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetApplicantDetailHistoryResponse {
        const json = this.toJSON();
        let result = new GetApplicantDetailHistoryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicantDetailHistoryResponse {
    history?: ApplicantDetailHistoryPreview[] | null;
}

export class ApplicantDetailHistoryPreview implements IApplicantDetailHistoryPreview {
    id?: number;
    applicationApplicantRootId?: number;
    lastName?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    prefix?: Prefix | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    workPhone?: string | null;
    emailAddress?: string | null;
    lastUpdatedDate?: Date | null;
    comments?: string | null;
    lastUpdatedBy?: string | null;
    type?: ApplicantType;

    constructor(data?: IApplicantDetailHistoryPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationApplicantRootId = _data["applicationApplicantRootId"] !== undefined ? _data["applicationApplicantRootId"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.state = _data["state"] !== undefined ? _data["state"] : null as any;
            this.zip = _data["zip"] !== undefined ? _data["zip"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryPhoneNumber = _data["secondaryPhoneNumber"] !== undefined ? _data["secondaryPhoneNumber"] : null as any;
            this.workPhone = _data["workPhone"] !== undefined ? _data["workPhone"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.lastUpdatedBy = _data["lastUpdatedBy"] !== undefined ? _data["lastUpdatedBy"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
        }
    }

    static fromJS(data: any): ApplicantDetailHistoryPreview {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicantDetailHistoryPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationApplicantRootId"] = this.applicationApplicantRootId !== undefined ? this.applicationApplicantRootId : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["state"] = this.state !== undefined ? this.state : null as any;
        data["zip"] = this.zip !== undefined ? this.zip : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryPhoneNumber"] = this.secondaryPhoneNumber !== undefined ? this.secondaryPhoneNumber : null as any;
        data["workPhone"] = this.workPhone !== undefined ? this.workPhone : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["lastUpdatedBy"] = this.lastUpdatedBy !== undefined ? this.lastUpdatedBy : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        return data;
    }

    clone(): ApplicantDetailHistoryPreview {
        const json = this.toJSON();
        let result = new ApplicantDetailHistoryPreview();
        result.init(json);
        return result;
    }
}

export interface IApplicantDetailHistoryPreview {
    id?: number;
    applicationApplicantRootId?: number;
    lastName?: string | null;
    firstName?: string | null;
    middleInitial?: string | null;
    prefix?: Prefix | null;
    birthDate?: Date | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: StateAbbreviation;
    zip?: string | null;
    phoneNumber?: string | null;
    secondaryPhoneNumber?: string | null;
    workPhone?: string | null;
    emailAddress?: string | null;
    lastUpdatedDate?: Date | null;
    comments?: string | null;
    lastUpdatedBy?: string | null;
    type?: ApplicantType;
}

export class SearchApplicationPreviewsResponse implements ISearchApplicationPreviewsResponse {
    applicationPreviews?: ApplicationPreview[] | null;

    constructor(data?: ISearchApplicationPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["applicationPreviews"])) {
                this.applicationPreviews = [] as any;
                for (let item of _data["applicationPreviews"])
                    this.applicationPreviews!.push(ApplicationPreview.fromJS(item));
            }
            else {
                this.applicationPreviews = null as any;
            }
        }
    }

    static fromJS(data: any): SearchApplicationPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicationPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.applicationPreviews)) {
            data["applicationPreviews"] = [];
            for (let item of this.applicationPreviews)
                data["applicationPreviews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): SearchApplicationPreviewsResponse {
        const json = this.toJSON();
        let result = new SearchApplicationPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicationPreviewsResponse {
    applicationPreviews?: ApplicationPreview[] | null;
}

export class SearchApplicationPreviewsRequest implements ISearchApplicationPreviewsRequest {
    name?: string | null;
    startCreatedDate?: Date | null;
    endCreatedDate?: Date | null;

    constructor(data?: ISearchApplicationPreviewsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.startCreatedDate = _data["startCreatedDate"] ? new Date(_data["startCreatedDate"].toString()) : null as any;
            this.endCreatedDate = _data["endCreatedDate"] ? new Date(_data["endCreatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SearchApplicationPreviewsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicationPreviewsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["startCreatedDate"] = this.startCreatedDate ? this.startCreatedDate.toISOString() : null as any;
        data["endCreatedDate"] = this.endCreatedDate ? this.endCreatedDate.toISOString() : null as any;
        return data;
    }

    clone(): SearchApplicationPreviewsRequest {
        const json = this.toJSON();
        let result = new SearchApplicationPreviewsRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicationPreviewsRequest {
    name?: string | null;
    startCreatedDate?: Date | null;
    endCreatedDate?: Date | null;
}

export class GetApplicationResponse implements IGetApplicationResponse {
    application?: ApplicationViewModel | null;
    hasSummary?: boolean;

    constructor(data?: IGetApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.hasSummary = _data["hasSummary"] !== undefined ? _data["hasSummary"] : null as any;
        }
    }

    static fromJS(data: any): GetApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["hasSummary"] = this.hasSummary !== undefined ? this.hasSummary : null as any;
        return data;
    }

    clone(): GetApplicationResponse {
        const json = this.toJSON();
        let result = new GetApplicationResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApplicationResponse {
    application?: ApplicationViewModel | null;
    hasSummary?: boolean;
}

export class GetPepApplicationPdfRequest implements IGetPepApplicationPdfRequest {
    applicationId?: number;
    estimatedMonthlyPayment?: string | null;

    constructor(data?: IGetPepApplicationPdfRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.estimatedMonthlyPayment = _data["estimatedMonthlyPayment"] !== undefined ? _data["estimatedMonthlyPayment"] : null as any;
        }
    }

    static fromJS(data: any): GetPepApplicationPdfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPepApplicationPdfRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["estimatedMonthlyPayment"] = this.estimatedMonthlyPayment !== undefined ? this.estimatedMonthlyPayment : null as any;
        return data;
    }

    clone(): GetPepApplicationPdfRequest {
        const json = this.toJSON();
        let result = new GetPepApplicationPdfRequest();
        result.init(json);
        return result;
    }
}

export interface IGetPepApplicationPdfRequest {
    applicationId?: number;
    estimatedMonthlyPayment?: string | null;
}

export class UpdateStatusResponse implements IUpdateStatusResponse {
    applicationId?: number;

    constructor(data?: IUpdateStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        return data;
    }

    clone(): UpdateStatusResponse {
        const json = this.toJSON();
        let result = new UpdateStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateStatusResponse {
    applicationId?: number;
}

export class UpdateStatusRequest implements IUpdateStatusRequest {
    applicationId?: number;
    applicationStatus?: ApplicationStatus;

    constructor(data?: IUpdateStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.applicationStatus = _data["applicationStatus"] !== undefined ? _data["applicationStatus"] : null as any;
        }
    }

    static fromJS(data: any): UpdateStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["applicationStatus"] = this.applicationStatus !== undefined ? this.applicationStatus : null as any;
        return data;
    }

    clone(): UpdateStatusRequest {
        const json = this.toJSON();
        let result = new UpdateStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateStatusRequest {
    applicationId?: number;
    applicationStatus?: ApplicationStatus;
}

export class CreateRefinanceApplicationResponse implements ICreateRefinanceApplicationResponse {
    accountId?: number;

    constructor(data?: ICreateRefinanceApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
        }
    }

    static fromJS(data: any): CreateRefinanceApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRefinanceApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        return data;
    }

    clone(): CreateRefinanceApplicationResponse {
        const json = this.toJSON();
        let result = new CreateRefinanceApplicationResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateRefinanceApplicationResponse {
    accountId?: number;
}

export class CreateRefinanceApplicationRequest implements ICreateRefinanceApplicationRequest {
    application?: ApplicationViewModel | null;

    constructor(data?: ICreateRefinanceApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
        }
    }

    static fromJS(data: any): CreateRefinanceApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateRefinanceApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : null as any;
        return data;
    }

    clone(): CreateRefinanceApplicationRequest {
        const json = this.toJSON();
        let result = new CreateRefinanceApplicationRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateRefinanceApplicationRequest {
    application?: ApplicationViewModel | null;
}

export class GetMatchingAccountIdsResponse implements IGetMatchingAccountIdsResponse {
    studentIds?: number[] | null;
    applicantIds?: number[] | null;
    coApplicantIds?: number[] | null;

    constructor(data?: IGetMatchingAccountIdsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["studentIds"])) {
                this.studentIds = [] as any;
                for (let item of _data["studentIds"])
                    this.studentIds!.push(item);
            }
            else {
                this.studentIds = null as any;
            }
            if (Array.isArray(_data["applicantIds"])) {
                this.applicantIds = [] as any;
                for (let item of _data["applicantIds"])
                    this.applicantIds!.push(item);
            }
            else {
                this.applicantIds = null as any;
            }
            if (Array.isArray(_data["coApplicantIds"])) {
                this.coApplicantIds = [] as any;
                for (let item of _data["coApplicantIds"])
                    this.coApplicantIds!.push(item);
            }
            else {
                this.coApplicantIds = null as any;
            }
        }
    }

    static fromJS(data: any): GetMatchingAccountIdsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetMatchingAccountIdsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.studentIds)) {
            data["studentIds"] = [];
            for (let item of this.studentIds)
                data["studentIds"].push(item);
        }
        if (Array.isArray(this.applicantIds)) {
            data["applicantIds"] = [];
            for (let item of this.applicantIds)
                data["applicantIds"].push(item);
        }
        if (Array.isArray(this.coApplicantIds)) {
            data["coApplicantIds"] = [];
            for (let item of this.coApplicantIds)
                data["coApplicantIds"].push(item);
        }
        return data;
    }

    clone(): GetMatchingAccountIdsResponse {
        const json = this.toJSON();
        let result = new GetMatchingAccountIdsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetMatchingAccountIdsResponse {
    studentIds?: number[] | null;
    applicantIds?: number[] | null;
    coApplicantIds?: number[] | null;
}

export class GetMatchingAccountIdsRequest implements IGetMatchingAccountIdsRequest {
    studentRootId?: number | null;
    applicantRootId?: number | null;
    coApplicantRootId?: number | null;

    constructor(data?: IGetMatchingAccountIdsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentRootId = _data["studentRootId"] !== undefined ? _data["studentRootId"] : null as any;
            this.applicantRootId = _data["applicantRootId"] !== undefined ? _data["applicantRootId"] : null as any;
            this.coApplicantRootId = _data["coApplicantRootId"] !== undefined ? _data["coApplicantRootId"] : null as any;
        }
    }

    static fromJS(data: any): GetMatchingAccountIdsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetMatchingAccountIdsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentRootId"] = this.studentRootId !== undefined ? this.studentRootId : null as any;
        data["applicantRootId"] = this.applicantRootId !== undefined ? this.applicantRootId : null as any;
        data["coApplicantRootId"] = this.coApplicantRootId !== undefined ? this.coApplicantRootId : null as any;
        return data;
    }

    clone(): GetMatchingAccountIdsRequest {
        const json = this.toJSON();
        let result = new GetMatchingAccountIdsRequest();
        result.init(json);
        return result;
    }
}

export interface IGetMatchingAccountIdsRequest {
    studentRootId?: number | null;
    applicantRootId?: number | null;
    coApplicantRootId?: number | null;
}

export class AddFinancialSummaryResponse implements IAddFinancialSummaryResponse {
    id?: number;
    error?: boolean;
    errorMessage?: string | null;

    constructor(data?: IAddFinancialSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
        }
    }

    static fromJS(data: any): AddFinancialSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddFinancialSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["error"] = this.error !== undefined ? this.error : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        return data;
    }

    clone(): AddFinancialSummaryResponse {
        const json = this.toJSON();
        let result = new AddFinancialSummaryResponse();
        result.init(json);
        return result;
    }
}

export interface IAddFinancialSummaryResponse {
    id?: number;
    error?: boolean;
    errorMessage?: string | null;
}

export class AddFinancialSummaryRequest implements IAddFinancialSummaryRequest {
    financialSummary?: FinancialSummaryViewModel | null;

    constructor(data?: IAddFinancialSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialSummary = _data["financialSummary"] ? FinancialSummaryViewModel.fromJS(_data["financialSummary"]) : null as any;
        }
    }

    static fromJS(data: any): AddFinancialSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddFinancialSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        return data;
    }

    clone(): AddFinancialSummaryRequest {
        const json = this.toJSON();
        let result = new AddFinancialSummaryRequest();
        result.init(json);
        return result;
    }
}

export interface IAddFinancialSummaryRequest {
    financialSummary?: FinancialSummaryViewModel | null;
}

export class GetFinancialSummaryResponse implements IGetFinancialSummaryResponse {
    financialSummary?: FinancialSummaryViewModel | null;

    constructor(data?: IGetFinancialSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialSummary = _data["financialSummary"] ? FinancialSummaryViewModel.fromJS(_data["financialSummary"]) : null as any;
        }
    }

    static fromJS(data: any): GetFinancialSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        return data;
    }

    clone(): GetFinancialSummaryResponse {
        const json = this.toJSON();
        let result = new GetFinancialSummaryResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFinancialSummaryResponse {
    financialSummary?: FinancialSummaryViewModel | null;
}

export class GetFinancialSummaryPreviewsResponse2 implements IGetFinancialSummaryPreviewsResponse2 {
    financialSummaryPreviews?: FinancialSummaryPreview[] | null;

    constructor(data?: IGetFinancialSummaryPreviewsResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["financialSummaryPreviews"])) {
                this.financialSummaryPreviews = [] as any;
                for (let item of _data["financialSummaryPreviews"])
                    this.financialSummaryPreviews!.push(FinancialSummaryPreview.fromJS(item));
            }
            else {
                this.financialSummaryPreviews = null as any;
            }
        }
    }

    static fromJS(data: any): GetFinancialSummaryPreviewsResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetFinancialSummaryPreviewsResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.financialSummaryPreviews)) {
            data["financialSummaryPreviews"] = [];
            for (let item of this.financialSummaryPreviews)
                data["financialSummaryPreviews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetFinancialSummaryPreviewsResponse2 {
        const json = this.toJSON();
        let result = new GetFinancialSummaryPreviewsResponse2();
        result.init(json);
        return result;
    }
}

export interface IGetFinancialSummaryPreviewsResponse2 {
    financialSummaryPreviews?: FinancialSummaryPreview[] | null;
}

export class UpdateFinancialSummaryResponse implements IUpdateFinancialSummaryResponse {
    id?: number;
    error?: boolean;
    errorMessage?: string | null;

    constructor(data?: IUpdateFinancialSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.error = _data["error"] !== undefined ? _data["error"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
        }
    }

    static fromJS(data: any): UpdateFinancialSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["error"] = this.error !== undefined ? this.error : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        return data;
    }

    clone(): UpdateFinancialSummaryResponse {
        const json = this.toJSON();
        let result = new UpdateFinancialSummaryResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateFinancialSummaryResponse {
    id?: number;
    error?: boolean;
    errorMessage?: string | null;
}

export class UpdateFinancialSummaryRequest implements IUpdateFinancialSummaryRequest {
    financialSummary?: FinancialSummaryViewModel | null;

    constructor(data?: IUpdateFinancialSummaryRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialSummary = _data["financialSummary"] ? FinancialSummaryViewModel.fromJS(_data["financialSummary"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateFinancialSummaryRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFinancialSummaryRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialSummary"] = this.financialSummary ? this.financialSummary.toJSON() : null as any;
        return data;
    }

    clone(): UpdateFinancialSummaryRequest {
        const json = this.toJSON();
        let result = new UpdateFinancialSummaryRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateFinancialSummaryRequest {
    financialSummary?: FinancialSummaryViewModel | null;
}

export class MakePlanResponse implements IMakePlanResponse {
    makePlanPreview?: MakePlanPreview | null;

    constructor(data?: IMakePlanResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.makePlanPreview = _data["makePlanPreview"] ? MakePlanPreview.fromJS(_data["makePlanPreview"]) : null as any;
        }
    }

    static fromJS(data: any): MakePlanResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MakePlanResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["makePlanPreview"] = this.makePlanPreview ? this.makePlanPreview.toJSON() : null as any;
        return data;
    }

    clone(): MakePlanResponse {
        const json = this.toJSON();
        let result = new MakePlanResponse();
        result.init(json);
        return result;
    }
}

export interface IMakePlanResponse {
    makePlanPreview?: MakePlanPreview | null;
}

export class MakePlanPreview implements IMakePlanPreview {
    applicationId?: number;
    submissionDate?: Date;
    planType?: PlanType;
    applicantId?: number;
    coApplicantId?: number;
    studentId?: number;

    constructor(data?: IMakePlanPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.submissionDate = _data["submissionDate"] ? new Date(_data["submissionDate"].toString()) : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
            this.coApplicantId = _data["coApplicantId"] !== undefined ? _data["coApplicantId"] : null as any;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : null as any;
        }
    }

    static fromJS(data: any): MakePlanPreview {
        data = typeof data === 'object' ? data : {};
        let result = new MakePlanPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["submissionDate"] = this.submissionDate ? this.submissionDate.toISOString() : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        data["coApplicantId"] = this.coApplicantId !== undefined ? this.coApplicantId : null as any;
        data["studentId"] = this.studentId !== undefined ? this.studentId : null as any;
        return data;
    }

    clone(): MakePlanPreview {
        const json = this.toJSON();
        let result = new MakePlanPreview();
        result.init(json);
        return result;
    }
}

export interface IMakePlanPreview {
    applicationId?: number;
    submissionDate?: Date;
    planType?: PlanType;
    applicantId?: number;
    coApplicantId?: number;
    studentId?: number;
}

export class DeleteApplicationResponse implements IDeleteApplicationResponse {
    result?: boolean;

    constructor(data?: IDeleteApplicationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): DeleteApplicationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteApplicationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }

    clone(): DeleteApplicationResponse {
        const json = this.toJSON();
        let result = new DeleteApplicationResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteApplicationResponse {
    result?: boolean;
}

export class GetCorrespondenceTypesResponse implements IGetCorrespondenceTypesResponse {
    types?: CorrespondenceTypeViewModel[] | null;

    constructor(data?: IGetCorrespondenceTypesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["types"])) {
                this.types = [] as any;
                for (let item of _data["types"])
                    this.types!.push(CorrespondenceTypeViewModel.fromJS(item));
            }
            else {
                this.types = null as any;
            }
        }
    }

    static fromJS(data: any): GetCorrespondenceTypesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCorrespondenceTypesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.types)) {
            data["types"] = [];
            for (let item of this.types)
                data["types"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetCorrespondenceTypesResponse {
        const json = this.toJSON();
        let result = new GetCorrespondenceTypesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCorrespondenceTypesResponse {
    types?: CorrespondenceTypeViewModel[] | null;
}

export class CorrespondenceTypeViewModel implements ICorrespondenceTypeViewModel {
    value?: CorrespondenceType;
    label?: string | null;

    constructor(data?: ICorrespondenceTypeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
        }
    }

    static fromJS(data: any): CorrespondenceTypeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new CorrespondenceTypeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value !== undefined ? this.value : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        return data;
    }

    clone(): CorrespondenceTypeViewModel {
        const json = this.toJSON();
        let result = new CorrespondenceTypeViewModel();
        result.init(json);
        return result;
    }
}

export interface ICorrespondenceTypeViewModel {
    value?: CorrespondenceType;
    label?: string | null;
}

export enum CorrespondenceType {
    PepAgreement = "PepAgreement",
}

export class GetPepAgreementResponse implements IGetPepAgreementResponse {
    numberOfAgreements?: number;
    agreements?: PepAgreementPreview[] | null;

    constructor(data?: IGetPepAgreementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfAgreements = _data["numberOfAgreements"] !== undefined ? _data["numberOfAgreements"] : null as any;
            if (Array.isArray(_data["agreements"])) {
                this.agreements = [] as any;
                for (let item of _data["agreements"])
                    this.agreements!.push(PepAgreementPreview.fromJS(item));
            }
            else {
                this.agreements = null as any;
            }
        }
    }

    static fromJS(data: any): GetPepAgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPepAgreementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfAgreements"] = this.numberOfAgreements !== undefined ? this.numberOfAgreements : null as any;
        if (Array.isArray(this.agreements)) {
            data["agreements"] = [];
            for (let item of this.agreements)
                data["agreements"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetPepAgreementResponse {
        const json = this.toJSON();
        let result = new GetPepAgreementResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPepAgreementResponse {
    numberOfAgreements?: number;
    agreements?: PepAgreementPreview[] | null;
}

export class PepAgreementPreview implements IPepAgreementPreview {
    accountId?: number;
    borrowerId?: number;
    borrowerName?: string | null;
    coBorrowerId?: number | null;
    coBorrowerName?: string | null;
    studentId?: number | null;
    studentName?: string | null;
    pepTotal?: number;

    constructor(data?: IPepAgreementPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.borrowerId = _data["borrowerId"] !== undefined ? _data["borrowerId"] : null as any;
            this.borrowerName = _data["borrowerName"] !== undefined ? _data["borrowerName"] : null as any;
            this.coBorrowerId = _data["coBorrowerId"] !== undefined ? _data["coBorrowerId"] : null as any;
            this.coBorrowerName = _data["coBorrowerName"] !== undefined ? _data["coBorrowerName"] : null as any;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : null as any;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : null as any;
            this.pepTotal = _data["pepTotal"] !== undefined ? _data["pepTotal"] : null as any;
        }
    }

    static fromJS(data: any): PepAgreementPreview {
        data = typeof data === 'object' ? data : {};
        let result = new PepAgreementPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["borrowerId"] = this.borrowerId !== undefined ? this.borrowerId : null as any;
        data["borrowerName"] = this.borrowerName !== undefined ? this.borrowerName : null as any;
        data["coBorrowerId"] = this.coBorrowerId !== undefined ? this.coBorrowerId : null as any;
        data["coBorrowerName"] = this.coBorrowerName !== undefined ? this.coBorrowerName : null as any;
        data["studentId"] = this.studentId !== undefined ? this.studentId : null as any;
        data["studentName"] = this.studentName !== undefined ? this.studentName : null as any;
        data["pepTotal"] = this.pepTotal !== undefined ? this.pepTotal : null as any;
        return data;
    }

    clone(): PepAgreementPreview {
        const json = this.toJSON();
        let result = new PepAgreementPreview();
        result.init(json);
        return result;
    }
}

export interface IPepAgreementPreview {
    accountId?: number;
    borrowerId?: number;
    borrowerName?: string | null;
    coBorrowerId?: number | null;
    coBorrowerName?: string | null;
    studentId?: number | null;
    studentName?: string | null;
    pepTotal?: number;
}

export class GetAccountDocumentsResponse implements IGetAccountDocumentsResponse {
    accountDocuments?: AccountDocumentViewModel[] | null;

    constructor(data?: IGetAccountDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["accountDocuments"])) {
                this.accountDocuments = [] as any;
                for (let item of _data["accountDocuments"])
                    this.accountDocuments!.push(AccountDocumentViewModel.fromJS(item));
            }
            else {
                this.accountDocuments = null as any;
            }
        }
    }

    static fromJS(data: any): GetAccountDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAccountDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.accountDocuments)) {
            data["accountDocuments"] = [];
            for (let item of this.accountDocuments)
                data["accountDocuments"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetAccountDocumentsResponse {
        const json = this.toJSON();
        let result = new GetAccountDocumentsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAccountDocumentsResponse {
    accountDocuments?: AccountDocumentViewModel[] | null;
}

export class AccountDocumentViewModel implements IAccountDocumentViewModel {
    id?: number | null;
    accountsMainId?: number;
    sentDate?: Date;
    documentType?: DocumentType;
    receivedDate?: Date | null;
    active?: boolean | null;
    complete?: boolean | null;
    comments?: string | null;
    fileName?: string | null;
    fileDescription?: string | null;

    constructor(data?: IAccountDocumentViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountsMainId = _data["accountsMainId"] !== undefined ? _data["accountsMainId"] : null as any;
            this.sentDate = _data["sentDate"] ? new Date(_data["sentDate"].toString()) : null as any;
            this.documentType = _data["documentType"] !== undefined ? _data["documentType"] : null as any;
            this.receivedDate = _data["receivedDate"] ? new Date(_data["receivedDate"].toString()) : null as any;
            this.active = _data["active"] !== undefined ? _data["active"] : null as any;
            this.complete = _data["complete"] !== undefined ? _data["complete"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileDescription = _data["fileDescription"] !== undefined ? _data["fileDescription"] : null as any;
        }
    }

    static fromJS(data: any): AccountDocumentViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountDocumentViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountsMainId"] = this.accountsMainId !== undefined ? this.accountsMainId : null as any;
        data["sentDate"] = this.sentDate ? this.sentDate.toISOString() : null as any;
        data["documentType"] = this.documentType !== undefined ? this.documentType : null as any;
        data["receivedDate"] = this.receivedDate ? this.receivedDate.toISOString() : null as any;
        data["active"] = this.active !== undefined ? this.active : null as any;
        data["complete"] = this.complete !== undefined ? this.complete : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileDescription"] = this.fileDescription !== undefined ? this.fileDescription : null as any;
        return data;
    }

    clone(): AccountDocumentViewModel {
        const json = this.toJSON();
        let result = new AccountDocumentViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountDocumentViewModel {
    id?: number | null;
    accountsMainId?: number;
    sentDate?: Date;
    documentType?: DocumentType;
    receivedDate?: Date | null;
    active?: boolean | null;
    complete?: boolean | null;
    comments?: string | null;
    fileName?: string | null;
    fileDescription?: string | null;
}

export class ExportPepAgreementResponse implements IExportPepAgreementResponse {
    result?: ExportPepAgreementResponseResult | null;

    constructor(data?: IExportPepAgreementResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? ExportPepAgreementResponseResult.fromJS(_data["result"]) : null as any;
        }
    }

    static fromJS(data: any): ExportPepAgreementResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPepAgreementResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : null as any;
        return data;
    }

    clone(): ExportPepAgreementResponse {
        const json = this.toJSON();
        let result = new ExportPepAgreementResponse();
        result.init(json);
        return result;
    }
}

export interface IExportPepAgreementResponse {
    result?: ExportPepAgreementResponseResult | null;
}

export class ExportPepAgreementResponseResult implements IExportPepAgreementResponseResult {
    fileData?: string | null;
    errors?: ExportPepAgreementError[] | null;

    constructor(data?: IExportPepAgreementResponseResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileData = _data["fileData"] !== undefined ? _data["fileData"] : null as any;
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(ExportPepAgreementError.fromJS(item));
            }
            else {
                this.errors = null as any;
            }
        }
    }

    static fromJS(data: any): ExportPepAgreementResponseResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPepAgreementResponseResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileData"] = this.fileData !== undefined ? this.fileData : null as any;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): ExportPepAgreementResponseResult {
        const json = this.toJSON();
        let result = new ExportPepAgreementResponseResult();
        result.init(json);
        return result;
    }
}

export interface IExportPepAgreementResponseResult {
    fileData?: string | null;
    errors?: ExportPepAgreementError[] | null;
}

export class ExportPepAgreementError implements IExportPepAgreementError {
    accountsMainsId?: number;
    errorMessage?: string | null;

    constructor(data?: IExportPepAgreementError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
        }
    }

    static fromJS(data: any): ExportPepAgreementError {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPepAgreementError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        return data;
    }

    clone(): ExportPepAgreementError {
        const json = this.toJSON();
        let result = new ExportPepAgreementError();
        result.init(json);
        return result;
    }
}

export interface IExportPepAgreementError {
    accountsMainsId?: number;
    errorMessage?: string | null;
}

export class ExportPepAgreementRequest implements IExportPepAgreementRequest {
    planType?: string | null;
    shouldAddDocument?: boolean;

    constructor(data?: IExportPepAgreementRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.shouldAddDocument = _data["shouldAddDocument"] !== undefined ? _data["shouldAddDocument"] : null as any;
        }
    }

    static fromJS(data: any): ExportPepAgreementRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPepAgreementRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["shouldAddDocument"] = this.shouldAddDocument !== undefined ? this.shouldAddDocument : null as any;
        return data;
    }

    clone(): ExportPepAgreementRequest {
        const json = this.toJSON();
        let result = new ExportPepAgreementRequest();
        result.init(json);
        return result;
    }
}

export interface IExportPepAgreementRequest {
    planType?: string | null;
    shouldAddDocument?: boolean;
}

export class DownloadPepAgreementErrorsFileRequest implements IDownloadPepAgreementErrorsFileRequest {
    results?: ExportPepAgreementResult[] | null;

    constructor(data?: IDownloadPepAgreementErrorsFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(ExportPepAgreementResult.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): DownloadPepAgreementErrorsFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadPepAgreementErrorsFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): DownloadPepAgreementErrorsFileRequest {
        const json = this.toJSON();
        let result = new DownloadPepAgreementErrorsFileRequest();
        result.init(json);
        return result;
    }
}

export interface IDownloadPepAgreementErrorsFileRequest {
    results?: ExportPepAgreementResult[] | null;
}

export class ExportPepAgreementResult implements IExportPepAgreementResult {
    hasError?: boolean;
    accountsMainsId?: number;
    rowData?: string | null;
    errorMessage?: string | null;

    constructor(data?: IExportPepAgreementResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.hasError = _data["hasError"] !== undefined ? _data["hasError"] : null as any;
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.rowData = _data["rowData"] !== undefined ? _data["rowData"] : null as any;
            this.errorMessage = _data["errorMessage"] !== undefined ? _data["errorMessage"] : null as any;
        }
    }

    static fromJS(data: any): ExportPepAgreementResult {
        data = typeof data === 'object' ? data : {};
        let result = new ExportPepAgreementResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["hasError"] = this.hasError !== undefined ? this.hasError : null as any;
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["rowData"] = this.rowData !== undefined ? this.rowData : null as any;
        data["errorMessage"] = this.errorMessage !== undefined ? this.errorMessage : null as any;
        return data;
    }

    clone(): ExportPepAgreementResult {
        const json = this.toJSON();
        let result = new ExportPepAgreementResult();
        result.init(json);
        return result;
    }
}

export interface IExportPepAgreementResult {
    hasError?: boolean;
    accountsMainsId?: number;
    rowData?: string | null;
    errorMessage?: string | null;
}

export class CreateAccountDocumentResponse implements ICreateAccountDocumentResponse {
    id?: number;
    fileName?: string | null;
    fileDescription?: string | null;

    constructor(data?: ICreateAccountDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileDescription = _data["fileDescription"] !== undefined ? _data["fileDescription"] : null as any;
        }
    }

    static fromJS(data: any): CreateAccountDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateAccountDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileDescription"] = this.fileDescription !== undefined ? this.fileDescription : null as any;
        return data;
    }

    clone(): CreateAccountDocumentResponse {
        const json = this.toJSON();
        let result = new CreateAccountDocumentResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateAccountDocumentResponse {
    id?: number;
    fileName?: string | null;
    fileDescription?: string | null;
}

export class UpdateAccountDocumentResponse implements IUpdateAccountDocumentResponse {
    fileName?: string | null;
    fileDescription?: string | null;

    constructor(data?: IUpdateAccountDocumentResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fileName = _data["fileName"] !== undefined ? _data["fileName"] : null as any;
            this.fileDescription = _data["fileDescription"] !== undefined ? _data["fileDescription"] : null as any;
        }
    }

    static fromJS(data: any): UpdateAccountDocumentResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateAccountDocumentResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fileName"] = this.fileName !== undefined ? this.fileName : null as any;
        data["fileDescription"] = this.fileDescription !== undefined ? this.fileDescription : null as any;
        return data;
    }

    clone(): UpdateAccountDocumentResponse {
        const json = this.toJSON();
        let result = new UpdateAccountDocumentResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateAccountDocumentResponse {
    fileName?: string | null;
    fileDescription?: string | null;
}

export class DeleteCorrespondenceResponse implements IDeleteCorrespondenceResponse {
    result?: boolean;

    constructor(data?: IDeleteCorrespondenceResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): DeleteCorrespondenceResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteCorrespondenceResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }

    clone(): DeleteCorrespondenceResponse {
        const json = this.toJSON();
        let result = new DeleteCorrespondenceResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteCorrespondenceResponse {
    result?: boolean;
}

export class GetCostsResponse implements IGetCostsResponse {
    costs?: CostViewModel[] | null;

    constructor(data?: IGetCostsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(CostViewModel.fromJS(item));
            }
            else {
                this.costs = null as any;
            }
        }
    }

    static fromJS(data: any): GetCostsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetCostsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetCostsResponse {
        const json = this.toJSON();
        let result = new GetCostsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetCostsResponse {
    costs?: CostViewModel[] | null;
}

export class AddCostsResponse implements IAddCostsResponse {

    constructor(data?: IAddCostsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddCostsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddCostsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): AddCostsResponse {
        const json = this.toJSON();
        let result = new AddCostsResponse();
        result.init(json);
        return result;
    }
}

export interface IAddCostsResponse {
}

export class AddCostsRequest implements IAddCostsRequest {
    costs?: CostViewModel[] | null;

    constructor(data?: IAddCostsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(CostViewModel.fromJS(item));
            }
            else {
                this.costs = null as any;
            }
        }
    }

    static fromJS(data: any): AddCostsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddCostsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AddCostsRequest {
        const json = this.toJSON();
        let result = new AddCostsRequest();
        result.init(json);
        return result;
    }
}

export interface IAddCostsRequest {
    costs?: CostViewModel[] | null;
}

export class UpdateCostsByFiscalYearResponse implements IUpdateCostsByFiscalYearResponse {

    constructor(data?: IUpdateCostsByFiscalYearResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateCostsByFiscalYearResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCostsByFiscalYearResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateCostsByFiscalYearResponse {
        const json = this.toJSON();
        let result = new UpdateCostsByFiscalYearResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateCostsByFiscalYearResponse {
}

export class UpdateCostsByFiscalYearRequest implements IUpdateCostsByFiscalYearRequest {
    fiscalYearId?: number;
    costs?: CostViewModel[] | null;

    constructor(data?: IUpdateCostsByFiscalYearRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(CostViewModel.fromJS(item));
            }
            else {
                this.costs = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateCostsByFiscalYearRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateCostsByFiscalYearRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateCostsByFiscalYearRequest {
        const json = this.toJSON();
        let result = new UpdateCostsByFiscalYearRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateCostsByFiscalYearRequest {
    fiscalYearId?: number;
    costs?: CostViewModel[] | null;
}

export class GetEmployeesResponse implements IGetEmployeesResponse {
    employees?: Employee[] | null;

    constructor(data?: IGetEmployeesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["employees"])) {
                this.employees = [] as any;
                for (let item of _data["employees"])
                    this.employees!.push(Employee.fromJS(item));
            }
            else {
                this.employees = null as any;
            }
        }
    }

    static fromJS(data: any): GetEmployeesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetEmployeesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.employees)) {
            data["employees"] = [];
            for (let item of this.employees)
                data["employees"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetEmployeesResponse {
        const json = this.toJSON();
        let result = new GetEmployeesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetEmployeesResponse {
    employees?: Employee[] | null;
}

export class Employee implements IEmployee {
    employeeId?: string | null;
    universalId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IEmployee) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.employeeId = _data["employeeId"] !== undefined ? _data["employeeId"] : null as any;
            this.universalId = _data["universalId"] !== undefined ? _data["universalId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): Employee {
        data = typeof data === 'object' ? data : {};
        let result = new Employee();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["employeeId"] = this.employeeId !== undefined ? this.employeeId : null as any;
        data["universalId"] = this.universalId !== undefined ? this.universalId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }

    clone(): Employee {
        const json = this.toJSON();
        let result = new Employee();
        result.init(json);
        return result;
    }
}

export interface IEmployee {
    employeeId?: string | null;
    universalId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class ExportRequest implements IExportRequest {
    records?: any[] | null;

    constructor(data?: IExportRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["records"])) {
                this.records = [] as any;
                for (let item of _data["records"])
                    this.records!.push(item);
            }
            else {
                this.records = null as any;
            }
        }
    }

    static fromJS(data: any): ExportRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ExportRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.records)) {
            data["records"] = [];
            for (let item of this.records)
                data["records"].push(item);
        }
        return data;
    }

    clone(): ExportRequest {
        const json = this.toJSON();
        let result = new ExportRequest();
        result.init(json);
        return result;
    }
}

export interface IExportRequest {
    records?: any[] | null;
}

export class GetFiscalYearsResponse implements IGetFiscalYearsResponse {
    fiscalYears?: FiscalYearViewModel[] | null;

    constructor(data?: IGetFiscalYearsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fiscalYears"])) {
                this.fiscalYears = [] as any;
                for (let item of _data["fiscalYears"])
                    this.fiscalYears!.push(FiscalYearViewModel.fromJS(item));
            }
            else {
                this.fiscalYears = null as any;
            }
        }
    }

    static fromJS(data: any): GetFiscalYearsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiscalYearsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fiscalYears)) {
            data["fiscalYears"] = [];
            for (let item of this.fiscalYears)
                data["fiscalYears"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetFiscalYearsResponse {
        const json = this.toJSON();
        let result = new GetFiscalYearsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetFiscalYearsResponse {
    fiscalYears?: FiscalYearViewModel[] | null;
}

export class UpdateFiscalYearsResponse implements IUpdateFiscalYearsResponse {

    constructor(data?: IUpdateFiscalYearsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateFiscalYearsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFiscalYearsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateFiscalYearsResponse {
        const json = this.toJSON();
        let result = new UpdateFiscalYearsResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateFiscalYearsResponse {
}

export class UpdateFiscalYearsRequest implements IUpdateFiscalYearsRequest {
    fiscalYears?: FiscalYearViewModel[] | null;

    constructor(data?: IUpdateFiscalYearsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["fiscalYears"])) {
                this.fiscalYears = [] as any;
                for (let item of _data["fiscalYears"])
                    this.fiscalYears!.push(FiscalYearViewModel.fromJS(item));
            }
            else {
                this.fiscalYears = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateFiscalYearsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateFiscalYearsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.fiscalYears)) {
            data["fiscalYears"] = [];
            for (let item of this.fiscalYears)
                data["fiscalYears"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateFiscalYearsRequest {
        const json = this.toJSON();
        let result = new UpdateFiscalYearsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateFiscalYearsRequest {
    fiscalYears?: FiscalYearViewModel[] | null;
}

export class AddFiscalYearResponse implements IAddFiscalYearResponse {
    id?: number;

    constructor(data?: IAddFiscalYearResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AddFiscalYearResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddFiscalYearResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): AddFiscalYearResponse {
        const json = this.toJSON();
        let result = new AddFiscalYearResponse();
        result.init(json);
        return result;
    }
}

export interface IAddFiscalYearResponse {
    id?: number;
}

export class ApiError implements IApiError {
    message?: string | null;

    constructor(data?: IApiError) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): ApiError {
        data = typeof data === 'object' ? data : {};
        let result = new ApiError();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        return data;
    }

    clone(): ApiError {
        const json = this.toJSON();
        let result = new ApiError();
        result.init(json);
        return result;
    }
}

export interface IApiError {
    message?: string | null;
}

export class AddFiscalYearRequest implements IAddFiscalYearRequest {
    fiscalYear?: FiscalYearViewModel | null;
    semesters?: AddSemesterRequest[] | null;

    constructor(data?: IAddFiscalYearRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fiscalYear = _data["fiscalYear"] ? FiscalYearViewModel.fromJS(_data["fiscalYear"]) : null as any;
            if (Array.isArray(_data["semesters"])) {
                this.semesters = [] as any;
                for (let item of _data["semesters"])
                    this.semesters!.push(AddSemesterRequest.fromJS(item));
            }
            else {
                this.semesters = null as any;
            }
        }
    }

    static fromJS(data: any): AddFiscalYearRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddFiscalYearRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fiscalYear"] = this.fiscalYear ? this.fiscalYear.toJSON() : null as any;
        if (Array.isArray(this.semesters)) {
            data["semesters"] = [];
            for (let item of this.semesters)
                data["semesters"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AddFiscalYearRequest {
        const json = this.toJSON();
        let result = new AddFiscalYearRequest();
        result.init(json);
        return result;
    }
}

export interface IAddFiscalYearRequest {
    fiscalYear?: FiscalYearViewModel | null;
    semesters?: AddSemesterRequest[] | null;
}

export class AddSemesterRequest implements IAddSemesterRequest {
    code?: string | null;
    workdayAcademicPeriod?: string | null;
    start?: Date;
    end?: Date;

    constructor(data?: IAddSemesterRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.workdayAcademicPeriod = _data["workdayAcademicPeriod"] !== undefined ? _data["workdayAcademicPeriod"] : null as any;
            this.start = _data["start"] ? new Date(_data["start"].toString()) : null as any;
            this.end = _data["end"] ? new Date(_data["end"].toString()) : null as any;
        }
    }

    static fromJS(data: any): AddSemesterRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddSemesterRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["workdayAcademicPeriod"] = this.workdayAcademicPeriod !== undefined ? this.workdayAcademicPeriod : null as any;
        data["start"] = this.start ? this.start.toISOString() : null as any;
        data["end"] = this.end ? this.end.toISOString() : null as any;
        return data;
    }

    clone(): AddSemesterRequest {
        const json = this.toJSON();
        let result = new AddSemesterRequest();
        result.init(json);
        return result;
    }
}

export interface IAddSemesterRequest {
    code?: string | null;
    workdayAcademicPeriod?: string | null;
    start?: Date;
    end?: Date;
}

export class DeleteFiscalYearResponse implements IDeleteFiscalYearResponse {

    constructor(data?: IDeleteFiscalYearResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteFiscalYearResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFiscalYearResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DeleteFiscalYearResponse {
        const json = this.toJSON();
        let result = new DeleteFiscalYearResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteFiscalYearResponse {
}

export class DeleteFiscalYearRequest implements IDeleteFiscalYearRequest {
    id?: number;

    constructor(data?: IDeleteFiscalYearRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): DeleteFiscalYearRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteFiscalYearRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): DeleteFiscalYearRequest {
        const json = this.toJSON();
        let result = new DeleteFiscalYearRequest();
        result.init(json);
        return result;
    }
}

export interface IDeleteFiscalYearRequest {
    id?: number;
}

export class GetPersonSsnResponse implements IGetPersonSsnResponse {
    ssn?: string | null;

    constructor(data?: IGetPersonSsnResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
        }
    }

    static fromJS(data: any): GetPersonSsnResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPersonSsnResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        return data;
    }

    clone(): GetPersonSsnResponse {
        const json = this.toJSON();
        let result = new GetPersonSsnResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPersonSsnResponse {
    ssn?: string | null;
}

export class AddPlanReductionResponse implements IAddPlanReductionResponse {
    id?: number;

    constructor(data?: IAddPlanReductionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AddPlanReductionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPlanReductionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): AddPlanReductionResponse {
        const json = this.toJSON();
        let result = new AddPlanReductionResponse();
        result.init(json);
        return result;
    }
}

export interface IAddPlanReductionResponse {
    id?: number;
}

export class AddPlanReductionRequest implements IAddPlanReductionRequest {
    reduction?: AccountPlanReductionViewModel | null;

    constructor(data?: IAddPlanReductionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reduction = _data["reduction"] ? AccountPlanReductionViewModel.fromJS(_data["reduction"]) : null as any;
        }
    }

    static fromJS(data: any): AddPlanReductionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPlanReductionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reduction"] = this.reduction ? this.reduction.toJSON() : null as any;
        return data;
    }

    clone(): AddPlanReductionRequest {
        const json = this.toJSON();
        let result = new AddPlanReductionRequest();
        result.init(json);
        return result;
    }
}

export interface IAddPlanReductionRequest {
    reduction?: AccountPlanReductionViewModel | null;
}

export class AccountPlanReductionViewModel implements IAccountPlanReductionViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    processedDate?: Date | null;
    interestAdjustmentAmount?: number;
    beginningInterestAccrualDate?: Date | null;
    lastInterestPaid?: Date | null;
    numberMonthsPaid?: number | null;
    principalReductionAmount?: number;
    interestRate?: number | null;
    totalReduction?: number;
    servPrincipalBalance?: number | null;
    remainingPrincipalBalance?: number | null;
    currentMonthlyInterestDue?: number | null;
    payoffAmount?: number | null;
    remainingRepaymentPeriod?: number | null;
    reAmortizedMonthlyPayment?: number | null;
    originalMonthlyPayment?: number | null;
    comments?: string | null;
    lastUpdatedUser?: string | null;
    allowTransaction?: boolean;
    semester?: SemesterViewModel | null;
    splitTransactions?: SplitTransactionViewModel[] | null;
    numberDaysPaid?: number | null;
    interestPaidToDate?: number;
    loanSeqId?: string | null;
    estimatedResultingMonthlyPayment?: number;
    calculatorRepaymentMonthsRemaining?: number | null;

    constructor(data?: IAccountPlanReductionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.accountsMains = _data["accountsMains"] ? AccountsMains.fromJS(_data["accountsMains"]) : null as any;
            this.processedDate = _data["processedDate"] ? new Date(_data["processedDate"].toString()) : null as any;
            this.interestAdjustmentAmount = _data["interestAdjustmentAmount"] !== undefined ? _data["interestAdjustmentAmount"] : null as any;
            this.beginningInterestAccrualDate = _data["beginningInterestAccrualDate"] ? new Date(_data["beginningInterestAccrualDate"].toString()) : null as any;
            this.lastInterestPaid = _data["lastInterestPaid"] ? new Date(_data["lastInterestPaid"].toString()) : null as any;
            this.numberMonthsPaid = _data["numberMonthsPaid"] !== undefined ? _data["numberMonthsPaid"] : null as any;
            this.principalReductionAmount = _data["principalReductionAmount"] !== undefined ? _data["principalReductionAmount"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.totalReduction = _data["totalReduction"] !== undefined ? _data["totalReduction"] : null as any;
            this.servPrincipalBalance = _data["servPrincipalBalance"] !== undefined ? _data["servPrincipalBalance"] : null as any;
            this.remainingPrincipalBalance = _data["remainingPrincipalBalance"] !== undefined ? _data["remainingPrincipalBalance"] : null as any;
            this.currentMonthlyInterestDue = _data["currentMonthlyInterestDue"] !== undefined ? _data["currentMonthlyInterestDue"] : null as any;
            this.payoffAmount = _data["payoffAmount"] !== undefined ? _data["payoffAmount"] : null as any;
            this.remainingRepaymentPeriod = _data["remainingRepaymentPeriod"] !== undefined ? _data["remainingRepaymentPeriod"] : null as any;
            this.reAmortizedMonthlyPayment = _data["reAmortizedMonthlyPayment"] !== undefined ? _data["reAmortizedMonthlyPayment"] : null as any;
            this.originalMonthlyPayment = _data["originalMonthlyPayment"] !== undefined ? _data["originalMonthlyPayment"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.lastUpdatedUser = _data["lastUpdatedUser"] !== undefined ? _data["lastUpdatedUser"] : null as any;
            this.allowTransaction = _data["allowTransaction"] !== undefined ? _data["allowTransaction"] : null as any;
            this.semester = _data["semester"] ? SemesterViewModel.fromJS(_data["semester"]) : null as any;
            if (Array.isArray(_data["splitTransactions"])) {
                this.splitTransactions = [] as any;
                for (let item of _data["splitTransactions"])
                    this.splitTransactions!.push(SplitTransactionViewModel.fromJS(item));
            }
            else {
                this.splitTransactions = null as any;
            }
            this.numberDaysPaid = _data["numberDaysPaid"] !== undefined ? _data["numberDaysPaid"] : null as any;
            this.interestPaidToDate = _data["interestPaidToDate"] !== undefined ? _data["interestPaidToDate"] : null as any;
            this.loanSeqId = _data["loanSeqId"] !== undefined ? _data["loanSeqId"] : null as any;
            this.estimatedResultingMonthlyPayment = _data["estimatedResultingMonthlyPayment"] !== undefined ? _data["estimatedResultingMonthlyPayment"] : null as any;
            this.calculatorRepaymentMonthsRemaining = _data["calculatorRepaymentMonthsRemaining"] !== undefined ? _data["calculatorRepaymentMonthsRemaining"] : null as any;
        }
    }

    static fromJS(data: any): AccountPlanReductionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountPlanReductionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["accountsMains"] = this.accountsMains ? this.accountsMains.toJSON() : null as any;
        data["processedDate"] = this.processedDate ? this.processedDate.toISOString() : null as any;
        data["interestAdjustmentAmount"] = this.interestAdjustmentAmount !== undefined ? this.interestAdjustmentAmount : null as any;
        data["beginningInterestAccrualDate"] = this.beginningInterestAccrualDate ? this.beginningInterestAccrualDate.toISOString() : null as any;
        data["lastInterestPaid"] = this.lastInterestPaid ? this.lastInterestPaid.toISOString() : null as any;
        data["numberMonthsPaid"] = this.numberMonthsPaid !== undefined ? this.numberMonthsPaid : null as any;
        data["principalReductionAmount"] = this.principalReductionAmount !== undefined ? this.principalReductionAmount : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["totalReduction"] = this.totalReduction !== undefined ? this.totalReduction : null as any;
        data["servPrincipalBalance"] = this.servPrincipalBalance !== undefined ? this.servPrincipalBalance : null as any;
        data["remainingPrincipalBalance"] = this.remainingPrincipalBalance !== undefined ? this.remainingPrincipalBalance : null as any;
        data["currentMonthlyInterestDue"] = this.currentMonthlyInterestDue !== undefined ? this.currentMonthlyInterestDue : null as any;
        data["payoffAmount"] = this.payoffAmount !== undefined ? this.payoffAmount : null as any;
        data["remainingRepaymentPeriod"] = this.remainingRepaymentPeriod !== undefined ? this.remainingRepaymentPeriod : null as any;
        data["reAmortizedMonthlyPayment"] = this.reAmortizedMonthlyPayment !== undefined ? this.reAmortizedMonthlyPayment : null as any;
        data["originalMonthlyPayment"] = this.originalMonthlyPayment !== undefined ? this.originalMonthlyPayment : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["lastUpdatedUser"] = this.lastUpdatedUser !== undefined ? this.lastUpdatedUser : null as any;
        data["allowTransaction"] = this.allowTransaction !== undefined ? this.allowTransaction : null as any;
        data["semester"] = this.semester ? this.semester.toJSON() : null as any;
        if (Array.isArray(this.splitTransactions)) {
            data["splitTransactions"] = [];
            for (let item of this.splitTransactions)
                data["splitTransactions"].push(item ? item.toJSON() : null as any);
        }
        data["numberDaysPaid"] = this.numberDaysPaid !== undefined ? this.numberDaysPaid : null as any;
        data["interestPaidToDate"] = this.interestPaidToDate !== undefined ? this.interestPaidToDate : null as any;
        data["loanSeqId"] = this.loanSeqId !== undefined ? this.loanSeqId : null as any;
        data["estimatedResultingMonthlyPayment"] = this.estimatedResultingMonthlyPayment !== undefined ? this.estimatedResultingMonthlyPayment : null as any;
        data["calculatorRepaymentMonthsRemaining"] = this.calculatorRepaymentMonthsRemaining !== undefined ? this.calculatorRepaymentMonthsRemaining : null as any;
        return data;
    }

    clone(): AccountPlanReductionViewModel {
        const json = this.toJSON();
        let result = new AccountPlanReductionViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountPlanReductionViewModel {
    id?: number | null;
    accountsMainsId?: number;
    accountsMains?: AccountsMains | null;
    processedDate?: Date | null;
    interestAdjustmentAmount?: number;
    beginningInterestAccrualDate?: Date | null;
    lastInterestPaid?: Date | null;
    numberMonthsPaid?: number | null;
    principalReductionAmount?: number;
    interestRate?: number | null;
    totalReduction?: number;
    servPrincipalBalance?: number | null;
    remainingPrincipalBalance?: number | null;
    currentMonthlyInterestDue?: number | null;
    payoffAmount?: number | null;
    remainingRepaymentPeriod?: number | null;
    reAmortizedMonthlyPayment?: number | null;
    originalMonthlyPayment?: number | null;
    comments?: string | null;
    lastUpdatedUser?: string | null;
    allowTransaction?: boolean;
    semester?: SemesterViewModel | null;
    splitTransactions?: SplitTransactionViewModel[] | null;
    numberDaysPaid?: number | null;
    interestPaidToDate?: number;
    loanSeqId?: string | null;
    estimatedResultingMonthlyPayment?: number;
    calculatorRepaymentMonthsRemaining?: number | null;
}

export class GetPlanReductionsResponse implements IGetPlanReductionsResponse {
    reductions?: AccountPlanReductionViewModel[] | null;

    constructor(data?: IGetPlanReductionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reductions"])) {
                this.reductions = [] as any;
                for (let item of _data["reductions"])
                    this.reductions!.push(AccountPlanReductionViewModel.fromJS(item));
            }
            else {
                this.reductions = null as any;
            }
        }
    }

    static fromJS(data: any): GetPlanReductionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPlanReductionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reductions)) {
            data["reductions"] = [];
            for (let item of this.reductions)
                data["reductions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetPlanReductionsResponse {
        const json = this.toJSON();
        let result = new GetPlanReductionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPlanReductionsResponse {
    reductions?: AccountPlanReductionViewModel[] | null;
}

export class UpdatePlanReductionResponse implements IUpdatePlanReductionResponse {
    id?: number;

    constructor(data?: IUpdatePlanReductionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): UpdatePlanReductionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanReductionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): UpdatePlanReductionResponse {
        const json = this.toJSON();
        let result = new UpdatePlanReductionResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlanReductionResponse {
    id?: number;
}

export class UpdatePlanReductionRequest implements IUpdatePlanReductionRequest {
    reduction?: AccountPlanReductionViewModel | null;

    constructor(data?: IUpdatePlanReductionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reduction = _data["reduction"] ? AccountPlanReductionViewModel.fromJS(_data["reduction"]) : null as any;
        }
    }

    static fromJS(data: any): UpdatePlanReductionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePlanReductionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reduction"] = this.reduction ? this.reduction.toJSON() : null as any;
        return data;
    }

    clone(): UpdatePlanReductionRequest {
        const json = this.toJSON();
        let result = new UpdatePlanReductionRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePlanReductionRequest {
    reduction?: AccountPlanReductionViewModel | null;
}

export class DeletePlanReductionResponse implements IDeletePlanReductionResponse {

    constructor(data?: IDeletePlanReductionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeletePlanReductionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePlanReductionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DeletePlanReductionResponse {
        const json = this.toJSON();
        let result = new DeletePlanReductionResponse();
        result.init(json);
        return result;
    }
}

export interface IDeletePlanReductionResponse {
}

export class AddPrepaymentRecordResponse implements IAddPrepaymentRecordResponse {
    id?: number;

    constructor(data?: IAddPrepaymentRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AddPrepaymentRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddPrepaymentRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): AddPrepaymentRecordResponse {
        const json = this.toJSON();
        let result = new AddPrepaymentRecordResponse();
        result.init(json);
        return result;
    }
}

export interface IAddPrepaymentRecordResponse {
    id?: number;
}

export class AddPrepaymentRecordRequest implements IAddPrepaymentRecordRequest {
    prepaymentRecord?: PrepaymentRecordViewModel | null;

    constructor(data?: IAddPrepaymentRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prepaymentRecord = _data["prepaymentRecord"] ? PrepaymentRecordViewModel.fromJS(_data["prepaymentRecord"]) : null as any;
        }
    }

    static fromJS(data: any): AddPrepaymentRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddPrepaymentRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prepaymentRecord"] = this.prepaymentRecord ? this.prepaymentRecord.toJSON() : null as any;
        return data;
    }

    clone(): AddPrepaymentRecordRequest {
        const json = this.toJSON();
        let result = new AddPrepaymentRecordRequest();
        result.init(json);
        return result;
    }
}

export interface IAddPrepaymentRecordRequest {
    prepaymentRecord?: PrepaymentRecordViewModel | null;
}

export class GetPrepaymentRecordsResponse implements IGetPrepaymentRecordsResponse {
    totalPrepaymentReceived?: number | null;
    totalPrepaymentDifference?: number | null;
    totalPrepayAmount?: number | null;
    prepaymentRecords?: PrepaymentRecordViewModel[] | null;

    constructor(data?: IGetPrepaymentRecordsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.totalPrepaymentReceived = _data["totalPrepaymentReceived"] !== undefined ? _data["totalPrepaymentReceived"] : null as any;
            this.totalPrepaymentDifference = _data["totalPrepaymentDifference"] !== undefined ? _data["totalPrepaymentDifference"] : null as any;
            this.totalPrepayAmount = _data["totalPrepayAmount"] !== undefined ? _data["totalPrepayAmount"] : null as any;
            if (Array.isArray(_data["prepaymentRecords"])) {
                this.prepaymentRecords = [] as any;
                for (let item of _data["prepaymentRecords"])
                    this.prepaymentRecords!.push(PrepaymentRecordViewModel.fromJS(item));
            }
            else {
                this.prepaymentRecords = null as any;
            }
        }
    }

    static fromJS(data: any): GetPrepaymentRecordsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPrepaymentRecordsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["totalPrepaymentReceived"] = this.totalPrepaymentReceived !== undefined ? this.totalPrepaymentReceived : null as any;
        data["totalPrepaymentDifference"] = this.totalPrepaymentDifference !== undefined ? this.totalPrepaymentDifference : null as any;
        data["totalPrepayAmount"] = this.totalPrepayAmount !== undefined ? this.totalPrepayAmount : null as any;
        if (Array.isArray(this.prepaymentRecords)) {
            data["prepaymentRecords"] = [];
            for (let item of this.prepaymentRecords)
                data["prepaymentRecords"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetPrepaymentRecordsResponse {
        const json = this.toJSON();
        let result = new GetPrepaymentRecordsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPrepaymentRecordsResponse {
    totalPrepaymentReceived?: number | null;
    totalPrepaymentDifference?: number | null;
    totalPrepayAmount?: number | null;
    prepaymentRecords?: PrepaymentRecordViewModel[] | null;
}

export class UpdatePrepaymentRecordResponse implements IUpdatePrepaymentRecordResponse {
    id?: number;

    constructor(data?: IUpdatePrepaymentRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): UpdatePrepaymentRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrepaymentRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): UpdatePrepaymentRecordResponse {
        const json = this.toJSON();
        let result = new UpdatePrepaymentRecordResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdatePrepaymentRecordResponse {
    id?: number;
}

export class UpdatePrepaymentRecordRequest implements IUpdatePrepaymentRecordRequest {
    prepaymentRecord?: PrepaymentRecordViewModel | null;

    constructor(data?: IUpdatePrepaymentRecordRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.prepaymentRecord = _data["prepaymentRecord"] ? PrepaymentRecordViewModel.fromJS(_data["prepaymentRecord"]) : null as any;
        }
    }

    static fromJS(data: any): UpdatePrepaymentRecordRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdatePrepaymentRecordRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["prepaymentRecord"] = this.prepaymentRecord ? this.prepaymentRecord.toJSON() : null as any;
        return data;
    }

    clone(): UpdatePrepaymentRecordRequest {
        const json = this.toJSON();
        let result = new UpdatePrepaymentRecordRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdatePrepaymentRecordRequest {
    prepaymentRecord?: PrepaymentRecordViewModel | null;
}

export class DeletePrepaymentRecordResponse implements IDeletePrepaymentRecordResponse {

    constructor(data?: IDeletePrepaymentRecordResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeletePrepaymentRecordResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeletePrepaymentRecordResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DeletePrepaymentRecordResponse {
        const json = this.toJSON();
        let result = new DeletePrepaymentRecordResponse();
        result.init(json);
        return result;
    }
}

export interface IDeletePrepaymentRecordResponse {
}

export class GetProgramTermsResponse implements IGetProgramTermsResponse {
    programTerms?: ProgramTermsViewModel[] | null;

    constructor(data?: IGetProgramTermsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["programTerms"])) {
                this.programTerms = [] as any;
                for (let item of _data["programTerms"])
                    this.programTerms!.push(ProgramTermsViewModel.fromJS(item));
            }
            else {
                this.programTerms = null as any;
            }
        }
    }

    static fromJS(data: any): GetProgramTermsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetProgramTermsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.programTerms)) {
            data["programTerms"] = [];
            for (let item of this.programTerms)
                data["programTerms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetProgramTermsResponse {
        const json = this.toJSON();
        let result = new GetProgramTermsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetProgramTermsResponse {
    programTerms?: ProgramTermsViewModel[] | null;
}

export class UpdateProgramTermsResponse implements IUpdateProgramTermsResponse {

    constructor(data?: IUpdateProgramTermsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateProgramTermsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProgramTermsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateProgramTermsResponse {
        const json = this.toJSON();
        let result = new UpdateProgramTermsResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateProgramTermsResponse {
}

export class UpdateProgramTermsRequest implements IUpdateProgramTermsRequest {
    programTerms?: ProgramTermsViewModel[] | null;

    constructor(data?: IUpdateProgramTermsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["programTerms"])) {
                this.programTerms = [] as any;
                for (let item of _data["programTerms"])
                    this.programTerms!.push(ProgramTermsViewModel.fromJS(item));
            }
            else {
                this.programTerms = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateProgramTermsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProgramTermsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.programTerms)) {
            data["programTerms"] = [];
            for (let item of this.programTerms)
                data["programTerms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateProgramTermsRequest {
        const json = this.toJSON();
        let result = new UpdateProgramTermsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateProgramTermsRequest {
    programTerms?: ProgramTermsViewModel[] | null;
}

export class CreateProgramTermsResponse implements ICreateProgramTermsResponse {
    ids?: number[] | null;

    constructor(data?: ICreateProgramTermsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["ids"])) {
                this.ids = [] as any;
                for (let item of _data["ids"])
                    this.ids!.push(item);
            }
            else {
                this.ids = null as any;
            }
        }
    }

    static fromJS(data: any): CreateProgramTermsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProgramTermsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.ids)) {
            data["ids"] = [];
            for (let item of this.ids)
                data["ids"].push(item);
        }
        return data;
    }

    clone(): CreateProgramTermsResponse {
        const json = this.toJSON();
        let result = new CreateProgramTermsResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateProgramTermsResponse {
    ids?: number[] | null;
}

export class CreateProgramTermsRequest implements ICreateProgramTermsRequest {
    programTerms?: ProgramTermsViewModel[] | null;

    constructor(data?: ICreateProgramTermsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["programTerms"])) {
                this.programTerms = [] as any;
                for (let item of _data["programTerms"])
                    this.programTerms!.push(ProgramTermsViewModel.fromJS(item));
            }
            else {
                this.programTerms = null as any;
            }
        }
    }

    static fromJS(data: any): CreateProgramTermsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateProgramTermsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.programTerms)) {
            data["programTerms"] = [];
            for (let item of this.programTerms)
                data["programTerms"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): CreateProgramTermsRequest {
        const json = this.toJSON();
        let result = new CreateProgramTermsRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateProgramTermsRequest {
    programTerms?: ProgramTermsViewModel[] | null;
}

export class GetRiskGradingsResponse implements IGetRiskGradingsResponse {
    riskGradings?: RiskGradingViewModel[] | null;

    constructor(data?: IGetRiskGradingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["riskGradings"])) {
                this.riskGradings = [] as any;
                for (let item of _data["riskGradings"])
                    this.riskGradings!.push(RiskGradingViewModel.fromJS(item));
            }
            else {
                this.riskGradings = null as any;
            }
        }
    }

    static fromJS(data: any): GetRiskGradingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRiskGradingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.riskGradings)) {
            data["riskGradings"] = [];
            for (let item of this.riskGradings)
                data["riskGradings"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetRiskGradingsResponse {
        const json = this.toJSON();
        let result = new GetRiskGradingsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRiskGradingsResponse {
    riskGradings?: RiskGradingViewModel[] | null;
}

export class RiskGradingViewModel implements IRiskGradingViewModel {
    id?: number;
    code?: RiskGradingCode;
    processName?: string | null;
    planType?: PlanType;
    lowRangeValue?: number;
    highRangeValue?: number;
    assessmentValue?: number;
    updatedUserId?: number;
    lastUpdatedDate?: Date;

    constructor(data?: IRiskGradingViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.processName = _data["processName"] !== undefined ? _data["processName"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.lowRangeValue = _data["lowRangeValue"] !== undefined ? _data["lowRangeValue"] : null as any;
            this.highRangeValue = _data["highRangeValue"] !== undefined ? _data["highRangeValue"] : null as any;
            this.assessmentValue = _data["assessmentValue"] !== undefined ? _data["assessmentValue"] : null as any;
            this.updatedUserId = _data["updatedUserId"] !== undefined ? _data["updatedUserId"] : null as any;
            this.lastUpdatedDate = _data["lastUpdatedDate"] ? new Date(_data["lastUpdatedDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): RiskGradingViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskGradingViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["processName"] = this.processName !== undefined ? this.processName : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["lowRangeValue"] = this.lowRangeValue !== undefined ? this.lowRangeValue : null as any;
        data["highRangeValue"] = this.highRangeValue !== undefined ? this.highRangeValue : null as any;
        data["assessmentValue"] = this.assessmentValue !== undefined ? this.assessmentValue : null as any;
        data["updatedUserId"] = this.updatedUserId !== undefined ? this.updatedUserId : null as any;
        data["lastUpdatedDate"] = this.lastUpdatedDate ? this.lastUpdatedDate.toISOString() : null as any;
        return data;
    }

    clone(): RiskGradingViewModel {
        const json = this.toJSON();
        let result = new RiskGradingViewModel();
        result.init(json);
        return result;
    }
}

export interface IRiskGradingViewModel {
    id?: number;
    code?: RiskGradingCode;
    processName?: string | null;
    planType?: PlanType;
    lowRangeValue?: number;
    highRangeValue?: number;
    assessmentValue?: number;
    updatedUserId?: number;
    lastUpdatedDate?: Date;
}

export enum RiskGradingCode {
    AmountFinanced = "AmountFinanced",
    PreviousAmountFinanced = "PreviousAmountFinanced",
    PotentialAmountFinanced = "PotentialAmountFinanced",
    DebtToIncomeRatio = "DebtToIncomeRatio",
    DebtToAssetsRatio = "DebtToAssetsRatio",
    BorrowerCreditScore = "BorrowerCreditScore",
    CoborrowerCreditScore = "CoborrowerCreditScore",
    Borrower30DayLatePayments = "Borrower30DayLatePayments",
    Coborrower30DayLatePayments = "Coborrower30DayLatePayments",
    Borrower60DayLatePayments = "Borrower60DayLatePayments",
    Coborrower60DayLatePayments = "Coborrower60DayLatePayments",
    Borrower90DayLatePayments = "Borrower90DayLatePayments",
    Coborrower90DayLatePayments = "Coborrower90DayLatePayments",
    BorrowerBankruptcy = "BorrowerBankruptcy",
    CoborrowerBankruptcy = "CoborrowerBankruptcy",
    BorrowerDefaulted = "BorrowerDefaulted",
    CoborrowerDefaulted = "CoborrowerDefaulted",
    RiskRating = "RiskRating",
}

export class CalculateRiskRankingResponse implements ICalculateRiskRankingResponse {
    financialRiskRankings?: FinancialRiskRankings | null;
    previousAmountFinanced?: number;
    potentialAmountFinanced?: number | null;

    constructor(data?: ICalculateRiskRankingResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.financialRiskRankings = _data["financialRiskRankings"] ? FinancialRiskRankings.fromJS(_data["financialRiskRankings"]) : null as any;
            this.previousAmountFinanced = _data["previousAmountFinanced"] !== undefined ? _data["previousAmountFinanced"] : null as any;
            this.potentialAmountFinanced = _data["potentialAmountFinanced"] !== undefined ? _data["potentialAmountFinanced"] : null as any;
        }
    }

    static fromJS(data: any): CalculateRiskRankingResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskRankingResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["financialRiskRankings"] = this.financialRiskRankings ? this.financialRiskRankings.toJSON() : null as any;
        data["previousAmountFinanced"] = this.previousAmountFinanced !== undefined ? this.previousAmountFinanced : null as any;
        data["potentialAmountFinanced"] = this.potentialAmountFinanced !== undefined ? this.potentialAmountFinanced : null as any;
        return data;
    }

    clone(): CalculateRiskRankingResponse {
        const json = this.toJSON();
        let result = new CalculateRiskRankingResponse();
        result.init(json);
        return result;
    }
}

export interface ICalculateRiskRankingResponse {
    financialRiskRankings?: FinancialRiskRankings | null;
    previousAmountFinanced?: number;
    potentialAmountFinanced?: number | null;
}

export class FinancialRiskRankings implements IFinancialRiskRankings {
    riskRating?: FinancialRiskRank | null;
    amountFinancedRank?: FinancialRiskRank | null;
    previousAmountFinancedRank?: FinancialRiskRank | null;
    potentialLoanAmountFinancedRank?: FinancialRiskRank | null;
    debtToIncomeRatioRank?: FinancialRiskRank | null;
    debtToAssetsRatioRank?: FinancialRiskRank | null;
    borrowerCreditScoreRank?: FinancialRiskRank | null;
    coborrowerCreditScoreRank?: FinancialRiskRank | null;
    borrower30DayLatePaymentsRank?: FinancialRiskRank | null;
    coborrower30DayLatePaymentsRank?: FinancialRiskRank | null;
    borrower60DayLatePaymentsRank?: FinancialRiskRank | null;
    coborrower60DayLatePaymentsRank?: FinancialRiskRank | null;
    borrower90DayLatePaymentsRank?: FinancialRiskRank | null;
    coborrower90DayLatePaymentsRank?: FinancialRiskRank | null;
    borrowerBankruptcyRank?: FinancialRiskRank | null;
    coborrowerBankruptcyRank?: FinancialRiskRank | null;
    borrowerDefaultedOnALoanRank?: FinancialRiskRank | null;
    coborrowerDefaultedOnALoanRank?: FinancialRiskRank | null;

    constructor(data?: IFinancialRiskRankings) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.riskRating = _data["riskRating"] ? FinancialRiskRank.fromJS(_data["riskRating"]) : null as any;
            this.amountFinancedRank = _data["amountFinancedRank"] ? FinancialRiskRank.fromJS(_data["amountFinancedRank"]) : null as any;
            this.previousAmountFinancedRank = _data["previousAmountFinancedRank"] ? FinancialRiskRank.fromJS(_data["previousAmountFinancedRank"]) : null as any;
            this.potentialLoanAmountFinancedRank = _data["potentialLoanAmountFinancedRank"] ? FinancialRiskRank.fromJS(_data["potentialLoanAmountFinancedRank"]) : null as any;
            this.debtToIncomeRatioRank = _data["debtToIncomeRatioRank"] ? FinancialRiskRank.fromJS(_data["debtToIncomeRatioRank"]) : null as any;
            this.debtToAssetsRatioRank = _data["debtToAssetsRatioRank"] ? FinancialRiskRank.fromJS(_data["debtToAssetsRatioRank"]) : null as any;
            this.borrowerCreditScoreRank = _data["borrowerCreditScoreRank"] ? FinancialRiskRank.fromJS(_data["borrowerCreditScoreRank"]) : null as any;
            this.coborrowerCreditScoreRank = _data["coborrowerCreditScoreRank"] ? FinancialRiskRank.fromJS(_data["coborrowerCreditScoreRank"]) : null as any;
            this.borrower30DayLatePaymentsRank = _data["borrower30DayLatePaymentsRank"] ? FinancialRiskRank.fromJS(_data["borrower30DayLatePaymentsRank"]) : null as any;
            this.coborrower30DayLatePaymentsRank = _data["coborrower30DayLatePaymentsRank"] ? FinancialRiskRank.fromJS(_data["coborrower30DayLatePaymentsRank"]) : null as any;
            this.borrower60DayLatePaymentsRank = _data["borrower60DayLatePaymentsRank"] ? FinancialRiskRank.fromJS(_data["borrower60DayLatePaymentsRank"]) : null as any;
            this.coborrower60DayLatePaymentsRank = _data["coborrower60DayLatePaymentsRank"] ? FinancialRiskRank.fromJS(_data["coborrower60DayLatePaymentsRank"]) : null as any;
            this.borrower90DayLatePaymentsRank = _data["borrower90DayLatePaymentsRank"] ? FinancialRiskRank.fromJS(_data["borrower90DayLatePaymentsRank"]) : null as any;
            this.coborrower90DayLatePaymentsRank = _data["coborrower90DayLatePaymentsRank"] ? FinancialRiskRank.fromJS(_data["coborrower90DayLatePaymentsRank"]) : null as any;
            this.borrowerBankruptcyRank = _data["borrowerBankruptcyRank"] ? FinancialRiskRank.fromJS(_data["borrowerBankruptcyRank"]) : null as any;
            this.coborrowerBankruptcyRank = _data["coborrowerBankruptcyRank"] ? FinancialRiskRank.fromJS(_data["coborrowerBankruptcyRank"]) : null as any;
            this.borrowerDefaultedOnALoanRank = _data["borrowerDefaultedOnALoanRank"] ? FinancialRiskRank.fromJS(_data["borrowerDefaultedOnALoanRank"]) : null as any;
            this.coborrowerDefaultedOnALoanRank = _data["coborrowerDefaultedOnALoanRank"] ? FinancialRiskRank.fromJS(_data["coborrowerDefaultedOnALoanRank"]) : null as any;
        }
    }

    static fromJS(data: any): FinancialRiskRankings {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialRiskRankings();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["riskRating"] = this.riskRating ? this.riskRating.toJSON() : null as any;
        data["amountFinancedRank"] = this.amountFinancedRank ? this.amountFinancedRank.toJSON() : null as any;
        data["previousAmountFinancedRank"] = this.previousAmountFinancedRank ? this.previousAmountFinancedRank.toJSON() : null as any;
        data["potentialLoanAmountFinancedRank"] = this.potentialLoanAmountFinancedRank ? this.potentialLoanAmountFinancedRank.toJSON() : null as any;
        data["debtToIncomeRatioRank"] = this.debtToIncomeRatioRank ? this.debtToIncomeRatioRank.toJSON() : null as any;
        data["debtToAssetsRatioRank"] = this.debtToAssetsRatioRank ? this.debtToAssetsRatioRank.toJSON() : null as any;
        data["borrowerCreditScoreRank"] = this.borrowerCreditScoreRank ? this.borrowerCreditScoreRank.toJSON() : null as any;
        data["coborrowerCreditScoreRank"] = this.coborrowerCreditScoreRank ? this.coborrowerCreditScoreRank.toJSON() : null as any;
        data["borrower30DayLatePaymentsRank"] = this.borrower30DayLatePaymentsRank ? this.borrower30DayLatePaymentsRank.toJSON() : null as any;
        data["coborrower30DayLatePaymentsRank"] = this.coborrower30DayLatePaymentsRank ? this.coborrower30DayLatePaymentsRank.toJSON() : null as any;
        data["borrower60DayLatePaymentsRank"] = this.borrower60DayLatePaymentsRank ? this.borrower60DayLatePaymentsRank.toJSON() : null as any;
        data["coborrower60DayLatePaymentsRank"] = this.coborrower60DayLatePaymentsRank ? this.coborrower60DayLatePaymentsRank.toJSON() : null as any;
        data["borrower90DayLatePaymentsRank"] = this.borrower90DayLatePaymentsRank ? this.borrower90DayLatePaymentsRank.toJSON() : null as any;
        data["coborrower90DayLatePaymentsRank"] = this.coborrower90DayLatePaymentsRank ? this.coborrower90DayLatePaymentsRank.toJSON() : null as any;
        data["borrowerBankruptcyRank"] = this.borrowerBankruptcyRank ? this.borrowerBankruptcyRank.toJSON() : null as any;
        data["coborrowerBankruptcyRank"] = this.coborrowerBankruptcyRank ? this.coborrowerBankruptcyRank.toJSON() : null as any;
        data["borrowerDefaultedOnALoanRank"] = this.borrowerDefaultedOnALoanRank ? this.borrowerDefaultedOnALoanRank.toJSON() : null as any;
        data["coborrowerDefaultedOnALoanRank"] = this.coborrowerDefaultedOnALoanRank ? this.coborrowerDefaultedOnALoanRank.toJSON() : null as any;
        return data;
    }

    clone(): FinancialRiskRankings {
        const json = this.toJSON();
        let result = new FinancialRiskRankings();
        result.init(json);
        return result;
    }
}

export interface IFinancialRiskRankings {
    riskRating?: FinancialRiskRank | null;
    amountFinancedRank?: FinancialRiskRank | null;
    previousAmountFinancedRank?: FinancialRiskRank | null;
    potentialLoanAmountFinancedRank?: FinancialRiskRank | null;
    debtToIncomeRatioRank?: FinancialRiskRank | null;
    debtToAssetsRatioRank?: FinancialRiskRank | null;
    borrowerCreditScoreRank?: FinancialRiskRank | null;
    coborrowerCreditScoreRank?: FinancialRiskRank | null;
    borrower30DayLatePaymentsRank?: FinancialRiskRank | null;
    coborrower30DayLatePaymentsRank?: FinancialRiskRank | null;
    borrower60DayLatePaymentsRank?: FinancialRiskRank | null;
    coborrower60DayLatePaymentsRank?: FinancialRiskRank | null;
    borrower90DayLatePaymentsRank?: FinancialRiskRank | null;
    coborrower90DayLatePaymentsRank?: FinancialRiskRank | null;
    borrowerBankruptcyRank?: FinancialRiskRank | null;
    coborrowerBankruptcyRank?: FinancialRiskRank | null;
    borrowerDefaultedOnALoanRank?: FinancialRiskRank | null;
    coborrowerDefaultedOnALoanRank?: FinancialRiskRank | null;
}

export class FinancialRiskRank implements IFinancialRiskRank {
    code?: RiskGradingCode;
    score?: number | null;

    constructor(data?: IFinancialRiskRank) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.code = _data["code"] !== undefined ? _data["code"] : null as any;
            this.score = _data["score"] !== undefined ? _data["score"] : null as any;
        }
    }

    static fromJS(data: any): FinancialRiskRank {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialRiskRank();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["code"] = this.code !== undefined ? this.code : null as any;
        data["score"] = this.score !== undefined ? this.score : null as any;
        return data;
    }

    clone(): FinancialRiskRank {
        const json = this.toJSON();
        let result = new FinancialRiskRank();
        result.init(json);
        return result;
    }
}

export interface IFinancialRiskRank {
    code?: RiskGradingCode;
    score?: number | null;
}

export class CalculateRiskRankingRequest implements ICalculateRiskRankingRequest {
    planType?: PlanType;
    hasCoborrower?: boolean;
    financialRisks?: FinancialRisks | null;
    applicantId?: number;
    academicLevel?: AcademicLevel;

    constructor(data?: ICalculateRiskRankingRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.hasCoborrower = _data["hasCoborrower"] !== undefined ? _data["hasCoborrower"] : null as any;
            this.financialRisks = _data["financialRisks"] ? FinancialRisks.fromJS(_data["financialRisks"]) : null as any;
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
            this.academicLevel = _data["academicLevel"] !== undefined ? _data["academicLevel"] : null as any;
        }
    }

    static fromJS(data: any): CalculateRiskRankingRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CalculateRiskRankingRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["hasCoborrower"] = this.hasCoborrower !== undefined ? this.hasCoborrower : null as any;
        data["financialRisks"] = this.financialRisks ? this.financialRisks.toJSON() : null as any;
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        data["academicLevel"] = this.academicLevel !== undefined ? this.academicLevel : null as any;
        return data;
    }

    clone(): CalculateRiskRankingRequest {
        const json = this.toJSON();
        let result = new CalculateRiskRankingRequest();
        result.init(json);
        return result;
    }
}

export interface ICalculateRiskRankingRequest {
    planType?: PlanType;
    hasCoborrower?: boolean;
    financialRisks?: FinancialRisks | null;
    applicantId?: number;
    academicLevel?: AcademicLevel;
}

export class FinancialRisks implements IFinancialRisks {
    amountFinanced?: number;
    debtToIncomeRatio?: number;
    debtToAssetsRatio?: number;
    borrowerCreditScore?: number;
    coborrowerCreditScore?: number;
    borrower30DayLatePayments?: number;
    coborrower30DayLatePayments?: number;
    borrower60DayLatePayments?: number;
    coborrower60DayLatePayments?: number;
    borrower90DayLatePayments?: number;
    coborrower90DayLatePayments?: number;
    borrowerBankruptcy?: number | null;
    coborrowerBankruptcy?: number | null;
    borrowerDefaultedOnALoan?: number;
    coborrowerDefaultedOnALoan?: number;

    constructor(data?: IFinancialRisks) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.amountFinanced = _data["amountFinanced"] !== undefined ? _data["amountFinanced"] : null as any;
            this.debtToIncomeRatio = _data["debtToIncomeRatio"] !== undefined ? _data["debtToIncomeRatio"] : null as any;
            this.debtToAssetsRatio = _data["debtToAssetsRatio"] !== undefined ? _data["debtToAssetsRatio"] : null as any;
            this.borrowerCreditScore = _data["borrowerCreditScore"] !== undefined ? _data["borrowerCreditScore"] : null as any;
            this.coborrowerCreditScore = _data["coborrowerCreditScore"] !== undefined ? _data["coborrowerCreditScore"] : null as any;
            this.borrower30DayLatePayments = _data["borrower30DayLatePayments"] !== undefined ? _data["borrower30DayLatePayments"] : null as any;
            this.coborrower30DayLatePayments = _data["coborrower30DayLatePayments"] !== undefined ? _data["coborrower30DayLatePayments"] : null as any;
            this.borrower60DayLatePayments = _data["borrower60DayLatePayments"] !== undefined ? _data["borrower60DayLatePayments"] : null as any;
            this.coborrower60DayLatePayments = _data["coborrower60DayLatePayments"] !== undefined ? _data["coborrower60DayLatePayments"] : null as any;
            this.borrower90DayLatePayments = _data["borrower90DayLatePayments"] !== undefined ? _data["borrower90DayLatePayments"] : null as any;
            this.coborrower90DayLatePayments = _data["coborrower90DayLatePayments"] !== undefined ? _data["coborrower90DayLatePayments"] : null as any;
            this.borrowerBankruptcy = _data["borrowerBankruptcy"] !== undefined ? _data["borrowerBankruptcy"] : null as any;
            this.coborrowerBankruptcy = _data["coborrowerBankruptcy"] !== undefined ? _data["coborrowerBankruptcy"] : null as any;
            this.borrowerDefaultedOnALoan = _data["borrowerDefaultedOnALoan"] !== undefined ? _data["borrowerDefaultedOnALoan"] : null as any;
            this.coborrowerDefaultedOnALoan = _data["coborrowerDefaultedOnALoan"] !== undefined ? _data["coborrowerDefaultedOnALoan"] : null as any;
        }
    }

    static fromJS(data: any): FinancialRisks {
        data = typeof data === 'object' ? data : {};
        let result = new FinancialRisks();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["amountFinanced"] = this.amountFinanced !== undefined ? this.amountFinanced : null as any;
        data["debtToIncomeRatio"] = this.debtToIncomeRatio !== undefined ? this.debtToIncomeRatio : null as any;
        data["debtToAssetsRatio"] = this.debtToAssetsRatio !== undefined ? this.debtToAssetsRatio : null as any;
        data["borrowerCreditScore"] = this.borrowerCreditScore !== undefined ? this.borrowerCreditScore : null as any;
        data["coborrowerCreditScore"] = this.coborrowerCreditScore !== undefined ? this.coborrowerCreditScore : null as any;
        data["borrower30DayLatePayments"] = this.borrower30DayLatePayments !== undefined ? this.borrower30DayLatePayments : null as any;
        data["coborrower30DayLatePayments"] = this.coborrower30DayLatePayments !== undefined ? this.coborrower30DayLatePayments : null as any;
        data["borrower60DayLatePayments"] = this.borrower60DayLatePayments !== undefined ? this.borrower60DayLatePayments : null as any;
        data["coborrower60DayLatePayments"] = this.coborrower60DayLatePayments !== undefined ? this.coborrower60DayLatePayments : null as any;
        data["borrower90DayLatePayments"] = this.borrower90DayLatePayments !== undefined ? this.borrower90DayLatePayments : null as any;
        data["coborrower90DayLatePayments"] = this.coborrower90DayLatePayments !== undefined ? this.coborrower90DayLatePayments : null as any;
        data["borrowerBankruptcy"] = this.borrowerBankruptcy !== undefined ? this.borrowerBankruptcy : null as any;
        data["coborrowerBankruptcy"] = this.coborrowerBankruptcy !== undefined ? this.coborrowerBankruptcy : null as any;
        data["borrowerDefaultedOnALoan"] = this.borrowerDefaultedOnALoan !== undefined ? this.borrowerDefaultedOnALoan : null as any;
        data["coborrowerDefaultedOnALoan"] = this.coborrowerDefaultedOnALoan !== undefined ? this.coborrowerDefaultedOnALoan : null as any;
        return data;
    }

    clone(): FinancialRisks {
        const json = this.toJSON();
        let result = new FinancialRisks();
        result.init(json);
        return result;
    }
}

export interface IFinancialRisks {
    amountFinanced?: number;
    debtToIncomeRatio?: number;
    debtToAssetsRatio?: number;
    borrowerCreditScore?: number;
    coborrowerCreditScore?: number;
    borrower30DayLatePayments?: number;
    coborrower30DayLatePayments?: number;
    borrower60DayLatePayments?: number;
    coborrower60DayLatePayments?: number;
    borrower90DayLatePayments?: number;
    coborrower90DayLatePayments?: number;
    borrowerBankruptcy?: number | null;
    coborrowerBankruptcy?: number | null;
    borrowerDefaultedOnALoan?: number;
    coborrowerDefaultedOnALoan?: number;
}

export class UpdateRiskGradingsResponse implements IUpdateRiskGradingsResponse {

    constructor(data?: IUpdateRiskGradingsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateRiskGradingsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRiskGradingsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateRiskGradingsResponse {
        const json = this.toJSON();
        let result = new UpdateRiskGradingsResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateRiskGradingsResponse {
}

export class UpdateRiskGradingsRequest implements IUpdateRiskGradingsRequest {
    riskGradings?: RiskGradingViewModel[] | null;

    constructor(data?: IUpdateRiskGradingsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["riskGradings"])) {
                this.riskGradings = [] as any;
                for (let item of _data["riskGradings"])
                    this.riskGradings!.push(RiskGradingViewModel.fromJS(item));
            }
            else {
                this.riskGradings = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateRiskGradingsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRiskGradingsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.riskGradings)) {
            data["riskGradings"] = [];
            for (let item of this.riskGradings)
                data["riskGradings"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateRiskGradingsRequest {
        const json = this.toJSON();
        let result = new UpdateRiskGradingsRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateRiskGradingsRequest {
    riskGradings?: RiskGradingViewModel[] | null;
}

export class GetRolesResponse implements IGetRolesResponse {
    roles?: RoleViewModel[] | null;

    constructor(data?: IGetRolesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleViewModel.fromJS(item));
            }
            else {
                this.roles = null as any;
            }
        }
    }

    static fromJS(data: any): GetRolesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetRolesResponse {
        const json = this.toJSON();
        let result = new GetRolesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetRolesResponse {
    roles?: RoleViewModel[] | null;
}

export class RoleViewModel implements IRoleViewModel {
    id?: number | null;
    name?: string | null;
    permissionKeys?: string[] | null;

    constructor(data?: IRoleViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            if (Array.isArray(_data["permissionKeys"])) {
                this.permissionKeys = [] as any;
                for (let item of _data["permissionKeys"])
                    this.permissionKeys!.push(item);
            }
            else {
                this.permissionKeys = null as any;
            }
        }
    }

    static fromJS(data: any): RoleViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        if (Array.isArray(this.permissionKeys)) {
            data["permissionKeys"] = [];
            for (let item of this.permissionKeys)
                data["permissionKeys"].push(item);
        }
        return data;
    }

    clone(): RoleViewModel {
        const json = this.toJSON();
        let result = new RoleViewModel();
        result.init(json);
        return result;
    }
}

export interface IRoleViewModel {
    id?: number | null;
    name?: string | null;
    permissionKeys?: string[] | null;
}

export class GetPermissionsResponse implements IGetPermissionsResponse {
    permissions?: PermissionViewModel[] | null;

    constructor(data?: IGetPermissionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(PermissionViewModel.fromJS(item));
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static fromJS(data: any): GetPermissionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPermissionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetPermissionsResponse {
        const json = this.toJSON();
        let result = new GetPermissionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetPermissionsResponse {
    permissions?: PermissionViewModel[] | null;
}

export class PermissionViewModel implements IPermissionViewModel {
    id?: number | null;
    key?: string | null;
    description?: string | null;

    constructor(data?: IPermissionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.description = _data["description"] !== undefined ? _data["description"] : null as any;
        }
    }

    static fromJS(data: any): PermissionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new PermissionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["description"] = this.description !== undefined ? this.description : null as any;
        return data;
    }

    clone(): PermissionViewModel {
        const json = this.toJSON();
        let result = new PermissionViewModel();
        result.init(json);
        return result;
    }
}

export interface IPermissionViewModel {
    id?: number | null;
    key?: string | null;
    description?: string | null;
}

export class UpdateRoleResponse implements IUpdateRoleResponse {

    constructor(data?: IUpdateRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateRoleResponse {
        const json = this.toJSON();
        let result = new UpdateRoleResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateRoleResponse {
}

export class UpdateRoleRequest implements IUpdateRoleRequest {
    id?: number;
    permissionKeys?: string[] | null;

    constructor(data?: IUpdateRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            if (Array.isArray(_data["permissionKeys"])) {
                this.permissionKeys = [] as any;
                for (let item of _data["permissionKeys"])
                    this.permissionKeys!.push(item);
            }
            else {
                this.permissionKeys = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        if (Array.isArray(this.permissionKeys)) {
            data["permissionKeys"] = [];
            for (let item of this.permissionKeys)
                data["permissionKeys"].push(item);
        }
        return data;
    }

    clone(): UpdateRoleRequest {
        const json = this.toJSON();
        let result = new UpdateRoleRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateRoleRequest {
    id?: number;
    permissionKeys?: string[] | null;
}

export class AddRoleResponse implements IAddRoleResponse {
    id?: number;

    constructor(data?: IAddRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
        }
    }

    static fromJS(data: any): AddRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        return data;
    }

    clone(): AddRoleResponse {
        const json = this.toJSON();
        let result = new AddRoleResponse();
        result.init(json);
        return result;
    }
}

export interface IAddRoleResponse {
    id?: number;
}

export class AddRoleRequest implements IAddRoleRequest {
    name?: string | null;

    constructor(data?: IAddRoleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
        }
    }

    static fromJS(data: any): AddRoleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddRoleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name !== undefined ? this.name : null as any;
        return data;
    }

    clone(): AddRoleRequest {
        const json = this.toJSON();
        let result = new AddRoleRequest();
        result.init(json);
        return result;
    }
}

export interface IAddRoleRequest {
    name?: string | null;
}

export class DeleteRoleResponse implements IDeleteRoleResponse {

    constructor(data?: IDeleteRoleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteRoleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRoleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): DeleteRoleResponse {
        const json = this.toJSON();
        let result = new DeleteRoleResponse();
        result.init(json);
        return result;
    }
}

export interface IDeleteRoleResponse {
}

export class SearchApplicantResponse implements ISearchApplicantResponse {
    results?: SearchApplicantResult[] | null;

    constructor(data?: ISearchApplicantResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SearchApplicantResult.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): SearchApplicantResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicantResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): SearchApplicantResponse {
        const json = this.toJSON();
        let result = new SearchApplicantResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicantResponse {
    results?: SearchApplicantResult[] | null;
}

export class SearchApplicantResult implements ISearchApplicantResult {
    id?: number;
    rootId?: number | null;
    lastFour?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    source?: ApplicantSource;
    lastUpdateDateTime?: Date;

    constructor(data?: ISearchApplicantResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.rootId = _data["rootId"] !== undefined ? _data["rootId"] : null as any;
            this.lastFour = _data["lastFour"] !== undefined ? _data["lastFour"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.source = _data["source"] !== undefined ? _data["source"] : null as any;
            this.lastUpdateDateTime = _data["lastUpdateDateTime"] ? new Date(_data["lastUpdateDateTime"].toString()) : null as any;
        }
    }

    static fromJS(data: any): SearchApplicantResult {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicantResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["rootId"] = this.rootId !== undefined ? this.rootId : null as any;
        data["lastFour"] = this.lastFour !== undefined ? this.lastFour : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["source"] = this.source !== undefined ? this.source : null as any;
        data["lastUpdateDateTime"] = this.lastUpdateDateTime ? this.lastUpdateDateTime.toISOString() : null as any;
        return data;
    }

    clone(): SearchApplicantResult {
        const json = this.toJSON();
        let result = new SearchApplicantResult();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicantResult {
    id?: number;
    rootId?: number | null;
    lastFour?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    ssn?: string | null;
    source?: ApplicantSource;
    lastUpdateDateTime?: Date;
}

export class SearchApplicantRequest implements ISearchApplicantRequest {
    rootId?: number | null;
    ssn?: string | null;
    lastFour?: string | null;
    name?: string | null;
    limit?: number | null;

    constructor(data?: ISearchApplicantRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rootId = _data["rootId"] !== undefined ? _data["rootId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
            this.lastFour = _data["lastFour"] !== undefined ? _data["lastFour"] : null as any;
            this.name = _data["name"] !== undefined ? _data["name"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
        }
    }

    static fromJS(data: any): SearchApplicantRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicantRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rootId"] = this.rootId !== undefined ? this.rootId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        data["lastFour"] = this.lastFour !== undefined ? this.lastFour : null as any;
        data["name"] = this.name !== undefined ? this.name : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        return data;
    }

    clone(): SearchApplicantRequest {
        const json = this.toJSON();
        let result = new SearchApplicantRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicantRequest {
    rootId?: number | null;
    ssn?: string | null;
    lastFour?: string | null;
    name?: string | null;
    limit?: number | null;
}

export class SearchApplicationAccountResponse implements ISearchApplicationAccountResponse {
    results?: SearchApplicationAccountResult[] | null;

    constructor(data?: ISearchApplicationAccountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["results"])) {
                this.results = [] as any;
                for (let item of _data["results"])
                    this.results!.push(SearchApplicationAccountResult.fromJS(item));
            }
            else {
                this.results = null as any;
            }
        }
    }

    static fromJS(data: any): SearchApplicationAccountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicationAccountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.results)) {
            data["results"] = [];
            for (let item of this.results)
                data["results"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): SearchApplicationAccountResponse {
        const json = this.toJSON();
        let result = new SearchApplicationAccountResponse();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicationAccountResponse {
    results?: SearchApplicationAccountResult[] | null;
}

export class SearchApplicationAccountResult implements ISearchApplicationAccountResult {
    id?: number;
    applicantRootId?: number | null;
    academicYear?: number;
    studentRootId?: number | null;
    applicantLastName?: string | null;
    applicantFirstName?: string | null;
    studentLastName?: string | null;
    studentFirstName?: string | null;
    status?: string | null;
    planType?: PlanType;
    type?: ApplicationAccountSearchType;
    applicantId?: number | null;
    sisId?: number | null;
    studentLastFour?: string | null;
    amountPrepay?: number | null;
    amountBorrow?: number | null;
    applicationStatus?: ApplicationStatus | null;
    decisionDate?: Date | null;
    accountStatus?: AccountStatus | null;
    cancellationDate?: Date | null;
    loanId?: string | null;
    servicerLoanNumber?: number | null;
    servicerDate?: Date | null;
    paidInFullDate?: Date | null;
    paymentStartDate?: Date | null;
    isOffCampus?: boolean | null;
    hasAgreementReceived?: boolean | null;

    constructor(data?: ISearchApplicationAccountResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicantRootId = _data["applicantRootId"] !== undefined ? _data["applicantRootId"] : null as any;
            this.academicYear = _data["academicYear"] !== undefined ? _data["academicYear"] : null as any;
            this.studentRootId = _data["studentRootId"] !== undefined ? _data["studentRootId"] : null as any;
            this.applicantLastName = _data["applicantLastName"] !== undefined ? _data["applicantLastName"] : null as any;
            this.applicantFirstName = _data["applicantFirstName"] !== undefined ? _data["applicantFirstName"] : null as any;
            this.studentLastName = _data["studentLastName"] !== undefined ? _data["studentLastName"] : null as any;
            this.studentFirstName = _data["studentFirstName"] !== undefined ? _data["studentFirstName"] : null as any;
            this.status = _data["status"] !== undefined ? _data["status"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.type = _data["type"] !== undefined ? _data["type"] : null as any;
            this.applicantId = _data["applicantId"] !== undefined ? _data["applicantId"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.studentLastFour = _data["studentLastFour"] !== undefined ? _data["studentLastFour"] : null as any;
            this.amountPrepay = _data["amountPrepay"] !== undefined ? _data["amountPrepay"] : null as any;
            this.amountBorrow = _data["amountBorrow"] !== undefined ? _data["amountBorrow"] : null as any;
            this.applicationStatus = _data["applicationStatus"] !== undefined ? _data["applicationStatus"] : null as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : null as any;
            this.accountStatus = _data["accountStatus"] !== undefined ? _data["accountStatus"] : null as any;
            this.cancellationDate = _data["cancellationDate"] ? new Date(_data["cancellationDate"].toString()) : null as any;
            this.loanId = _data["loanId"] !== undefined ? _data["loanId"] : null as any;
            this.servicerLoanNumber = _data["servicerLoanNumber"] !== undefined ? _data["servicerLoanNumber"] : null as any;
            this.servicerDate = _data["servicerDate"] ? new Date(_data["servicerDate"].toString()) : null as any;
            this.paidInFullDate = _data["paidInFullDate"] ? new Date(_data["paidInFullDate"].toString()) : null as any;
            this.paymentStartDate = _data["paymentStartDate"] ? new Date(_data["paymentStartDate"].toString()) : null as any;
            this.isOffCampus = _data["isOffCampus"] !== undefined ? _data["isOffCampus"] : null as any;
            this.hasAgreementReceived = _data["hasAgreementReceived"] !== undefined ? _data["hasAgreementReceived"] : null as any;
        }
    }

    static fromJS(data: any): SearchApplicationAccountResult {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicationAccountResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicantRootId"] = this.applicantRootId !== undefined ? this.applicantRootId : null as any;
        data["academicYear"] = this.academicYear !== undefined ? this.academicYear : null as any;
        data["studentRootId"] = this.studentRootId !== undefined ? this.studentRootId : null as any;
        data["applicantLastName"] = this.applicantLastName !== undefined ? this.applicantLastName : null as any;
        data["applicantFirstName"] = this.applicantFirstName !== undefined ? this.applicantFirstName : null as any;
        data["studentLastName"] = this.studentLastName !== undefined ? this.studentLastName : null as any;
        data["studentFirstName"] = this.studentFirstName !== undefined ? this.studentFirstName : null as any;
        data["status"] = this.status !== undefined ? this.status : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["type"] = this.type !== undefined ? this.type : null as any;
        data["applicantId"] = this.applicantId !== undefined ? this.applicantId : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["studentLastFour"] = this.studentLastFour !== undefined ? this.studentLastFour : null as any;
        data["amountPrepay"] = this.amountPrepay !== undefined ? this.amountPrepay : null as any;
        data["amountBorrow"] = this.amountBorrow !== undefined ? this.amountBorrow : null as any;
        data["applicationStatus"] = this.applicationStatus !== undefined ? this.applicationStatus : null as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : null as any;
        data["accountStatus"] = this.accountStatus !== undefined ? this.accountStatus : null as any;
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : null as any;
        data["loanId"] = this.loanId !== undefined ? this.loanId : null as any;
        data["servicerLoanNumber"] = this.servicerLoanNumber !== undefined ? this.servicerLoanNumber : null as any;
        data["servicerDate"] = this.servicerDate ? this.servicerDate.toISOString() : null as any;
        data["paidInFullDate"] = this.paidInFullDate ? this.paidInFullDate.toISOString() : null as any;
        data["paymentStartDate"] = this.paymentStartDate ? this.paymentStartDate.toISOString() : null as any;
        data["isOffCampus"] = this.isOffCampus !== undefined ? this.isOffCampus : null as any;
        data["hasAgreementReceived"] = this.hasAgreementReceived !== undefined ? this.hasAgreementReceived : null as any;
        return data;
    }

    clone(): SearchApplicationAccountResult {
        const json = this.toJSON();
        let result = new SearchApplicationAccountResult();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicationAccountResult {
    id?: number;
    applicantRootId?: number | null;
    academicYear?: number;
    studentRootId?: number | null;
    applicantLastName?: string | null;
    applicantFirstName?: string | null;
    studentLastName?: string | null;
    studentFirstName?: string | null;
    status?: string | null;
    planType?: PlanType;
    type?: ApplicationAccountSearchType;
    applicantId?: number | null;
    sisId?: number | null;
    studentLastFour?: string | null;
    amountPrepay?: number | null;
    amountBorrow?: number | null;
    applicationStatus?: ApplicationStatus | null;
    decisionDate?: Date | null;
    accountStatus?: AccountStatus | null;
    cancellationDate?: Date | null;
    loanId?: string | null;
    servicerLoanNumber?: number | null;
    servicerDate?: Date | null;
    paidInFullDate?: Date | null;
    paymentStartDate?: Date | null;
    isOffCampus?: boolean | null;
    hasAgreementReceived?: boolean | null;
}

export enum ApplicationAccountSearchType {
    Application = "Application",
    Account = "Account",
}

export class SearchApplicationAccountRequest implements ISearchApplicationAccountRequest {
    searchType?: ApplicationAccountSearchType;
    applicantName?: string | null;
    studentName?: string | null;
    studentSsn?: string | null;
    studentLastFour?: string | null;
    applicantRootId?: number | null;
    sisId?: number | null;
    planType?: PlanType | null;
    academicYear?: number | null;
    minPrepay?: number | null;
    maxPrepay?: number | null;
    minFinanced?: number | null;
    maxFinanced?: number | null;
    id?: number | null;
    applicationStatus?: ApplicationStatus | null;
    decisionDate?: Date | null;
    accountStatus?: AccountStatus | null;
    cancellationDate?: Date | null;
    loanSeqId?: string | null;
    servicerLoanId?: number | null;
    servicerDateMin?: Date | null;
    servicerDateMax?: Date | null;
    paymentStartDateMin?: Date | null;
    paymentStartDateMax?: Date | null;
    noServicerDateSearch?: boolean | null;
    paidInFullDate?: Date | null;
    noPaidInFullDate?: boolean | null;
    offCampus?: boolean | null;
    agreementReceived?: boolean | null;
    limit?: number | null;

    constructor(data?: ISearchApplicationAccountRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.searchType = _data["searchType"] !== undefined ? _data["searchType"] : null as any;
            this.applicantName = _data["applicantName"] !== undefined ? _data["applicantName"] : null as any;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : null as any;
            this.studentSsn = _data["studentSsn"] !== undefined ? _data["studentSsn"] : null as any;
            this.studentLastFour = _data["studentLastFour"] !== undefined ? _data["studentLastFour"] : null as any;
            this.applicantRootId = _data["applicantRootId"] !== undefined ? _data["applicantRootId"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.academicYear = _data["academicYear"] !== undefined ? _data["academicYear"] : null as any;
            this.minPrepay = _data["minPrepay"] !== undefined ? _data["minPrepay"] : null as any;
            this.maxPrepay = _data["maxPrepay"] !== undefined ? _data["maxPrepay"] : null as any;
            this.minFinanced = _data["minFinanced"] !== undefined ? _data["minFinanced"] : null as any;
            this.maxFinanced = _data["maxFinanced"] !== undefined ? _data["maxFinanced"] : null as any;
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.applicationStatus = _data["applicationStatus"] !== undefined ? _data["applicationStatus"] : null as any;
            this.decisionDate = _data["decisionDate"] ? new Date(_data["decisionDate"].toString()) : null as any;
            this.accountStatus = _data["accountStatus"] !== undefined ? _data["accountStatus"] : null as any;
            this.cancellationDate = _data["cancellationDate"] ? new Date(_data["cancellationDate"].toString()) : null as any;
            this.loanSeqId = _data["loanSeqId"] !== undefined ? _data["loanSeqId"] : null as any;
            this.servicerLoanId = _data["servicerLoanId"] !== undefined ? _data["servicerLoanId"] : null as any;
            this.servicerDateMin = _data["servicerDateMin"] ? new Date(_data["servicerDateMin"].toString()) : null as any;
            this.servicerDateMax = _data["servicerDateMax"] ? new Date(_data["servicerDateMax"].toString()) : null as any;
            this.paymentStartDateMin = _data["paymentStartDateMin"] ? new Date(_data["paymentStartDateMin"].toString()) : null as any;
            this.paymentStartDateMax = _data["paymentStartDateMax"] ? new Date(_data["paymentStartDateMax"].toString()) : null as any;
            this.noServicerDateSearch = _data["noServicerDateSearch"] !== undefined ? _data["noServicerDateSearch"] : null as any;
            this.paidInFullDate = _data["paidInFullDate"] ? new Date(_data["paidInFullDate"].toString()) : null as any;
            this.noPaidInFullDate = _data["noPaidInFullDate"] !== undefined ? _data["noPaidInFullDate"] : null as any;
            this.offCampus = _data["offCampus"] !== undefined ? _data["offCampus"] : null as any;
            this.agreementReceived = _data["agreementReceived"] !== undefined ? _data["agreementReceived"] : null as any;
            this.limit = _data["limit"] !== undefined ? _data["limit"] : null as any;
        }
    }

    static fromJS(data: any): SearchApplicationAccountRequest {
        data = typeof data === 'object' ? data : {};
        let result = new SearchApplicationAccountRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["searchType"] = this.searchType !== undefined ? this.searchType : null as any;
        data["applicantName"] = this.applicantName !== undefined ? this.applicantName : null as any;
        data["studentName"] = this.studentName !== undefined ? this.studentName : null as any;
        data["studentSsn"] = this.studentSsn !== undefined ? this.studentSsn : null as any;
        data["studentLastFour"] = this.studentLastFour !== undefined ? this.studentLastFour : null as any;
        data["applicantRootId"] = this.applicantRootId !== undefined ? this.applicantRootId : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["academicYear"] = this.academicYear !== undefined ? this.academicYear : null as any;
        data["minPrepay"] = this.minPrepay !== undefined ? this.minPrepay : null as any;
        data["maxPrepay"] = this.maxPrepay !== undefined ? this.maxPrepay : null as any;
        data["minFinanced"] = this.minFinanced !== undefined ? this.minFinanced : null as any;
        data["maxFinanced"] = this.maxFinanced !== undefined ? this.maxFinanced : null as any;
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["applicationStatus"] = this.applicationStatus !== undefined ? this.applicationStatus : null as any;
        data["decisionDate"] = this.decisionDate ? this.decisionDate.toISOString() : null as any;
        data["accountStatus"] = this.accountStatus !== undefined ? this.accountStatus : null as any;
        data["cancellationDate"] = this.cancellationDate ? this.cancellationDate.toISOString() : null as any;
        data["loanSeqId"] = this.loanSeqId !== undefined ? this.loanSeqId : null as any;
        data["servicerLoanId"] = this.servicerLoanId !== undefined ? this.servicerLoanId : null as any;
        data["servicerDateMin"] = this.servicerDateMin ? this.servicerDateMin.toISOString() : null as any;
        data["servicerDateMax"] = this.servicerDateMax ? this.servicerDateMax.toISOString() : null as any;
        data["paymentStartDateMin"] = this.paymentStartDateMin ? this.paymentStartDateMin.toISOString() : null as any;
        data["paymentStartDateMax"] = this.paymentStartDateMax ? this.paymentStartDateMax.toISOString() : null as any;
        data["noServicerDateSearch"] = this.noServicerDateSearch !== undefined ? this.noServicerDateSearch : null as any;
        data["paidInFullDate"] = this.paidInFullDate ? this.paidInFullDate.toISOString() : null as any;
        data["noPaidInFullDate"] = this.noPaidInFullDate !== undefined ? this.noPaidInFullDate : null as any;
        data["offCampus"] = this.offCampus !== undefined ? this.offCampus : null as any;
        data["agreementReceived"] = this.agreementReceived !== undefined ? this.agreementReceived : null as any;
        data["limit"] = this.limit !== undefined ? this.limit : null as any;
        return data;
    }

    clone(): SearchApplicationAccountRequest {
        const json = this.toJSON();
        let result = new SearchApplicationAccountRequest();
        result.init(json);
        return result;
    }
}

export interface ISearchApplicationAccountRequest {
    searchType?: ApplicationAccountSearchType;
    applicantName?: string | null;
    studentName?: string | null;
    studentSsn?: string | null;
    studentLastFour?: string | null;
    applicantRootId?: number | null;
    sisId?: number | null;
    planType?: PlanType | null;
    academicYear?: number | null;
    minPrepay?: number | null;
    maxPrepay?: number | null;
    minFinanced?: number | null;
    maxFinanced?: number | null;
    id?: number | null;
    applicationStatus?: ApplicationStatus | null;
    decisionDate?: Date | null;
    accountStatus?: AccountStatus | null;
    cancellationDate?: Date | null;
    loanSeqId?: string | null;
    servicerLoanId?: number | null;
    servicerDateMin?: Date | null;
    servicerDateMax?: Date | null;
    paymentStartDateMin?: Date | null;
    paymentStartDateMax?: Date | null;
    noServicerDateSearch?: boolean | null;
    paidInFullDate?: Date | null;
    noPaidInFullDate?: boolean | null;
    offCampus?: boolean | null;
    agreementReceived?: boolean | null;
    limit?: number | null;
}

export class GetSemestersByFiscalYearResponse implements IGetSemestersByFiscalYearResponse {
    semesters?: SemesterViewModel[] | null;

    constructor(data?: IGetSemestersByFiscalYearResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["semesters"])) {
                this.semesters = [] as any;
                for (let item of _data["semesters"])
                    this.semesters!.push(SemesterViewModel.fromJS(item));
            }
            else {
                this.semesters = null as any;
            }
        }
    }

    static fromJS(data: any): GetSemestersByFiscalYearResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSemestersByFiscalYearResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.semesters)) {
            data["semesters"] = [];
            for (let item of this.semesters)
                data["semesters"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetSemestersByFiscalYearResponse {
        const json = this.toJSON();
        let result = new GetSemestersByFiscalYearResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSemestersByFiscalYearResponse {
    semesters?: SemesterViewModel[] | null;
}

export class GetSemesterOptionsResponse implements IGetSemesterOptionsResponse {
    semesterOptions?: SemesterOptionViewModel[] | null;

    constructor(data?: IGetSemesterOptionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["semesterOptions"])) {
                this.semesterOptions = [] as any;
                for (let item of _data["semesterOptions"])
                    this.semesterOptions!.push(SemesterOptionViewModel.fromJS(item));
            }
            else {
                this.semesterOptions = null as any;
            }
        }
    }

    static fromJS(data: any): GetSemesterOptionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSemesterOptionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.semesterOptions)) {
            data["semesterOptions"] = [];
            for (let item of this.semesterOptions)
                data["semesterOptions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetSemesterOptionsResponse {
        const json = this.toJSON();
        let result = new GetSemesterOptionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSemesterOptionsResponse {
    semesterOptions?: SemesterOptionViewModel[] | null;
}

export class SemesterOptionViewModel implements ISemesterOptionViewModel {
    semesterCode?: string | null;
    semesterValue?: string | null;
    semesterLabel?: string | null;

    constructor(data?: ISemesterOptionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.semesterCode = _data["semesterCode"] !== undefined ? _data["semesterCode"] : null as any;
            this.semesterValue = _data["semesterValue"] !== undefined ? _data["semesterValue"] : null as any;
            this.semesterLabel = _data["semesterLabel"] !== undefined ? _data["semesterLabel"] : null as any;
        }
    }

    static fromJS(data: any): SemesterOptionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new SemesterOptionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["semesterCode"] = this.semesterCode !== undefined ? this.semesterCode : null as any;
        data["semesterValue"] = this.semesterValue !== undefined ? this.semesterValue : null as any;
        data["semesterLabel"] = this.semesterLabel !== undefined ? this.semesterLabel : null as any;
        return data;
    }

    clone(): SemesterOptionViewModel {
        const json = this.toJSON();
        let result = new SemesterOptionViewModel();
        result.init(json);
        return result;
    }
}

export interface ISemesterOptionViewModel {
    semesterCode?: string | null;
    semesterValue?: string | null;
    semesterLabel?: string | null;
}

export class GetSemestersResponse implements IGetSemestersResponse {
    semesters?: SemesterViewModel[] | null;

    constructor(data?: IGetSemestersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["semesters"])) {
                this.semesters = [] as any;
                for (let item of _data["semesters"])
                    this.semesters!.push(SemesterViewModel.fromJS(item));
            }
            else {
                this.semesters = null as any;
            }
        }
    }

    static fromJS(data: any): GetSemestersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetSemestersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.semesters)) {
            data["semesters"] = [];
            for (let item of this.semesters)
                data["semesters"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetSemestersResponse {
        const json = this.toJSON();
        let result = new GetSemestersResponse();
        result.init(json);
        return result;
    }
}

export interface IGetSemestersResponse {
    semesters?: SemesterViewModel[] | null;
}

export class UpdateSemestersResponse implements IUpdateSemestersResponse {

    constructor(data?: IUpdateSemestersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateSemestersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSemestersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateSemestersResponse {
        const json = this.toJSON();
        let result = new UpdateSemestersResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateSemestersResponse {
}

export class UpdateSemestersRequest implements IUpdateSemestersRequest {
    workdayAwardYear?: string | null;
    semesters?: SemesterViewModel[] | null;

    constructor(data?: IUpdateSemestersRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.workdayAwardYear = _data["workdayAwardYear"] !== undefined ? _data["workdayAwardYear"] : null as any;
            if (Array.isArray(_data["semesters"])) {
                this.semesters = [] as any;
                for (let item of _data["semesters"])
                    this.semesters!.push(SemesterViewModel.fromJS(item));
            }
            else {
                this.semesters = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateSemestersRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateSemestersRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["workdayAwardYear"] = this.workdayAwardYear !== undefined ? this.workdayAwardYear : null as any;
        if (Array.isArray(this.semesters)) {
            data["semesters"] = [];
            for (let item of this.semesters)
                data["semesters"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateSemestersRequest {
        const json = this.toJSON();
        let result = new UpdateSemestersRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateSemestersRequest {
    workdayAwardYear?: string | null;
    semesters?: SemesterViewModel[] | null;
}

export class AddStudentAccountTransactionsResponse implements IAddStudentAccountTransactionsResponse {
    results?: AccountingTransactionResult | null;

    constructor(data?: IAddStudentAccountTransactionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.results = _data["results"] ? AccountingTransactionResult.fromJS(_data["results"]) : null as any;
        }
    }

    static fromJS(data: any): AddStudentAccountTransactionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddStudentAccountTransactionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["results"] = this.results ? this.results.toJSON() : null as any;
        return data;
    }

    clone(): AddStudentAccountTransactionsResponse {
        const json = this.toJSON();
        let result = new AddStudentAccountTransactionsResponse();
        result.init(json);
        return result;
    }
}

export interface IAddStudentAccountTransactionsResponse {
    results?: AccountingTransactionResult | null;
}

export class AccountingTransactionResult implements IAccountingTransactionResult {
    success?: AccountTransactionSuccessResultViewModel[] | null;
    warning?: AccountTransactionWarningResultViewModel[] | null;
    error?: AccountTransactionErrorResultViewModel[] | null;

    constructor(data?: IAccountingTransactionResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["success"])) {
                this.success = [] as any;
                for (let item of _data["success"])
                    this.success!.push(AccountTransactionSuccessResultViewModel.fromJS(item));
            }
            else {
                this.success = null as any;
            }
            if (Array.isArray(_data["warning"])) {
                this.warning = [] as any;
                for (let item of _data["warning"])
                    this.warning!.push(AccountTransactionWarningResultViewModel.fromJS(item));
            }
            else {
                this.warning = null as any;
            }
            if (Array.isArray(_data["error"])) {
                this.error = [] as any;
                for (let item of _data["error"])
                    this.error!.push(AccountTransactionErrorResultViewModel.fromJS(item));
            }
            else {
                this.error = null as any;
            }
        }
    }

    static fromJS(data: any): AccountingTransactionResult {
        data = typeof data === 'object' ? data : {};
        let result = new AccountingTransactionResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.success)) {
            data["success"] = [];
            for (let item of this.success)
                data["success"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.warning)) {
            data["warning"] = [];
            for (let item of this.warning)
                data["warning"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.error)) {
            data["error"] = [];
            for (let item of this.error)
                data["error"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): AccountingTransactionResult {
        const json = this.toJSON();
        let result = new AccountingTransactionResult();
        result.init(json);
        return result;
    }
}

export interface IAccountingTransactionResult {
    success?: AccountTransactionSuccessResultViewModel[] | null;
    warning?: AccountTransactionWarningResultViewModel[] | null;
    error?: AccountTransactionErrorResultViewModel[] | null;
}

export abstract class BaseAccountTransactionResultViewModel implements IBaseAccountTransactionResultViewModel {
    accountId?: string | null;
    sisId?: string | null;
    studentName?: string | null;

    constructor(data?: IBaseAccountTransactionResultViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountId = _data["accountId"] !== undefined ? _data["accountId"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.studentName = _data["studentName"] !== undefined ? _data["studentName"] : null as any;
        }
    }

    static fromJS(data: any): BaseAccountTransactionResultViewModel {
        data = typeof data === 'object' ? data : {};
        throw new Error("The abstract class 'BaseAccountTransactionResultViewModel' cannot be instantiated.");
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountId"] = this.accountId !== undefined ? this.accountId : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["studentName"] = this.studentName !== undefined ? this.studentName : null as any;
        return data;
    }

    clone(): BaseAccountTransactionResultViewModel {
        throw new Error("The abstract class 'BaseAccountTransactionResultViewModel' cannot be instantiated.");
    }
}

export interface IBaseAccountTransactionResultViewModel {
    accountId?: string | null;
    sisId?: string | null;
    studentName?: string | null;
}

export class AccountTransactionSuccessResultViewModel extends BaseAccountTransactionResultViewModel implements IAccountTransactionSuccessResultViewModel {
    transType?: string | null;
    transAmount?: string | null;

    constructor(data?: IAccountTransactionSuccessResultViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.transType = _data["transType"] !== undefined ? _data["transType"] : null as any;
            this.transAmount = _data["transAmount"] !== undefined ? _data["transAmount"] : null as any;
        }
    }

    static fromJS(data: any): AccountTransactionSuccessResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTransactionSuccessResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["transType"] = this.transType !== undefined ? this.transType : null as any;
        data["transAmount"] = this.transAmount !== undefined ? this.transAmount : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountTransactionSuccessResultViewModel {
        const json = this.toJSON();
        let result = new AccountTransactionSuccessResultViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountTransactionSuccessResultViewModel extends IBaseAccountTransactionResultViewModel {
    transType?: string | null;
    transAmount?: string | null;
}

export class AccountTransactionWarningResultViewModel extends BaseAccountTransactionResultViewModel implements IAccountTransactionWarningResultViewModel {
    message?: string | null;

    constructor(data?: IAccountTransactionWarningResultViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): AccountTransactionWarningResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTransactionWarningResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountTransactionWarningResultViewModel {
        const json = this.toJSON();
        let result = new AccountTransactionWarningResultViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountTransactionWarningResultViewModel extends IBaseAccountTransactionResultViewModel {
    message?: string | null;
}

export class AccountTransactionErrorResultViewModel extends BaseAccountTransactionResultViewModel implements IAccountTransactionErrorResultViewModel {
    message?: string | null;

    constructor(data?: IAccountTransactionErrorResultViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.message = _data["message"] !== undefined ? _data["message"] : null as any;
        }
    }

    static fromJS(data: any): AccountTransactionErrorResultViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new AccountTransactionErrorResultViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["message"] = this.message !== undefined ? this.message : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): AccountTransactionErrorResultViewModel {
        const json = this.toJSON();
        let result = new AccountTransactionErrorResultViewModel();
        result.init(json);
        return result;
    }
}

export interface IAccountTransactionErrorResultViewModel extends IBaseAccountTransactionResultViewModel {
    message?: string | null;
}

export class AddStudentAccountTransactionsRequest implements IAddStudentAccountTransactionsRequest {
    postSaSemester?: string | null;
    isPreviewOnly?: boolean;

    constructor(data?: IAddStudentAccountTransactionsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.postSaSemester = _data["postSaSemester"] !== undefined ? _data["postSaSemester"] : null as any;
            this.isPreviewOnly = _data["isPreviewOnly"] !== undefined ? _data["isPreviewOnly"] : null as any;
        }
    }

    static fromJS(data: any): AddStudentAccountTransactionsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddStudentAccountTransactionsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["postSaSemester"] = this.postSaSemester !== undefined ? this.postSaSemester : null as any;
        data["isPreviewOnly"] = this.isPreviewOnly !== undefined ? this.isPreviewOnly : null as any;
        return data;
    }

    clone(): AddStudentAccountTransactionsRequest {
        const json = this.toJSON();
        let result = new AddStudentAccountTransactionsRequest();
        result.init(json);
        return result;
    }
}

export interface IAddStudentAccountTransactionsRequest {
    postSaSemester?: string | null;
    isPreviewOnly?: boolean;
}

export class DownloadResultsFileRequest implements IDownloadResultsFileRequest {
    result?: AccountingTransactionResult | null;

    constructor(data?: IDownloadResultsFileRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] ? AccountingTransactionResult.fromJS(_data["result"]) : null as any;
        }
    }

    static fromJS(data: any): DownloadResultsFileRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DownloadResultsFileRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result ? this.result.toJSON() : null as any;
        return data;
    }

    clone(): DownloadResultsFileRequest {
        const json = this.toJSON();
        let result = new DownloadResultsFileRequest();
        result.init(json);
        return result;
    }
}

export interface IDownloadResultsFileRequest {
    result?: AccountingTransactionResult | null;
}

export class GetStudentPreviewResponse implements IGetStudentPreviewResponse {
    studentPreview?: StudentPreview | null;

    constructor(data?: IGetStudentPreviewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentPreview = _data["studentPreview"] ? StudentPreview.fromJS(_data["studentPreview"]) : null as any;
        }
    }

    static fromJS(data: any): GetStudentPreviewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetStudentPreviewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentPreview"] = this.studentPreview ? this.studentPreview.toJSON() : null as any;
        return data;
    }

    clone(): GetStudentPreviewResponse {
        const json = this.toJSON();
        let result = new GetStudentPreviewResponse();
        result.init(json);
        return result;
    }
}

export interface IGetStudentPreviewResponse {
    studentPreview?: StudentPreview | null;
}

export class StudentPreview implements IStudentPreview {
    id?: number;
    sisId?: number | null;
    studentRootId?: number | null;
    fullName?: string | null;
    isNew?: boolean;
    lastFourSsn?: string | null;
    matchingAccountIds?: number[] | null;

    constructor(data?: IStudentPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.studentRootId = _data["studentRootId"] !== undefined ? _data["studentRootId"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.isNew = _data["isNew"] !== undefined ? _data["isNew"] : null as any;
            this.lastFourSsn = _data["lastFourSsn"] !== undefined ? _data["lastFourSsn"] : null as any;
            if (Array.isArray(_data["matchingAccountIds"])) {
                this.matchingAccountIds = [] as any;
                for (let item of _data["matchingAccountIds"])
                    this.matchingAccountIds!.push(item);
            }
            else {
                this.matchingAccountIds = null as any;
            }
        }
    }

    static fromJS(data: any): StudentPreview {
        data = typeof data === 'object' ? data : {};
        let result = new StudentPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["studentRootId"] = this.studentRootId !== undefined ? this.studentRootId : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["isNew"] = this.isNew !== undefined ? this.isNew : null as any;
        data["lastFourSsn"] = this.lastFourSsn !== undefined ? this.lastFourSsn : null as any;
        if (Array.isArray(this.matchingAccountIds)) {
            data["matchingAccountIds"] = [];
            for (let item of this.matchingAccountIds)
                data["matchingAccountIds"].push(item);
        }
        return data;
    }

    clone(): StudentPreview {
        const json = this.toJSON();
        let result = new StudentPreview();
        result.init(json);
        return result;
    }
}

export interface IStudentPreview {
    id?: number;
    sisId?: number | null;
    studentRootId?: number | null;
    fullName?: string | null;
    isNew?: boolean;
    lastFourSsn?: string | null;
    matchingAccountIds?: number[] | null;
}

export class MatchStudentSisIdResponse implements IMatchStudentSisIdResponse {
    autoMatchedStudent?: boolean;
    matchedSisId?: string | null;
    mulesoftStudents?: PossibleStudentMatch[] | null;

    constructor(data?: IMatchStudentSisIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.autoMatchedStudent = _data["autoMatchedStudent"] !== undefined ? _data["autoMatchedStudent"] : null as any;
            this.matchedSisId = _data["matchedSisId"] !== undefined ? _data["matchedSisId"] : null as any;
            if (Array.isArray(_data["mulesoftStudents"])) {
                this.mulesoftStudents = [] as any;
                for (let item of _data["mulesoftStudents"])
                    this.mulesoftStudents!.push(PossibleStudentMatch.fromJS(item));
            }
            else {
                this.mulesoftStudents = null as any;
            }
        }
    }

    static fromJS(data: any): MatchStudentSisIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MatchStudentSisIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["autoMatchedStudent"] = this.autoMatchedStudent !== undefined ? this.autoMatchedStudent : null as any;
        data["matchedSisId"] = this.matchedSisId !== undefined ? this.matchedSisId : null as any;
        if (Array.isArray(this.mulesoftStudents)) {
            data["mulesoftStudents"] = [];
            for (let item of this.mulesoftStudents)
                data["mulesoftStudents"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): MatchStudentSisIdResponse {
        const json = this.toJSON();
        let result = new MatchStudentSisIdResponse();
        result.init(json);
        return result;
    }
}

export interface IMatchStudentSisIdResponse {
    autoMatchedStudent?: boolean;
    matchedSisId?: string | null;
    mulesoftStudents?: PossibleStudentMatch[] | null;
}

export class PossibleStudentMatch implements IPossibleStudentMatch {
    sisId?: string | null;
    dateOfBirth?: Date | null;
    firstName?: string | null;
    lastName?: string | null;
    mpStatus?: string | null;

    constructor(data?: IPossibleStudentMatch) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] ? new Date(_data["dateOfBirth"].toString()) : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.mpStatus = _data["mpStatus"] !== undefined ? _data["mpStatus"] : null as any;
        }
    }

    static fromJS(data: any): PossibleStudentMatch {
        data = typeof data === 'object' ? data : {};
        let result = new PossibleStudentMatch();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["dateOfBirth"] = this.dateOfBirth ? this.dateOfBirth.toISOString() : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["mpStatus"] = this.mpStatus !== undefined ? this.mpStatus : null as any;
        return data;
    }

    clone(): PossibleStudentMatch {
        const json = this.toJSON();
        let result = new PossibleStudentMatch();
        result.init(json);
        return result;
    }
}

export interface IPossibleStudentMatch {
    sisId?: string | null;
    dateOfBirth?: Date | null;
    firstName?: string | null;
    lastName?: string | null;
    mpStatus?: string | null;
}

export class ManualMatchStudentSisIdResponse implements IManualMatchStudentSisIdResponse {

    constructor(data?: IManualMatchStudentSisIdResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ManualMatchStudentSisIdResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ManualMatchStudentSisIdResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): ManualMatchStudentSisIdResponse {
        const json = this.toJSON();
        let result = new ManualMatchStudentSisIdResponse();
        result.init(json);
        return result;
    }
}

export interface IManualMatchStudentSisIdResponse {
}

export class ManualMatchStudentSisIdRequest implements IManualMatchStudentSisIdRequest {
    studentId?: number;
    sisId?: string | null;
    mpStatus?: string | null;
    isApplication?: boolean;

    constructor(data?: IManualMatchStudentSisIdRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : null as any;
            this.sisId = _data["sisId"] !== undefined ? _data["sisId"] : null as any;
            this.mpStatus = _data["mpStatus"] !== undefined ? _data["mpStatus"] : null as any;
            this.isApplication = _data["isApplication"] !== undefined ? _data["isApplication"] : null as any;
        }
    }

    static fromJS(data: any): ManualMatchStudentSisIdRequest {
        data = typeof data === 'object' ? data : {};
        let result = new ManualMatchStudentSisIdRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["studentId"] = this.studentId !== undefined ? this.studentId : null as any;
        data["sisId"] = this.sisId !== undefined ? this.sisId : null as any;
        data["mpStatus"] = this.mpStatus !== undefined ? this.mpStatus : null as any;
        data["isApplication"] = this.isApplication !== undefined ? this.isApplication : null as any;
        return data;
    }

    clone(): ManualMatchStudentSisIdRequest {
        const json = this.toJSON();
        let result = new ManualMatchStudentSisIdRequest();
        result.init(json);
        return result;
    }
}

export interface IManualMatchStudentSisIdRequest {
    studentId?: number;
    sisId?: string | null;
    mpStatus?: string | null;
    isApplication?: boolean;
}

export class UpdateStudentSsnResponse implements IUpdateStudentSsnResponse {
    lastFourSsn?: string | null;
    ssn?: string | null;

    constructor(data?: IUpdateStudentSsnResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastFourSsn = _data["lastFourSsn"] !== undefined ? _data["lastFourSsn"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
        }
    }

    static fromJS(data: any): UpdateStudentSsnResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentSsnResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastFourSsn"] = this.lastFourSsn !== undefined ? this.lastFourSsn : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        return data;
    }

    clone(): UpdateStudentSsnResponse {
        const json = this.toJSON();
        let result = new UpdateStudentSsnResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentSsnResponse {
    lastFourSsn?: string | null;
    ssn?: string | null;
}

export class UpdateStudentSsnRequest implements IUpdateStudentSsnRequest {
    applicationId?: number;
    studentId?: number;
    ssn?: string | null;

    constructor(data?: IUpdateStudentSsnRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : null as any;
            this.ssn = _data["ssn"] !== undefined ? _data["ssn"] : null as any;
        }
    }

    static fromJS(data: any): UpdateStudentSsnRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentSsnRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["studentId"] = this.studentId !== undefined ? this.studentId : null as any;
        data["ssn"] = this.ssn !== undefined ? this.ssn : null as any;
        return data;
    }

    clone(): UpdateStudentSsnRequest {
        const json = this.toJSON();
        let result = new UpdateStudentSsnRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentSsnRequest {
    applicationId?: number;
    studentId?: number;
    ssn?: string | null;
}

export class UpdateStudentLastNameResponse implements IUpdateStudentLastNameResponse {
    lastName?: string | null;

    constructor(data?: IUpdateStudentLastNameResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): UpdateStudentLastNameResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentLastNameResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }

    clone(): UpdateStudentLastNameResponse {
        const json = this.toJSON();
        let result = new UpdateStudentLastNameResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentLastNameResponse {
    lastName?: string | null;
}

export class UpdateStudentLastNameRequest implements IUpdateStudentLastNameRequest {
    applicationId?: number;
    studentId?: number;
    lastName?: string | null;

    constructor(data?: IUpdateStudentLastNameRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
        }
    }

    static fromJS(data: any): UpdateStudentLastNameRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentLastNameRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["studentId"] = this.studentId !== undefined ? this.studentId : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        return data;
    }

    clone(): UpdateStudentLastNameRequest {
        const json = this.toJSON();
        let result = new UpdateStudentLastNameRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentLastNameRequest {
    applicationId?: number;
    studentId?: number;
    lastName?: string | null;
}

export class UpdateStudentBirthdateResponse implements IUpdateStudentBirthdateResponse {
    birthDate?: Date;

    constructor(data?: IUpdateStudentBirthdateResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UpdateStudentBirthdateResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentBirthdateResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        return data;
    }

    clone(): UpdateStudentBirthdateResponse {
        const json = this.toJSON();
        let result = new UpdateStudentBirthdateResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentBirthdateResponse {
    birthDate?: Date;
}

export class UpdateStudentBirthdateRequest implements IUpdateStudentBirthdateRequest {
    applicationId?: number;
    studentId?: number;
    birthDate?: Date;

    constructor(data?: IUpdateStudentBirthdateRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.applicationId = _data["applicationId"] !== undefined ? _data["applicationId"] : null as any;
            this.studentId = _data["studentId"] !== undefined ? _data["studentId"] : null as any;
            this.birthDate = _data["birthDate"] ? new Date(_data["birthDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UpdateStudentBirthdateRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStudentBirthdateRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["applicationId"] = this.applicationId !== undefined ? this.applicationId : null as any;
        data["studentId"] = this.studentId !== undefined ? this.studentId : null as any;
        data["birthDate"] = this.birthDate ? this.birthDate.toISOString() : null as any;
        return data;
    }

    clone(): UpdateStudentBirthdateRequest {
        const json = this.toJSON();
        let result = new UpdateStudentBirthdateRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateStudentBirthdateRequest {
    applicationId?: number;
    studentId?: number;
    birthDate?: Date;
}

export class CreateTransactionCodesResponse implements ICreateTransactionCodesResponse {

    constructor(data?: ICreateTransactionCodesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateTransactionCodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransactionCodesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): CreateTransactionCodesResponse {
        const json = this.toJSON();
        let result = new CreateTransactionCodesResponse();
        result.init(json);
        return result;
    }
}

export interface ICreateTransactionCodesResponse {
}

export class CreateTransactionCodesRequest implements ICreateTransactionCodesRequest {
    transactionCodes?: TransactionCodeViewModel[] | null;

    constructor(data?: ICreateTransactionCodesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactionCodes"])) {
                this.transactionCodes = [] as any;
                for (let item of _data["transactionCodes"])
                    this.transactionCodes!.push(TransactionCodeViewModel.fromJS(item));
            }
            else {
                this.transactionCodes = null as any;
            }
        }
    }

    static fromJS(data: any): CreateTransactionCodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateTransactionCodesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactionCodes)) {
            data["transactionCodes"] = [];
            for (let item of this.transactionCodes)
                data["transactionCodes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): CreateTransactionCodesRequest {
        const json = this.toJSON();
        let result = new CreateTransactionCodesRequest();
        result.init(json);
        return result;
    }
}

export interface ICreateTransactionCodesRequest {
    transactionCodes?: TransactionCodeViewModel[] | null;
}

export class TransactionCodeViewModel implements ITransactionCodeViewModel {
    id?: number | null;
    fiscalYearId?: number;
    tranCodePlanType?: PlanType;
    componentType?: ComponentType;
    saPlanCode?: string | null;
    label?: string | null;
    workDayProject?: string | null;
    workDayProjectDescription?: string | null;
    workDayCostCenter?: string | null;
    workDayCostCenterDescription?: string | null;
    workDayLedgerAccount?: string | null;
    workDayLedgerAccountDescription?: string | null;
    pepLedger?: string | null;
    pepLedgerDescription?: string | null;
    revenueCategory?: string | null;
    revenueCategoryDescription?: string | null;
    spendCategory?: string | null;
    spendCategoryDescription?: string | null;
    fund?: string | null;
    fundDescription?: string | null;
    workDayWaiverItem?: string | null;
    workDayBenefitWaiverItem?: string | null;
    workDayBenefitWaiverItemLedger?: string | null;
    workDayBenefitWaiverItemLedgerDescription?: string | null;
    workDayWaiverItemSpendCategory?: string | null;
    workDayWaiverItemSpendCategoryDescription?: string | null;
    workDayBenefitWaiverItemSpendCategory?: string | null;
    workDayBenefitWaiverItemSpendCategoryDescription?: string | null;

    constructor(data?: ITransactionCodeViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.fiscalYearId = _data["fiscalYearId"] !== undefined ? _data["fiscalYearId"] : null as any;
            this.tranCodePlanType = _data["tranCodePlanType"] !== undefined ? _data["tranCodePlanType"] : null as any;
            this.componentType = _data["componentType"] !== undefined ? _data["componentType"] : null as any;
            this.saPlanCode = _data["saPlanCode"] !== undefined ? _data["saPlanCode"] : null as any;
            this.label = _data["label"] !== undefined ? _data["label"] : null as any;
            this.workDayProject = _data["workDayProject"] !== undefined ? _data["workDayProject"] : null as any;
            this.workDayProjectDescription = _data["workDayProjectDescription"] !== undefined ? _data["workDayProjectDescription"] : null as any;
            this.workDayCostCenter = _data["workDayCostCenter"] !== undefined ? _data["workDayCostCenter"] : null as any;
            this.workDayCostCenterDescription = _data["workDayCostCenterDescription"] !== undefined ? _data["workDayCostCenterDescription"] : null as any;
            this.workDayLedgerAccount = _data["workDayLedgerAccount"] !== undefined ? _data["workDayLedgerAccount"] : null as any;
            this.workDayLedgerAccountDescription = _data["workDayLedgerAccountDescription"] !== undefined ? _data["workDayLedgerAccountDescription"] : null as any;
            this.pepLedger = _data["pepLedger"] !== undefined ? _data["pepLedger"] : null as any;
            this.pepLedgerDescription = _data["pepLedgerDescription"] !== undefined ? _data["pepLedgerDescription"] : null as any;
            this.revenueCategory = _data["revenueCategory"] !== undefined ? _data["revenueCategory"] : null as any;
            this.revenueCategoryDescription = _data["revenueCategoryDescription"] !== undefined ? _data["revenueCategoryDescription"] : null as any;
            this.spendCategory = _data["spendCategory"] !== undefined ? _data["spendCategory"] : null as any;
            this.spendCategoryDescription = _data["spendCategoryDescription"] !== undefined ? _data["spendCategoryDescription"] : null as any;
            this.fund = _data["fund"] !== undefined ? _data["fund"] : null as any;
            this.fundDescription = _data["fundDescription"] !== undefined ? _data["fundDescription"] : null as any;
            this.workDayWaiverItem = _data["workDayWaiverItem"] !== undefined ? _data["workDayWaiverItem"] : null as any;
            this.workDayBenefitWaiverItem = _data["workDayBenefitWaiverItem"] !== undefined ? _data["workDayBenefitWaiverItem"] : null as any;
            this.workDayBenefitWaiverItemLedger = _data["workDayBenefitWaiverItemLedger"] !== undefined ? _data["workDayBenefitWaiverItemLedger"] : null as any;
            this.workDayBenefitWaiverItemLedgerDescription = _data["workDayBenefitWaiverItemLedgerDescription"] !== undefined ? _data["workDayBenefitWaiverItemLedgerDescription"] : null as any;
            this.workDayWaiverItemSpendCategory = _data["workDayWaiverItemSpendCategory"] !== undefined ? _data["workDayWaiverItemSpendCategory"] : null as any;
            this.workDayWaiverItemSpendCategoryDescription = _data["workDayWaiverItemSpendCategoryDescription"] !== undefined ? _data["workDayWaiverItemSpendCategoryDescription"] : null as any;
            this.workDayBenefitWaiverItemSpendCategory = _data["workDayBenefitWaiverItemSpendCategory"] !== undefined ? _data["workDayBenefitWaiverItemSpendCategory"] : null as any;
            this.workDayBenefitWaiverItemSpendCategoryDescription = _data["workDayBenefitWaiverItemSpendCategoryDescription"] !== undefined ? _data["workDayBenefitWaiverItemSpendCategoryDescription"] : null as any;
        }
    }

    static fromJS(data: any): TransactionCodeViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionCodeViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["fiscalYearId"] = this.fiscalYearId !== undefined ? this.fiscalYearId : null as any;
        data["tranCodePlanType"] = this.tranCodePlanType !== undefined ? this.tranCodePlanType : null as any;
        data["componentType"] = this.componentType !== undefined ? this.componentType : null as any;
        data["saPlanCode"] = this.saPlanCode !== undefined ? this.saPlanCode : null as any;
        data["label"] = this.label !== undefined ? this.label : null as any;
        data["workDayProject"] = this.workDayProject !== undefined ? this.workDayProject : null as any;
        data["workDayProjectDescription"] = this.workDayProjectDescription !== undefined ? this.workDayProjectDescription : null as any;
        data["workDayCostCenter"] = this.workDayCostCenter !== undefined ? this.workDayCostCenter : null as any;
        data["workDayCostCenterDescription"] = this.workDayCostCenterDescription !== undefined ? this.workDayCostCenterDescription : null as any;
        data["workDayLedgerAccount"] = this.workDayLedgerAccount !== undefined ? this.workDayLedgerAccount : null as any;
        data["workDayLedgerAccountDescription"] = this.workDayLedgerAccountDescription !== undefined ? this.workDayLedgerAccountDescription : null as any;
        data["pepLedger"] = this.pepLedger !== undefined ? this.pepLedger : null as any;
        data["pepLedgerDescription"] = this.pepLedgerDescription !== undefined ? this.pepLedgerDescription : null as any;
        data["revenueCategory"] = this.revenueCategory !== undefined ? this.revenueCategory : null as any;
        data["revenueCategoryDescription"] = this.revenueCategoryDescription !== undefined ? this.revenueCategoryDescription : null as any;
        data["spendCategory"] = this.spendCategory !== undefined ? this.spendCategory : null as any;
        data["spendCategoryDescription"] = this.spendCategoryDescription !== undefined ? this.spendCategoryDescription : null as any;
        data["fund"] = this.fund !== undefined ? this.fund : null as any;
        data["fundDescription"] = this.fundDescription !== undefined ? this.fundDescription : null as any;
        data["workDayWaiverItem"] = this.workDayWaiverItem !== undefined ? this.workDayWaiverItem : null as any;
        data["workDayBenefitWaiverItem"] = this.workDayBenefitWaiverItem !== undefined ? this.workDayBenefitWaiverItem : null as any;
        data["workDayBenefitWaiverItemLedger"] = this.workDayBenefitWaiverItemLedger !== undefined ? this.workDayBenefitWaiverItemLedger : null as any;
        data["workDayBenefitWaiverItemLedgerDescription"] = this.workDayBenefitWaiverItemLedgerDescription !== undefined ? this.workDayBenefitWaiverItemLedgerDescription : null as any;
        data["workDayWaiverItemSpendCategory"] = this.workDayWaiverItemSpendCategory !== undefined ? this.workDayWaiverItemSpendCategory : null as any;
        data["workDayWaiverItemSpendCategoryDescription"] = this.workDayWaiverItemSpendCategoryDescription !== undefined ? this.workDayWaiverItemSpendCategoryDescription : null as any;
        data["workDayBenefitWaiverItemSpendCategory"] = this.workDayBenefitWaiverItemSpendCategory !== undefined ? this.workDayBenefitWaiverItemSpendCategory : null as any;
        data["workDayBenefitWaiverItemSpendCategoryDescription"] = this.workDayBenefitWaiverItemSpendCategoryDescription !== undefined ? this.workDayBenefitWaiverItemSpendCategoryDescription : null as any;
        return data;
    }

    clone(): TransactionCodeViewModel {
        const json = this.toJSON();
        let result = new TransactionCodeViewModel();
        result.init(json);
        return result;
    }
}

export interface ITransactionCodeViewModel {
    id?: number | null;
    fiscalYearId?: number;
    tranCodePlanType?: PlanType;
    componentType?: ComponentType;
    saPlanCode?: string | null;
    label?: string | null;
    workDayProject?: string | null;
    workDayProjectDescription?: string | null;
    workDayCostCenter?: string | null;
    workDayCostCenterDescription?: string | null;
    workDayLedgerAccount?: string | null;
    workDayLedgerAccountDescription?: string | null;
    pepLedger?: string | null;
    pepLedgerDescription?: string | null;
    revenueCategory?: string | null;
    revenueCategoryDescription?: string | null;
    spendCategory?: string | null;
    spendCategoryDescription?: string | null;
    fund?: string | null;
    fundDescription?: string | null;
    workDayWaiverItem?: string | null;
    workDayBenefitWaiverItem?: string | null;
    workDayBenefitWaiverItemLedger?: string | null;
    workDayBenefitWaiverItemLedgerDescription?: string | null;
    workDayWaiverItemSpendCategory?: string | null;
    workDayWaiverItemSpendCategoryDescription?: string | null;
    workDayBenefitWaiverItemSpendCategory?: string | null;
    workDayBenefitWaiverItemSpendCategoryDescription?: string | null;
}

export class GetTransactionCodesResponse implements IGetTransactionCodesResponse {
    transactionCodes?: TransactionCodeViewModel[] | null;

    constructor(data?: IGetTransactionCodesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactionCodes"])) {
                this.transactionCodes = [] as any;
                for (let item of _data["transactionCodes"])
                    this.transactionCodes!.push(TransactionCodeViewModel.fromJS(item));
            }
            else {
                this.transactionCodes = null as any;
            }
        }
    }

    static fromJS(data: any): GetTransactionCodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionCodesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactionCodes)) {
            data["transactionCodes"] = [];
            for (let item of this.transactionCodes)
                data["transactionCodes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetTransactionCodesResponse {
        const json = this.toJSON();
        let result = new GetTransactionCodesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetTransactionCodesResponse {
    transactionCodes?: TransactionCodeViewModel[] | null;
}

export class UpdateTransactionCodesResponse implements IUpdateTransactionCodesResponse {

    constructor(data?: IUpdateTransactionCodesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateTransactionCodesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransactionCodesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateTransactionCodesResponse {
        const json = this.toJSON();
        let result = new UpdateTransactionCodesResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateTransactionCodesResponse {
}

export class UpdateTransactionCodesRequest implements IUpdateTransactionCodesRequest {
    transactionCodes?: TransactionCodeViewModel[] | null;

    constructor(data?: IUpdateTransactionCodesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["transactionCodes"])) {
                this.transactionCodes = [] as any;
                for (let item of _data["transactionCodes"])
                    this.transactionCodes!.push(TransactionCodeViewModel.fromJS(item));
            }
            else {
                this.transactionCodes = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateTransactionCodesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateTransactionCodesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.transactionCodes)) {
            data["transactionCodes"] = [];
            for (let item of this.transactionCodes)
                data["transactionCodes"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateTransactionCodesRequest {
        const json = this.toJSON();
        let result = new UpdateTransactionCodesRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateTransactionCodesRequest {
    transactionCodes?: TransactionCodeViewModel[] | null;
}

export class GetTransactionsResponse implements IGetTransactionsResponse {
    pepPlanTotal?: number;
    transactionPlanTotal?: number;
    studentAccountTotal?: number;
    baseYearTotal?: number;
    difference?: number;
    transactions?: TransactionViewModel[] | null;

    constructor(data?: IGetTransactionsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.pepPlanTotal = _data["pepPlanTotal"] !== undefined ? _data["pepPlanTotal"] : null as any;
            this.transactionPlanTotal = _data["transactionPlanTotal"] !== undefined ? _data["transactionPlanTotal"] : null as any;
            this.studentAccountTotal = _data["studentAccountTotal"] !== undefined ? _data["studentAccountTotal"] : null as any;
            this.baseYearTotal = _data["baseYearTotal"] !== undefined ? _data["baseYearTotal"] : null as any;
            this.difference = _data["difference"] !== undefined ? _data["difference"] : null as any;
            if (Array.isArray(_data["transactions"])) {
                this.transactions = [] as any;
                for (let item of _data["transactions"])
                    this.transactions!.push(TransactionViewModel.fromJS(item));
            }
            else {
                this.transactions = null as any;
            }
        }
    }

    static fromJS(data: any): GetTransactionsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTransactionsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["pepPlanTotal"] = this.pepPlanTotal !== undefined ? this.pepPlanTotal : null as any;
        data["transactionPlanTotal"] = this.transactionPlanTotal !== undefined ? this.transactionPlanTotal : null as any;
        data["studentAccountTotal"] = this.studentAccountTotal !== undefined ? this.studentAccountTotal : null as any;
        data["baseYearTotal"] = this.baseYearTotal !== undefined ? this.baseYearTotal : null as any;
        data["difference"] = this.difference !== undefined ? this.difference : null as any;
        if (Array.isArray(this.transactions)) {
            data["transactions"] = [];
            for (let item of this.transactions)
                data["transactions"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetTransactionsResponse {
        const json = this.toJSON();
        let result = new GetTransactionsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetTransactionsResponse {
    pepPlanTotal?: number;
    transactionPlanTotal?: number;
    studentAccountTotal?: number;
    baseYearTotal?: number;
    difference?: number;
    transactions?: TransactionViewModel[] | null;
}

export class TransactionViewModel implements ITransactionViewModel {
    sortOrder?: number | null;
    fiscalYear?: number;
    semesterCode?: string | null;
    componentType?: ComponentType;
    transactionTypeComments?: string | null;
    transactionType?: TransactionType;
    transactionDate?: Date;
    debitUsed?: number | null;
    creditAvailable?: number | null;
    baseYearBalance?: number | null;
    baseYearTotal?: number | null;
    debitReversed?: number | null;
    creditReceived?: number | null;
    studentAccountBalance?: number | null;
    studentAccountTotal?: number | null;
    benefitAmount?: number | null;

    constructor(data?: ITransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sortOrder = _data["sortOrder"] !== undefined ? _data["sortOrder"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
            this.semesterCode = _data["semesterCode"] !== undefined ? _data["semesterCode"] : null as any;
            this.componentType = _data["componentType"] !== undefined ? _data["componentType"] : null as any;
            this.transactionTypeComments = _data["transactionTypeComments"] !== undefined ? _data["transactionTypeComments"] : null as any;
            this.transactionType = _data["transactionType"] !== undefined ? _data["transactionType"] : null as any;
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : null as any;
            this.debitUsed = _data["debitUsed"] !== undefined ? _data["debitUsed"] : null as any;
            this.creditAvailable = _data["creditAvailable"] !== undefined ? _data["creditAvailable"] : null as any;
            this.baseYearBalance = _data["baseYearBalance"] !== undefined ? _data["baseYearBalance"] : null as any;
            this.baseYearTotal = _data["baseYearTotal"] !== undefined ? _data["baseYearTotal"] : null as any;
            this.debitReversed = _data["debitReversed"] !== undefined ? _data["debitReversed"] : null as any;
            this.creditReceived = _data["creditReceived"] !== undefined ? _data["creditReceived"] : null as any;
            this.studentAccountBalance = _data["studentAccountBalance"] !== undefined ? _data["studentAccountBalance"] : null as any;
            this.studentAccountTotal = _data["studentAccountTotal"] !== undefined ? _data["studentAccountTotal"] : null as any;
            this.benefitAmount = _data["benefitAmount"] !== undefined ? _data["benefitAmount"] : null as any;
        }
    }

    static fromJS(data: any): TransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sortOrder"] = this.sortOrder !== undefined ? this.sortOrder : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        data["semesterCode"] = this.semesterCode !== undefined ? this.semesterCode : null as any;
        data["componentType"] = this.componentType !== undefined ? this.componentType : null as any;
        data["transactionTypeComments"] = this.transactionTypeComments !== undefined ? this.transactionTypeComments : null as any;
        data["transactionType"] = this.transactionType !== undefined ? this.transactionType : null as any;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : null as any;
        data["debitUsed"] = this.debitUsed !== undefined ? this.debitUsed : null as any;
        data["creditAvailable"] = this.creditAvailable !== undefined ? this.creditAvailable : null as any;
        data["baseYearBalance"] = this.baseYearBalance !== undefined ? this.baseYearBalance : null as any;
        data["baseYearTotal"] = this.baseYearTotal !== undefined ? this.baseYearTotal : null as any;
        data["debitReversed"] = this.debitReversed !== undefined ? this.debitReversed : null as any;
        data["creditReceived"] = this.creditReceived !== undefined ? this.creditReceived : null as any;
        data["studentAccountBalance"] = this.studentAccountBalance !== undefined ? this.studentAccountBalance : null as any;
        data["studentAccountTotal"] = this.studentAccountTotal !== undefined ? this.studentAccountTotal : null as any;
        data["benefitAmount"] = this.benefitAmount !== undefined ? this.benefitAmount : null as any;
        return data;
    }

    clone(): TransactionViewModel {
        const json = this.toJSON();
        let result = new TransactionViewModel();
        result.init(json);
        return result;
    }
}

export interface ITransactionViewModel {
    sortOrder?: number | null;
    fiscalYear?: number;
    semesterCode?: string | null;
    componentType?: ComponentType;
    transactionTypeComments?: string | null;
    transactionType?: TransactionType;
    transactionDate?: Date;
    debitUsed?: number | null;
    creditAvailable?: number | null;
    baseYearBalance?: number | null;
    baseYearTotal?: number | null;
    debitReversed?: number | null;
    creditReceived?: number | null;
    studentAccountBalance?: number | null;
    studentAccountTotal?: number | null;
    benefitAmount?: number | null;
}

export enum TransactionType {
    SaBatch = "SaBatch",
    Manual = "Manual",
    WdJrnl = "WdJrnl",
    Prepayment = "Prepayment",
    Reduction = "Reduction",
    MigratedSaBatch = "MigratedSaBatch",
    MigratedManual = "MigratedManual",
    MigratedWdJrnl = "MigratedWdJrnl",
    TempSaBatch = "TempSaBatch",
}

export class AddManualTransactionResponse implements IAddManualTransactionResponse {

    constructor(data?: IAddManualTransactionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): AddManualTransactionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddManualTransactionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): AddManualTransactionResponse {
        const json = this.toJSON();
        let result = new AddManualTransactionResponse();
        result.init(json);
        return result;
    }
}

export interface IAddManualTransactionResponse {
}

export class AddManualTransactionRequest implements IAddManualTransactionRequest {
    accountTransaction?: ManualTransactionViewModel | null;

    constructor(data?: IAddManualTransactionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountTransaction = _data["accountTransaction"] ? ManualTransactionViewModel.fromJS(_data["accountTransaction"]) : null as any;
        }
    }

    static fromJS(data: any): AddManualTransactionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddManualTransactionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountTransaction"] = this.accountTransaction ? this.accountTransaction.toJSON() : null as any;
        return data;
    }

    clone(): AddManualTransactionRequest {
        const json = this.toJSON();
        let result = new AddManualTransactionRequest();
        result.init(json);
        return result;
    }
}

export interface IAddManualTransactionRequest {
    accountTransaction?: ManualTransactionViewModel | null;
}

export class ManualTransactionViewModel implements IManualTransactionViewModel {
    accountsMainsId?: number;
    fiscalYear?: number;
    semesterCode?: string | null;
    componentType?: string | null;
    transactionDate?: Date | null;
    baseDebitAmount?: number | null;
    baseCreditAmount?: number | null;
    studentDebitAmount?: number | null;
    studentCreditAmount?: number | null;
    comments?: string | null;
    benefitAmount?: number | null;

    constructor(data?: IManualTransactionViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
            this.semesterCode = _data["semesterCode"] !== undefined ? _data["semesterCode"] : null as any;
            this.componentType = _data["componentType"] !== undefined ? _data["componentType"] : null as any;
            this.transactionDate = _data["transactionDate"] ? new Date(_data["transactionDate"].toString()) : null as any;
            this.baseDebitAmount = _data["baseDebitAmount"] !== undefined ? _data["baseDebitAmount"] : null as any;
            this.baseCreditAmount = _data["baseCreditAmount"] !== undefined ? _data["baseCreditAmount"] : null as any;
            this.studentDebitAmount = _data["studentDebitAmount"] !== undefined ? _data["studentDebitAmount"] : null as any;
            this.studentCreditAmount = _data["studentCreditAmount"] !== undefined ? _data["studentCreditAmount"] : null as any;
            this.comments = _data["comments"] !== undefined ? _data["comments"] : null as any;
            this.benefitAmount = _data["benefitAmount"] !== undefined ? _data["benefitAmount"] : null as any;
        }
    }

    static fromJS(data: any): ManualTransactionViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ManualTransactionViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        data["semesterCode"] = this.semesterCode !== undefined ? this.semesterCode : null as any;
        data["componentType"] = this.componentType !== undefined ? this.componentType : null as any;
        data["transactionDate"] = this.transactionDate ? this.transactionDate.toISOString() : null as any;
        data["baseDebitAmount"] = this.baseDebitAmount !== undefined ? this.baseDebitAmount : null as any;
        data["baseCreditAmount"] = this.baseCreditAmount !== undefined ? this.baseCreditAmount : null as any;
        data["studentDebitAmount"] = this.studentDebitAmount !== undefined ? this.studentDebitAmount : null as any;
        data["studentCreditAmount"] = this.studentCreditAmount !== undefined ? this.studentCreditAmount : null as any;
        data["comments"] = this.comments !== undefined ? this.comments : null as any;
        data["benefitAmount"] = this.benefitAmount !== undefined ? this.benefitAmount : null as any;
        return data;
    }

    clone(): ManualTransactionViewModel {
        const json = this.toJSON();
        let result = new ManualTransactionViewModel();
        result.init(json);
        return result;
    }
}

export interface IManualTransactionViewModel {
    accountsMainsId?: number;
    fiscalYear?: number;
    semesterCode?: string | null;
    componentType?: string | null;
    transactionDate?: Date | null;
    baseDebitAmount?: number | null;
    baseCreditAmount?: number | null;
    studentDebitAmount?: number | null;
    studentCreditAmount?: number | null;
    comments?: string | null;
    benefitAmount?: number | null;
}

export class GetUasOutboundPreviewsResponse implements IGetUasOutboundPreviewsResponse {
    previews?: UasOutboundPreview[] | null;

    constructor(data?: IGetUasOutboundPreviewsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["previews"])) {
                this.previews = [] as any;
                for (let item of _data["previews"])
                    this.previews!.push(UasOutboundPreview.fromJS(item));
            }
            else {
                this.previews = null as any;
            }
        }
    }

    static fromJS(data: any): GetUasOutboundPreviewsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUasOutboundPreviewsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.previews)) {
            data["previews"] = [];
            for (let item of this.previews)
                data["previews"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetUasOutboundPreviewsResponse {
        const json = this.toJSON();
        let result = new GetUasOutboundPreviewsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUasOutboundPreviewsResponse {
    previews?: UasOutboundPreview[] | null;
}

export class UasOutboundPreview implements IUasOutboundPreview {
    accountsMainsId?: number;
    borrowerId?: number;
    borrowerName?: string | null;
    coBorrowerId?: number | null;
    coBorrowerName?: string | null;
    loanClientId?: string | null;
    planType?: PlanType | null;
    planTypeDescription?: string | null;
    sentToServicerDate?: Date | null;
    fileSequenceId?: number | null;
    agreementReceivedDate?: Date | null;
    paymentStartDate?: Date | null;

    constructor(data?: IUasOutboundPreview) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.accountsMainsId = _data["accountsMainsId"] !== undefined ? _data["accountsMainsId"] : null as any;
            this.borrowerId = _data["borrowerId"] !== undefined ? _data["borrowerId"] : null as any;
            this.borrowerName = _data["borrowerName"] !== undefined ? _data["borrowerName"] : null as any;
            this.coBorrowerId = _data["coBorrowerId"] !== undefined ? _data["coBorrowerId"] : null as any;
            this.coBorrowerName = _data["coBorrowerName"] !== undefined ? _data["coBorrowerName"] : null as any;
            this.loanClientId = _data["loanClientId"] !== undefined ? _data["loanClientId"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.planTypeDescription = _data["planTypeDescription"] !== undefined ? _data["planTypeDescription"] : null as any;
            this.sentToServicerDate = _data["sentToServicerDate"] ? new Date(_data["sentToServicerDate"].toString()) : null as any;
            this.fileSequenceId = _data["fileSequenceId"] !== undefined ? _data["fileSequenceId"] : null as any;
            this.agreementReceivedDate = _data["agreementReceivedDate"] ? new Date(_data["agreementReceivedDate"].toString()) : null as any;
            this.paymentStartDate = _data["paymentStartDate"] ? new Date(_data["paymentStartDate"].toString()) : null as any;
        }
    }

    static fromJS(data: any): UasOutboundPreview {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundPreview();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["accountsMainsId"] = this.accountsMainsId !== undefined ? this.accountsMainsId : null as any;
        data["borrowerId"] = this.borrowerId !== undefined ? this.borrowerId : null as any;
        data["borrowerName"] = this.borrowerName !== undefined ? this.borrowerName : null as any;
        data["coBorrowerId"] = this.coBorrowerId !== undefined ? this.coBorrowerId : null as any;
        data["coBorrowerName"] = this.coBorrowerName !== undefined ? this.coBorrowerName : null as any;
        data["loanClientId"] = this.loanClientId !== undefined ? this.loanClientId : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["planTypeDescription"] = this.planTypeDescription !== undefined ? this.planTypeDescription : null as any;
        data["sentToServicerDate"] = this.sentToServicerDate ? this.sentToServicerDate.toISOString() : null as any;
        data["fileSequenceId"] = this.fileSequenceId !== undefined ? this.fileSequenceId : null as any;
        data["agreementReceivedDate"] = this.agreementReceivedDate ? this.agreementReceivedDate.toISOString() : null as any;
        data["paymentStartDate"] = this.paymentStartDate ? this.paymentStartDate.toISOString() : null as any;
        return data;
    }

    clone(): UasOutboundPreview {
        const json = this.toJSON();
        let result = new UasOutboundPreview();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundPreview {
    accountsMainsId?: number;
    borrowerId?: number;
    borrowerName?: string | null;
    coBorrowerId?: number | null;
    coBorrowerName?: string | null;
    loanClientId?: string | null;
    planType?: PlanType | null;
    planTypeDescription?: string | null;
    sentToServicerDate?: Date | null;
    fileSequenceId?: number | null;
    agreementReceivedDate?: Date | null;
    paymentStartDate?: Date | null;
}

export class GetUasOutboundDetailResponse implements IGetUasOutboundDetailResponse {
    detail?: UasOutboundDetailViewModel | null;

    constructor(data?: IGetUasOutboundDetailResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.detail = _data["detail"] ? UasOutboundDetailViewModel.fromJS(_data["detail"]) : null as any;
        }
    }

    static fromJS(data: any): GetUasOutboundDetailResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUasOutboundDetailResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["detail"] = this.detail ? this.detail.toJSON() : null as any;
        return data;
    }

    clone(): GetUasOutboundDetailResponse {
        const json = this.toJSON();
        let result = new GetUasOutboundDetailResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUasOutboundDetailResponse {
    detail?: UasOutboundDetailViewModel | null;
}

export class UasOutboundDetailViewModel implements IUasOutboundDetailViewModel {
    borrower?: UasOutboundBorrowerDetailViewModel | null;
    coBorrower?: UasOutboundCoBorrowerDetailViewModel | null;
    loan?: UasOutboundLoanDetailViewModel | null;
    loanState?: UasOutboundLoanStateDetailViewModel | null;
    transaction?: UasOutboundTransactionDetailViewModel | null;
    reference?: UasOutboundReferenceDetailViewModel | null;

    constructor(data?: IUasOutboundDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borrower = _data["borrower"] ? UasOutboundBorrowerDetailViewModel.fromJS(_data["borrower"]) : null as any;
            this.coBorrower = _data["coBorrower"] ? UasOutboundCoBorrowerDetailViewModel.fromJS(_data["coBorrower"]) : null as any;
            this.loan = _data["loan"] ? UasOutboundLoanDetailViewModel.fromJS(_data["loan"]) : null as any;
            this.loanState = _data["loanState"] ? UasOutboundLoanStateDetailViewModel.fromJS(_data["loanState"]) : null as any;
            this.transaction = _data["transaction"] ? UasOutboundTransactionDetailViewModel.fromJS(_data["transaction"]) : null as any;
            this.reference = _data["reference"] ? UasOutboundReferenceDetailViewModel.fromJS(_data["reference"]) : null as any;
        }
    }

    static fromJS(data: any): UasOutboundDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borrower"] = this.borrower ? this.borrower.toJSON() : null as any;
        data["coBorrower"] = this.coBorrower ? this.coBorrower.toJSON() : null as any;
        data["loan"] = this.loan ? this.loan.toJSON() : null as any;
        data["loanState"] = this.loanState ? this.loanState.toJSON() : null as any;
        data["transaction"] = this.transaction ? this.transaction.toJSON() : null as any;
        data["reference"] = this.reference ? this.reference.toJSON() : null as any;
        return data;
    }

    clone(): UasOutboundDetailViewModel {
        const json = this.toJSON();
        let result = new UasOutboundDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundDetailViewModel {
    borrower?: UasOutboundBorrowerDetailViewModel | null;
    coBorrower?: UasOutboundCoBorrowerDetailViewModel | null;
    loan?: UasOutboundLoanDetailViewModel | null;
    loanState?: UasOutboundLoanStateDetailViewModel | null;
    transaction?: UasOutboundTransactionDetailViewModel | null;
    reference?: UasOutboundReferenceDetailViewModel | null;
}

export class BaseUasOutboundDetailViewModel implements IBaseUasOutboundDetailViewModel {
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    prefix?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateCode?: string | null;
    zipCode?: string | null;
    dateOfBirth?: string | null;
    phoneNumber?: string | null;
    secondaryNumber?: string | null;
    workPhoneNumber?: string | null;
    email?: string | null;

    constructor(data?: IBaseUasOutboundDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.middleInitial = _data["middleInitial"] !== undefined ? _data["middleInitial"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.prefix = _data["prefix"] !== undefined ? _data["prefix"] : null as any;
            this.address1 = _data["address1"] !== undefined ? _data["address1"] : null as any;
            this.address2 = _data["address2"] !== undefined ? _data["address2"] : null as any;
            this.city = _data["city"] !== undefined ? _data["city"] : null as any;
            this.stateCode = _data["stateCode"] !== undefined ? _data["stateCode"] : null as any;
            this.zipCode = _data["zipCode"] !== undefined ? _data["zipCode"] : null as any;
            this.dateOfBirth = _data["dateOfBirth"] !== undefined ? _data["dateOfBirth"] : null as any;
            this.phoneNumber = _data["phoneNumber"] !== undefined ? _data["phoneNumber"] : null as any;
            this.secondaryNumber = _data["secondaryNumber"] !== undefined ? _data["secondaryNumber"] : null as any;
            this.workPhoneNumber = _data["workPhoneNumber"] !== undefined ? _data["workPhoneNumber"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): BaseUasOutboundDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new BaseUasOutboundDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["middleInitial"] = this.middleInitial !== undefined ? this.middleInitial : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["prefix"] = this.prefix !== undefined ? this.prefix : null as any;
        data["address1"] = this.address1 !== undefined ? this.address1 : null as any;
        data["address2"] = this.address2 !== undefined ? this.address2 : null as any;
        data["city"] = this.city !== undefined ? this.city : null as any;
        data["stateCode"] = this.stateCode !== undefined ? this.stateCode : null as any;
        data["zipCode"] = this.zipCode !== undefined ? this.zipCode : null as any;
        data["dateOfBirth"] = this.dateOfBirth !== undefined ? this.dateOfBirth : null as any;
        data["phoneNumber"] = this.phoneNumber !== undefined ? this.phoneNumber : null as any;
        data["secondaryNumber"] = this.secondaryNumber !== undefined ? this.secondaryNumber : null as any;
        data["workPhoneNumber"] = this.workPhoneNumber !== undefined ? this.workPhoneNumber : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }

    clone(): BaseUasOutboundDetailViewModel {
        const json = this.toJSON();
        let result = new BaseUasOutboundDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IBaseUasOutboundDetailViewModel {
    firstName?: string | null;
    middleInitial?: string | null;
    lastName?: string | null;
    prefix?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    stateCode?: string | null;
    zipCode?: string | null;
    dateOfBirth?: string | null;
    phoneNumber?: string | null;
    secondaryNumber?: string | null;
    workPhoneNumber?: string | null;
    email?: string | null;
}

export class UasOutboundBorrowerDetailViewModel extends BaseUasOutboundDetailViewModel implements IUasOutboundBorrowerDetailViewModel {
    borrowerClientId?: string | null;
    securityNumber?: string | null;

    constructor(data?: IUasOutboundBorrowerDetailViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.borrowerClientId = _data["borrowerClientId"] !== undefined ? _data["borrowerClientId"] : null as any;
            this.securityNumber = _data["securityNumber"] !== undefined ? _data["securityNumber"] : null as any;
        }
    }

    static fromJS(data: any): UasOutboundBorrowerDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundBorrowerDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borrowerClientId"] = this.borrowerClientId !== undefined ? this.borrowerClientId : null as any;
        data["securityNumber"] = this.securityNumber !== undefined ? this.securityNumber : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): UasOutboundBorrowerDetailViewModel {
        const json = this.toJSON();
        let result = new UasOutboundBorrowerDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundBorrowerDetailViewModel extends IBaseUasOutboundDetailViewModel {
    borrowerClientId?: string | null;
    securityNumber?: string | null;
}

export class UasOutboundCoBorrowerDetailViewModel extends BaseUasOutboundDetailViewModel implements IUasOutboundCoBorrowerDetailViewModel {
    clientId?: string | null;
    loanClientId?: string | null;
    borrowerClientId?: string | null;
    securityNumber?: string | null;

    constructor(data?: IUasOutboundCoBorrowerDetailViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.loanClientId = _data["loanClientId"] !== undefined ? _data["loanClientId"] : null as any;
            this.borrowerClientId = _data["borrowerClientId"] !== undefined ? _data["borrowerClientId"] : null as any;
            this.securityNumber = _data["securityNumber"] !== undefined ? _data["securityNumber"] : null as any;
        }
    }

    static fromJS(data: any): UasOutboundCoBorrowerDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundCoBorrowerDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["loanClientId"] = this.loanClientId !== undefined ? this.loanClientId : null as any;
        data["borrowerClientId"] = this.borrowerClientId !== undefined ? this.borrowerClientId : null as any;
        data["securityNumber"] = this.securityNumber !== undefined ? this.securityNumber : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): UasOutboundCoBorrowerDetailViewModel {
        const json = this.toJSON();
        let result = new UasOutboundCoBorrowerDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundCoBorrowerDetailViewModel extends IBaseUasOutboundDetailViewModel {
    clientId?: string | null;
    loanClientId?: string | null;
    borrowerClientId?: string | null;
    securityNumber?: string | null;
}

export class UasOutboundLoanDetailViewModel implements IUasOutboundLoanDetailViewModel {
    borrowerClientId?: string | null;
    loanClientId?: string | null;
    planType?: string | null;
    pepMonthlyPayment?: string | null;
    repaymentPeriod?: string | null;
    interestRate?: string | null;
    separationDate?: string | null;
    altLoanId?: string | null;
    loanProgramClientID?: string | null;

    constructor(data?: IUasOutboundLoanDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borrowerClientId = _data["borrowerClientId"] !== undefined ? _data["borrowerClientId"] : null as any;
            this.loanClientId = _data["loanClientId"] !== undefined ? _data["loanClientId"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.pepMonthlyPayment = _data["pepMonthlyPayment"] !== undefined ? _data["pepMonthlyPayment"] : null as any;
            this.repaymentPeriod = _data["repaymentPeriod"] !== undefined ? _data["repaymentPeriod"] : null as any;
            this.interestRate = _data["interestRate"] !== undefined ? _data["interestRate"] : null as any;
            this.separationDate = _data["separationDate"] !== undefined ? _data["separationDate"] : null as any;
            this.altLoanId = _data["altLoanId"] !== undefined ? _data["altLoanId"] : null as any;
            this.loanProgramClientID = _data["loanProgramClientID"] !== undefined ? _data["loanProgramClientID"] : null as any;
        }
    }

    static fromJS(data: any): UasOutboundLoanDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundLoanDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borrowerClientId"] = this.borrowerClientId !== undefined ? this.borrowerClientId : null as any;
        data["loanClientId"] = this.loanClientId !== undefined ? this.loanClientId : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["pepMonthlyPayment"] = this.pepMonthlyPayment !== undefined ? this.pepMonthlyPayment : null as any;
        data["repaymentPeriod"] = this.repaymentPeriod !== undefined ? this.repaymentPeriod : null as any;
        data["interestRate"] = this.interestRate !== undefined ? this.interestRate : null as any;
        data["separationDate"] = this.separationDate !== undefined ? this.separationDate : null as any;
        data["altLoanId"] = this.altLoanId !== undefined ? this.altLoanId : null as any;
        data["loanProgramClientID"] = this.loanProgramClientID !== undefined ? this.loanProgramClientID : null as any;
        return data;
    }

    clone(): UasOutboundLoanDetailViewModel {
        const json = this.toJSON();
        let result = new UasOutboundLoanDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundLoanDetailViewModel {
    borrowerClientId?: string | null;
    loanClientId?: string | null;
    planType?: string | null;
    pepMonthlyPayment?: string | null;
    repaymentPeriod?: string | null;
    interestRate?: string | null;
    separationDate?: string | null;
    altLoanId?: string | null;
    loanProgramClientID?: string | null;
}

export class UasOutboundLoanStateDetailViewModel implements IUasOutboundLoanStateDetailViewModel {
    borrowerClientId?: string | null;
    loanClientId?: string | null;
    clientId?: string | null;
    effectiveDate?: string | null;
    planType?: string | null;
    pepMonthlyPayment?: string | null;

    constructor(data?: IUasOutboundLoanStateDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borrowerClientId = _data["borrowerClientId"] !== undefined ? _data["borrowerClientId"] : null as any;
            this.loanClientId = _data["loanClientId"] !== undefined ? _data["loanClientId"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.effectiveDate = _data["effectiveDate"] !== undefined ? _data["effectiveDate"] : null as any;
            this.planType = _data["planType"] !== undefined ? _data["planType"] : null as any;
            this.pepMonthlyPayment = _data["pepMonthlyPayment"] !== undefined ? _data["pepMonthlyPayment"] : null as any;
        }
    }

    static fromJS(data: any): UasOutboundLoanStateDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundLoanStateDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borrowerClientId"] = this.borrowerClientId !== undefined ? this.borrowerClientId : null as any;
        data["loanClientId"] = this.loanClientId !== undefined ? this.loanClientId : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["effectiveDate"] = this.effectiveDate !== undefined ? this.effectiveDate : null as any;
        data["planType"] = this.planType !== undefined ? this.planType : null as any;
        data["pepMonthlyPayment"] = this.pepMonthlyPayment !== undefined ? this.pepMonthlyPayment : null as any;
        return data;
    }

    clone(): UasOutboundLoanStateDetailViewModel {
        const json = this.toJSON();
        let result = new UasOutboundLoanStateDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundLoanStateDetailViewModel {
    borrowerClientId?: string | null;
    loanClientId?: string | null;
    clientId?: string | null;
    effectiveDate?: string | null;
    planType?: string | null;
    pepMonthlyPayment?: string | null;
}

export class UasOutboundTransactionDetailViewModel implements IUasOutboundTransactionDetailViewModel {
    borrowerClientId?: string | null;
    loanClientId?: string | null;
    clientId?: string | null;
    transactionDate?: string | null;
    amount?: string | null;
    principalAmount?: string | null;
    fiscalYear?: string | null;

    constructor(data?: IUasOutboundTransactionDetailViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.borrowerClientId = _data["borrowerClientId"] !== undefined ? _data["borrowerClientId"] : null as any;
            this.loanClientId = _data["loanClientId"] !== undefined ? _data["loanClientId"] : null as any;
            this.clientId = _data["clientId"] !== undefined ? _data["clientId"] : null as any;
            this.transactionDate = _data["transactionDate"] !== undefined ? _data["transactionDate"] : null as any;
            this.amount = _data["amount"] !== undefined ? _data["amount"] : null as any;
            this.principalAmount = _data["principalAmount"] !== undefined ? _data["principalAmount"] : null as any;
            this.fiscalYear = _data["fiscalYear"] !== undefined ? _data["fiscalYear"] : null as any;
        }
    }

    static fromJS(data: any): UasOutboundTransactionDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundTransactionDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borrowerClientId"] = this.borrowerClientId !== undefined ? this.borrowerClientId : null as any;
        data["loanClientId"] = this.loanClientId !== undefined ? this.loanClientId : null as any;
        data["clientId"] = this.clientId !== undefined ? this.clientId : null as any;
        data["transactionDate"] = this.transactionDate !== undefined ? this.transactionDate : null as any;
        data["amount"] = this.amount !== undefined ? this.amount : null as any;
        data["principalAmount"] = this.principalAmount !== undefined ? this.principalAmount : null as any;
        data["fiscalYear"] = this.fiscalYear !== undefined ? this.fiscalYear : null as any;
        return data;
    }

    clone(): UasOutboundTransactionDetailViewModel {
        const json = this.toJSON();
        let result = new UasOutboundTransactionDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundTransactionDetailViewModel {
    borrowerClientId?: string | null;
    loanClientId?: string | null;
    clientId?: string | null;
    transactionDate?: string | null;
    amount?: string | null;
    principalAmount?: string | null;
    fiscalYear?: string | null;
}

export class UasOutboundReferenceDetailViewModel extends BaseUasOutboundDetailViewModel implements IUasOutboundReferenceDetailViewModel {
    borrowerClientId?: string | null;
    entityClientId?: string | null;

    constructor(data?: IUasOutboundReferenceDetailViewModel) {
        super(data);
    }

    init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.borrowerClientId = _data["borrowerClientId"] !== undefined ? _data["borrowerClientId"] : null as any;
            this.entityClientId = _data["entityClientId"] !== undefined ? _data["entityClientId"] : null as any;
        }
    }

    static fromJS(data: any): UasOutboundReferenceDetailViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UasOutboundReferenceDetailViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["borrowerClientId"] = this.borrowerClientId !== undefined ? this.borrowerClientId : null as any;
        data["entityClientId"] = this.entityClientId !== undefined ? this.entityClientId : null as any;
        super.toJSON(data);
        return data;
    }

    clone(): UasOutboundReferenceDetailViewModel {
        const json = this.toJSON();
        let result = new UasOutboundReferenceDetailViewModel();
        result.init(json);
        return result;
    }
}

export interface IUasOutboundReferenceDetailViewModel extends IBaseUasOutboundDetailViewModel {
    borrowerClientId?: string | null;
    entityClientId?: string | null;
}

export class SendUasOutboundFileResponse implements ISendUasOutboundFileResponse {
    result?: boolean;

    constructor(data?: ISendUasOutboundFileResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.result = _data["result"] !== undefined ? _data["result"] : null as any;
        }
    }

    static fromJS(data: any): SendUasOutboundFileResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SendUasOutboundFileResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["result"] = this.result !== undefined ? this.result : null as any;
        return data;
    }

    clone(): SendUasOutboundFileResponse {
        const json = this.toJSON();
        let result = new SendUasOutboundFileResponse();
        result.init(json);
        return result;
    }
}

export interface ISendUasOutboundFileResponse {
    result?: boolean;
}

export class UpdateUserFromTokenRequest implements IUpdateUserFromTokenRequest {
    externalUserId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;

    constructor(data?: IUpdateUserFromTokenRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.externalUserId = _data["externalUserId"] !== undefined ? _data["externalUserId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
        }
    }

    static fromJS(data: any): UpdateUserFromTokenRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserFromTokenRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["externalUserId"] = this.externalUserId !== undefined ? this.externalUserId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        return data;
    }

    clone(): UpdateUserFromTokenRequest {
        const json = this.toJSON();
        let result = new UpdateUserFromTokenRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserFromTokenRequest {
    externalUserId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
}

export class GetUserClaimsResponse implements IGetUserClaimsResponse {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;
    permissions?: string[] | null;

    constructor(data?: IGetUserClaimsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.fullName = _data["fullName"] !== undefined ? _data["fullName"] : null as any;
            this.phone = _data["phone"] !== undefined ? _data["phone"] : null as any;
            this.emailAddress = _data["emailAddress"] !== undefined ? _data["emailAddress"] : null as any;
            this.externalId = _data["externalId"] !== undefined ? _data["externalId"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
            this.isActive = _data["isActive"] !== undefined ? _data["isActive"] : null as any;
            if (Array.isArray(_data["permissions"])) {
                this.permissions = [] as any;
                for (let item of _data["permissions"])
                    this.permissions!.push(item);
            }
            else {
                this.permissions = null as any;
            }
        }
    }

    static fromJS(data: any): GetUserClaimsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUserClaimsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["fullName"] = this.fullName !== undefined ? this.fullName : null as any;
        data["phone"] = this.phone !== undefined ? this.phone : null as any;
        data["emailAddress"] = this.emailAddress !== undefined ? this.emailAddress : null as any;
        data["externalId"] = this.externalId !== undefined ? this.externalId : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        data["isActive"] = this.isActive !== undefined ? this.isActive : null as any;
        if (Array.isArray(this.permissions)) {
            data["permissions"] = [];
            for (let item of this.permissions)
                data["permissions"].push(item);
        }
        return data;
    }

    clone(): GetUserClaimsResponse {
        const json = this.toJSON();
        let result = new GetUserClaimsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUserClaimsResponse {
    firstName?: string | null;
    lastName?: string | null;
    fullName?: string | null;
    phone?: string | null;
    emailAddress?: string | null;
    externalId?: string | null;
    role?: string | null;
    isActive?: boolean;
    permissions?: string[] | null;
}

export class GetAllUserClaimsResponse implements IGetAllUserClaimsResponse {
    users?: AppUserViewModel[] | null;

    constructor(data?: IGetAllUserClaimsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AppUserViewModel.fromJS(item));
            }
            else {
                this.users = null as any;
            }
        }
    }

    static fromJS(data: any): GetAllUserClaimsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetAllUserClaimsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetAllUserClaimsResponse {
        const json = this.toJSON();
        let result = new GetAllUserClaimsResponse();
        result.init(json);
        return result;
    }
}

export interface IGetAllUserClaimsResponse {
    users?: AppUserViewModel[] | null;
}

export class UpdateUserRoleAndStatusResponse implements IUpdateUserRoleAndStatusResponse {

    constructor(data?: IUpdateUserRoleAndStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): UpdateUserRoleAndStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleAndStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }

    clone(): UpdateUserRoleAndStatusResponse {
        const json = this.toJSON();
        let result = new UpdateUserRoleAndStatusResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserRoleAndStatusResponse {
}

export class UpdateUserRoleAndStatusRequest implements IUpdateUserRoleAndStatusRequest {
    users?: AppUserViewModel[] | null;

    constructor(data?: IUpdateUserRoleAndStatusRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["users"])) {
                this.users = [] as any;
                for (let item of _data["users"])
                    this.users!.push(AppUserViewModel.fromJS(item));
            }
            else {
                this.users = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateUserRoleAndStatusRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUserRoleAndStatusRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.users)) {
            data["users"] = [];
            for (let item of this.users)
                data["users"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateUserRoleAndStatusRequest {
        const json = this.toJSON();
        let result = new UpdateUserRoleAndStatusRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUserRoleAndStatusRequest {
    users?: AppUserViewModel[] | null;
}

export class AddUserRequest implements IAddUserRequest {
    universalId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    role?: string | null;

    constructor(data?: IAddUserRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.universalId = _data["universalId"] !== undefined ? _data["universalId"] : null as any;
            this.firstName = _data["firstName"] !== undefined ? _data["firstName"] : null as any;
            this.lastName = _data["lastName"] !== undefined ? _data["lastName"] : null as any;
            this.email = _data["email"] !== undefined ? _data["email"] : null as any;
            this.role = _data["role"] !== undefined ? _data["role"] : null as any;
        }
    }

    static fromJS(data: any): AddUserRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUserRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universalId"] = this.universalId !== undefined ? this.universalId : null as any;
        data["firstName"] = this.firstName !== undefined ? this.firstName : null as any;
        data["lastName"] = this.lastName !== undefined ? this.lastName : null as any;
        data["email"] = this.email !== undefined ? this.email : null as any;
        data["role"] = this.role !== undefined ? this.role : null as any;
        return data;
    }

    clone(): AddUserRequest {
        const json = this.toJSON();
        let result = new AddUserRequest();
        result.init(json);
        return result;
    }
}

export interface IAddUserRequest {
    universalId?: string | null;
    firstName?: string | null;
    lastName?: string | null;
    email?: string | null;
    role?: string | null;
}

export class GetUtilitiesResponse implements IGetUtilitiesResponse {
    utilities?: UtilitiesViewModel | null;

    constructor(data?: IGetUtilitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilities = _data["utilities"] ? UtilitiesViewModel.fromJS(_data["utilities"]) : null as any;
        }
    }

    static fromJS(data: any): GetUtilitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtilitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilities"] = this.utilities ? this.utilities.toJSON() : null as any;
        return data;
    }

    clone(): GetUtilitiesResponse {
        const json = this.toJSON();
        let result = new GetUtilitiesResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUtilitiesResponse {
    utilities?: UtilitiesViewModel | null;
}

export class UtilitiesViewModel implements IUtilitiesViewModel {
    id?: number | null;
    key?: string | null;
    value?: string | null;

    constructor(data?: IUtilitiesViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"] !== undefined ? _data["id"] : null as any;
            this.key = _data["key"] !== undefined ? _data["key"] : null as any;
            this.value = _data["value"] !== undefined ? _data["value"] : null as any;
        }
    }

    static fromJS(data: any): UtilitiesViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new UtilitiesViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id !== undefined ? this.id : null as any;
        data["key"] = this.key !== undefined ? this.key : null as any;
        data["value"] = this.value !== undefined ? this.value : null as any;
        return data;
    }

    clone(): UtilitiesViewModel {
        const json = this.toJSON();
        let result = new UtilitiesViewModel();
        result.init(json);
        return result;
    }
}

export interface IUtilitiesViewModel {
    id?: number | null;
    key?: string | null;
    value?: string | null;
}

export class GetUtilitiesMultipleResponse implements IGetUtilitiesMultipleResponse {
    utilities?: UtilitiesViewModel[] | null;

    constructor(data?: IGetUtilitiesMultipleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(UtilitiesViewModel.fromJS(item));
            }
            else {
                this.utilities = null as any;
            }
        }
    }

    static fromJS(data: any): GetUtilitiesMultipleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtilitiesMultipleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetUtilitiesMultipleResponse {
        const json = this.toJSON();
        let result = new GetUtilitiesMultipleResponse();
        result.init(json);
        return result;
    }
}

export interface IGetUtilitiesMultipleResponse {
    utilities?: UtilitiesViewModel[] | null;
}

export class GetUtilitiesMultipleRequest implements IGetUtilitiesMultipleRequest {
    keys?: PageType[] | null;

    constructor(data?: IGetUtilitiesMultipleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["keys"])) {
                this.keys = [] as any;
                for (let item of _data["keys"])
                    this.keys!.push(item);
            }
            else {
                this.keys = null as any;
            }
        }
    }

    static fromJS(data: any): GetUtilitiesMultipleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetUtilitiesMultipleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.keys)) {
            data["keys"] = [];
            for (let item of this.keys)
                data["keys"].push(item);
        }
        return data;
    }

    clone(): GetUtilitiesMultipleRequest {
        const json = this.toJSON();
        let result = new GetUtilitiesMultipleRequest();
        result.init(json);
        return result;
    }
}

export interface IGetUtilitiesMultipleRequest {
    keys?: PageType[] | null;
}

export enum PageType {
    ComparisonWorksheet = "ComparisonWorksheet",
    ParentPepApplication = "ParentPepApplication",
    PostSaSemesterValue = "PostSaSemesterValue",
    UasProgramIdentifierValue = "UasProgramIdentifierValue",
    PepFinalAgreeDateModValue = "PepFinalAgreeDateModValue",
    FpcwAnnualIncrease = "FpcwAnnualIncrease",
    PostSATransBatchType = "PostSATransBatchType",
    StudentUrl = "StudentUrl",
}

export class GetRolesResponse2 implements IGetRolesResponse2 {
    roles?: UtilitiesViewModel[] | null;

    constructor(data?: IGetRolesResponse2) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(UtilitiesViewModel.fromJS(item));
            }
            else {
                this.roles = null as any;
            }
        }
    }

    static fromJS(data: any): GetRolesResponse2 {
        data = typeof data === 'object' ? data : {};
        let result = new GetRolesResponse2();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): GetRolesResponse2 {
        const json = this.toJSON();
        let result = new GetRolesResponse2();
        result.init(json);
        return result;
    }
}

export interface IGetRolesResponse2 {
    roles?: UtilitiesViewModel[] | null;
}

export class UpdateUtilitiesResponse implements IUpdateUtilitiesResponse {
    utilityId?: number;

    constructor(data?: IUpdateUtilitiesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilityId = _data["utilityId"] !== undefined ? _data["utilityId"] : null as any;
        }
    }

    static fromJS(data: any): UpdateUtilitiesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtilitiesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilityId"] = this.utilityId !== undefined ? this.utilityId : null as any;
        return data;
    }

    clone(): UpdateUtilitiesResponse {
        const json = this.toJSON();
        let result = new UpdateUtilitiesResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUtilitiesResponse {
    utilityId?: number;
}

export class UpdateUtilitiesRequest implements IUpdateUtilitiesRequest {
    utilities?: UtilitiesViewModel | null;

    constructor(data?: IUpdateUtilitiesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.utilities = _data["utilities"] ? UtilitiesViewModel.fromJS(_data["utilities"]) : null as any;
        }
    }

    static fromJS(data: any): UpdateUtilitiesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtilitiesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["utilities"] = this.utilities ? this.utilities.toJSON() : null as any;
        return data;
    }

    clone(): UpdateUtilitiesRequest {
        const json = this.toJSON();
        let result = new UpdateUtilitiesRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUtilitiesRequest {
    utilities?: UtilitiesViewModel | null;
}

export class UpdateUtilitiesMultipleResponse implements IUpdateUtilitiesMultipleResponse {
    utilityIds?: number[] | null;

    constructor(data?: IUpdateUtilitiesMultipleResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["utilityIds"])) {
                this.utilityIds = [] as any;
                for (let item of _data["utilityIds"])
                    this.utilityIds!.push(item);
            }
            else {
                this.utilityIds = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateUtilitiesMultipleResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtilitiesMultipleResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.utilityIds)) {
            data["utilityIds"] = [];
            for (let item of this.utilityIds)
                data["utilityIds"].push(item);
        }
        return data;
    }

    clone(): UpdateUtilitiesMultipleResponse {
        const json = this.toJSON();
        let result = new UpdateUtilitiesMultipleResponse();
        result.init(json);
        return result;
    }
}

export interface IUpdateUtilitiesMultipleResponse {
    utilityIds?: number[] | null;
}

export class UpdateUtilitiesMultipleRequest implements IUpdateUtilitiesMultipleRequest {
    utilities?: UtilitiesViewModel[] | null;

    constructor(data?: IUpdateUtilitiesMultipleRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["utilities"])) {
                this.utilities = [] as any;
                for (let item of _data["utilities"])
                    this.utilities!.push(UtilitiesViewModel.fromJS(item));
            }
            else {
                this.utilities = null as any;
            }
        }
    }

    static fromJS(data: any): UpdateUtilitiesMultipleRequest {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateUtilitiesMultipleRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.utilities)) {
            data["utilities"] = [];
            for (let item of this.utilities)
                data["utilities"].push(item ? item.toJSON() : null as any);
        }
        return data;
    }

    clone(): UpdateUtilitiesMultipleRequest {
        const json = this.toJSON();
        let result = new UpdateUtilitiesMultipleRequest();
        result.init(json);
        return result;
    }
}

export interface IUpdateUtilitiesMultipleRequest {
    utilities?: UtilitiesViewModel[] | null;
}

export class GetApiKeyResponse implements IGetApiKeyResponse {
    currentKey?: string | null;

    constructor(data?: IGetApiKeyResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.currentKey = _data["currentKey"] !== undefined ? _data["currentKey"] : null as any;
        }
    }

    static fromJS(data: any): GetApiKeyResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetApiKeyResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["currentKey"] = this.currentKey !== undefined ? this.currentKey : null as any;
        return data;
    }

    clone(): GetApiKeyResponse {
        const json = this.toJSON();
        let result = new GetApiKeyResponse();
        result.init(json);
        return result;
    }
}

export interface IGetApiKeyResponse {
    currentKey?: string | null;
}

export class GenerateWorksheetDataResponse implements IGenerateWorksheetDataResponse {
    worksheetViewModel?: FpcwPdfViewModel | null;

    constructor(data?: IGenerateWorksheetDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.worksheetViewModel = _data["worksheetViewModel"] ? FpcwPdfViewModel.fromJS(_data["worksheetViewModel"]) : null as any;
        }
    }

    static fromJS(data: any): GenerateWorksheetDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateWorksheetDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["worksheetViewModel"] = this.worksheetViewModel ? this.worksheetViewModel.toJSON() : null as any;
        return data;
    }

    clone(): GenerateWorksheetDataResponse {
        const json = this.toJSON();
        let result = new GenerateWorksheetDataResponse();
        result.init(json);
        return result;
    }
}

export interface IGenerateWorksheetDataResponse {
    worksheetViewModel?: FpcwPdfViewModel | null;
}

export class FpcwPdfViewModel implements IFpcwPdfViewModel {
    universityChargesTuition?: WorksheetRow | null;
    universityChargesFees?: WorksheetRow | null;
    universityChargesRoom?: WorksheetRow | null;
    universityChargesMealPlan?: WorksheetRow | null;
    universityChargesTotal?: WorksheetRow | null;
    universityChargesAssistanceOther?: WorksheetRow | null;
    universityChargesRemaining?: WorksheetRow | null;
    participationAmount?: WorksheetRow | null;
    participationRate?: WorksheetRow | null;
    participationSemesters?: WorksheetRow | null;
    planPrepay?: WorksheetRow | null;
    planYears?: WorksheetRow[] | null;
    planAnnualInterest?: WorksheetRow | null;
    planOriginationFee?: WorksheetRow | null;
    paymentYears?: SplitWorksheetRow[] | null;
    afterGraduationPaymentYears?: SplitWorksheetRow[] | null;
    annualCostIncrease?: string | null;
    parentPlusOriginationFee?: string | null;
    housingName?: string | null;
    mealPlanName?: string | null;

    constructor(data?: IFpcwPdfViewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.universityChargesTuition = _data["universityChargesTuition"] ? WorksheetRow.fromJS(_data["universityChargesTuition"]) : null as any;
            this.universityChargesFees = _data["universityChargesFees"] ? WorksheetRow.fromJS(_data["universityChargesFees"]) : null as any;
            this.universityChargesRoom = _data["universityChargesRoom"] ? WorksheetRow.fromJS(_data["universityChargesRoom"]) : null as any;
            this.universityChargesMealPlan = _data["universityChargesMealPlan"] ? WorksheetRow.fromJS(_data["universityChargesMealPlan"]) : null as any;
            this.universityChargesTotal = _data["universityChargesTotal"] ? WorksheetRow.fromJS(_data["universityChargesTotal"]) : null as any;
            this.universityChargesAssistanceOther = _data["universityChargesAssistanceOther"] ? WorksheetRow.fromJS(_data["universityChargesAssistanceOther"]) : null as any;
            this.universityChargesRemaining = _data["universityChargesRemaining"] ? WorksheetRow.fromJS(_data["universityChargesRemaining"]) : null as any;
            this.participationAmount = _data["participationAmount"] ? WorksheetRow.fromJS(_data["participationAmount"]) : null as any;
            this.participationRate = _data["participationRate"] ? WorksheetRow.fromJS(_data["participationRate"]) : null as any;
            this.participationSemesters = _data["participationSemesters"] ? WorksheetRow.fromJS(_data["participationSemesters"]) : null as any;
            this.planPrepay = _data["planPrepay"] ? WorksheetRow.fromJS(_data["planPrepay"]) : null as any;
            if (Array.isArray(_data["planYears"])) {
                this.planYears = [] as any;
                for (let item of _data["planYears"])
                    this.planYears!.push(WorksheetRow.fromJS(item));
            }
            else {
                this.planYears = null as any;
            }
            this.planAnnualInterest = _data["planAnnualInterest"] ? WorksheetRow.fromJS(_data["planAnnualInterest"]) : null as any;
            this.planOriginationFee = _data["planOriginationFee"] ? WorksheetRow.fromJS(_data["planOriginationFee"]) : null as any;
            if (Array.isArray(_data["paymentYears"])) {
                this.paymentYears = [] as any;
                for (let item of _data["paymentYears"])
                    this.paymentYears!.push(SplitWorksheetRow.fromJS(item));
            }
            else {
                this.paymentYears = null as any;
            }
            if (Array.isArray(_data["afterGraduationPaymentYears"])) {
                this.afterGraduationPaymentYears = [] as any;
                for (let item of _data["afterGraduationPaymentYears"])
                    this.afterGraduationPaymentYears!.push(SplitWorksheetRow.fromJS(item));
            }
            else {
                this.afterGraduationPaymentYears = null as any;
            }
            this.annualCostIncrease = _data["annualCostIncrease"] !== undefined ? _data["annualCostIncrease"] : null as any;
            this.parentPlusOriginationFee = _data["parentPlusOriginationFee"] !== undefined ? _data["parentPlusOriginationFee"] : null as any;
            this.housingName = _data["housingName"] !== undefined ? _data["housingName"] : null as any;
            this.mealPlanName = _data["mealPlanName"] !== undefined ? _data["mealPlanName"] : null as any;
        }
    }

    static fromJS(data: any): FpcwPdfViewModel {
        data = typeof data === 'object' ? data : {};
        let result = new FpcwPdfViewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["universityChargesTuition"] = this.universityChargesTuition ? this.universityChargesTuition.toJSON() : null as any;
        data["universityChargesFees"] = this.universityChargesFees ? this.universityChargesFees.toJSON() : null as any;
        data["universityChargesRoom"] = this.universityChargesRoom ? this.universityChargesRoom.toJSON() : null as any;
        data["universityChargesMealPlan"] = this.universityChargesMealPlan ? this.universityChargesMealPlan.toJSON() : null as any;
        data["universityChargesTotal"] = this.universityChargesTotal ? this.universityChargesTotal.toJSON() : null as any;
        data["universityChargesAssistanceOther"] = this.universityChargesAssistanceOther ? this.universityChargesAssistanceOther.toJSON() : null as any;
        data["universityChargesRemaining"] = this.universityChargesRemaining ? this.universityChargesRemaining.toJSON() : null as any;
        data["participationAmount"] = this.participationAmount ? this.participationAmount.toJSON() : null as any;
        data["participationRate"] = this.participationRate ? this.participationRate.toJSON() : null as any;
        data["participationSemesters"] = this.participationSemesters ? this.participationSemesters.toJSON() : null as any;
        data["planPrepay"] = this.planPrepay ? this.planPrepay.toJSON() : null as any;
        if (Array.isArray(this.planYears)) {
            data["planYears"] = [];
            for (let item of this.planYears)
                data["planYears"].push(item ? item.toJSON() : null as any);
        }
        data["planAnnualInterest"] = this.planAnnualInterest ? this.planAnnualInterest.toJSON() : null as any;
        data["planOriginationFee"] = this.planOriginationFee ? this.planOriginationFee.toJSON() : null as any;
        if (Array.isArray(this.paymentYears)) {
            data["paymentYears"] = [];
            for (let item of this.paymentYears)
                data["paymentYears"].push(item ? item.toJSON() : null as any);
        }
        if (Array.isArray(this.afterGraduationPaymentYears)) {
            data["afterGraduationPaymentYears"] = [];
            for (let item of this.afterGraduationPaymentYears)
                data["afterGraduationPaymentYears"].push(item ? item.toJSON() : null as any);
        }
        data["annualCostIncrease"] = this.annualCostIncrease !== undefined ? this.annualCostIncrease : null as any;
        data["parentPlusOriginationFee"] = this.parentPlusOriginationFee !== undefined ? this.parentPlusOriginationFee : null as any;
        data["housingName"] = this.housingName !== undefined ? this.housingName : null as any;
        data["mealPlanName"] = this.mealPlanName !== undefined ? this.mealPlanName : null as any;
        return data;
    }

    clone(): FpcwPdfViewModel {
        const json = this.toJSON();
        let result = new FpcwPdfViewModel();
        result.init(json);
        return result;
    }
}

export interface IFpcwPdfViewModel {
    universityChargesTuition?: WorksheetRow | null;
    universityChargesFees?: WorksheetRow | null;
    universityChargesRoom?: WorksheetRow | null;
    universityChargesMealPlan?: WorksheetRow | null;
    universityChargesTotal?: WorksheetRow | null;
    universityChargesAssistanceOther?: WorksheetRow | null;
    universityChargesRemaining?: WorksheetRow | null;
    participationAmount?: WorksheetRow | null;
    participationRate?: WorksheetRow | null;
    participationSemesters?: WorksheetRow | null;
    planPrepay?: WorksheetRow | null;
    planYears?: WorksheetRow[] | null;
    planAnnualInterest?: WorksheetRow | null;
    planOriginationFee?: WorksheetRow | null;
    paymentYears?: SplitWorksheetRow[] | null;
    afterGraduationPaymentYears?: SplitWorksheetRow[] | null;
    annualCostIncrease?: string | null;
    parentPlusOriginationFee?: string | null;
    housingName?: string | null;
    mealPlanName?: string | null;
}

export class WorksheetRow implements IWorksheetRow {
    title?: string | null;
    multiYear?: string | null;
    prepayment?: string | null;
    combination?: string | null;
    annual?: string | null;
    parentPlus?: string | null;
    installment?: string | null;
    standard?: string | null;

    constructor(data?: IWorksheetRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.multiYear = _data["multiYear"] !== undefined ? _data["multiYear"] : null as any;
            this.prepayment = _data["prepayment"] !== undefined ? _data["prepayment"] : null as any;
            this.combination = _data["combination"] !== undefined ? _data["combination"] : null as any;
            this.annual = _data["annual"] !== undefined ? _data["annual"] : null as any;
            this.parentPlus = _data["parentPlus"] !== undefined ? _data["parentPlus"] : null as any;
            this.installment = _data["installment"] !== undefined ? _data["installment"] : null as any;
            this.standard = _data["standard"] !== undefined ? _data["standard"] : null as any;
        }
    }

    static fromJS(data: any): WorksheetRow {
        data = typeof data === 'object' ? data : {};
        let result = new WorksheetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["multiYear"] = this.multiYear !== undefined ? this.multiYear : null as any;
        data["prepayment"] = this.prepayment !== undefined ? this.prepayment : null as any;
        data["combination"] = this.combination !== undefined ? this.combination : null as any;
        data["annual"] = this.annual !== undefined ? this.annual : null as any;
        data["parentPlus"] = this.parentPlus !== undefined ? this.parentPlus : null as any;
        data["installment"] = this.installment !== undefined ? this.installment : null as any;
        data["standard"] = this.standard !== undefined ? this.standard : null as any;
        return data;
    }

    clone(): WorksheetRow {
        const json = this.toJSON();
        let result = new WorksheetRow();
        result.init(json);
        return result;
    }
}

export interface IWorksheetRow {
    title?: string | null;
    multiYear?: string | null;
    prepayment?: string | null;
    combination?: string | null;
    annual?: string | null;
    parentPlus?: string | null;
    installment?: string | null;
    standard?: string | null;
}

export class SplitWorksheetRow implements ISplitWorksheetRow {
    title?: string | null;
    multiYear1?: string | null;
    multiYear2?: string | null;
    prepayment1?: string | null;
    prepayment2?: string | null;
    combination1?: string | null;
    combination2?: string | null;
    annual?: string | null;
    parentPlus?: string | null;
    installment1?: string | null;
    installment2?: string | null;
    standard?: string | null;

    constructor(data?: ISplitWorksheetRow) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.title = _data["title"] !== undefined ? _data["title"] : null as any;
            this.multiYear1 = _data["multiYear1"] !== undefined ? _data["multiYear1"] : null as any;
            this.multiYear2 = _data["multiYear2"] !== undefined ? _data["multiYear2"] : null as any;
            this.prepayment1 = _data["prepayment1"] !== undefined ? _data["prepayment1"] : null as any;
            this.prepayment2 = _data["prepayment2"] !== undefined ? _data["prepayment2"] : null as any;
            this.combination1 = _data["combination1"] !== undefined ? _data["combination1"] : null as any;
            this.combination2 = _data["combination2"] !== undefined ? _data["combination2"] : null as any;
            this.annual = _data["annual"] !== undefined ? _data["annual"] : null as any;
            this.parentPlus = _data["parentPlus"] !== undefined ? _data["parentPlus"] : null as any;
            this.installment1 = _data["installment1"] !== undefined ? _data["installment1"] : null as any;
            this.installment2 = _data["installment2"] !== undefined ? _data["installment2"] : null as any;
            this.standard = _data["standard"] !== undefined ? _data["standard"] : null as any;
        }
    }

    static fromJS(data: any): SplitWorksheetRow {
        data = typeof data === 'object' ? data : {};
        let result = new SplitWorksheetRow();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["title"] = this.title !== undefined ? this.title : null as any;
        data["multiYear1"] = this.multiYear1 !== undefined ? this.multiYear1 : null as any;
        data["multiYear2"] = this.multiYear2 !== undefined ? this.multiYear2 : null as any;
        data["prepayment1"] = this.prepayment1 !== undefined ? this.prepayment1 : null as any;
        data["prepayment2"] = this.prepayment2 !== undefined ? this.prepayment2 : null as any;
        data["combination1"] = this.combination1 !== undefined ? this.combination1 : null as any;
        data["combination2"] = this.combination2 !== undefined ? this.combination2 : null as any;
        data["annual"] = this.annual !== undefined ? this.annual : null as any;
        data["parentPlus"] = this.parentPlus !== undefined ? this.parentPlus : null as any;
        data["installment1"] = this.installment1 !== undefined ? this.installment1 : null as any;
        data["installment2"] = this.installment2 !== undefined ? this.installment2 : null as any;
        data["standard"] = this.standard !== undefined ? this.standard : null as any;
        return data;
    }

    clone(): SplitWorksheetRow {
        const json = this.toJSON();
        let result = new SplitWorksheetRow();
        result.init(json);
        return result;
    }
}

export interface ISplitWorksheetRow {
    title?: string | null;
    multiYear1?: string | null;
    multiYear2?: string | null;
    prepayment1?: string | null;
    prepayment2?: string | null;
    combination1?: string | null;
    combination2?: string | null;
    annual?: string | null;
    parentPlus?: string | null;
    installment1?: string | null;
    installment2?: string | null;
    standard?: string | null;
}

export class GenerateWorksheetDataRequest implements IGenerateWorksheetDataRequest {
    academicLevel?: AcademicLevel;
    tuitionAmount?: number;
    activityFee?: number;
    roomBoard?: number;
    foodService?: number;
    financialAward?: number;
    otherResources?: number;
    prepayment?: number;
    numSemesters?: number;
    roomId?: number | null;
    mealPlanId?: number | null;
    baseSemester?: BaseSemester;

    constructor(data?: IGenerateWorksheetDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.academicLevel = _data["academicLevel"] !== undefined ? _data["academicLevel"] : null as any;
            this.tuitionAmount = _data["tuitionAmount"] !== undefined ? _data["tuitionAmount"] : null as any;
            this.activityFee = _data["activityFee"] !== undefined ? _data["activityFee"] : null as any;
            this.roomBoard = _data["roomBoard"] !== undefined ? _data["roomBoard"] : null as any;
            this.foodService = _data["foodService"] !== undefined ? _data["foodService"] : null as any;
            this.financialAward = _data["financialAward"] !== undefined ? _data["financialAward"] : null as any;
            this.otherResources = _data["otherResources"] !== undefined ? _data["otherResources"] : null as any;
            this.prepayment = _data["prepayment"] !== undefined ? _data["prepayment"] : null as any;
            this.numSemesters = _data["numSemesters"] !== undefined ? _data["numSemesters"] : null as any;
            this.roomId = _data["roomId"] !== undefined ? _data["roomId"] : null as any;
            this.mealPlanId = _data["mealPlanId"] !== undefined ? _data["mealPlanId"] : null as any;
            this.baseSemester = _data["baseSemester"] !== undefined ? _data["baseSemester"] : null as any;
        }
    }

    static fromJS(data: any): GenerateWorksheetDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GenerateWorksheetDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["academicLevel"] = this.academicLevel !== undefined ? this.academicLevel : null as any;
        data["tuitionAmount"] = this.tuitionAmount !== undefined ? this.tuitionAmount : null as any;
        data["activityFee"] = this.activityFee !== undefined ? this.activityFee : null as any;
        data["roomBoard"] = this.roomBoard !== undefined ? this.roomBoard : null as any;
        data["foodService"] = this.foodService !== undefined ? this.foodService : null as any;
        data["financialAward"] = this.financialAward !== undefined ? this.financialAward : null as any;
        data["otherResources"] = this.otherResources !== undefined ? this.otherResources : null as any;
        data["prepayment"] = this.prepayment !== undefined ? this.prepayment : null as any;
        data["numSemesters"] = this.numSemesters !== undefined ? this.numSemesters : null as any;
        data["roomId"] = this.roomId !== undefined ? this.roomId : null as any;
        data["mealPlanId"] = this.mealPlanId !== undefined ? this.mealPlanId : null as any;
        data["baseSemester"] = this.baseSemester !== undefined ? this.baseSemester : null as any;
        return data;
    }

    clone(): GenerateWorksheetDataRequest {
        const json = this.toJSON();
        let result = new GenerateWorksheetDataRequest();
        result.init(json);
        return result;
    }
}

export interface IGenerateWorksheetDataRequest {
    academicLevel?: AcademicLevel;
    tuitionAmount?: number;
    activityFee?: number;
    roomBoard?: number;
    foodService?: number;
    financialAward?: number;
    otherResources?: number;
    prepayment?: number;
    numSemesters?: number;
    roomId?: number | null;
    mealPlanId?: number | null;
    baseSemester?: BaseSemester;
}

export enum BaseSemester {
    Fall = "Fall",
    Spring = "Spring",
}

export class AddApplicationRequest implements IAddApplicationRequest {
    application?: ApplicationViewModel | null;
    shouldSendEmail?: boolean;
    taxDocumentFiles?: string[] | null;

    constructor(data?: IAddApplicationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application = _data["application"] ? ApplicationViewModel.fromJS(_data["application"]) : null as any;
            this.shouldSendEmail = _data["shouldSendEmail"] !== undefined ? _data["shouldSendEmail"] : null as any;
            if (Array.isArray(_data["taxDocumentFiles"])) {
                this.taxDocumentFiles = [] as any;
                for (let item of _data["taxDocumentFiles"])
                    this.taxDocumentFiles!.push(item);
            }
            else {
                this.taxDocumentFiles = null as any;
            }
        }
    }

    static fromJS(data: any): AddApplicationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddApplicationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application"] = this.application ? this.application.toJSON() : null as any;
        data["shouldSendEmail"] = this.shouldSendEmail !== undefined ? this.shouldSendEmail : null as any;
        if (Array.isArray(this.taxDocumentFiles)) {
            data["taxDocumentFiles"] = [];
            for (let item of this.taxDocumentFiles)
                data["taxDocumentFiles"].push(item);
        }
        return data;
    }

    clone(): AddApplicationRequest {
        const json = this.toJSON();
        let result = new AddApplicationRequest();
        result.init(json);
        return result;
    }
}

export interface IAddApplicationRequest {
    application?: ApplicationViewModel | null;
    shouldSendEmail?: boolean;
    taxDocumentFiles?: string[] | null;
}

export class UploadDocumentsResponse implements IUploadDocumentsResponse {
    documentIds?: string[] | null;

    constructor(data?: IUploadDocumentsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["documentIds"])) {
                this.documentIds = [] as any;
                for (let item of _data["documentIds"])
                    this.documentIds!.push(item);
            }
            else {
                this.documentIds = null as any;
            }
        }
    }

    static fromJS(data: any): UploadDocumentsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadDocumentsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.documentIds)) {
            data["documentIds"] = [];
            for (let item of this.documentIds)
                data["documentIds"].push(item);
        }
        return data;
    }

    clone(): UploadDocumentsResponse {
        const json = this.toJSON();
        let result = new UploadDocumentsResponse();
        result.init(json);
        return result;
    }
}

export interface IUploadDocumentsResponse {
    documentIds?: string[] | null;
}

export class GetFpcwPdfRequest implements IGetFpcwPdfRequest {
    academicLevel?: AcademicLevel;
    activityFee?: number;
    baseSemester?: BaseSemester;
    financialAward?: number;
    foodService?: number;
    numSemesters?: number;
    otherResources?: number;
    prepayment?: number;
    roomBoard?: number;
    tuitionAmount?: number;
    roomId?: number | null;
    mealPlanId?: number | null;
    conversionOptions?: ConversionOptions | null;

    constructor(data?: IGetFpcwPdfRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.academicLevel = _data["academicLevel"] !== undefined ? _data["academicLevel"] : null as any;
            this.activityFee = _data["activityFee"] !== undefined ? _data["activityFee"] : null as any;
            this.baseSemester = _data["baseSemester"] !== undefined ? _data["baseSemester"] : null as any;
            this.financialAward = _data["financialAward"] !== undefined ? _data["financialAward"] : null as any;
            this.foodService = _data["foodService"] !== undefined ? _data["foodService"] : null as any;
            this.numSemesters = _data["numSemesters"] !== undefined ? _data["numSemesters"] : null as any;
            this.otherResources = _data["otherResources"] !== undefined ? _data["otherResources"] : null as any;
            this.prepayment = _data["prepayment"] !== undefined ? _data["prepayment"] : null as any;
            this.roomBoard = _data["roomBoard"] !== undefined ? _data["roomBoard"] : null as any;
            this.tuitionAmount = _data["tuitionAmount"] !== undefined ? _data["tuitionAmount"] : null as any;
            this.roomId = _data["roomId"] !== undefined ? _data["roomId"] : null as any;
            this.mealPlanId = _data["mealPlanId"] !== undefined ? _data["mealPlanId"] : null as any;
            this.conversionOptions = _data["conversionOptions"] ? ConversionOptions.fromJS(_data["conversionOptions"]) : null as any;
        }
    }

    static fromJS(data: any): GetFpcwPdfRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetFpcwPdfRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["academicLevel"] = this.academicLevel !== undefined ? this.academicLevel : null as any;
        data["activityFee"] = this.activityFee !== undefined ? this.activityFee : null as any;
        data["baseSemester"] = this.baseSemester !== undefined ? this.baseSemester : null as any;
        data["financialAward"] = this.financialAward !== undefined ? this.financialAward : null as any;
        data["foodService"] = this.foodService !== undefined ? this.foodService : null as any;
        data["numSemesters"] = this.numSemesters !== undefined ? this.numSemesters : null as any;
        data["otherResources"] = this.otherResources !== undefined ? this.otherResources : null as any;
        data["prepayment"] = this.prepayment !== undefined ? this.prepayment : null as any;
        data["roomBoard"] = this.roomBoard !== undefined ? this.roomBoard : null as any;
        data["tuitionAmount"] = this.tuitionAmount !== undefined ? this.tuitionAmount : null as any;
        data["roomId"] = this.roomId !== undefined ? this.roomId : null as any;
        data["mealPlanId"] = this.mealPlanId !== undefined ? this.mealPlanId : null as any;
        data["conversionOptions"] = this.conversionOptions ? this.conversionOptions.toJSON() : null as any;
        return data;
    }

    clone(): GetFpcwPdfRequest {
        const json = this.toJSON();
        let result = new GetFpcwPdfRequest();
        result.init(json);
        return result;
    }
}

export interface IGetFpcwPdfRequest {
    academicLevel?: AcademicLevel;
    activityFee?: number;
    baseSemester?: BaseSemester;
    financialAward?: number;
    foodService?: number;
    numSemesters?: number;
    otherResources?: number;
    prepayment?: number;
    roomBoard?: number;
    tuitionAmount?: number;
    roomId?: number | null;
    mealPlanId?: number | null;
    conversionOptions?: ConversionOptions | null;
}

export class ConversionOptions implements IConversionOptions {
    deviceScaleFactor?: number;
    height?: number;
    width?: number;
    isLandscape?: boolean;
    isMobile?: boolean;
    printFromPage?: number;
    printToPage?: number;
    htmlString?: string | null;

    constructor(data?: IConversionOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deviceScaleFactor = _data["deviceScaleFactor"] !== undefined ? _data["deviceScaleFactor"] : null as any;
            this.height = _data["height"] !== undefined ? _data["height"] : null as any;
            this.width = _data["width"] !== undefined ? _data["width"] : null as any;
            this.isLandscape = _data["isLandscape"] !== undefined ? _data["isLandscape"] : null as any;
            this.isMobile = _data["isMobile"] !== undefined ? _data["isMobile"] : null as any;
            this.printFromPage = _data["printFromPage"] !== undefined ? _data["printFromPage"] : null as any;
            this.printToPage = _data["printToPage"] !== undefined ? _data["printToPage"] : null as any;
            this.htmlString = _data["htmlString"] !== undefined ? _data["htmlString"] : null as any;
        }
    }

    static fromJS(data: any): ConversionOptions {
        data = typeof data === 'object' ? data : {};
        let result = new ConversionOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deviceScaleFactor"] = this.deviceScaleFactor !== undefined ? this.deviceScaleFactor : null as any;
        data["height"] = this.height !== undefined ? this.height : null as any;
        data["width"] = this.width !== undefined ? this.width : null as any;
        data["isLandscape"] = this.isLandscape !== undefined ? this.isLandscape : null as any;
        data["isMobile"] = this.isMobile !== undefined ? this.isMobile : null as any;
        data["printFromPage"] = this.printFromPage !== undefined ? this.printFromPage : null as any;
        data["printToPage"] = this.printToPage !== undefined ? this.printToPage : null as any;
        data["htmlString"] = this.htmlString !== undefined ? this.htmlString : null as any;
        return data;
    }

    clone(): ConversionOptions {
        const json = this.toJSON();
        let result = new ConversionOptions();
        result.init(json);
        return result;
    }
}

export interface IConversionOptions {
    deviceScaleFactor?: number;
    height?: number;
    width?: number;
    isLandscape?: boolean;
    isMobile?: boolean;
    printFromPage?: number;
    printToPage?: number;
    htmlString?: string | null;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class SwaggerException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isSwaggerException = true;

    static isSwaggerException(obj: any): obj is SwaggerException {
        return obj.isSwaggerException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new SwaggerException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}